VERSION_cx = `3.10.29`;
(function(global, factory)
{
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('xlsx'), require('axios'), require('vue'), require('vue-router'))
    : typeof define === 'function' && define.amd ? define(['xlsx', 'axios', 'vue', 'vue-router'], factory)
      : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.CX = factory(global.XLSX, global.axios, global.Vue, global.VueRouter))
}(this, function(XLSX, axios, Vue, VueRouter)
{
  'use strict'

  function _interopDefaultLegacy(e)
  {
    return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }
  }

  var XLSX__default = /*#__PURE__*/_interopDefaultLegacy(XLSX)
  var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios)
  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue)
  var VueRouter__default = /*#__PURE__*/_interopDefaultLegacy(VueRouter)

  var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function(obj)
  {
    return typeof obj
  } : function(obj)
  {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj
  }

  var classCallCheck = function(instance, Constructor)
  {
    if (!(instance instanceof Constructor))
    
      throw new TypeError('Cannot call a class as a function')
  }

  var createClass = (function()
  {
    function defineProperties(target, props)
    {
      for (var i = 0; i < props.length; i++)
      {
        var descriptor = props[i]
        descriptor.enumerable = descriptor.enumerable || false
        descriptor.configurable = true
        if ('value' in descriptor) descriptor.writable = true
        Object.defineProperty(target, descriptor.key, descriptor)
      }
    }

    return function(Constructor, protoProps, staticProps)
    {
      if (protoProps) defineProperties(Constructor.prototype, protoProps)
      if (staticProps) defineProperties(Constructor, staticProps)
      return Constructor
    }
  }())

  var defineProperty = function(obj, key, value)
  {
    if (key in obj)
    {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      })
    }
    else
    
      obj[key] = value
    

    return obj
  }

  var get = function get(object, property, receiver)
  {
    if (object === null) object = Function.prototype
    var desc = Object.getOwnPropertyDescriptor(object, property)

    if (desc === undefined)
    {
      var parent = Object.getPrototypeOf(object)

      if (parent === null)
      
        return undefined
      
      else
      
        return get(parent, property, receiver)
    }
    else if ('value' in desc)
    
      return desc.value
    
    else
    {
      var getter = desc.get

      if (getter === undefined)
      
        return undefined
      

      return getter.call(receiver)
    }
  }

  var inherits = function(subClass, superClass)
  {
    if (typeof superClass !== 'function' && superClass !== null)
    
      throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass)
    

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    })
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass
  }

  var possibleConstructorReturn = function(self, call)
  {
    if (!self)
    
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
    

    return call && (typeof call === 'object' || typeof call === 'function') ? call : self
  }

  var toConsumableArray = function(arr)
  {
    if (Array.isArray(arr))
    {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]

      return arr2
    }
    else
    
      return Array.from(arr)
  }

  /**
   * $g
   * 类-全局对象
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */
  var Global = function Global()
  {
    classCallCheck(this, Global)
  }

  /** * @property {Number}            loc             0-英文 1-中文 */


  Global.loc = 1

  /** * @property {cx.AttFactory}     attFactory      属性对象工厂 */
  Global.attFactory = null

  /** * @property {Object}            syscfg          系统配置 */
  Global.syscfg = null

  /** * @property {Object}            user            用户信息 */
  Global.user = null

  /** * @property {cx.Entities}       entity          实体对象 */
  Global.entity = null

  /** * @property {cx.Fields}         field           字段对象 */
  Global.field = null

  /** * @property {cx.Plugins}        plugin          插件对象 */
  Global.plugin = null

  /** * @property {cx.Funcs}          func            功能对象 */
  Global.func = null

  /** * @property {cx.FieldCfgs}      fldcfg          字段配置对象 */
  Global.fldcfg = null

  /** * @property {cx.Services}       service         服务对象 */
  Global.service = null

  /** * @property {cx.IAccess}        access          权限对象 */
  Global.access = null

  /** * @property {cx.ProcAssign}     prosAssi        权限对象 */
  Global.prosAssi = null

  /** * @property {cx.IMessage}       message         消息处理对象 */
  Global.message = null

  /** * @property {String}            runType         运行模式 */
  Global.runType = null

  /** * @property {Object}            container       当前的容器 */
  Global.container = null

  /** * @property {cx.MyIndexDb}      myIndexDb       IndexDb管理对象 */
  Global.myIndexDb = null

  /** * @property {Object}            dlgcfg          对话框设置 */
  Global.dlgcfg = {
    dlgType: 'headerbody', //对话框类型
    borderOuter: 0, //外边框粗细
    borderInner: 0, //内边框粗细
    gapBorders: 6 //两个边框之间的大小
  }

  /**
   * cx.Caller
   * 类-Caller
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-28
   */
  var Caller = (function()
  {
    /**
     * 支持两种方式调用 1. Caller(function) 2.Caller(object, 'methodName')
     * @constructor
     */
    function Caller()
    {
      classCallCheck(this, Caller)

      if (typeof arguments[0] === 'function')
      {
        this.obj = null
        this.func = arguments[0]
      }
      else if (_typeof(arguments[0]) && typeof arguments[1] === 'string')
      {
        this.obj = arguments[0]
        this.func = arguments[1]
      }
    }

    /**
     * 调用方法
     * @method
     * @param   {Object}    argvs           可变参数
     * @returns {*}
     */


    createClass(Caller, [{
      key: 'call',
      value: function call()
      {
        var func = void 0

        for (var _len = arguments.length, argvs = Array(_len), _key = 0; _key < _len; _key++)
        
          argvs[_key] = arguments[_key]
        

        if (this.obj)
        {
          func = this.obj[this.func]
          if (func) return func.apply(this.obj, argvs)
        }
        else
        {
          func = this.func
          if (func) return func.apply(null, argvs)
        }
      }
    }])
    return Caller
  }())

  /**
   * cx.base
   * 类-Base
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-28
   */

  var Base = (function()
  {
    /**
     * @constructor
     */
    function Base()
    {
      classCallCheck(this, Base)

      this._newId = 0
      this._nextZIndex = 1000
      this.debug = false
    }

    /**
     * 比较v1和v2两个版本的大小
     * @param {string|number} v1 第一个版本值，如：'1.1.2' 或数值
     * @param {string|number} v2 第二个版本值
     * @returns {number}         判断的值，0是相等，1是v1大于v2，-1是v1小于v2
     */


    createClass(Base, null, [{
      key: 'compareVersions',
      value: function compareVersions(v1, v2)
      {
        var s1 = ('' + v1).split('.')
        var s2 = ('' + v2).split('.')
        for (var i = 0; i < Math.max(s1.length, s2.length); i++)
        {
          var n1 = parseInt(s1[i] || '0', 10)
          var n2 = parseInt(s2[i] || '0', 10)

          if (n1 > n2) return 1

          if (n2 > n1) return -1
        }

        return 0
      }

      /**
       * 产生一个新ID
       * @static
       * @method
       * @returns {Number}
       */

    }, {
      key: 'nextId',
      value: function nextId()
      {
        return this._newId++
      }

      /**
       * 产生一个新 z-index
       * @static
       * @method
       * @returns {Number}
       */

    }, {
      key: 'nextZIndex',
      value: function nextZIndex()
      {
        this._nextZIndex += 2 //对话框，对话框下面的模态对话
        return this._nextZIndex
      }

      /**
       * 判断是否Boolean类型，是时返回true，否则false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isBoolean',
      value: function isBoolean(val)
      {
        return typeof val === 'boolean'
      }

      /**
       * 判断是否定义，不等于undefined时返回true，否则false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isDef',
      value: function isDef(val)
      {
        return val !== undefined
      }

      /**
       * 判断val是否为空，等于null时返回true，否则false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isNull',
      value: function isNull(val)
      {
        return val === null
      }

      /**
       * 判断val已定义且不为null，即有赋值时返回true，否则false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isNNull',
      value: function isNNull(val)
      {
        return val !== undefined && val !== null
      }

      /**
       * 判断val是否为数值，是返回true，不是返回false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isNum',
      value: function isNum(val)
      {
        return typeof val === 'number' && !isNaN(val)
      }

      /**
       * 判断val是否为字符串，是返回true，不是返回false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isStr',
      value: function isStr(val)
      {
        return typeof val === 'string' || val instanceof String
      }

      /**
       * 判断val是否为数组，是返回true，不是返回false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isArr',
      value: function isArr(val)
      {
        return val instanceof Array
      }

      /**
       * 判断val是否为对象，是返回true，不是返回false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isObj',
      value: function isObj(val)
      {
        return val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')
      }

      /**
       * 判断val是否为函数，是返回true不是返回false
       * @static
       * @method
       * @param   {Object}    val
       * @returns {Boolean}
       */

    }, {
      key: 'isFunc',
      value: function isFunc(val)
      {
        return typeof val === 'function'
      }

      /**
       * 如果给出的值为未定义，则给出缺省值
       * @static
       * @method
       * @param   {Object}  value            值
       * @param   {Object}  defValue         缺省值
       * @returns {Object}
       */

    }, {
      key: 'defVal',
      value: function defVal(value, defValue)
      {
        return value !== undefined ? value : defValue
      }

      /**
       * 判断val(对象或者属性)是否在obj(数组或者对象)中
       * @static
       * @method
       * @param   {Object|Array}  obj
       * @param   {Object}        val
       * @returns {Boolean}
       */

    }, {
      key: 'contains',
      value: function contains(obj, val)
      {
        var i = void 0
        if (this.isArr(obj))
        {
          for (i = 0; i < obj.length; i++)
          
            if (obj[i] === val) return true
        }
        else if (this.isObj(obj))
        {
          for (i in obj)
          
            if (obj[i] === val) return true
        }
        return false
      }

      /**
       * 目标对象(target)继承对象(args可以多个参数)
       * @static
       * @method
       * @param   {Object}    target          目标对象
       * @param   {Object}    argvs           可变参数
       * @returns {Object}                    target
       */

    }, {
      key: 'extend',
      value: function extend(target)
      {
        for (var _len = arguments.length, argvs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)
        
          argvs[_key - 1] = arguments[_key]
        

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = argvs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var argv = _step.value

            if ((typeof argv === 'undefined' ? 'undefined' : _typeof(argv)) === 'object')
            {
              for (var key in argv)
              
                target[key] = argv[key]
            }
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return target
      }

      /**
       * Funciton或Caller调用
       * @static
       * @method
       * @param   {cx.Caller}     func         函数或者Caller
       * @param   {String}        argvs       可变参数,参数1，参数2，..参数n
       * @returns {*}
       */

    }, {
      key: 'call',
      value: function call(func)
      {
        if (!func) return undefined

        //调用

        for (var _len2 = arguments.length, argvs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)
        
          argvs[_key2 - 1] = arguments[_key2]
        

        if (typeof func === 'function') return func.apply(null, argvs); else if (func instanceof Caller)
        {
          var func1 = void 0
          if (func.obj)
          {
            func1 = func.obj[func.func]
            if (func1) return func1.apply(func.obj, argvs)
          }
          else
          {
            func1 = func.func
            if (func1) return func1.apply(null, argvs)
          }
        }
      }

      /**
       * 字符串调用
       * @static
       * @method
       * @param  {String}   func            函数字符串,可以'()'结束，也可以没有'()' (如 'test' 或 'test()')
       * @param  {Array}    argvs           参数数组
       * @returns {*}
       */

    }, {
      key: 'execute',
      value: function execute(func, argvs)
      {
        if (func)
        {
          var parent = window
          var obj = window
          var strs = func
          if (strs.indexOf('()') >= 0) //去掉()
            strs = strs.slice(0, -2)
          strs = strs.split('.') //查找包名
          for (var i = 0; i < strs.length; i++)
          {
            parent = obj
            obj = obj[strs[i]]
          }
          if (obj) //执行函数
            return obj.apply(parent, argvs)
        }
      }

      /**
       * 确定显示中英文字符串
       * @static
       * @method
       * @param   {String}    dispc       中文字符串
       * @param   {String}    dispe       英文字符串
       * @param   {String}
       */

    }, {
      key: 'locale',
      value: function locale(dispc, dispe)
      {
        return Global.loc ? dispc : dispe
      }

      /**
       * 取字词表符串
       * @static
       * @method
       * @param   {String}    key           字符串key
       * @param   {*}         argvs         变参，要被替换的目标字符串
       * @returns {String}                  词表字符串
       */

    }, {
      key: 'loc',
      value: function loc(key)
      {
        var ret = vm.$t(key)

        for (var _len3 = arguments.length, argvs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)
        
          argvs[_key3 - 1] = arguments[_key3]
        

        if (argvs.length > 0)
        {
          for (var i = 0; i < argvs.length; i++)
          
            ret = ret.replace('%' + (i + 1), '' + argvs[i])
        }
        return ret
      }

      /**
       * 显示信息
       * @static
       * @method
       * @param {String}    message       消息文本
       * @param {String}    [type]        类型(success/warning/info/error)
       */

    }, {
      key: 'showMsg',
      value: function showMsg(message, type)
      {
        if (!type) vm.$message(message); else
        
        if (type === 'error') vm.$message.error(message); else vm.$message({ type: type, message: message })
      }

      /**
       * 输出调试信息
       * @static
       * @method
       * @param  {String}     msg
       */

    }, {
      key: 'log',
      value: function log(msg)
      {
        if (this.debug) console.log(msg)
      }

      /**
       * 设置计时器，来监测条件满足时执行回调
       * @static
       * @method
       * @param   {Function}    isReady     是否满足条件的判断函数
       * @param   {Function}    callBack    满足条件后的回调函数
       * @param   {Number}      [time=600] 间隔时间(ms)。
       */

    }, {
      key: 'watch',
      value: function watch(isReady, callBack)
      {
        var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200

        var func = function func(_)
        {
          if (isReady())
          {
            if (myInterval) window.clearInterval(myInterval)
            callBack()
          }
        }
        //设置定时任务，每1000ms执行一次watch方法。
        var myInterval = window.setInterval(func, time)
      }
    }])
    return Base
  }())

  Base._newId = 0
  Base._nextZIndex = 1000
  Base.debug = false
  Base.processing = {
    _loads: [],
    _getDom: function _getDom(target)
    {
      if (target) return Base.isStr(target) ? document.getElementById(target) || document.body : target; else return document.body
    },

    /**
     * 显示控件
     * @method
     * @param {Element|String|null}  [target]       正在加载显示的容器对象或id，默认是body
     */
    show: function show(target)
    {
      var dom = this._getDom(target)
      this.loading = vm.$loading({
        lock: true,
        text: vm.$loc('cx.processing'),
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.5)',
        customClass: 'cx-processing',
        target: dom
      })

      this._loads.push({ dom: dom, load: this.loading })
    },

    /**
     * 关闭控件
     * @method
     * @param {Element|String|null}  [target]       正在加载显示的容器对象或id，默认是body
     */
    close: function close(target)
    {
      var dom = this._getDom(target)
      var idx = this._loads.findIndex(function(item)
      {
        return item.dom === dom
      })
      var loadObj = this._loads[idx]

      if (!loadObj && this._loads.length === 1)
      {
        loadObj = this._loads[0]
        idx = 0
      }

      if (loadObj && loadObj.load)
      {
        loadObj.load.close()
        this._loads.splice(idx, 1)
      }
    }
  }

  /**
   * cx.array
   * 类-数组语法糖
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var Array$1 = (function()
  {
    function Array()
    {
      classCallCheck(this, Array)
    }

    createClass(Array, null, [{
      key: 'listToMap',

      /**
       * 将数组转成map
       * @method
       * @static
       * @param {Array.Object}  data  带转换的数据
       * @param {String}        key   转换成map所依据的key
       * @returns {Object.Array}      转换成的map对象
       */
      value: function listToMap(data, key)
      {
        var map = {}
        data.forEach(function(obj)
        {
          map[obj[key]] = map[obj[key]] || []
          map[obj[key]].push(obj)
        })
        return map
      }

      /**
       * 根据keyList中的多组key序列，把data转化为map对象。对象的键值是各key值字段对应值拼成的字符串，值是数组中对象包含该键值的对象序列
       * 应用场景：数据序列中多个字段是相同信息，并需要用该信息进行分组时
       * @method
       * @static
       * @param {Array.Object}                  data       待转换的数据
       * @param {Array.<Array.<String>>}        keysList   转换成map所依据的keys集合，如[[name,id],[no],[press,color]]
       * @returns {Object.Array}  转换成的map对象
       *
       * 如    var arr = [{begin: 1, end: 2},{begin:3, end:1},{begin:4, end: 2},{begin: 5, end:1}]
       *       listToMapByKeys(arr,['begin'],['end'])
       */

    }, {
      key: 'listToMapByKeys',
      value: function listToMapByKeys(data, keysList)
      {
        if (keysList.some(function(item)
        {
          return item.length === 0
        })) return data

        var map = {}
        data.forEach(function(obj)
        {
          var toMap = function toMap(keys)
          {
            var key = keys.map(function(key)
            {
              return obj[key]
            }).join('_')
            map[key] = map[key] || []
            map[key].push(obj)
          }
          keysList.forEach(toMap)
        })
        if (data.every(function(item)
        {
          return item.id
        }))
        {
          Object.keys(map).forEach(function(key)
          {
            return cx.base.extend(map, defineProperty({}, key, cx.util.filterRepeat(map[key])))
          })
        }
        return map
      }

      /**
       * 判断数组是否为空数组
       * @static
       * @method
       * @param   {Array}     arr                 数组
       * @returns {Boolean}
       */

    }, {
      key: 'isEmpty',
      value: function isEmpty(arr)
      {
        return arr.length === 0
      }

      /**
       * 判断数组是否包含指定元素
       * @static
       * @method
       * @param   {Array}     arr                 数组
       * @param   {Object}    element             元素
       * @returns {Boolean}
       */

    }, {
      key: 'has',
      value: function has(arr, element)
      {
        if (Base.isArr(arr))
        {
          for (var i = arr.length - 1; i >= 0; i--)
          
            if (arr[i] === element) return true
        }
        return false
      }

      /**
       * 对数组元素进行循环操作
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {cx.Caller} callback        回调函数(function(obj))
       * @param   {Object}    context         上下文
       * @returns {Object}                    this
       */

    }, {
      key: 'forEach',
      value: function forEach(arr, callback, context)
      {
        if (Base.isArr(arr))
        {
          for (var i = 0; i < arr.length; i++)
          
            if (callback.call(context, arr[i])) break
        }
        return this
      }

      /**
       * 清空
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @returns {Object}                    this
       */

    }, {
      key: 'clear',
      value: function clear(arr)
      {
        if (Base.isArr(arr))
        {
          for (var i = arr.length - 1; i >= 0; i--)
          
            arr.splice(i, 1)
        }
        return this
      }

      /**
       * 查找元素在数组中的下标
       * @static
       * @method
       * @param   {Array}         arr             数组
       * @param   {Object}        val             值
       */

    }, {
      key: 'indexOf',
      value: function indexOf(arr, val)
      {
        if (Base.isArr(arr))
        {
          for (var i = arr.length - 1; i >= 0; i--)
          
            if (arr[i] === val) return i
        }
        return -1
      }

      /**
       * 取满足条件的第一个元素
       * @static
       * @method
       * @param   {Array}         arr             数组
       * @param   {Object}        exp             条件
       * @returns {Object}
       */

    }, {
      key: 'get1',
      value: function get1(arr, exp)
      {
        var ise = void 0
        var i = void 0,
          j = void 0
        if (Base.isArr(arr))
        {
          for (i = 0; i < arr.length; i++)
          {
            ise = true
            for (j in exp)
            
              if (arr[i][j] !== exp[j]) ise = false
            
            if (ise) return arr[i]
          }
        }
        return null
      }

      /**
       * 取满足条件的所有元素
       * @static
       * @method
       * @param   {Array}     arr                 数组
       * @param   {Object}    exp                 条件
       * @returns {Array}
       */

    }, {
      key: 'gets',
      value: function gets(arr, exp)
      {
        var ret = []
        var ise = void 0
        var i = void 0,
          j = void 0
        if (Base.isArr(arr))
        {
          for (i = 0; i < arr.length; i++)
          {
            ise = true
            for (j in exp)
            {
              if (arr[i][j] !== exp[j])
              {
                ise = false
                break
              }
            }
            if (ise) ret.push(arr[i])
          }
        }
        return ret
      }

      /**
       * 取不满足条件的所有元素
       * @static
       * @method
       * @param   {Array}     arr                 数组
       * @param   {Object}    exp                 条件
       * @returns {Array}
       */

    }, {
      key: 'getsNot',
      value: function getsNot(arr, exp)
      {
        var ret = []
        var ise = void 0
        var i = void 0,
          j = void 0
        if (Base.isArr(arr))
        {
          for (i = 0; i < arr.length; i++)
          {
            ise = true
            for (j in exp)
            {
              if (arr[i][j] === exp[j])
              {
                ise = false
                break
              }
            }
            if (ise) ret.push(arr[i])
          }
        }
        return ret
      }

      /**
       * 模糊查找取不满足条件的所有元素
       * @static
       * @method
       * @param   {Array}     arr                 数组
       * @param   {String}    fld                 键名
       * @param   {Object}    val                 值
       * @returns {Array}
       */

    }, {
      key: 'getsNotFuz',
      value: function getsNotFuz(arr, fld, val)
      {
        var ret = []
        if (Base.isArr(arr))
        {
          for (var i = 0; i < arr.length; i++)
          
            if (arr[i][fld].indexOf(val) < 0) ret.push(arr[i])
        }
        return ret
      }

      /**
       * 从数组中模糊查找数据
       * @static
       * @method
       * @param   {Array}     arr                 数组
       * @param   {String}    fld                 键名
       * @param   {Object}    val                 值
       * @returns {Array}
       */

    }, {
      key: 'getsFuz',
      value: function getsFuz(arr, fld, val)
      {
        var ret = []
        if (Base.isArr(arr))
        {
          for (var i = 0; i < arr.length; i++)
          
            if (arr[i][fld].indexOf(val) > -1) ret.push(arr[i])
        }
        return ret
      }

      /**
       * 把对象增加数组中，插入到开头位置
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Object}    obj             待插入对象
       * @returns {Object}                    this
       */

    }, {
      key: 'insert',
      value: function insert(arr, obj)
      {
        if (Base.isArr(arr)) arr.unshift(obj)
        return this
      }

      /**
       * 把对象增加数组中，插入到指定位置
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Object}    obj             待插入对象
       * @param   {Number}    idx             插入位置
       * @returns {Object}                    this
       */

    }, {
      key: 'insertAt',
      value: function insertAt(arr, obj, idx)
      {
        if (Base.isArr(arr))
        {
          if (!Base.isArr(obj)) arr.splice(idx, 0, obj); else
          {
            for (var i = arr.length - 1; i >= 0; i--)
            
              arr.splice(idx, 0, obj[i])
          }
        }
        return this
      }

      /**
       * 添加多个元素到数组
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Object}    elments         变参（支持多个元素）
       * @returns {Object}                    this
       */

    }, {
      key: 'append',
      value: function append(arr)
      {
        if (Base.isArr(arr))
        {
          for (var _len = arguments.length, elments = Array(), _key = 1; _key < _len; _key++)
          
            elments[_key - 1] = arguments[_key]
          

          var _iteratorNormalCompletion = true
          var _didIteratorError = false
          var _iteratorError = undefined

          try
          {
            for (var _iterator = elments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
            {
              var elment = _step.value

              arr.push(elment)
            }
          }
          catch (err)
          {
            _didIteratorError = true
            _iteratorError = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion && _iterator.return)
              
                _iterator.return()
            }
            finally
            {
              if (_didIteratorError)
              
                throw _iteratorError
            }
          }
        }
        return this
      }

      /**
       * 添加数组中的元素到数组
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Array}     src             源数组
       * @returns {Object}                    this
       */

    }, {
      key: 'appendArr',
      value: function appendArr(arr, src)
      {
        if (Base.isArr(arr) && Base.isArr(src))
        {
          for (var i = 0; i < src.length; i++)
          
            arr.push(src[i])
        }
        return this
      }

      /**
       * 构造指定长度的数组
       * @method
       * @static
       * @param   {Number}   length      指定的数组长度
       * @param   {Number}   [defVal]    默认填充值，没有时就用对于序号填充
       * @returns {Array}    构造好的数组
       */

    }, {
      key: 'makeArr',
      value: function makeArr(length, defVal)
      {
        return Array.from({ length: length }).map(function(item, index)
        {
          return cx.base.isDef(defVal) ? defVal : index
        })
      }

      /**
       * 从数组中删除指定对象的数据
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Object}    exp             条件
       * @returns {Object}                    this
       */

    }, {
      key: 'remove',
      value: function remove(arr, exp)
      {
        var ise = void 0
        var i = void 0,
          j = void 0
        if (Base.isArr(arr))
        {
          for (i = arr.length - 1; i >= 0; i--)
          {
            ise = true
            for (j in exp)
            {
              if (arr[i][j] !== exp[j])
              {
                ise = false
                break
              }
            }
            if (ise) arr.splice(i, 1)
          }
        }
        return this
      }

      /**
       * 从数组中删除指定位置删除多个元素
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Number}    idx             删除位置
       * @param   {Number}    number          个数
       * @returns {Object}                    this
       */

    }, {
      key: 'removeAt',
      value: function removeAt(arr, idx, number)
      {
        if (Base.isArr(arr)) arr.splice(idx, number)
        return this
      }

      /**
       * 从数组中删除指定元素
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Object}    element         数组元素
       * @returns {Object}                    this
       */

    }, {
      key: 'removeElement',
      value: function removeElement(arr, element)
      {
        if (Base.isArr(arr))
        {
          for (var i = arr.length - 1; i >= 0; i--)
          
            if (arr[i] === element) arr.splice(i, 1)
        }
        return this
      }

      /**
       * 把对象更新到数组中
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Object}    exp             条件
       * @param   {Object}    obj             对象
       * @returns {Object}                    this
       */

    }, {
      key: 'update',
      value: function update(arr, exp, obj)
      {
        var ise = void 0
        var i = void 0,
          j = void 0
        if (Base.isArr(arr))
        {
          for (i in arr)
          {
            ise = true
            for (j in exp)
            {
              if (arr[i][j] !== exp[j])
              {
                ise = false
                break
              }
            }
            if (ise)
            {
              arr[i] = obj
              break
            }
          }
        }
        return this
      }

      /**
       * 合并数组(把arr2合并到arr, 返回arr)
       * @static
       * @method
       * @param   {Array}     arr             数组
       * @param   {Array}     arr2            数组2
       * @param   {Boolean}   noMulti         是否剔除重复数据
       * @returns {Object}                    this
       */

    }, {
      key: 'merge',
      value: function merge(arr, arr2, noMulti)
      {
        if (Base.isArr(arr) && Base.isArr(arr2))
        {
          for (var i = 0; i < arr2.length; i++)
          
            if (!noMulti || !this.has(arr2[i])) arr.push(arr2[i])
        }
        return this
      }

      /**
       * 将数组分割为指定长度的多个子数组。
       * @method
       * @static
       * @param   {Array<Object>}   arr     待分割的数组
       * @param   {Number}          size    子数组的长度（最后一个子数组的长度 <= size）
       * @returns {Array<Array>}    构造好的多个子数组
       */

    }, {
      key: 'splitArray',
      value: function splitArray(arr)
      {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 999

        return Array.from({ length: Math.floor(arr.length / size) + 1 }).map(function(item, index)
        {
          return arr.slice(index * size, (index + 1) * size)
        }).filter(function(arr)
        {
          return arr.length !== 0
        })
      }

      /**
       * 把数组转换为字符串
       * @static
       * @method
       * @param   {Array}     arr                 数组
       * @param   {String}    [keyFld]            数组成员对象的keyFld属性的值添加到字符串序列
       * @param   {String}    [separator = ',']   转换为字符串的值分隔符，默认为逗号
       */

    }, {
      key: 'toString',
      value: function toString(arr, keyFld, separator)
      {
        var str = ''
        separator = separator || ','
        if (Base.isArr(arr))
        {
          var _iteratorNormalCompletion2 = true
          var _didIteratorError2 = false
          var _iteratorError2 = undefined

          try
          {
            for (var _iterator2 = arr[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
            {
              var item = _step2.value

              if (Base.isObj(item)) str += (str ? separator : '') + item[keyFld]; else str += (str ? separator : '') + item
            }
          }
          catch (err)
          {
            _didIteratorError2 = true
            _iteratorError2 = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion2 && _iterator2.return)
              
                _iterator2.return()
            }
            finally
            {
              if (_didIteratorError2)
              
                throw _iteratorError2
            }
          }
        }
        return str
      }
    }])
    return Array
  }())

  /**
   * cx.att
   * 类-属性类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-25
   */

  var Att = (function()
  {
    function Att()
    {
      classCallCheck(this, Att)
    }

    createClass(Att, null, [{
      key: 'cacheAtt',

      /**
       * 缓存属性
       * @method
       * @static
       * @param   {Number}    major         主类型
       * @param   {Number}    minor         子类型
       * @param   {Object}    att           属性
       * @param   {Array}     [cols]        需要缓存的列列表(如果不传值，则缓存全部)
       * @returns {Number}                  返回缓存字段数量
       */
      value: function cacheAtt(major, minor, att, cols)
      {
        var count = 0

        for (var key in att)
        {
          var isIn = false
          if (att[key] === undefined || att[key] === null) continue

          //查找是不是在指定的列里面,如果不在则不缓存
          if (cols && Base.isArr(cols))
          {
            var _iteratorNormalCompletion = true
            var _didIteratorError = false
            var _iteratorError = undefined

            try
            {
              for (var _iterator = cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
              {
                var col = _step.value

                if (col === key)
                {
                  isIn = true
                  break
                }
              }
            }
            catch (err)
            {
              _didIteratorError = true
              _iteratorError = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion && _iterator.return)
                
                  _iterator.return()
              }
              finally
              {
                if (_didIteratorError)
                
                  throw _iteratorError
              }
            }

            if (!isIn) continue
          }
          localStorage.setItem(major + '_' + minor + '_' + key, att[key])
          count++
        }
        return count
      }

      /**
       * 取缓存属性
       * @method
       * @static
       * @param   {Number}    major         主类型
       * @param   {Number}    minor         子类型
       * @param   {Object}    att           属性
       * @returns {Number}                  返回缓存的字段数
       */

    }, {
      key: 'getCacheAtt',
      value: function getCacheAtt(major, minor, att)
      {
        var count = 0

        for (var key in att)
        {
          var value = localStorage.getItem(major + '_' + minor + '_' + key)
          if (value !== undefined && value !== null)
          {
            att[key] = value
            count++
          }
        }
        return count
      }
    }])
    return Att
  }())

  /**
   * cx.regEx
   * 类-正则表达式
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */
  var RegEx = function RegEx()
  {
    classCallCheck(this, RegEx)
  }

  /** *@property {String}  numberAndUnit          Parse unit value */


  RegEx.numberAndUnit = /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i

  /** *@property {String}  hex                    Parse hex value    */
  RegEx.hex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i

  /** *@property {String}  rgb                    Parse rgb value    */
  RegEx.rgb = /rgb\((\d+),(\d+),(\d+)\)/

  /** *@property {String}  reference              Parse reference id */
  RegEx.reference = /#([a-z0-9\-_]+)/i

  /** *@property {String}  matrix                 Parse matrix wrapper */
  RegEx.matrix = /matrix\(|\)/g

  /** *@property {String}  matrixElements         Elements of a matrix */
  RegEx.matrixElements = /,*\s+|,/

  /** *@property {String}  Whitespace             Whitespace */
  RegEx.whitespace = /\s/g

  /** *@property {String}  isHex                  Test hex value */
  RegEx.isHex = /^#[a-f0-9]{3,6}$/i

  /** *@property {String}  isRgb                  Test rgb value */
  RegEx.isRgb = /^rgb\(/

  /** *@property {String}  isCss                  Test css declaration */
  RegEx.isCss = /[^:]+:[^;]+;?/

  /** *@property {String}  isBlank                Test for blank string */
  RegEx.isBlank = /^(\s+)?$/

  /** *@property {String}  isNumber               Test for numeric string */
  RegEx.isNumber = /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i

  /** *@property {String}  isImage                Test for image url */
  RegEx.isImage = /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i

  /** *@property {String}  comma                  Replaces all comma */
  RegEx.comma = /,/g

  /** *@property {String}  pathLetters            Replaces and tests for all path letters */
  RegEx.pathLetters = /[MLHVCSQTAZ]/gi

  /** *@property {String}  isPathLetter           yes we need RegEx oneRegEx.too */
  RegEx.isPathLetter = /[MLHVCSQTAZ]/i

  /** *@property {String}  whitespaces            split at whitespaces */
  RegEx.whitespaces = /\s+/

  /** *@property {String}  refId                  引用ID */
  RegEx.refId = /#\{([a-z0-9\-_]+)\}/i

  /** *@property {String}  refVar                 引用变量 */
  RegEx.refVar = /\$\{([a-z0-9\-_]+)\}/i

  /** *@property {String}  timestamp              邮戳 */
  RegEx.timestamp = /^([1-9]\d{3})-(\d+)-(\d+)\s+(\d+):(\d+):(\d+)(?=\.\d+)*|$/

  /** *@property {String}  time                   时间 */
  RegEx.time = /^([0-1][0-9]|2[0-3]):([0-5][0-9])(:([0-5][0-9]))?$/

  /**
   * cx.consts
   * 类-常量定义
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */
  var Consts = function Consts()
  {
    classCallCheck(this, Consts)
  }

  /** * @property {Number}  DISPC                 1-显示中文 */


  Consts.DISPE = 0
  /** * @property {Number}  DISPE                 0-显示英文 */
  Consts.DISPC = 1

  /** * @property {Number}  DB_ORACLE             1-Oracle */
  Consts.DB_ORACLE = 1
  /** * @property {Number}  DB_MYSQL              2-MySQL */
  Consts.DB_MYSQL = 2
  /** * @property {Number}  DB_POSTGRESQL         3-PostgreSQL */
  Consts.DB_POSTGRESQL = 3
  /** * @property {Number}  DB_MSSQL              4-SQL Server */
  Consts.DB_MSSQL = 4

  /** * @property {Number}  DISP_TEXTBOX          1-文本编辑框 */
  Consts.DISP_TEXTBOX = 1
  /** * @property {Number}  DISP_LIST             2-下拉选择 */
  Consts.DISP_LIST = 2
  /** * @property {Number}  DISP_DATE             3-日期 yyyy-MM-dd*/
  Consts.DISP_DATE = 3
  /** * @property {Number}  DISP_RTEXT            4-富文本 */
  Consts.DISP_RTEXT = 4
  /** * @property {Number}  DISP_TIMESTAMP        5-邮戳 yyyy-MM-dd HH:mm:ss*/
  Consts.DISP_TIMESTAMP = 5
  /** * @property {Number}  DISP_DROPDOWN         6-下拉可自己输入其他值 */
  Consts.DISP_DROPDOWN = 6
  /** * @property {Number}  DISP_VALBUTTON        7-按钮 */
  Consts.DISP_VALBUTTON = 7
  /** * @property {Number}  DISP_SELDEPPOS        8-选择操作人的部门和职位 */
  Consts.DISP_SELDEPPOS = 8
  /** * @property {Number}  DISP_SELDYNA          9-动态选择 */
  Consts.DISP_SELDYNA = 9
  /** * @property {Number}  DISP_HLTEXT           10-TEXT(高亮文本显示) */
  Consts.DISP_HLTEXT = 10
  /** * @property {Number}  DISP_AUTOCODE         11-AUTOCODE(自动编码) */
  Consts.DISP_AUTOCODE = 11
  /** * @property {Number}  DISP_TIME             12-TIME HH:mm*/
  Consts.DISP_TIME = 12
  /** * @property {Number}  DISP_DATEYEAR         13-年份 yyyy*/
  Consts.DISP_DATEYEAR = 13

  /** * @property {Number}  ENTITY_TABLE          1-属性表 */
  Consts.ENTITY_TABLE = 1
  /** * @property {Number}  ENTITY_PNT            2-点 */
  Consts.ENTITY_PNT = 2
  /** * @property {Number}  ENTITY_LIN            3-线 */
  Consts.ENTITY_LIN = 3
  /** * @property {Number}  ENTITY_REG            4-面 */
  Consts.ENTITY_REG = 4
  /** * @property {Number}  ENTITY_NOTE           5-注 */
  Consts.ENTITY_NOTE = 5

  /** * @property {Number}  FEATURE_PNT           12-点 */
  Consts.FEATURE_PNT = 12
  /** * @property {Number}  FEATURE_LIN           13-线 */
  Consts.FEATURE_LIN = 13
  /** * @property {Number}  FEATURE_REG           14-面 */
  Consts.FEATURE_REG = 14

  /** * @property {Number}  UI_NONE               0-None */
  Consts.UI_NONE = 0
  /** * @property {Number}  UI_DIALOG             1-Dialog */
  Consts.UI_DIALOG = 1
  /** * @property {Number}  UI_TABPAGE            2-TabPage */
  Consts.UI_TABPAGE = 2
  /** * @property {Number}  UI_PANE               3-Pane */
  Consts.UI_PANE = 3
  /** * @property {Number}  UI_ROUTE              4-ROUTE */
  Consts.UI_ROUTE = 4

  /** * @property {Number}  MAPS_SYMBOL           1-符号库 */
  Consts.MAPS_SYMBOL = 1
  /** * @property {Number}  MAPS_VECTOR           2-矢量符号 */
  Consts.MAPS_VECTOR = 2
  /** * @property {Number}  MAPS_ICON             3-图标 */
  Consts.MAPS_ICON = 3
  /** * @property {Number}  MAPS_MODEL            4-模型 */
  Consts.MAPS_MODEL = 4

  /** * @property {Number}  FILE_DOC              1-文档 */
  Consts.FILE_DOC = 1
  /** * @property {Number}  FILE_IMG              2-图片 */
  Consts.FILE_IMG = 2
  /** * @property {Number}  FILE_VIDEO            3-视频 */
  Consts.FILE_VIDEO = 3
  /** * @property {Number}  FILE_AUDIO            4-音频 */
  Consts.FILE_AUDIO = 4

  /** * @property {Number}  DELFILE_NO            0-不删除 */
  Consts.DELFILE_NO = 0
  /** * @property {Number}  DELFILE_SUCCESS       1-成功时删除 */
  Consts.DELFILE_SUCCESS = 1
  /** * @property {Number}  DELFILE_FAIL          2-失败后删除 */
  Consts.DELFILE_FAIL = 2

  /** * @property {Number}  OPENFILE_OPEN         1-打开文件方式-打开 */
  Consts.OPENFILE_OPEN = 1
  /** * @property {Number}  OPENFILE_SAVE         2-打开文件方式-保存 */
  Consts.OPENFILE_SAVE = 2

  /** * @property {Number}  RES_FILE              0-文件 */
  Consts.RES_FILE = 1
  /** * @property {Number}  RES_URL               1-网址 */
  Consts.RES_URL = 2
  /** * @property {Number}  RES_LINK              2-链接文件 */
  Consts.RES_LINK = 3

  /** * @property {Number}  PROC_START            1-发起流程 */
  Consts.PROC_START = 1
  /** * @property {Number}  PROC_HANDLE           2-办理任务 */
  Consts.PROC_HANDLE = 2
  /** * @property {Number}  PROC_PROGRESS         3-流程进展 */
  Consts.PROC_PROGRESS = 3
  /** * @property {Number}  PROC_TRACE            4-流程跟踪图 */
  Consts.PROC_TRACE = 4
  /** * @property {Number}  ATT_EDIT              5-属性编辑 */
  Consts.ATT_EDIT = 5
  /** * @property {Number}  ATT_VIEW              6-属性查看 */
  Consts.ATT_VIEW = 6
  /** * @property {Number}  ATT_ADD               7-录入属性 */
  Consts.ATT_ADD = 7

  /** * @property {Number}  SYSTAB                99-系统表 */
  Consts.SYSTAB = 99
  /** * @property {Number}  TAB_ENTITY            4-表实体总览表 */
  Consts.TAB_ENTITY = 4
  /** * @property {Number}  TAB_FLD               5-字段配置表 */
  Consts.TAB_FLD = 5
  /** * @property {Number}  TAB_FLDVALUE          6-字段值配置表 */
  Consts.TAB_FLDVALUE = 6
  /** * @property {Number}  TAB_FUNCGRP           9-菜单组 */
  Consts.TAB_FUNCGRP = 9
  /** * @property {Number}  TAB_FUNC              10-功能表 */
  Consts.TAB_FUNC = 10
  /** * @property {Number}  TAB_FACE              11-皮肤表 */
  Consts.TAB_FACE = 11
  /** * @property {Number}  TAB_ORGAN             12-组织结构 */
  Consts.TAB_ORGAN = 12
  /** * @property {Number}  TAB_USER1             13-用户表 */
  Consts.TAB_USER1 = 13
  /** * @property {Number}  TAB_SYSUSER           14-系统用户 */
  Consts.TAB_SYSUSER = 14
  /** * @property {Number}  TAB_SYSROLE           15-系统角色 */
  Consts.TAB_SYSROLE = 15
  /** * @property {Number}  TAB_USERROLE          16-用户角色关联 */
  Consts.TAB_USERROLE = 16
  /** * @property {Number}  TAB_USERDEP           17-用户部门关联 */
  Consts.TAB_USERDEP = 17
  /** * @property {Number}  TAB_SYSROLEOBJ        18-角色对象表 */
  Consts.TAB_SYSROLEOBJ = 18
  /** * @property {Number}  TAB_WMS               31-wms图层表 */
  Consts.TAB_WMS = 31
  /** * @property {Number}  TAB_WFS               32-wfs图层表 */
  Consts.TAB_WFS = 32
  /** * @property {Number}  TAB_VECTOR            33-vector矢量图层表 */
  Consts.TAB_VECTOR = 33
  /** * @property {Number}  TAB_VIEWPORT          34-地图视图表 */
  Consts.TAB_VIEWPORT = 34
  /** * @property {Number}  TAB_REGION            35-区域表 */
  Consts.TAB_REGION = 35
  /** * @property {Number}  TAB_LAYER             36-图层表 */
  Consts.TAB_LAYER = 36
  /** * @property {Number}  TAB_MAPARA            37-制图参数表 */
  Consts.TAB_MAPARA = 37
  /** * @property {Number}  TAB_LOGINLOG          38-登录日志表 */
  Consts.TAB_LOGINLOG = 38
  /** * @property {Number}  TAB_OPERLOG           39-操作日志表 */
  Consts.TAB_OPERLOG = 39
  /** * @property {Number}  TAB_SYSGROUP          40-系统组 */
  Consts.TAB_SYSGROUP = 40
  /** * @property {Number}  TAB_USERGROUP         41-用户组关联 */
  Consts.TAB_USERGROUP = 41
  /** * @property {Number}  TAB_MEDIA             45-附件 */
  Consts.TAB_MEDIA = 45
  /** * @property {Number}  TAB_USERSQL           47-自定义SQL */
  Consts.TAB_USERSQL = 47
  /** * @property {Number}  TAB_CODERULE          48-编码规范 */
  Consts.TAB_CODERULE = 48
  /** * @property {Number}  TAB_ZYTREE            49-资源树 */
  Consts.TAB_ZYTREE = 49

  /** * @property {Number}  TAB_PROCS             61-流程 */
  Consts.TAB_PROCS = 61
  /** * @property {Number}  TAB_DELEGATE          62-委办 */
  Consts.TAB_DELEGATE = 62
  /** * @property {Number}  TAB_PROCASSI          63-流程人员 */
  Consts.TAB_PROCASSI = 63
  /** * @property {Number}  TAB_PROCCOMP          65-流程结案通知 */
  Consts.TAB_PROCCOMP = 65

  /** 兼容老代码 */
  Consts.ORGAN = 12
  Consts.USER1 = 13
  Consts.SYSUSER = 14
  Consts.SYSROLE = 15
  Consts.USERROLE = 16
  Consts.USERDEP = 17
  Consts.ROLEOBJ = 18
  Consts.SYSGROUP = 19
  Consts.USERGROUP = 41
  Consts.MEDIA = 45

  /** * @property {Number}  ALIGN_LEFT            -1-水平左对齐 */
  Consts.ALIGN_LEFT = -1
  /** * @property {Number}  ALIGN_CENTER          0-水平居中对齐 */
  Consts.ALIGN_CENTER = 0
  /** * @property {Number}  ALIGN_RIGHT           1-水平右对齐 */
  Consts.ALIGN_RIGHT = 1
  /** * @property {Number}  ALIGN_TOP             -1-垂直上对齐 */
  Consts.ALIGN_TOP = -1
  /** * @property {Number}  ALIGN_MIDDLE          0-垂直居中对齐 */
  Consts.ALIGN_MIDDLE = 0
  /** * @property {Number}  ALIGN_BOTTOM          1-垂直底对齐 */
  Consts.ALIGN_BOTTOM = 1

  /** * @property {String}  RUN_VUE               1-运行环境-VUE */
  Consts.RUN_VUE = 1

  /** * @property {String}  SCENE_2D              1-二维场景 */
  Consts.SCENE_2D = 1
  /** * @property {String}  SCENE_3D              2-三维场景 */
  Consts.SCENE_3D = 2
  /** * @property {String}  SCENE_23D             3-二三维场景 */
  Consts.SCENE_23D = 3

  /** * @property {String}  REG_NORTH             0-布局-north */
  Consts.REG_NORTH = 0
  /** * @property {String}  REG_WEST              1-布局-west */
  Consts.REG_WEST = 1
  /** * @property {String}  REG_EAST              2-布局-east */
  Consts.REG_EAST = 2
  /** * @property {String}  REG_SOUTH             3-布局-south */
  Consts.REG_SOUTH = 3
  /** * @property {String}  REG_CENTER            4-布局-center */
  Consts.REG_CENTER = 4

  /** * @property {String}  THISMONTH             1-本月 */
  Consts.THISMONTH = 1
  /** * @property {String}  LASTMONTH             2-上月 */
  Consts.LASTMONTH = 2
  /** * @property {String}  NEXTMONTH             3-下月 */
  Consts.NEXTMONTH = 3

  /** * @property {String}  LEVEL_NORMAL          1-正常 */
  Consts.LEVEL_NORMAL = 1
  /** * @property {String}  LEVEL_SAFE            2-安全 */
  Consts.LEVEL_SAFE = 2
  /** * @property {String}  LEVEL_WARN            3-警告 */
  Consts.LEVEL_WARN = 3
  /** * @property {String}  LEVEL_DANGER          4-危险 */
  Consts.LEVEL_DANGER = 4
  /** * @property {String}  LEVEL_EMPHASIZE       5-强调 */
  Consts.LEVEL_EMPHASIZE = 5

  /** * @property {String}  TEXT_SEPARATOR        ':@:'-内容分隔符 */
  Consts.TEXT_SEPARATOR = ':@:'
  /** * @property {String}  TEXT_NULLVAL          'null'-空值的替代值 */
  Consts.TEXT_NULLVAL = 'null'
  /** * @property {String}  TEXT_COMPLETED        '■'-'已完成'-显示值 */
  Consts.TEXT_COMPLETED = '■'

  /** * @property {Number}  PAGE_SIZE             25-默认每页数据量 */
  Consts.PAGE_SIZE = 25
  /** * @property {Array}   PAGE_SIZES            [10, 25, 50, 100]-分页页面大小数组 */
  Consts.PAGE_SIZES = [10, 25, 50, 100]

  /** * @property {Number}  NULL                  0 */
  Consts.NULL = 0
  /** * @property {Number}  PAGE_SIZE             'px' */
  Consts.PX = 'px'

  /** * @property {String}  ATT_WIDTH_VAL         属性输入框的宽度，300px */
  Consts.ATT_WIDTH_VAL = '300px'

  /**
   * cx.date
   * 类-date处理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var DateCx = (function()
  {
    function DateCx()
    {
      classCallCheck(this, DateCx)
    }

    createClass(DateCx, null, [{
      key: 'parse',

      /**
       * 把字符串解析成日期格式
       * @static
       * @method
       * @param   {String}    str         支持格式:YYYY-MM-DD  MM/DD/YYYY  YYYY年MM月DD日
       * @returns {Date}
       */
      value: function parse(str)
      {
        var len = str.indexOf(' ')
        var matches = void 0

        len = len > 0 ? len : str.length
        str = str.substring(0, len)

        matches = str.match(/([\d]+)-([\d]+)-([\d]+)/i) // 2020-11-06
        if (!matches) matches = str.match(/([\d]+)年([\d]+)月([\d]+)日/i) // 2020年11月05日
        if (!matches) matches = str.match(/([\d]+)\/([\d]+)\/([\d]+)/i) // 11/06/2020

        if (matches && matches.length === 4)
        {
          var _date = void 0

          if (matches[1].length < 4) _date = new Date(parseInt(matches[3]), parseInt(matches[1]) - 1, parseInt(matches[2])); else _date = new Date(parseInt(matches[1]), parseInt(matches[2]) - 1, parseInt(matches[3]))

          return _date
        }
      }

      /**
       * 日期增加指定的天数
       * @static
       * @method
       * @param   {Date}    _date
       * @param   {Number}  nDays    天数
       * @returns {Date}
       */

    }, {
      key: 'addDays',
      value: function addDays(_date, nDays)
      {
        var newDate = new Date()
        newDate.setTime(_date.getTime() + nDays * 86400000) // = 24 * 60 * 60 * 1000
        return newDate
      }

      /**
       * 拷贝对象
       * @static
       * @method
       * @param   {Date}      date            日期对象
       * @returns {Date}
       */

    }, {
      key: 'copy',
      value: function copy(date)
      {
        var newDate = new Date()

        newDate.setTime(date.getTime())
        newDate.setHours(0)
        newDate.setMinutes(0)
        newDate.setSeconds(0)
        newDate.setMilliseconds(0)

        return newDate
      }
      /**
       * 判断两个日期相差的天数, 用date2减date1
       * @static
       * @method
       * @param   {Date|String}    date1         时间1
       * @param   {Date|String}    date2         时间2
       * @param   {Boolean}        [isAbs=true]  是否返回差值的绝对值
       * @returns {Number}                       相差的天数
       */

    }, {
      key: 'diffDays',
      value: function diffDays(date1, date2)
      {
        var isAbs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true

        var diff = Math.floor((new Date(date2) - new Date(date1)) / (1000 * 60 * 60 * 24))
        return isAbs ? Math.abs(diff) : diff
      }

      /**
       * 判断两个日期相差的天数，用date1 - date2
       * @static
       * @method
       * @param   {Date}    date1     时间1
       * @param   {Date}    date2     时间2
       * @returns {Number}            相差的天数
       */

    }, {
      key: 'diffDat',
      value: function diffDat(date1, date2)
      {
        return (date1 - date2) / 86400000
      }

      /**
       * 判断两个日期是否相等
       * @static
       * @method
       * @param   {Date}      date1
       * @param   {Date}      date2
       * @returns {Boolean}
       */

    }, {
      key: 'equals',
      value: function equals(date1, date2)
      {
        return date1.getYear() === date2.getYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()
      }

      /**
       * 获取某年+月的天数
       * @static
       * @method
       * @param   {Object}    argvs       可变参数
       * @returns {Number}                天数
       *     参数方式1：
       *        {Number} year 年份
       *        {Number} month 月份
       *
       *     参数方式2：
       *        {Data} date 日期对象
       */

    }, {
      key: 'getDaysByMonth',
      value: function getDaysByMonth()
      {
        var days = { 1: 31, 3: 31, 4: 30, 5: 31, 6: 30, 7: 31, 8: 31, 9: 30, 10: 31, 11: 30, 12: 31 }
        var year = null
        var month = null

        for (var _len = arguments.length, argvs = Array(_len), _key = 0; _key < _len; _key++)
        
          argvs[_key] = arguments[_key]
        

        if (argvs.length === 1 && argvs[0] instanceof Date)
        {
          year = argvs[0].getFullYear()
          month = argvs[0].getMonth() + 1
        }
        else if (argvs.length === 2)
        {
          year = argvs[0]
          month = argvs[1]
        }
        if (month === 2)
        
          if (this.isLeapYear(year)) return 29; else return 28
        
        return days[month]
      }

      /**
       * 获取本周的起止日期
       * @static
       * @method
       * @returns {Object}                结果
       * @returns {Object.monday}         起始日期，周一，yyyy-mm-dd 00:00:00
       * @returns {Object.sunday}         终止日期，周日，yyyy-mm-dd 23:59:59
       */

    }, {
      key: 'getDatesCurWeek',
      value: function getDatesCurWeek()
      {
        var date = new Date()
        var curY = date.getFullYear()
        var curM = date.getMonth()
        var curD = date.getDate()
        var day = date.getDay()
        if (day === 0) day = 7

        var start = new Date(curY, curM, curD, 0, 0, 0)
        var end = new Date(curY, curM, curD, 23, 59, 59)

        var dayTime = 24 * 60 * 60 * 1000 //一天的毫秒数
        var mondayTime = start.getTime() - (day - 1) * dayTime //周一
        var sundayTime = end.getTime() + (6 - (day - 1)) * dayTime //周日

        return { monday: new Date(mondayTime), sunday: new Date(sundayTime) }
      }
      /**
       * 获取上周的起止日期
       * @static
       * @method
       * @returns {Object}                结果
       * @returns {Object.monday}         起始日期，周一，yyyy-mm-dd 00:00:00
       * @returns {Object.sunday}         终止日期，周日，yyyy-mm-dd 23:59:59
       */

    }, {
      key: 'getDatesPreWeek',
      value: function getDatesPreWeek()
      {
        var date = new Date()
        var curY = date.getFullYear()
        var curM = date.getMonth()
        var curD = date.getDate()
        var day = (date.getDay() || 7) + 7

        var start = new Date(curY, curM, curD, 0, 0, 0)
        var end = new Date(curY, curM, curD, 23, 59, 59)

        var dayTime = 24 * 60 * 60 * 1000 //一天的毫秒数
        var mondayTime = start.getTime() - (day - 1) * dayTime //周一
        var sundayTime = end.getTime() + (6 - (day - 1)) * dayTime //周日

        return { monday: new Date(mondayTime), sunday: new Date(sundayTime) }
      }
      /**
       * 获取本月的起止日期
       * @static
       * @method
       * @returns {Object}                结果
       * @returns {Object.first}          起始日期，1号，yyyy-mm-dd 00:00:00
       * @returns {Object.last}           终止日期，30或31号，yyyy-mm-dd 23:59:59
       */

    }, {
      key: 'getDatesCurMonth',
      value: function getDatesCurMonth()
      {
        var date = new Date()
        var curY = date.getFullYear()
        var curM = date.getMonth()

        var start = new Date(curY, curM, 1, 0, 0, 0)
        var end = new Date(curY, curM + 1, 0, 23, 59, 59)
        // let oneDay = 1000 * 60 * 60 * 24
        // let nextMonthFirstDay = new Date(curY, curM + 1, 1, 23, 59, 59)
        // let last = new Date(nextMonthFirstDay - oneDay)

        return { first: start, last: end }
      }

      /**
       * 获取上月的起止日期
       * @static
       * @method
       * @returns {Object}                结果
       * @returns {Object.first}          起始日期，1号，yyyy-mm-dd 00:00:00
       * @returns {Object.last}           终止日期，30或31号，yyyy-mm-dd 23:59:59
       */

    }, {
      key: 'getDatesPreMonth',
      value: function getDatesPreMonth()
      {
        var date = new Date()
        var curY = date.getFullYear()
        var curM = date.getMonth()

        curM--
        if (curM < 0)
        {
          curM = 12
          curY = curY - 1
        }
        var start = new Date(curY, curM, 1, 0, 0, 0)
        var end = new Date(curY, curM + 1, 0, 23, 59, 59)

        return { first: start, last: end }
      }

      /**
       * 获取当天算起的近一周起止日期
       * @static
       * @method
       * @returns {Object}                结果
       * @returns {Object.start}          起始日期，如yyyy-mm-10 00:00:00
       * @returns {Object.end}            终止日期，如yyyy-mm-17 23:59:59
       */

    }, {
      key: 'getNearWeek',
      value: function getNearWeek()
      {
        var date = new Date()
        var curY = date.getFullYear()
        var curM = date.getMonth()
        var curD = date.getDate()

        var start = new Date(curY, curM, curD, 0, 0, 0)
        var end = new Date(curY, curM, curD, 23, 59, 59)
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)

        return { start: start, end: end }
      }
      /**
       * 获取当天算起的近一月起止日期，一月30天算
       * @static
       * @method
       * @returns {Object}                结果
       * @returns {Object.start}          起始日期，如yyyy-mm-1 00:00:00
       * @returns {Object.end}            终止日期，如yyyy-mm-30 23:59:59
       */

    }, {
      key: 'getNearMonth',
      value: function getNearMonth()
      {
        var date = new Date()
        var curY = date.getFullYear()
        var curM = date.getMonth()
        var curD = date.getDate()

        var start = new Date(curY, curM, curD, 0, 0, 0)
        var end = new Date(curY, curM, curD, 23, 59, 59)
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)

        return { start: start, end: end }
      }
      /**
       * 获取当天算起的近三个月起止日期，一月30天算
       * @static
       * @method
       * @returns {Object}                结果
       * @returns {Object.start}          起始日期，如yyyy-mm-dd 00:00:00
       * @returns {Object.end}            终止日期，如yyyy-mm-dd 23:59:59
       */

    }, {
      key: 'getNearThreeMonth',
      value: function getNearThreeMonth()
      {
        var date = new Date()
        var curY = date.getFullYear()
        var curM = date.getMonth()
        var curD = date.getDate()

        var start = new Date(curY, curM, curD, 0, 0, 0)
        var end = new Date(curY, curM, curD, 23, 59, 59)
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        return { start: start, end: end }
      }

      /**
       * 给出到期日
       * @static
       * @method
       * @param   {Date}        date            日期
       * @param   {Number}      years           年数数量
       * @param   {Number}      monthes         月份数量
       */

    }, {
      key: 'getExpire',
      value: function getExpire(date, years, monthes)
      {
        var year = date.getFullYear() + years
        var month = date.getMonth() + 1 + monthes
        var day = date.getDate()
        var isLeap = false

        //月份数量超过12则递增年
        while (month > 13)
        {
          year++
          month -= 12
        }
        while (month < 1)
        {
          year--
          month += 12
        }

        //2月需要考虑闰月
        if (month === 2 && day === 29)
        {
          isLeap = this.isLeapYear(year)
          if (isLeap) day = 28
        }

        var newDay = new Date(year + '-' + month + '-' + day)

        if (isLeap) return newDay

        return this.addDays(newDay, -1)
      }

      /**
       * 取时间范围
       * @static
       * @method
       * @param   {Number}    type              类型(cx.consts.THISMONTH, LASTMONTH,...)
       * @param   {Array}
       */

    }, {
      key: 'getRange',
      value: function getRange(type)
      {
        var now = new Date()
        var year = void 0,
          month = void 0,
          days = void 0,
          first = void 0,
          last = void 0

        switch (type)
        {
        case Consts.THISMONTH:
        case Consts.LASTMONTH:
        case Consts.NEXTMONTH:
          year = now.getFullYear()
          switch (type)
          {
          case Consts.THISMONTH:
            month = now.getMonth() + 1
            break
          case Consts.LASTMONTH:
            month = now.getMonth()
            if (month === 0)
            {
              year--
              month = 12
            }
            break
          case Consts.NEXTMONTH:
            month = now.getMonth() + 2
            if (month === 13)
            {
              year++
              month = 1
            }
            break
          }
          first = year + '-' + (month >= 10 ? month : '0' + month) + '-01'
          last = year + '-' + (month >= 10 ? month : '0' + month) + '-' + days
          break
        }
        return [first, last]
      }

      /**
       * 判断字符串是否是日期格式
       * @static
       * @method
       * @param   {String}    str
       * @returns {boolean}
       */

    }, {
      key: 'isDate',
      value: function isDate(str)
      {
        if (str)
        {
          var arrs = void 0
          arrs = str.split('-')
          if (arrs.length === 3) return true
          arrs = str.split('/')
          if (arrs.length === 3) return true
        }
        return false
      }

      /**
       * 判断date是否在date1与date2之间
       * @static
       * @method
       * @param   {Date}      _date   要判断的日期对象
       * @param   {Date}      date1   基准日期对象A
       * @param   {Date}      date2   基准日期对象B
       * @returns {Boolean}
       */

    }, {
      key: 'isIn',
      value: function isIn(_date, date1, date2)
      {
        return _date >= date1 && _date <= date2
      }

      /**
       * 判断是否位闰年
       * @static
       * @method
       * @param   {Number|String} year      待判断的年份或日期对象
       * @returns {Boolean}                 判断结果
       */

    }, {
      key: 'isLeapYear',
      value: function isLeapYear(year)
      {
        year = parseInt(year)
        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)
      }

      /**
       * 取今天
       * @static
       * @method
       * @returns {Date}
       */

    }, {
      key: 'today',
      value: function today()
      {
        var now = new Date()

        now.setHours(0)
        now.setMinutes(0)
        now.setSeconds(0)
        now.setMilliseconds(0)

        return now
      }
      /**
       * 把日期(Date)转化成数据库格式
       * @static
       * @method
       * @param  {Date|String}  _date  日期(Date)或字符串，如2014-1-1
       * @returns  {String}
       */

    }, {
      key: 'toSqlDate',
      value: function toSqlDate(_date)
      {
        var str = cx.formatter.dateDb(_date)
        switch (Global.syscfg.dbType)
        {
        case Consts.DB_ORACLE:
          return 'TO_DATE(\'' + str + '\',\'yyyy-mm-dd\')' //2014-01-01
        case Consts.DB_MYSQL:
          return 'STR_TO_DATE(\'' + str + '\',\'%Y-%m-%d\')' //2014-01-01
        case Consts.DB_POSTGRESQL:
          return 'TO_DATE(\'' + str + '\',\'yyyy-mm-dd\')' //2014-01-01
        }
        return ''
      }

      /**
       * 把日期时间(Date)转化成数据库格式
       * @static
       * @method
       * @param  {Date|String}  datetime  日期时间(Date)
       * @returns  {String}
       */

    }, {
      key: 'toSqlDatetime',
      value: function toSqlDatetime(datetime)
      {
        var str = cx.formatter.datetimeDb(datetime)
        switch (Global.syscfg.dbType)
        {
        case Consts.DB_ORACLE:
          return 'TO_DATE(\'' + str + '\',\'yyyy-mm-dd hh24:mi:ss\')' //2014-01-01 13:01:01
        case Consts.DB_MYSQL:
          return 'STR_TO_DATE(\'' + str + '\',\'%Y-%m-%d %T\')' //2014-01-01 13:01:01
        case Consts.DB_POSTGRESQL:
          return 'TO_TIMESTAMP(\'' + str + '\',\'YYYY-MM-DD hh24:mi:ss\')' //2014-01-01 13:01:01
        }
        return ''
      }

      /**
       * 取数据库中取当前时间的函数
       * @static
       * @method
       * @returns {String}
       */

    }, {
      key: 'sqlNow',
      value: function sqlNow()
      {
        switch (Global.syscfg.dbType)
        {
        case Consts.DB_ORACLE:
          return 'SYSDATE'
        case Consts.DB_MYSQL:
          return 'NOW()'
        case Consts.DB_POSTGRESQL:
          return 'NOW()'
        case Consts.DB_MSSQL:
          return 'GETDATE()'
        }
        return ''
      }
    }])
    return DateCx
  }())

  /**
   * cx.datetime
   * 类-datetime处理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var Datetime = (function()
  {
    function Datetime()
    {
      classCallCheck(this, Datetime)
    }

    createClass(Datetime, null, [{
      key: 'parse',

      /**
       * 根据字符串解析日期+时间(格式: 2017-10-26 09:00:00)(IE的Date类不能识别Timestamp字符串，切记!!)
       * @static
       * @method
       * @param   {String}    str         日期+时间字符串
       * @returns {Date}
       */
      value: function parse(str)
      {
        if (!RegEx.timestamp.test(str)) return null

        var matches = str.match(RegEx.timestamp)
        var _datetime = new Date(matches[1] + '-' + matches[2] + '-' + matches[3])
        _datetime.setHours(parseInt(matches[4]))
        _datetime.setMinutes(parseInt(matches[5]))
        _datetime.setSeconds(parseInt(matches[6]))
        _datetime.setMilliseconds(0)
        return _datetime
      }

      /**
       * 拷贝对象
       * @static
       * @method
       * @param   {Date}      timestamp       Timestamp对象
       * @returns {Date}
       */

    }, {
      key: 'copy',
      value: function copy(timestamp)
      {
        var newDate = new Date()
        newDate.setTime(timestamp.getTime())
        return newDate
      }

      /**
       * 按照年+月给出时间范围
       * @static
       * @method
       * @param   {Date}      timestamp       Timestamp对象
       * @returns {Date}
       */

    }, {
      key: 'rangeMonth',
      value: function rangeMonth(year, month)
      {
        var days = DateCx.getDaysByMonth(year, month)
        return [year + '-' + (month >= 10 ? month : '0' + month) + '-01 00:00:00', year + '-' + (month >= 10 ? month : '0' + month) + '-' + days + ' 23:59:59']
      }

      /**
       * 取时间范围
       * @static
       * @method
       * @param   {Number}    type              类型(cx.consts.THISMONTH, LASTMONTH,...)
       * @param   {Array}
       */

    }, {
      key: 'getRange',
      value: function getRange(type)
      {
        var now = new Date()
        var year = void 0,
          month = void 0

        switch (type)
        {
        case Consts.THISMONTH:
        case Consts.LASTMONTH:
        case Consts.NEXTMONTH:
          year = now.getFullYear()
          switch (type)
          {
          case Consts.THISMONTH:
            month = now.getMonth() + 1
            break
          case Consts.LASTMONTH:
            month = now.getMonth()
            if (month === 0)
            {
              year--
              month = 12
            }
            break
          case Consts.NEXTMONTH:
            month = now.getMonth() + 2
            if (month === 13)
            {
              year++
              month = 1
            }
            break
          }
          return this.rangeMonth(year, month)
        }
        return null
      }
    }])
    return Datetime
  }())

  /**
   * cx.formatter
   * 类-格式化
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var Formatter = (function()
  {
    function Formatter()
    {
      classCallCheck(this, Formatter)
    }

    createClass(Formatter, [{
      key: 'formatJsonTxt',


      /**
       * 序列化处理json对象，返回格式化后的文本
       * @static
       * @method
       * @param {Object} json
       * @returns {String}
       */
      value: function formatJsonTxt(json)
      {
        var formatted = '' //转换后的json字符串
        var padIdx = 0 //换行后是否增减PADDING的标识
        var PADDING = '    ' //4个空格符

        //将对象转化为string
        if (typeof json !== 'string') json = JSON.stringify(json)

        /**
         * 利用正则类似将{'name':'ccy','age':18,'info':['address':'wuhan','interest':'playCards']}
         * ---> \r\n{\r\n'name':'ccy',\r\n'age':18,\r\n
         * 'info':\r\n[\r\n'address':'wuhan',\r\n'interest':'playCards'\r\n]\r\n}\r\n
         */
        json = json.replace(/([\{\}])/g, '\r\n$1\r\n').replace(/([\[\]])/g, '\r\n$1\r\n').replace(/(\,)/g, '$1\r\n').replace(/(\r\n\r\n)/g, '\r\n').replace(/\r\n\,/g, ',')

        /**
         * 根据split生成数据进行遍历，一行行判断是否增减PADDING
         */
        json.split('\r\n').forEach(function(node, index)
        {
          var indent = 0
          var padding = ''
          if (node.match(/\{$/) || node.match(/\[$/)) indent = 1; else if (node.match(/\}/) || node.match(/\]/)) padIdx = padIdx !== 0 ? --padIdx : padIdx; else indent = 0

          for (var i = 0; i < padIdx; i++)
          
            padding += PADDING
          formatted += padding + node + '\r\n'
          padIdx += indent
          // console.log('index:' + index + ',indent:' + indent + ',padIdx:' + padIdx + ',node-->' + node)
        })
        return formatted
      }

      /**
       * 序列化处理json对象，返回可在html中格式化成展示的文本
       * @static
       * @method
       * @param {Object} json
       * @returns {String}
       */

    }, {
      key: 'formatJsonHtml',
      value: function formatJsonHtml(json)
      {
        var formatted = '' //转换后的json字符串
        var padIdx = 0 //换行后是否增减PADDING的标识
        var PADDING = '&nbsp&nbsp&nbsp&nbsp' //4个空格符

        //将对象转化为string
        if (typeof json !== 'string') json = JSON.stringify(json)

        /**
         * 利用正则类似将{'name':'ccy','age':18,'info':['address':'wuhan','interest':'playCards']}
         * ---> \r\n{\r\n'name':'ccy',\r\n'age':18,\r\n
         * 'info':\r\n[\r\n'address':'wuhan',\r\n'interest':'playCards'\r\n]\r\n}\r\n
         */
        json = json.replace(/([\{\}])/g, '<br>$1<br>').replace(/([\[\]])/g, '<br>$1<br>').replace(/(\,)/g, '$1<br>').replace(/(<br><br>)/g, '<br>').replace(/<br>\,/g, ',')

        /**
         * 根据split生成数据进行遍历，一行行判断是否增减PADDING
         */
        json.split('<br>').forEach(function(node, index)
        {
          var indent = 0
          var padding = ''
          if (node.match(/\{$/) || node.match(/\[$/)) indent = 1; else if (node.match(/\}/) || node.match(/\]/)) padIdx = padIdx !== 0 ? --padIdx : padIdx; else indent = 0

          for (var i = 0; i < padIdx; i++)
          
            padding += PADDING
          formatted += padding + node + '<br>'
          padIdx += indent
          // console.log('index:' + index + ',indent:' + indent + ',padIdx:' + padIdx + ',node-->' + node)
        })
        return formatted
      }
    }], [{
      key: 'lengthNum',

      /**
       * 折线显示长度
       * @static
       * @method
       * @param   {Object}    line                线
       * @returns {String}
       */
      // static length(line)
      // {
      //   let geom = line
      //   if ($g.syscfg.srsUnit !== 'm')
      //   {
      //     geom = line.clone()
      //     geom.transform('EPSG:' + $g.syscfg.srsSys, 'EPSG:3857')
      //   }
      //   let length = Math.round(geom.getLength() * 100) / 100
      //   let output
      //   if (length > 1000)
      //     output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km'
      //   else
      //     output = (Math.round(length * 100) / 100) + ' ' + 'm'
      //   return output
      // }

      /**
       * 折线显示长度字符串
       * @static
       * @method
       * @param   {Object}    line        线
       * @param   {String}    unit        单位(km, m)
       * @returns {String}
       */
      value: function lengthNum(line, unit)
      {
        var geom = line
        if (Global.syscfg.srsUnit !== 'm')
        {
          geom = line.clone()
          geom.transform('EPSG:' + Global.syscfg.srsSys, 'EPSG:3857')
        }
        var length = Math.round(geom.getLength() * 100) / 100
        var output = void 0
        switch (unit)
        {
        case 'km':
          output = Math.round(length / 1000 * 100) / 100
          break
        case 'm':
          output = Math.round(length * 100) / 100
          break
        }
        return output
      }

      /**
       * 多边形显示面积
       * @static
       * @method
       * @param   {Object}    polygon     多边形
       * @returns {String}
       */

    }, {
      key: 'area',
      value: function area(polygon)
      {
        var geom = polygon
        if (Global.syscfg.srsUnit !== 'm')
        {
          geom = polygon.clone()
          geom.transform('EPSG:' + Global.syscfg.srsSys, 'EPSG:3857')
        }
        var area = geom.getArea()
        var output = void 0
        if (area > 1000000) output = Math.round(area / 1000000 * 100) / 100 + ' ' + 'km<sup>2</sup>'; else output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>'
        return output
      }

      /**
       * 园显示半径
       * @static
       * @method
       * @param   {Object}    circle      园
       * @returns {String}
       */

    }, {
      key: 'radius',
      value: function radius(circle)
      {
        var geom = circle
        if (Global.syscfg.srsUnit !== 'm')
        {
          geom = circle.clone()
          geom.transform('EPSG:' + Global.syscfg.srsSys, 'EPSG:3857')
        }
        var length = Math.round(geom.getRadius() * 100) / 100
        var output = void 0
        if (length > 1000) output = Math.round(length / 1000 * 100) / 100 + ' ' + 'km'; else output = Math.round(length * 100) / 100 + ' ' + 'm'
        return output
      }

      /**
       * 格式化时长
       * @static
       * @method
       * @param   {Number}    durationInMillis      毫秒
       * @param   {Boolean}   [hideSecond = false]  是否隐藏显示秒
       * @returns {string}
       */

    }, {
      key: 'duration',
      value: function duration(durationInMillis, hideSecond)
      {
        var second = void 0,
          days = void 0,
          hours = void 0,
          minutes = void 0
        second = Math.floor(durationInMillis / 1000)
        days = Math.floor(second / 86400)
        second = second % 86400
        hours = Math.floor(second / 3600)
        second = second % 3600
        minutes = Math.floor(second / 60)
        second = second % 60
        return (days > 0 ? days + Base.loc('cx.days') + ' ' : '') + this.fixedInt(hours, 2) + ':' + this.fixedInt(minutes, 2) + (hideSecond ? '' : ':' + this.fixedInt(second, 2))
      }

      /**
       * 按照指定长度格式化整数,不足位数前面补0
       * @static
       * @method
       * @param   {Number}    value       值
       * @param   {Number}    len         长度
       * @returns {String}
       */

    }, {
      key: 'fixedInt',
      value: function fixedInt(value, len)
      {
        var str = '0000' + value
        return str.substr(str.length - len)
      }

      /**
       * 格式化货币数值
       * @static
       * @method
       * @param   {Number}    value       元
       * @returns {string}
       */

    }, {
      key: 'money',
      value: function money(value)
      {
        if (value === '') return value
        value = parseFloat(value)

        var arr = []
        var str = value.toFixed(2)
        var len = str.length,
          st = void 0,
          end = void 0
        var ret = ''

        end = len
        st = end - 3 //小数点及后面2位
        arr.push(str.substring(st, end))
        while (true) //3位截断
        {
          end = st
          st = end - 3
          if (st < 0) st = 0
          arr.push(str.substring(st, end))
          if (st <= 0) break
        }

        for (st = arr.length - 1; st >= 0; st--)
        {
          ret += arr[st]
          if (st >= 2) ret += ','
        }
        return ret
      }

      /**
       * 日期数据格式化成字符串(中文:YYYY-MM-DD 英文:MM/DD/YYYY)
       * @static
       * @method
       * @param   {Date|String}   date    日期
       * @returns {String}
       */

    }, {
      key: 'date',
      value: function date(_date)
      {
        if (_date)
        {
          if (typeof _date === 'string') _date = DateCx.parse(_date)
          if (Global.loc) return _date.getFullYear() + '-' + this.fixedInt(_date.getMonth() + 1, 2) + '-' + this.fixedInt(_date.getDate(), 2); else return this.fixedInt(_date.getMonth() + 1, 2) + '/' + this.fixedInt(_date.getDate(), 2) + '/' + _date.getFullYear()
        }
        return ''
      }

      /**
       * 日期数据格式化成数据库字符串(格式:YYYY-MM-DD)
       * @static
       * @method
       * @param   {Date|String}   date    日期
       * @returns {String}
       */

    }, {
      key: 'dateDb',
      value: function dateDb(date)
      {
        if (date)
        {
          if (typeof date === 'string') date = DateCx.parse(date)
          return date.getFullYear() + '-' + this.fixedInt(date.getMonth() + 1, 2) + '-' + this.fixedInt(date.getDate(), 2)
        }
        return ''
      }

      /**
       * 时间数据格式化成字符串(格式HH:MM:SS)
       * @static
       * @method
       * @param   {Date}          date                    日期时间
       * @param   {Boolean}       [hideSecond = false]    是否隐藏显示秒
       * @returns {String}
       */

    }, {
      key: 'time',
      value: function time(date, hideSecond)
      {
        return this.fixedInt(date.getHours(), 2) + ':' + this.fixedInt(date.getMinutes(), 2) + (!hideSecond ? ':' + this.fixedInt(date.getSeconds(), 2) : '')
      }

      /**
       * 日期时间数据格式化成字符串(中文:YYYY-MM-DD HH:MM:SS 英文:MM/DD/YYYY HH:MM:SS)
       * @static
       * @method
       * @param   {Date|String}   date                    日期
       * @param   {Boolean}       [hideSecond = false]    是否隐藏显示秒
       * @returns {String}
       */

    }, {
      key: 'datetime',
      value: function datetime(date, hideSecond)
      {
        if (date)
        {
          if (typeof date === 'string') date = Datetime.parse(date)
          return this.date(date) + ' ' + this.time(date, hideSecond)
        }
        return ''
      }

      /**
       * 日期时间数据格式化成字符串(格式:YYYY-MM-DD HH:MM:SS)
       * @static
       * @method
       * @param   {Date|String}   date                    日期
       * @returns {String}
       */

    }, {
      key: 'datetimeDb',
      value: function datetimeDb(date)
      {
        if (date)
        {
          if (typeof date === 'string') date = Datetime.parse(date)
          return this.dateDb(date) + ' ' + this.time(date)
        }
        return ''
      }

      /**
       * 日格式化成字符串(中文:3月26日)
       * @static
       * @method
       * @param   {Date|String}   date                    日期
       * @returns {String}
       */

    }, {
      key: 'dateLocale',
      value: function dateLocale(date)
      {
        if (date)
        {
          if (typeof date === 'string') date = Datetime.parse(date)
          return date.getMonth() + 1 + '月' + date.getDate() + '日'
        }
        return ''
      }

      /**
       * 格式化Date 成 月-日 时:分 格式
       * @static
       * @method
       * @param   {Date|String}   date                    日期
       * @returns {String}
       */

    }, {
      key: 'ymhm',
      value: function ymhm(date)
      {
        if (date)
        {
          if (typeof date === 'string') date = Datetime.parse(date)
          return this.fixedInt(date.getMonth() + 1, 2) + '-' + this.fixedInt(date.getDate(), 2) + ' ' + this.time(date, true)
        }
        return ''
      }

      /**
       * 用指定的分隔符/空值连接数组成字符串
       * @static
       * @method
       * @param   {Array}     arr                     数组
       * @param   {String}    [separator = ':@:']     分隔符
       * @param   {String}    [nullVal = 'null']      空值时的值
       * @returns {String}
       */

    }, {
      key: 'joinArray',
      value: function joinArray(arr, separator, nullVal)
      {
        var ret = ''
        separator = separator || Consts.TEXT_SEPARATOR
        nullVal = nullVal || Consts.TEXT_NULLVAL
        if (Base.isArr(arr))
        {
          var _iteratorNormalCompletion = true
          var _didIteratorError = false
          var _iteratorError = undefined

          try
          {
            for (var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
            {
              var val = _step.value

              ret += (ret ? separator : '') + ('' + val || nullVal)
            }
          }
          catch (err)
          {
            _didIteratorError = true
            _iteratorError = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion && _iterator.return)
              
                _iterator.return()
            }
            finally
            {
              if (_didIteratorError)
              
                throw _iteratorError
            }
          }
        }
        return ret
      }

      /**
       * 取文件长度字符串
       * @static
       * @method
       * @param   {Number}    filelen         文件长度
       * @returns {String}
       */

    }, {
      key: 'fileLen',
      value: function fileLen(filelen)
      {
        var k = Math.ceil(filelen / 1024)
        var m = Math.ceil(k / 1024 * 1000) / 1000
        var ret = ''
        if (filelen >= 1024 * 1024) ret += m + ' M'; else ret += k + ' K'
        return ret
      }
    }])
    return Formatter
  }())

  /**
   * cx.number
   * 类-Number
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var Number$1 = (function()
  {
    function Number()
    {
      classCallCheck(this, Number)
    }

    createClass(Number, null, [{
      key: 'is',

      /**
       * 判断是否是数值型
       * @method
       * @static
       * @param   {String}    str         字符串
       * @returns {Boolean}
       */
      value: function is(str)
      {
        if (!str) return false
        if (typeof str === 'number') return true
        return RegEx.isNumber.test(str)
      }

      /**
       * 根据字符串取数值
       * @method
       * @static
       * @param   {String}    str         字符串
       * @returns {Number}
       */

    }, {
      key: 'parse',
      value: function parse(str)
      {
        if (typeof str === 'number') return str
        if (!this.is(str)) return 0
        var pos = str.indexOf('.')
        if (pos >= 0) return parseFloat(str); else return parseInt(str)
      }

      /**
       * 根据字符串取数值
       * @method
       * @static
       * @param   {String}    str         字符串
       * @returns {Number}
       */

    }, {
      key: 'parse999',
      value: function parse999(str)
      {
        if (typeof str === 'number') return str
        if (!this.is(str)) return ''
        var pos = str.indexOf('.')
        if (pos >= 0) return parseFloat(str); else return parseInt(str)
      }
    }])
    return Number
  }())

  /**
   * cx.parser
   * 类-解析器
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-17
   */

  var Parser = (function()
  {
    function Parser()
    {
      classCallCheck(this, Parser)
    }

    createClass(Parser, null, [{
      key: 'trim',

      /**
      * 去除空格
      * @method
         * @static
      * @param   {String}    str           字符串
         * @returns {String}
      */
      value: function trim(str)
      {
        return str.replace(/(^\s*)|(\s*$)/g, '')
      }

      /**
      * 设置键值对
         * @static
      * @method
      * @param   {String}    obj           对象
      * @param   {String}    key           键
      * @param   {String}    value         值
      * @param   {Boolean}   bStr          是否是引号括起来('....')格式的字符串
      */

    }, {
      key: 'setKeyVal',
      value: function setKeyVal(obj, key, value, bStr)
      {
        key = this.trim(key)
        if (!bStr)
        {
          value = this.trim(value)
          if (value === 'true') value = true; else if (value === 'false') value = false; else if (Number$1.is(value)) value = parseFloat(value)
        }
        if (key) obj[key] = value
      }

      /**
       * 取DOM里面的data-options键值对
       * @static
       * @method
       * @param   {String}      str         配置字符串信息(如"region:'center',fit:true,gutters:true,split:true,height:32")
       * @returns {Object}
       */

    }, {
      key: 'parseOptions',
      value: function parseOptions()
      {
        var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''

        var ret = {},
          key = void 0,
          value = void 0
        var len = void 0,
          pos = void 0,
          startPos = void 0
        var isStr = void 0 //'...' 格式字符串
        var isFound = void 0

        len = str.length
        pos = 0
        while (pos < len)
        {
          key = ''
          value = null
          //开始找键
          while (pos < len && (str.charAt(pos) === ' ' || str.charAt(pos) === '\t'))
          {
            //去除空格
            pos++
          }startPos = pos
          while (pos < len && str.charAt(pos) !== ':')
          {
            pos++
          } if (str.charAt(pos) === ':')
          {
            key = str.substring(startPos, pos)
            pos++ //跳过:
            //开始找值
            while (pos < len && (str.charAt(pos) === ' ' || str.charAt(pos) === '\t'))
            {
              //去除空格
              pos++
            }isStr = false
            if (str.charAt(pos) === '\'')
            {
              isStr = true
              pos++
            }
            startPos = pos
            isFound = false
            while (pos < len && !isFound)
            {
              if (isStr)
              {
                if (str.charAt(pos) === '\'') //字符串结束了
                {
                  isFound = true
                  value = str.substring(startPos, pos)
                  this.setKeyVal(ret, key, value, true)
                  while (pos < len && str.charAt(pos) !== ',')
                  {
                    //继续找，一直找到下一个开始的位置去
                    pos++
                  }
                }
              }
              else
              {
                if (str.charAt(pos) === ',') //找到下一个键值对起点
                {
                  isFound = true
                  value = str.substring(startPos, pos)
                  this.setKeyVal(ret, key, value, false)
                }
              }
              pos++
            }
            if (!isFound && pos > startPos) //
            {
              value = str.substring(startPos, pos)
              this.setKeyVal(ret, key, value, false)
            }
          }
        }
        return ret
      }

      /**
       * 解析CSS字符串
       * @static
       * @method
       * @param   {String|Object}   str         CSS字符串(如"margin:0 2px;font-family:Microsoft Yahei;height:32px;")
       * @returns {Object}
       */

    }, {
      key: 'parseCss',
      value: function parseCss()
      {
        var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''

        if (Base.isObj(str)) return str

        var ret = {},
          key = void 0
        var arr1 = void 0,
          arr2 = void 0

        arr1 = str.split(';')
        for (i = 0; i < arr1.length; i++)
        {
          arr2 = arr1[i].split(':')
          if (arr2.length === 2)
          {
            key = this.trim(arr2[0])
            if (key) ret[key] = this.trim(arr2[1])
          }
        }
        return ret
      }
    }])
    return Parser
  }())

  /**
   * cx.AttBase
   * 类-属性对象
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-17
   */

  /**
   * 修改说明:
   * 2020-06-22  张发勇  makeInput 增加了默认的 ID 字段，因为有的地方需要引用 ID。
   *
   */

  var AttBase = (function()
  {
    /**
     * @constructor
     * @param {Object}    options
     * @param {String}    [options.tabname]         表名 (不传的时候，必须提供 flds + fldVals)
     * @param {Array}     [options.flds]            字段列表
     * @param {Array}     [options.fldVals]         字段列值表
     */
    function AttBase()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, AttBase)

      /** *@property  {Array}       flds            字段列表 */
      /** *@property  {Array}       fldVals         字段列值表*/
      /** *@property  {Object}      att             属性对象 */
      /** *@property  {Boolean}     isNew           是否新属性 */

      this.flds = options.flds
      this.fldVals = options.fldVals
      this.att = {}
      this.isNew = true

      //初始化
      if (!this.flds && options.tabname) this.flds = Global.field.getFlds(options.tabname)
    }

    /**
     * 根据表名和字段名获取字段值序列
     * @method
     * @param {String}      tabname   表名
     * @param {String}      colname   字段名
     * @returns {Array.<Object>}      字段值对象属性
     */


    createClass(AttBase, [{
      key: 'getFldVals',
      value: function getFldVals(tabname, colname)
      {
        var ret = []

        if (this.fldVals) ret = Array$1.gets(this.fldVals, { tabname: tabname, colname: colname })

        if (ret.length < 1 && tabname) ret = Global.field.getFldvalues(tabname, colname)

        return ret
      }

      /**
       * 取数据库中字段默认值，不存在时数字型为0
       * @method
       * @returns {Object}      默认对象属性
       */

    }, {
      key: 'getDefVal',
      value: function getDefVal()
      {
        var att = {}
        var fld = void 0,
          value = void 0,
          opts = void 0

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.flds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            fld = _step.value

            value = ''
            if (fld.defval)
            {
              switch (fld.defval)
              {
              case '${userid}':
                value = Global.user.id; break
              case '${userno}':
                value = Global.user.no; break
              case '${username}':
                value = Global.user.name; break
              case '${sys}':
                value = Global.user.sys; break
              case '${today}':
                value = Formatter.dateDb(Global.loginTime ? Global.loginTime : new Date())
                break
              case '${now}':
                value = Formatter.datetimeDb(Global.loginTime ? Global.loginTime : new Date())
                break
              default:
                value = fld.defval
                break
              }
            }
            else
            {
              switch (fld.disptype)
              {
              case Consts.DISP_LIST:
                opts = this.getFldVals(fld.tabname, fld.colname)
                if (opts && opts.length > 0) value = opts[0].dbvalue
                break
              case Consts.DISP_SELDEPPOS:
                opts = this.getFldVals(fld.tabname, fld.colname)
                var opt = Array$1.get1(opts, { dbvalue: 'BS' })
                var config = Parser.parseOptions(Base.locale(opt.dispc, opt.dispe))
                if (config.select === 'department')
                {
                  opts = Global.init.user.organs
                  if (opts && opts.length > 0) value = opts[0][config.field]
                }
                else if (config.select === 'position')
                {
                  opts = Global.init.user.organs
                  if (opts && opts.length > 0) value = opts[0].position
                }
                break
              }
            }

            //转换成数值
            if (fld.isnum && value) value = parseInt(value)

            att[fld.colname] = value
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return att
      }

      /**
       * 取数据库中字段默认值，不存在时都默认为空
       * @method
       * @returns {Object}       默认对象属性
       */

    }, {
      key: 'getDefValExp',
      value: function getDefValExp()
      {
        var att = {}
        var _iteratorNormalCompletion2 = true
        var _didIteratorError2 = false
        var _iteratorError2 = undefined

        try
        {
          for (var _iterator2 = this.flds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
          {
            var fld = _step2.value

            att[fld.colname] = ''
            if (fld.defval)
            
              if (fld.isnum) att[fld.colname] = Number$1.parse(fld.defval); else att[fld.colname] = fld.defval
          }
        }
        catch (err)
        {
          _didIteratorError2 = true
          _iteratorError2 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion2 && _iterator2.return)
            
              _iterator2.return()
          }
          finally
          {
            if (_didIteratorError2)
            
              throw _iteratorError2
          }
        }

        return att
      }

      /**
       * 将属性里面的数值字段值(字符串)数值化
       * @method
       * @param  {Object}  att      属性值
       */

    }, {
      key: 'numberize',
      value: function numberize(att)
      {
        var _iteratorNormalCompletion3 = true
        var _didIteratorError3 = false
        var _iteratorError3 = undefined

        try
        {
          for (var _iterator3 = this.flds[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)
          {
            var fld = _step3.value

            if (fld.isnum)
            {
              if (typeof att[fld.colname] === 'string')
              
                if (att[fld.colname]) att[fld.colname] = parseFloat(att[fld.colname]); else att[fld.colname] = ''
            }
          }
        }
        catch (err)
        {
          _didIteratorError3 = true
          _iteratorError3 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion3 && _iterator3.return)
            
              _iterator3.return()
          }
          finally
          {
            if (_didIteratorError3)
            
              throw _iteratorError3
          }
        }
      }

      /**
       * 判断是否改变
       * @method
       * @param   {Object}    att       属性
       * @returns {Boolean}
       */

    }, {
      key: 'changed',
      value: function changed(att)
      {
        for (var key in att)
        
          if (att[key] != this.att[key]) return true
        
        return false
      }

      /**
       * 将属性转换成显示用的属性,主要针对下拉显示和时间数据
       * @method
       * @param   {Object}      att               列名
       */

    }, {
      key: 'getDisp',
      value: function getDisp(att)
      {
        var fld = void 0,
          val = void 0

        var _iteratorNormalCompletion4 = true
        var _didIteratorError4 = false
        var _iteratorError4 = undefined

        try
        {
          for (var _iterator4 = this.flds[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true)
          {
            fld = _step4.value

            //仅当字段显示时，把Object转为字符串
            val = att[fld.colname]
            if (fld.disporder > 0 && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object')
            {
              att[fld.colname] = JSON.stringify(val)
              val = att[fld.colname]
            }

            switch (fld.disptype)
            {
            case Consts.DISP_LIST:
            case Consts.DISP_SELDYNA:
            case Consts.DISP_DROPDOWN:
              var opts = this.getFldVals(fld.tabname, fld.colname)
              if (opts)
              {
                var _iteratorNormalCompletion5 = true
                var _didIteratorError5 = false
                var _iteratorError5 = undefined

                try
                {
                  for (var _iterator5 = opts[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true)
                  {
                    var opt = _step5.value

                    if (opt.dbvalue == val)
                    {
                      val = Base.locale(opt.dispc, opt.dispe)
                      break
                    }
                  }
                }
                catch (err)
                {
                  _didIteratorError5 = true
                  _iteratorError5 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion5 && _iterator5.return)
                    
                      _iterator5.return()
                  }
                  finally
                  {
                    if (_didIteratorError5)
                    
                      throw _iteratorError5
                  }
                }
              }
              att['_' + fld.colname] = val
              break
            case Consts.DISP_DATE:
              if (val) val = Formatter.date(DateCx.parse(val))
              att['_' + fld.colname] = val
              break
            case Consts.DISP_TIMESTAMP:
              val = att[fld.colname]
              if (val) val = Formatter.datetime(Datetime.parse(val))
              att['_' + fld.colname] = val
              break
            }
          }
        }
        catch (err)
        {
          _didIteratorError4 = true
          _iteratorError4 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion4 && _iterator4.return)
            
              _iterator4.return()
          }
          finally
          {
            if (_didIteratorError4)
            
              throw _iteratorError4
          }
        }
      }

      /**
       * 初始化数据输入值
       * @method
       * @param   {Array}       flds              所有字段信息
       */

    }, {
      key: 'initFlds',
      value: function initFlds(flds)
      {}

      /**
       * 消息响应函数-字段值发生变化
       * @method
       * @param   {Array}       flds              所有字段信息
       * @param   {Object}      fld               发生变化的字段
       */

    }, {
      key: 'onChange',
      value: function onChange(flds, fld)
      {}

      /**
       * 下拉选项过滤函数
       * @method
       * @param   {Array}       options           下拉选项数组
       * @param   {Object}      fld               字段信息
       */

    }, {
      key: 'filterOptions',
      value: function filterOptions(options, fld)
      {}

      /**
       * 检查数据是否符合要求
       * @method
       * @param   {Array}       flds              所有字段信息
       * @returns {Boolean | String}              符合要求返回true,不符合要求返回报错信息
       */

    }, {
      key: 'checkValue',
      value: function checkValue(flds)
      {
        return true
      }

      /**
       * 计算属性
       * @method
       * @param	  {Object}      att			          属性对象
       */

    }, {
      key: 'calcAtt',
      value: function calcAtt(att)
      {}

      /**
       * 在流程中设置属性信息
       * @method
       * @param   {Object}      att               属性
       * @param   {String}      task              流程环节
       */

    }, {
      key: 'makeAtt',
      value: function makeAtt(att, task)
      {}

      /**
       * 属性加密
       * @method
       * @param	  {Object}      att			          属性对象
       */

    }, {
      key: 'encode',
      value: function encode(att)
      {}

      /**
       * 属性解密
       * @method
       * @param	  {Object}      att			          属性对象
       */

    }, {
      key: 'decode',
      value: function decode(att)
      {}

      /**
       * 把字段信息生成为属性输入的信息
       * @method
       * @param   {Array}     result                          返回结果
       * @param   {Object}    options
       * @param   {Boolean}   [options.editable = false]      是否编辑模式
       * @param   {Object}    [options.att]                   属性
       * @param   {Boolean}   [options.isNew = false]         是否新属性
       * @returns {Object}                                    this
       */

    }, {
      key: 'makeInput',
      value: function makeInput(result)
      {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}

        var editable = Base.defVal(options.editable, false)
        var att = void 0,
          fld = void 0
        var obj = void 0,
          label = void 0,
          value = void 0,
          opts = void 0,
          opt = void 0,
          config = void 0,
          arrParam = void 0,
          param = void 0,
          matches = void 0

        //先清除结果
        Array$1.clear(result)

        //属性信息
        att = options.att
        this.isNew = Base.defVal(options.isNew, false)
        if (!att)
        {
          this.isNew = true
          att = this.getDefVal()
          att.id = 0
        }

        //拷贝属性
        this.att = {}
        Base.extend(this.att, att)

        //ID 字段
        obj = {
          colname: 'id',
          disporder: 0,
          type: Consts.DISP_TEXTBOX,
          title: 'id',
          group: '',
          isnum: true,
          required: false,
          rows: 1,
          refChange: 0,
          disped: false,
          editable: false,
          value: '' + att.id
        }
        result.push(obj)

        //字段信息
        var _iteratorNormalCompletion6 = true
        var _didIteratorError6 = false
        var _iteratorError6 = undefined

        try
        {
          for (var _iterator6 = this.flds[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true)
          {
            fld = _step6.value

            obj = {
              colname: fld.colname, //列名
              disporder: fld.disporder, //显示顺序
              type: fld.disptype, //显示类型
              title: Base.locale(fld.namec, fld.namee), //标题
              group: Base.locale(fld.groupc, fld.groupe), //分组
              isnum: !!fld.isnum, //是否数值型
              required: !fld.nullable, //是否必填
              rows: fld.disprows, //文本显示行数
              minval: fld.minval, //最小值
              maxval: fld.maxval, //最大值
              minlen: fld.minlen, //最小长度
              maxlen: fld.maxlen, //最大长度
              pattern: fld.pattern, //匹配模式
              refChange: 0, //动态选择改变标记
              disped: false //是否显示出来 (用于输入校验，因为有的字都没有显示，没显示的字段不能校验)


              //有些类型不能是数值型
            }; switch (fld.disptype)
            {
            case Consts.DISP_DATE:
            case Consts.DISP_TIMESTAMP:
            case Consts.DISP_HLTEXT:
            case Consts.DISP_AUTOCODE:
              obj.isnum = false
              break
            }

            //是否可编辑
            obj.editable = editable ? this.isNew && fld.newedit || !this.isNew && fld.editable : false

            //下拉选项及字段配置信息
            config = null
            obj.options = null
            switch (fld.disptype)
            {
            case Consts.DISP_LIST:
              obj.options = []
              opts = this.getFldVals(fld.tabname, fld.colname)
              var _iteratorNormalCompletion7 = true
              var _didIteratorError7 = false
              var _iteratorError7 = undefined

              try
              {
                for (var _iterator7 = opts[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true)
                {
                  opt = _step7.value

                  value = opt.dbvalue //值用文本方式显示
                  obj.options.push({ value: value, label: Base.locale(opt.dispc, opt.dispe) })
                }
              }
              catch (err)
              {
                _didIteratorError7 = true
                _iteratorError7 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion7 && _iterator7.return)
                  
                    _iterator7.return()
                }
                finally
                {
                  if (_didIteratorError7)
                  
                    throw _iteratorError7
                }
              }

              this.filterOptions(obj.options, fld)
              break
            case Consts.DISP_DROPDOWN:
              obj.options = []
              opts = this.getFldVals(fld.tabname, fld.colname)
              var _iteratorNormalCompletion8 = true
              var _didIteratorError8 = false
              var _iteratorError8 = undefined

              try
              {
                for (var _iterator8 = opts[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true)
                {
                  opt = _step8.value

                  obj.options.push({ value: opt.dbvalue, label: Base.locale(opt.dispc, opt.dispe) })
                }
              }
              catch (err)
              {
                _didIteratorError8 = true
                _iteratorError8 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion8 && _iterator8.return)
                  
                    _iterator8.return()
                }
                finally
                {
                  if (_didIteratorError8)
                  
                    throw _iteratorError8
                }
              }

              this.filterOptions(obj.options, fld)
              break
            case Consts.DISP_VALBUTTON:
            case Consts.DISP_AUTOCODE:
              opts = this.getFldVals(fld.tabname, fld.colname)
              opt = Array$1.get1(opts, { dbvalue: 'BS' })
              config = Parser.parseOptions(Base.locale(opt.dispc, opt.dispe))
              break
            case Consts.DISP_SELDYNA:
              obj.options = []
              opts = this.getFldVals(fld.tabname, fld.colname)
              opt = Array$1.get1(opts, { dbvalue: 'BS' })
              config = Parser.parseOptions(Base.locale(opt.dispc, opt.dispe))
              break
            case Consts.DISP_SELDEPPOS:
              obj.options = []
              opts = this.getFldVals(fld.tabname, fld.colname)
              opt = Array$1.get1(opts, { dbvalue: 'BS' })
              config = Parser.parseOptions(Base.locale(opt.dispc, opt.dispe))
              if (config.select === 'department')
              {
                opts = Global.init.user.organs
                var _iteratorNormalCompletion9 = true
                var _didIteratorError9 = false
                var _iteratorError9 = undefined

                try
                {
                  for (var _iterator9 = opts[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true)
                  {
                    opt = _step9.value

                    label = opt[config.fieldDisp ? config.fieldDisp : config.field]
                    value = opt[config.field]
                    obj.options.push({ value: value, label: label })
                  }
                }
                catch (err)
                {
                  _didIteratorError9 = true
                  _iteratorError9 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion9 && _iterator9.return)
                    
                      _iterator9.return()
                  }
                  finally
                  {
                    if (_didIteratorError9)
                    
                      throw _iteratorError9
                  }
                }
              }
              else if (config.select === 'position')
              {
                opts = Global.init.user.organs
                var _iteratorNormalCompletion10 = true
                var _didIteratorError10 = false
                var _iteratorError10 = undefined

                try
                {
                  for (var _iterator10 = opts[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true)
                  {
                    opt = _step10.value

                    value = opt.position
                    label = opt.position
                    obj.options.push({ value: value, label: label })
                  }
                }
                catch (err)
                {
                  _didIteratorError10 = true
                  _iteratorError10 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion10 && _iterator10.return)
                    
                      _iterator10.return()
                  }
                  finally
                  {
                    if (_didIteratorError10)
                    
                      throw _iteratorError10
                  }
                }
              }
              break
            }

            //根据下拉值来确定默认值
            switch (fld.disptype)
            {
            case Consts.DISP_LIST:
              if (obj.value === '' && obj.options.length > 0) obj.value = obj.options[0].value
              break
            }

            //配置信息
            if (config)
            {
              obj.config = config

              //计算引用的字段
              obj.refed = {}
              for (param in config)
              {
                if (RegEx.refId.test(param)) //#{colname}:id
                {
                  matches = param.match(RegEx.refId)
                  obj.refed[matches[1]] = config[param]
                }
              }
            }

            //计算被引用的字段
            switch (fld.disptype)
            {
            case Consts.DISP_SELDYNA:
              obj.refs = [] //引用了别的字段
              if (config.params)
              {
                arrParam = config.params.split(',')
                var _iteratorNormalCompletion11 = true
                var _didIteratorError11 = false
                var _iteratorError11 = undefined

                try
                {
                  for (var _iterator11 = arrParam[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true)
                  {
                    param = _step11.value

                    if (RegEx.refId.test(param)) //#{fld1},#{fld2}
                    {
                      matches = param.match(RegEx.refId)
                      obj.refs.push(matches[1]) //引用了别的参数
                    }
                  }
                }
                catch (err)
                {
                  _didIteratorError11 = true
                  _iteratorError11 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion11 && _iterator11.return)
                    
                      _iterator11.return()
                  }
                  finally
                  {
                    if (_didIteratorError11)
                    
                      throw _iteratorError11
                  }
                }
              }
              break
            }

            //值 (数值型改成字符串，否则验证可能有问题，不能识别字符串)
            obj.value = obj.isnum ? '' + this.att[fld.colname] : this.att[fld.colname]
            if (obj.value === undefined || obj.value === null) obj.value = ''

            result.push(obj)
          }
        }
        catch (err)
        {
          _didIteratorError6 = true
          _iteratorError6 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion6 && _iterator6.return)
            
              _iterator6.return()
          }
          finally
          {
            if (_didIteratorError6)
            
              throw _iteratorError6
          }
        }

        return this
      }

      /**
       * 把字段信息生成为属性条件表达式的信息
       * @method
       * @param   {Array}           result        返回结果
       * @param   {Array.<String>}  [expRanges]   需要输入范围的列(如： ['fld1', 'fld2'])
       * @param   {Array.<String>}  [excludes]    需要排除的列(如： ['fld3', 'fld4'])
       * @returns {Object}                        this
       */

    }, {
      key: 'makeExp',
      value: function makeExp(result, expRanges, excludes)
      {
        //1)所有字段好像都需要映射出去，否则动态字段有可能出错！

        var fld = void 0,
          mode = void 0,
          colname = void 0
        var obj = void 0,
          label = void 0,
          value = void 0,
          opts = void 0,
          opt = void 0,
          config = void 0,
          arrParam = void 0,
          param = void 0,
          matches = void 0

        //先清除结果
        Array$1.clear(result)

        var _iteratorNormalCompletion12 = true
        var _didIteratorError12 = false
        var _iteratorError12 = undefined

        try
        {
          for (var _iterator12 = this.flds[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true)
          {
            fld = _step12.value

            mode = 'value'

            //是否需要输入范围
            if (expRanges)
            {
              var _iteratorNormalCompletion13 = true
              var _didIteratorError13 = false
              var _iteratorError13 = undefined

              try
              {
                for (var _iterator13 = expRanges[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true)
                {
                  colname = _step13.value

                  if (colname === fld.colname) mode = 'range'
                }
              }
              catch (err)
              {
                _didIteratorError13 = true
                _iteratorError13 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion13 && _iterator13.return)
                  
                    _iterator13.return()
                }
                finally
                {
                  if (_didIteratorError13)
                  
                    throw _iteratorError13
                }
              }
            }

            //表达式对象
            obj = {
              colname: fld.colname, //列名
              disporder: fld.disporder, //显示顺序
              type: fld.disptype, //显示类型
              title: Base.locale(fld.namec, fld.namee), //标题
              isnum: !!fld.isnum, //是否数值型
              qrylevel: fld.qrylevel, //查询级别
              refChange: 0, //动态选择改变标记
              mode: mode //'value' / 'range' - 输入值还是输入范围


              //判断需要排除掉不？
            }; if (excludes && obj.qrylevel === 1)
            {
              var _iteratorNormalCompletion14 = true
              var _didIteratorError14 = false
              var _iteratorError14 = undefined

              try
              {
                for (var _iterator14 = excludes[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true)
                {
                  colname = _step14.value

                  if (colname === fld.colname) obj.qrylevel = 2
                }
              }
              catch (err)
              {
                _didIteratorError14 = true
                _iteratorError14 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion14 && _iterator14.return)
                  
                    _iterator14.return()
                }
                finally
                {
                  if (_didIteratorError14)
                  
                    throw _iteratorError14
                }
              }
            }

            //有些类型不能是数值型
            if (obj.isnum)
            {
              switch (fld.disptype)
              {
              case Consts.DISP_DATE:
              case Consts.DISP_TIMESTAMP:
              case Consts.DISP_HLTEXT:
              case Consts.DISP_AUTOCODE:
                obj.isnum = false
                break
              }
            }

            //只有部分类型才可以输入范围
            if (mode !== 'value')
            {
              switch (fld.disptype)
              {
              case Consts.DISP_TEXTBOX:
              case Consts.DISP_HLTEXT:
                if (!obj.isnum) obj.mode = 'value'
                break
              case Consts.DISP_DATE:
              case Consts.DISP_TIMESTAMP:
                break
              default:
                obj.mode = 'value'
                break
              }
            }

            //下拉选项及字段配置信息
            config = null
            obj.options = null
            switch (fld.disptype)
            {
            case Consts.DISP_LIST:
              obj.options = []
              obj.options.push({ value: '', label: '' }) //增加一个空行供不选择
              opts = this.getFldVals(fld.tabname, fld.colname)
              var _iteratorNormalCompletion15 = true
              var _didIteratorError15 = false
              var _iteratorError15 = undefined

              try
              {
                for (var _iterator15 = opts[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true)
                {
                  opt = _step15.value

                  obj.options.push({ value: opt.dbvalue, label: Base.locale(opt.dispc, opt.dispe) })
                }
              }
              catch (err)
              {
                _didIteratorError15 = true
                _iteratorError15 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion15 && _iterator15.return)
                  
                    _iterator15.return()
                }
                finally
                {
                  if (_didIteratorError15)
                  
                    throw _iteratorError15
                }
              }

              break
            case Consts.DISP_DROPDOWN:
              obj.options = []
              opts = this.getFldVals(fld.tabname, fld.colname)
              var _iteratorNormalCompletion16 = true
              var _didIteratorError16 = false
              var _iteratorError16 = undefined

              try
              {
                for (var _iterator16 = opts[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true)
                {
                  opt = _step16.value

                  obj.options.push({ value: opt.dbvalue, label: Base.locale(opt.dispc, opt.dispe) })
                }
              }
              catch (err)
              {
                _didIteratorError16 = true
                _iteratorError16 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion16 && _iterator16.return)
                  
                    _iterator16.return()
                }
                finally
                {
                  if (_didIteratorError16)
                  
                    throw _iteratorError16
                }
              }

              break
            case Consts.DISP_VALBUTTON:
              opts = this.getFldVals(fld.tabname, fld.colname)
              opt = Array$1.get1(opts, { dbvalue: 'BS' })
              config = Parser.parseOptions(Base.locale(opt.dispc, opt.dispe))
              break
            case Consts.DISP_SELDYNA:
              obj.options = []
              obj.expMode = true //增加一个标记，以便动态的时候，知道在前面增加空行
              opts = this.getFldVals(fld.tabname, fld.colname)
              opt = Array$1.get1(opts, { dbvalue: 'BS' })
              config = Parser.parseOptions(Base.locale(opt.dispc, opt.dispe))
              break
            case Consts.DISP_SELDEPPOS:
              obj.options = []
              obj.options.push({ value: '', label: '' }) //增加一个空行供不选择
              opts = this.getFldVals(fld.tabname, fld.colname)
              opt = Array$1.get1(opts, { dbvalue: 'BS' })
              config = Parser.parseOptions(Base.locale(opt.dispc, opt.dispe))
              if (config.select === 'department')
              {
                opts = Global.init.organ
                var _iteratorNormalCompletion17 = true
                var _didIteratorError17 = false
                var _iteratorError17 = undefined

                try
                {
                  for (var _iterator17 = opts[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true)
                  {
                    opt = _step17.value

                    label = opt[config.fieldDisp ? config.fieldDisp : config.field]
                    value = opt[config.field]
                    obj.options.push({ value: value, label: label })
                  }
                }
                catch (err)
                {
                  _didIteratorError17 = true
                  _iteratorError17 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion17 && _iterator17.return)
                    
                      _iterator17.return()
                  }
                  finally
                  {
                    if (_didIteratorError17)
                    
                      throw _iteratorError17
                  }
                }
              }
              else if (config.select === 'position')
              {
                opts = Global.init.user.organs
                var _iteratorNormalCompletion18 = true
                var _didIteratorError18 = false
                var _iteratorError18 = undefined

                try
                {
                  for (var _iterator18 = opts[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true)
                  {
                    opt = _step18.value

                    value = opt[config.field]
                    label = Base.locale(opt.namec, opt.namee)
                    obj.options.push({ value: value, label: label })
                  }
                }
                catch (err)
                {
                  _didIteratorError18 = true
                  _iteratorError18 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion18 && _iterator18.return)
                    
                      _iterator18.return()
                  }
                  finally
                  {
                    if (_didIteratorError18)
                    
                      throw _iteratorError18
                  }
                }
              }
              break
            case Consts.DISP_AUTOCODE:
              obj.type = Consts.DISP_TEXTBOX
              break
            }

            //配置信息
            if (config)
            {
              obj.config = config

              //计算引用的字段
              obj.refed = {}
              for (param in config)
              {
                if (RegEx.refId.test(param)) //#{colname}:id
                {
                  matches = param.match(RegEx.refId)
                  obj.refed[matches[1]] = config[param]
                }
              }
            }

            //计算被引用的字段
            switch (fld.disptype)
            {
            case Consts.DISP_SELDYNA:
              obj.refs = [] //引用了别的字段
              if (config.params)
              {
                arrParam = config.params.split(',')
                var _iteratorNormalCompletion19 = true
                var _didIteratorError19 = false
                var _iteratorError19 = undefined

                try
                {
                  for (var _iterator19 = arrParam[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true)
                  {
                    param = _step19.value

                    if (RegEx.refId.test(param)) //#{fld1},#{fld2}
                    {
                      matches = param.match(RegEx.refId)
                      obj.refs.push(matches[1]) //引用了别的参数
                    }
                  }
                }
                catch (err)
                {
                  _didIteratorError19 = true
                  _iteratorError19 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion19 && _iterator19.return)
                    
                      _iterator19.return()
                  }
                  finally
                  {
                    if (_didIteratorError19)
                    
                      throw _iteratorError19
                  }
                }
              }
              break
            }

            //值、范围值
            obj.value = ''
            obj.value1 = ''
            obj.value2 = ''

            result.push(obj)
          }
        }
        catch (err)
        {
          _didIteratorError12 = true
          _iteratorError12 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion12 && _iterator12.return)
            
              _iterator12.return()
          }
          finally
          {
            if (_didIteratorError12)
            
              throw _iteratorError12
          }
        }

        return this
      }

      /**
       * 给字段增加可编辑字段的信息
       * @method
       * @param   {Array}     cols              列数组
       * @param   {Array}     editCols          可编辑的字段信息( [{colname: String, isEdit: Boolean, isDate: boolean, .., selOptions: []}] )
       */

    }, {
      key: 'makeEdit',
      value: function makeEdit(cols, editCols)
      {
        var col = void 0,
          fld = void 0,
          colname = void 0,
          editCol = void 0
        var opts = void 0,
          opt = void 0

        var _iteratorNormalCompletion20 = true
        var _didIteratorError20 = false
        var _iteratorError20 = undefined

        try
        {
          for (var _iterator20 = cols[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true)
          {
            col = _step20.value

            colname = col.colname
            if (colname.charAt(0) === '_') colname = colname.substring(1)
            fld = Array$1.get1(this.flds, { colname: colname })
            if (!fld) continue

            editCol = Array$1.get1(editCols, { colname: col.colname })
            if (!editCol) continue

            switch (fld.disptype)
            {
            case Consts.DISP_TEXTBOX:
            case Consts.DISP_RTEXT:
            case Consts.DISP_HLTEXT:
              col.isEdit = true
              col.rows = fld.disprows
              break
            case Consts.DISP_LIST:
              col.isSelect = true
              col.selOptions = []
              opts = this.getFldVals(fld.tabname, fld.colname)
              var _iteratorNormalCompletion21 = true
              var _didIteratorError21 = false
              var _iteratorError21 = undefined

              try
              {
                for (var _iterator21 = opts[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true)
                {
                  opt = _step21.value

                  col.selOptions.push({ value: opt.dbvalue, label: Base.locale(opt.dispc, opt.dispe) })
                }
              }
              catch (err)
              {
                _didIteratorError21 = true
                _iteratorError21 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion21 && _iterator21.return)
                  
                    _iterator21.return()
                }
                finally
                {
                  if (_didIteratorError21)
                  
                    throw _iteratorError21
                }
              }

              break
            case Consts.DISP_DROPDOWN:
              col.isDropdown = true
              col.selOptions = []
              opts = this.getFldVals(fld.tabname, fld.colname)
              var _iteratorNormalCompletion22 = true
              var _didIteratorError22 = false
              var _iteratorError22 = undefined

              try
              {
                for (var _iterator22 = opts[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true)
                {
                  opt = _step22.value

                  col.selOptions.push({ value: opt.dbvalue, label: Base.locale(opt.dispc, opt.dispe) })
                }
              }
              catch (err)
              {
                _didIteratorError22 = true
                _iteratorError22 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion22 && _iterator22.return)
                  
                    _iterator22.return()
                }
                finally
                {
                  if (_didIteratorError22)
                  
                    throw _iteratorError22
                }
              }

              break
            case Consts.DISP_DATE:
              col.isDate = true
              col.dateFormat = 'yyyy-MM-dd'
              break
            case Consts.DISP_TIMESTAMP:
              col.isDateTime = true
              col.dateTimeFormat = 'yyyy-MM-dd HH:mm:ss'
              break
            }
          }
        }
        catch (err)
        {
          _didIteratorError20 = true
          _iteratorError20 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion20 && _iterator20.return)
            
              _iterator20.return()
          }
          finally
          {
            if (_didIteratorError20)
            
              throw _iteratorError20
          }
        }
      }
    }])
    return AttBase
  }())

  /**
   * cx.AttFactory
   * 类-属性对象工厂
   *
   * @class
   * @memberof    cx
   * @extends     cx.IAttManager
   * @author      Zhang Fayong
   * @since       2018-05-17
   */

  var AttFactory = (function()
  {
    /**
     * @constructor
     * @param {Object}    [options]
     * @param {Array}     [options.attClass]        属性类对照表(major, minor, className)
     */
    function AttFactory()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, AttFactory)

      /** *@property  {Array}       list            对照表 */
      this.list = null

      if (options.attClass)
      {
        var lookTable = require('@/' + options.attClass).default
        if (lookTable && Base.isArr(lookTable.list)) this.list = lookTable.list
      }
    }

    /**
     * 构建属性框操作对象
     * @method
     * @param   {Number}    major               主类型
     * @param   {Number}    minor               子类型
     * @param   {Object}    [options]           其他参数
     * @param   {String}    [options.tabname]   表名 (不传的时候，根据major、minor取entity中的属性表配置)
     * @param   {Array}     [options.flds]      字段列表
     * @param   {Array}     [options.fldVals]   字段列值表
     * @returns {cx.AttBase}                    属性处理对象
     */


    createClass(AttFactory, [{
      key: 'byMajMin',
      value: function byMajMin(major, minor)
      {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}

        if (!options.tabname)
        {
          var entity = Global.entity.byMajMin(major, minor)
          if (entity) options.tabname = entity.tabatt
        }

        //查找对照表
        var ClassName = void 0

        if (this.list)
        {
          var obj = Array$1.get1(this.list, { major: major, minor: minor })

          if (obj) ClassName = obj.className
        }
        if (!ClassName) ClassName = AttBase

        return new ClassName(options)
      }
    }])
    return AttFactory
  }())

  /**
   * cx.CacheLru
   * 类-缓存（基于双向链表的最久未用淘汰策略）
   *
   * @class
   * @memberof    cx
   * @extends     cx.ICache
   * @author      Zhang Fayong
   * @since       2018-05-02
   */

  var CacheLru = (function()
  {
    /**
     * @constructor
     * @param   {Object}    [options = {}]          参数
     * @param   {Number}    [options.limit]         缓存限制
     * @param   {Caller}    [options.onRemove]      淘汰时的回调函数-function(value)
     */
    function CacheLru()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, CacheLru)

      this.limit = options.limit || 100 // 标识缓存数组能达到的最大长度
      if (this.limit < 3) // 太少不能做双向链表
        this.limit = 3
      this.onRemove = options.onRemove // 淘汰时的回调函数
      this.size = 0 // 标识当前缓存数组的大小
      this.head = this.tail = undefined // head（最常用的项），tail（最不常用的项）全部初始化为undefined
      this.map = {}
    }

    /**
     * 清除缓存数据
     * @method
     * @returns {Object}                            this
     */


    createClass(CacheLru, [{
      key: 'clear',
      value: function clear()
      {
        for (var i in this.map)
        
          this._remove(this.map[i].value)
        // 回调
        this.size = 0
        this.head = this.tail = null
        this.map = {}
        return this
      }

      /**
       * 设置最大缓存数量
       * @method
       * @param   {Number}    limit                   最大门限值
       * @returns {Object}                            this
       */

    }, {
      key: 'setLimit',
      value: function setLimit(limit)
      {
        if (limit < 3) limit = 3
        while (this.size >= limit)
        
          this.remove()
        this.limit = limit
        return this
      }

      /**
       * 移除最久未用对象
       * @method
       * @returns {Object}                            this
       */

    }, {
      key: 'remove',
      value: function remove()
      {
        var node = this.tail
        if (node)
        {
          this.tail = this.tail.prev // 删最后一个节点
          this.tail.next = undefined
          node.prev = node.next = undefined // 断链
          this.size-- // 同步更新缓存数
          delete this.map[node.key] // 删除结点
          this._remove(node.value) // 回调
          node.value = null
          node = null
        }
        return this
      }

      /**
       * 根据键值弹出对象(删除数据，但是不调用删除销毁函数)
       * @method
       * @param   {String}    key                     键值
       * @returns {Object}                            返回key对应的对象
       */

    }, {
      key: 'pop',
      value: function pop(key)
      {
        var node = this.map[key]
        if (node === undefined) // 如果查找不到含有key这个属性的缓存对象
          return

        // head 和 tail
        if (node === this.head) this.head = node.next
        if (node === this.tail) this.tail = node.prev

        //改动链表
        if (node.prev) node.prev.next = node.next
        if (node.next) node.next.prev = node.prev

        this.size-- // 同步更新缓存数
        delete this.map[key] // 删除结点

        return node.value
      }

      /**
       * 根据键值取对象
       * @method
       * @param   {String}    key                     键值
       * @param   {Boolean}   returnEntry             是否返回键值对
       * @returns {Object}                            返回key对应的对象，或者是{key, value}对
       */

    }, {
      key: 'get',
      value: function get(key, returnEntry)
      {
        var node = this.map[key]
        if (node === undefined) // 如果查找不到含有key这个属性的缓存对象
          return
        if (node === this.head) // 如果查找到的缓存对象已经是 head (最近使用过的)
          return returnEntry ? node : node.value
        if (node.prev) // 不是头结点，铁定要移动元素了
        {
          if (node === this.tail) // 有前驱，若是尾节点的话多一步，让尾指针指向当前节点的前驱
            this.tail = node.prev
          node.prev.next = node.next // 把当前节点的后继交接给当前节点的前驱去指向。
        }
        if (node.next) // 判断该节点是不是有后继
          node.next.prev = node.prev // 有后继的话直接让后继的前驱指向当前节点的前驱
        node.prev = undefined // 移动到最前面，所以没了前驱
        node.next = this.head // 这里要先把之前的排头给接到手！！！！让当前节点的后继指向原排头
        if (this.head) this.head.prev = node //让之前的排头的前驱指向现在的节点
        this.head = node //完成了交接，才能执行此步！不然就找不到之前的排头啦！
        return returnEntry ? node : node.value
      }

      /**
       * 增加键值对
       * @method
       * @param   {String}    key                     键值
       * @param   {Object}    value                   对象
       * @returns {Object}                            被删除的对象
       */

    }, {
      key: 'put',
      value: function put(key, value)
      {
        if (key)
        {
          var node = this.get(key, true)
          if (!node) // 查看是否已经有了该节点
          {
            if (this.size >= this.limit) // 如果达到上限，则需要淘汰尾结点
              this.remove()
            node = { key: key // 增加新对象
            }; this.map[key] = node
            if (this.head) // 判断缓存里面是不是有节点
            {
              this.head.prev = node
              node.next = this.head
            }
            else // 缓存里没有值，皆大欢喜，直接让head指向新节点就行了
              this.tail = node
            this.head = node
            this.size++ // 减少一个缓存槽位
          }
          node.value = value // 节点存不存在都要给他重新赋值
        }
        return this
      }

      /**
       * 异步删除对象
       * @private
       * @method
       * @param   {Object}    value                   对象
       */

    }, {
      key: '_remove',
      value: function _remove(value)
      {
        var _this = this

        if (value)
        {
          setTimeout(function()
          {
            Base.call(_this.onRemove, value) // 回调
          }, 0)
        }
      }
    }])
    return CacheLru
  }())

  /**
   * cx.Color
   * 颜色处理基础类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Qing
   * @since       2018-07-30
   */

  var Color = (function()
  {
    function Color()
    {
      classCallCheck(this, Color)
    }

    createClass(Color, null, [{
      key: 'getRandomColor',

      /**
       * 返回随机颜色
       * @method
       * @static
       * @param   {String}   color   需要排除的颜色
       * @returns {String}           构造好的随机颜色
       */
      value: function getRandomColor()
      {
        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#ffffff'

        var randColor = '#' + Math.floor(Math.random() * 0xffffff).toString(16)
        while (color === randColor)
        
          randColor = '#' + Math.floor(Math.random() * 0xffffff).toString(16)
        return randColor
      }

      /**
       * 根据colorArr中每两个color对象间的梯度，插入若干新color,共生成num个元素
       * @static
       * @method
       * @param {Number}          num      最终的color对象的个数
       * @param {Array.<String>}  colorArr 颜色数组，每个元素都是16进制字符串
       * @returns {Array}                  包含根据颜色变化斜率生成的num个color对象数组
       */

    }, {
      key: 'getColorRamp',
      value: function getColorRamp(num, colorArr)
      {
        if (num <= colorArr.length) return colorArr

        var colors = []
        var insertTotal = num - colorArr.length
        var inserPerPart = Math.ceil(insertTotal / (colorArr.length - 1))

        //每部分节点数 = 首尾节点数+插入的节点数
        var numPerPart = 2 + inserPerPart
        for (var i = 1; i < colorArr.length; i++)
        {
          //剩余的num不为0时，numPerPart和num中取较小的
          if (num > 0 && numPerPart > num) numPerPart = num

          num = num - numPerPart + 1
          var temp = this.gradientColor(colorArr[i - 1], colorArr[i], numPerPart)

          //每组最后一个与下组第一个重复
          for (var k = 0; k < temp.length - 1; k++)
          
            colors.push(temp[k])
        }
        colors.push(colorArr[colorArr.length - 1])

        return colors
      }

      /**
       * 根据起始颜色和终止颜色，生成num个颜色
       * @static
       * @method
       * @param {String} startColor 开始颜色（十六进制）
       * @param {String} endColor   终止颜色（十六进制）
       * @param {Number} num        分组数
       * @returns {Array}           生成的颜色数组
       */

    }, {
      key: 'gradientColor',
      value: function gradientColor(startColor, endColor, num)
      {
        //转换为rgb数组模式
        var startRGB = this.hexToRgb(startColor)
        var startR = startRGB[0]
        var startG = startRGB[1]
        var startB = startRGB[2]

        var endRGB = this.hexToRgb(endColor)
        var endR = endRGB[0]
        var endG = endRGB[1]
        var endB = endRGB[2]

        //总差值
        var sR = (endR - startR) / num
        var sG = (endG - startG) / num
        var sB = (endB - startB) / num

        var colorArr = [startColor]
        for (var i = 1; i < num - 1; i++)
        {
          //计算每一步的hex值
          var hex = this.rgbToHex('rgb(' + parseInt(sR * i + startR) + ',' + parseInt(sG * i + startG) + ',' + parseInt(sB * i + startB) + ')')
          colorArr.push(hex)
        }
        colorArr.push(endColor)

        return colorArr
      }

      /**
       * 十六进制转rgb
       * @static
       * @method
       * @param {String}  sHex             十六进制颜色，如 #FF42EE
       * @param {Number}  [opacity=1]      颜色透明度(0~1), 0表示完全透明，1表示完全不透明
       * @param {Boolean} [isFinal=false]  是否生成最终值，如 grb(12,34,56)，默认输出grb的颜色值数组
       * @returns {String|Array}           转换后的颜色
       */

    }, {
      key: 'hexToRgb',
      value: function hexToRgb(sHex)
      {
        var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1
        var isFinal = arguments[2]

        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
        var i = void 0

        sHex = sHex.toLowerCase()
        if (sHex && reg.test(sHex))
        {
          if (sHex.length === 4)
          {
            var sColorNew = '#'
            for (i = 1; i < 4; i++)
            
              sColorNew += sHex.slice(i, i + 1).concat(sHex.slice(i, i + 1))
            sHex = sColorNew
          }

          //处理六位的颜色值
          var aColor = []
          for (i = 1; i < 7; i += 2)
          
            aColor.push(parseInt('0x' + sHex.slice(i, i + 2)))
          aColor.push(opacity)
          if (isFinal) return 'rgb(' + aColor[0] + ',' + aColor[1] + ',' + aColor[2] + ',' + opacity + ')'; else return aColor
        }
        else return sHex
      }

      /**
       * rgb转十六进制
       * @static
       * @method
       * @param {String}  sRgb    rgb颜色，如 rgb(12,33,23)
       * @returns {String}        转换后的颜色
       */

    }, {
      key: 'rgbToHex',
      value: function rgbToHex(sRgb)
      {
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
        var i = void 0

        if (/^(rgb|RGB)/.test(sRgb))
        {
          var aColor = sRgb.replace(/(?:\(|\)|rgb|RGB)*/g, '').split(',')
          var strHex = '#'
          for (i = 0; i < aColor.length; i++)
          {
            var hex = Number(aColor[i]).toString(16)
            hex = hex < 10 || hex.length === 1 ? 0 + '' + hex : hex // 保证每个rgb的值为2位
            if (hex === '0') hex += hex

            strHex += hex
          }
          if (strHex.length !== 7) strHex = sRgb

          return strHex
        }
        else if (reg.test(sRgb))
        {
          var aNum = sRgb.replace(/#/, '').split('')
          if (aNum.length === 6) return sRgb; else if (aNum.length === 3)
          {
            var numHex = '#'
            for (i = 0; i < aNum.length; i++)
            
              numHex += aNum[i] + aNum[i]
            return numHex
          }
        }
        else return sRgb
      }

      /**
       * rgb转rgba
       * @static
       * @method
       * @param {String}  sRgb             grb颜色，如 grb(12,34,56)
       * @param {Number}  opacity          不透明度，0为全透明，1为全不透明
       * @param {Boolean} [isFinal=false]  是否生成最终值，如 grba(12,34,56,0.5)，默认输出grba的颜色值数组
       * @returns {String|Array}           转换后的颜色
       */

    }, {
      key: 'rgbToRgba',
      value: function rgbToRgba(sRgb, opacity, isFinal)
      {
        if (/^(rgb|RGB)/.test(sRgb))
        {
          var aColor = sRgb.replace(/(?:\(|\)|rgb|RGB)*/g, '').split(',')
          aColor.push(opacity)

          if (isFinal) return 'rgba(' + aColor[0] + ',' + aColor[1] + ',' + aColor[2] + ',' + aColor[3] + ')'; else return aColor
        }
        else return sRgb
      }
    }])
    return Color
  }())

  /**
   * cx.column
   * 类-字段
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-07-13
   */

  var Column = (function()
  {
    function Column()
    {
      classCallCheck(this, Column)
    }

    createClass(Column, null, [{
      key: 'getCol',

      /**
       * 得到一个字段对象
       * @method
       * @static
       * @param   {Number}    disporder         显示顺序( < 1 不显示)
       * @param   {String}    colname           列名
       * @param   {String}    title             标题
       * @param   {Number}    disptype          显示类型(cx.consts.DISP_*)
       * @param   {Boolean}   isnum             是否数字
       * @param   {Boolean}   required          是否必填项
       * @param   {String}    [strCfg]          配置信息字符串(当类型为 VALBUTTON / SELDYNA 时的配置信息, 如:"plugin:'SelRoad',field:mc,#{id1}:id")
       * @returns {Object}                      {value: '', editable: true, rows: 1, ..}
       */
      value: function getCol(disporder, colname, title, disptype, isnum, required, strCfg)
      {
        var config = void 0
        var opts = void 0,
          opt = void 0,
          label = void 0,
          value = void 0
        var param = void 0,
          matches = void 0,
          arrParam = void 0

        var obj = {
          colname: colname,
          title: title,
          disporder: disporder,
          type: disptype,
          value: '',
          isnum: isnum,
          editable: true,
          required: required,
          rows: 1,
          disped: false,
          refChange: 0 //动态选择改变标记


          //解配置信息
        }; switch (disptype)
        {
        case Consts.DISP_VALBUTTON:
        case Consts.DISP_SELDYNA:
        case Consts.DISP_AUTOCODE:
          config = Parser.parseOptions(strCfg)
          break
        case Consts.DISP_SELDEPPOS:
          config = Parser.parseOptions(strCfg)
          //取下拉值
          if (config.select === 'department')
          {
            opts = $g.init.user.organs
            var _iteratorNormalCompletion = true
            var _didIteratorError = false
            var _iteratorError = undefined

            try
            {
              for (var _iterator = opts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
              {
                opt = _step.value

                label = opt[config.fieldDisp ? config.fieldDisp : config.field]
                value = opt[config.field]
                value = obj.isnum ? parseFloat(value) : value //数值字段转成数值
                obj.options.push({ value: value, label: label })
              }
            }
            catch (err)
            {
              _didIteratorError = true
              _iteratorError = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion && _iterator.return)
                
                  _iterator.return()
              }
              finally
              {
                if (_didIteratorError)
                
                  throw _iteratorError
              }
            }
          }
          else if (config.select === 'position')
          {
            opts = $g.init.user.organs
            var _iteratorNormalCompletion2 = true
            var _didIteratorError2 = false
            var _iteratorError2 = undefined

            try
            {
              for (var _iterator2 = opts[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
              {
                opt = _step2.value

                value = opt.position
                label = opt.position
                obj.options.push({ value: value, label: label })
              }
            }
            catch (err)
            {
              _didIteratorError2 = true
              _iteratorError2 = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion2 && _iterator2.return)
                
                  _iterator2.return()
              }
              finally
              {
                if (_didIteratorError2)
                
                  throw _iteratorError2
              }
            }
          }
          break
        }

        //配置信息
        if (config)
        {
          obj.config = config

          //计算引用的字段
          obj.refed = {}
          for (param in config)
          {
            if (RegEx.refId.test(param)) //#{colname}:id
            {
              matches = param.match(RegEx.refId)
              obj.refed[matches[1]] = config[param]
            }
          }
        }

        //计算被引用的字段
        switch (disptype)
        {
        case Consts.DISP_SELDYNA:
          obj.refs = [] //引用了别的字段
          if (config.params)
          {
            arrParam = config.params.split(',')
            var _iteratorNormalCompletion3 = true
            var _didIteratorError3 = false
            var _iteratorError3 = undefined

            try
            {
              for (var _iterator3 = arrParam[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)
              {
                param = _step3.value

                matches = param.match(RegEx.refId)
                obj.refs.push(matches[1]) //引用了别的参数
              }
            }
            catch (err)
            {
              _didIteratorError3 = true
              _iteratorError3 = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion3 && _iterator3.return)
                
                  _iterator3.return()
              }
              finally
              {
                if (_didIteratorError3)
                
                  throw _iteratorError3
              }
            }
          }
          break
        }

        return obj
      }
    }])
    return Column
  }())

  /**
   * cx.converter
   * 数据转换对象
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Converter = (function()
  {
    function Converter()
    {
      classCallCheck(this, Converter)
    }

    createClass(Converter, null, [{
      key: 'toHtml',

      /**
       * 将字符串转换成HTML格式(空格->&nbsp; \n-><br>)
       * @static
       * @method
       * @param   {String}    str           字符串
       * @returns {String}
       */
      value: function toHtml(str)
      {
        var ret = str.replace(/\n/g, '<br/>')
        ret = ret.replace(/ /g, '&nbsp;')
        return ret
      }

      /**
       * 将字符串转换成Object
       * @static
       * @method
       * @param   {String}    str           字符串
       * @returns {Object}
       */

    }, {
      key: 'toObject',
      value: function toObject(str)
      {
        if (Base.isObj(str)) return str
        if (str === undefined || str === null) return null; else if (str === '') return {}; else return eval('(' + str + ')')
      }

      /**
       * 对象转换成字符串
       * @static
       * @method
       * @param   {Object}    data          对象
       * @param   {Boolean}   strict        是否严格类型检查
       * @returns {String}
       */

    }, {
      key: 'data2String',
      value: function data2String(data, strict)
      {
        var str = ''
        if (strict && data instanceof Object)
        {
          str = JSON.stringify(data, function replace(key, val)
          {
            if (typeof val === 'number' || typeof val === 'boolean') val += ''
            return val
          })
        }
        else str = JSON.stringify(data)
        return str
      }

      /**
       * 把数组的成员返回列表字符串，中间用,隔开
       * @static
       * @method
       * @param   {Array}     arr           数组
       * @returns {String}
       */

    }, {
      key: 'array2List',
      value: function array2List(arr)
      {
        var ret = ''
        if (arr)
        {
          for (var i = 0; i < arr.length; i++)
          {
            if (i > 0) ret += ','
            ret += arr[i]
          }
        }
        return ret
      }
    }])
    return Converter
  }())

  /**
   * cx.dom
   * 类-DOM辅助类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-01
   */

  var Dom = (function()
  {
    function Dom()
    {
      classCallCheck(this, Dom)
    }

    createClass(Dom, null, [{
      key: 'byId',

      /**
       * 根据ID取DomNode结点
       * @static
       * @method
       * @returns {Object}
       */
      value: function byId(id)
      {
        return document.getElementById(id)
      }

      /**
       * 根据ID or DomNode 取DomNode结点
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getDomNode',
      value: function getDomNode(dom)
      {
        if (typeof dom === 'string') return this.byId(dom)
        return dom
      }

      /**
       * 取 document.body
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'body',
      value: function body()
      {
        return document.body
      }

      /**
       * 禁止/使能DOM对象
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {Boolean}   able
       * @returns {Object}                    this
       */

    }, {
      key: 'enable',
      value: function enable(dom, able)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.disabled = !able
        return this
      }

      /**
       * 根据DOM取DomNode的值
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Object}
       */

    }, {
      key: 'getValue',
      value: function getValue(dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) return domNode.value
        return null
      }

      /**
       * 根据DOM设置DomNode的值
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {Object}    value
       * @returns {Object}                    this
       */

    }, {
      key: 'setValue',
      value: function setValue(dom, value)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.value = value
        return this
      }

      /**
       * 根据DOM设置DomNode的 innerHTML
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {String}    html
       * @returns {Object}                    this
       */

    }, {
      key: 'setInnerHTML',
      value: function setInnerHTML(dom, html)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.innerHTML = html
        return this
      }

      /**
       * 根据DOM设置DomNode是否可见
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {Boolean}   visible
       * @returns {Object}                    this
       */

    }, {
      key: 'setVisible',
      value: function setVisible(dom, visible)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.style.display = visible ? 'block' : 'none'
        return this
      }

      /**
       * 根据DOM设置DomNode的style
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {Object}    styles          {width:**, height:**}
       * @returns {Object}                    this
       */

    }, {
      key: 'setStyle',
      value: function setStyle(dom, styles)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) Base.extend(domNode.style, styles)
        return this
      }

      /**
       * 根据DOM设置z-index
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {Number}    zIndex
       * @returns {Object}                    this
       */

    }, {
      key: 'setZIndex',
      value: function setZIndex(dom, zIndex)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.style.zIndex = zIndex
        return this
      }

      /**
       * 根据DOM绑定消息事件
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {Object}    obj             obj-{onClick()}
       * @returns {Object}                    this
       */

    }, {
      key: 'bind',
      value: function bind(dom, obj)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) Base.extend(domNode, obj)
        return this
      }

      /**
       * 根据DOM清空内部html
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Object}                    this
       */

    }, {
      key: 'empty',
      value: function empty(dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.innerHTML = ''
        return this
      }

      /**
       * 创建DomNode
       * @static
       * @method
       * @param   {String}  type            'div' or 'a' ...
       * @param   {String}  className       CSS类名
       * @param   {dom}     parentDom       父亲dom
       * @param   {Object}  atts            属性(可以设置style)
       * @returns {dom}
       */

    }, {
      key: 'create',
      value: function create(type, className, parentDom, atts)
      {
        var element = document.createElement(type)
        //类名
        if (className) element.className = className
        if (atts)
        {
          //style
          if (atts.style)
          {
            element.style.cssText = atts.style
            delete atts.style //避免后面拷贝到DOM对象里面去
          }
          Base.extend(element, atts)
        }
        parentDom = this.getDomNode(parentDom)
        if (parentDom) parentDom.appendChild(element)
        return element
      }

      /**
       * 用NS方式创建DomNode
       * @static
       * @method
       * @param   {String}    NS            namespace
       * @param   {String}    type          tag名
       * @param   {String}    className     样式类名
       * @param   {dom}       parentDom     父节点
       * @param   {Object}    atts          属性
       * @returns {dom}
       */

    }, {
      key: 'createNS',
      value: function createNS(NS, type, className, parentDom, atts)
      {
        var element = document.createElementNS(NS, type)
        //类名
        if (className) element.setAttribute('class', className)
        if (atts)
        {
          //style
          if (atts.style)
          {
            element.style.cssText = atts.style
            delete atts.style //避免后面拷贝到DOM对象里面去
          }
          for (var i in atts)
          
            element.setAttribute(i, atts[i])
        }
        parentDom = this.getDomNode(parentDom)
        if (parentDom) parentDom.appendChild(element)
        return element
      }

      /**
       * 添加儿子
       * @static
       * @method
       * @param   {Array}     children        可以是数组，也可以是耽搁dom
       * @param   {dom}       dom             dom
       * @returns {Object}                    this
       */

    }, {
      key: 'append',
      value: function append(children, dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode)
        {
          var dom1 = void 0
          if (Base.isArr(children))
          {
            for (var i = 0; i < children.length; i++)
            {
              dom1 = this.getDomNode(children[i])
              if (dom1) domNode.appendChild(dom1)
            }
          }
          else
          {
            dom1 = this.getDomNode(children)
            if (dom1) domNode.appendChild(dom1)
          }
        }
        return this
      }

      /**
       * 在..后面添加儿子
       * @static
       * @method
       * @param   {dom}       newDom          待添加的dom
       * @param   {dom}       dom             在dom之后添加
       * @returns {Object}                    this
       */

    }, {
      key: 'appendAfter',
      value: function appendAfter(newDom, dom)
      {
        var newDomNode = this.getDomNode(newDom)
        var domNode = this.getDomNode(dom)
        if (newDomNode && domNode && domNode.parentNode)
        
          if (domNode.nextSibling) domNode.parentNode.insertBefore(newDomNode, domNode.nextSibling); else domNode.parentNode.appendChild(newDomNode)
        
        return this
      }

      /**
       * 在..之前添加儿子
       * @static
       * @method
       * @param   {dom}       newDom          待添加的dom
       * @param   {dom}       dom             在dom之前添加
       * @returns {Object}                    this
       */

    }, {
      key: 'insertBefore',
      value: function insertBefore(newDom, dom)
      {
        var newDomNode = this.getDomNode(newDom)
        var domNode = this.getDomNode(dom)
        if (newDomNode && domNode && domNode.parentNode) domNode.parentNode.insertBefore(newDomNode, domNode)
        return this
      }

      /**
       * 添加到第一个儿子的位置
       * @static
       * @method
       * @param   {dom}       newDom          待添加的dom
       * @param   {dom}       parentDom       父亲结点
       * @returns {Object}                    this
       */

    }, {
      key: 'insertFirst',
      value: function insertFirst(newDom, parentDom)
      {
        var newNode = this.getDomNode(newDom)
        var parent = this.getDomNode(parentDom)
        if (newNode && parent)
        
          if (parent.childNodes.length > 0) parent.insertBefore(newNode, parent.childNodes[0]); else parent.appendChild(newNode)
        
        return this
      }

      /**
       * 删除dom
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Object}                    this
       */

    }, {
      key: 'remove',
      value: function remove(dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode && domNode.parentNode) domNode.parentNode.removeChild(domNode)
        return this
      }

      /**
       * 根据字符串创建css样式
       * @static
       * @method
       * @param   {String}    cssString
       * @returns {Object}                    this
       */

    }, {
      key: 'createCss',
      value: function createCss(cssString)
      {
        var style = document.createElement('style')
        style.setAttribute('type', 'text/css')
        var cssText = document.createTextNode(cssString)
        style.appendChild(cssText)
        var heads = document.getElementsByTagName('head')
        heads[0].appendChild(style)
        return this
      }

      /**
       * 根据DOM取DomNode的大小
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Object}    结构如{w: Number, h: Number}
       */

    }, {
      key: 'getSize',
      value: function getSize(dom)
      {
        var ret = { w: 0, h: 0 }
        var domNode = this.getDomNode(dom)
        if (domNode)
        {
          if (domNode.clientWidth !== undefined)
          {
            ret.w = domNode.clientWidth
            ret.h = domNode.clientHeight
          }
          else if (domNode.offsetWidth !== undefined)
          {
            ret.w = domNode.offsetWidth
            ret.h = domNode.offsetHeight
          }
        }
        return ret
      }

      /**
       * 取dom的考研度
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Number}
       */

    }, {
      key: 'getWidth',
      value: function getWidth(dom)
      {
        var domNode = this.getDomNode(dom)
        var x = 0
        if (domNode)
        
          if (domNode.getComputedStyle) x = domNode.offsetWidth; else if (window.getComputedStyle) x = parseInt(document.defaultView.getComputedStyle(domNode, null).getPropertyValue('width'))
        
        return x
      }

      /**
       * 取dom的高度
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Number}
       */

    }, {
      key: 'getHeight',
      value: function getHeight(dom)
      {
        var domNode = this.getDomNode(dom)
        var y = 0
        if (domNode)
        
          if (domNode.getComputedStyle) y = domNode.offsetHeight; else if (window.getComputedStyle) y = parseInt(document.defaultView.getComputedStyle(domNode, null).getPropertyValue('height'))
        
        return y
      }

      /**
       * 根据DOM取DomNode的位置、大小
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Object}    结构如{x: Number, yx: Number, wx: Number, hx: Number}
       */

    }, {
      key: 'getPosSize',
      value: function getPosSize(dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode)
        {
          return {
            x: domNode.offsetLeft,
            y: domNode.offsetTop,
            w: domNode.offsetWidth,
            h: domNode.offsetHeight
          }
        }
        return { x: 0, y: 0, w: 0, h: 0 }
      }

      /**
       * 根据DOM取DomNode在Body中的的位置、大小
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Object}    结构如{x: Number, yx: Number, wx: Number, hx: Number}
       */

    }, {
      key: 'getPosSizeBody',
      value: function getPosSizeBody(dom)
      {
        var body = this.body()
        var list = []
        var domNode = this.getDomNode(dom)
        var ret = { x: 0, y: 0, w: 0, h: 0 }
        if (domNode)
        {
          if (domNode === body)
          {
            ret.w = window.innerWidth
            ret.h = window.innerHeight
          }
          else
          {
            ret.w = domNode.offsetWidth
            ret.h = domNode.offsetHeight
          }
          //递归往上找
          while (domNode !== body)
          {
            list.push({
              x: domNode.offsetLeft,
              y: domNode.offsetTop
            })
            if (domNode === body) break
            domNode = domNode.parentNode
          }
          //递归取
          for (var i = 0; i < list.length; i++)
          {
            ret.x += list[i].x
            ret.y += list[i].y
          }
        }
        return ret
      }

      /**
       * 把dom移动到指定的位置(x, y)
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {Number}    x               x坐标(像素)
       * @param   {Number}    y               y坐标(像素)
       * @returns {Object}                    this
       */

    }, {
      key: 'moveTo',
      value: function moveTo(dom, x, y)
      {
        this.setStyle(dom, { left: x + 'px', top: y + 'px' })
        return this
      }

      /**
       * 水平居中对齐两个DOM(待对齐DOM、参照DOM)
       * @static
       * @method
       * @param   {dom}       refDom          参照DOM
       * @param   {dom}       dom             待对齐的DOM
       * @returns {Object}                    this
       */

    }, {
      key: 'setAlignCenter',
      value: function setAlignCenter(refDom, dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.style.left = parseInt(this.getWidth(refDom) / 2 - this.getWidth(domNode) / 2) + 'px'
        return this
      }

      /**
       * 垂直居中对齐两个DOM(待对齐DOM、参照DOM)
       * @static
       * @method
       * @param   {dom}     refDom            参照DOM
       * @param   {dom}     dom               待对齐的DOM
       * @returns {Object}                    this
       */

    }, {
      key: 'setAlignMiddle',
      value: function setAlignMiddle(refDom, dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode) domNode.style.top = parseInt(this.getHeight(refDom) / 2 - this.getHeight(domNode) / 2) + 'px'
        return this
      }

      /**
       * 克隆dom
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {dom}
       */

    }, {
      key: 'clone',
      value: function clone(dom)
      {
        var domNode = this.getDomNode(dom)
        var obj = void 0
        if (domNode)
        {
          obj = domNode.cloneNode(false)
          this.setStyle(obj, {
            left: domNode.offsetLeft + 'px',
            top: domNode.offsetTop + 'px',
            width: domNode.clientWidth + 'px',
            height: domNode.clientHeight + 'px'
          })
          obj.id = ''
          this.body().appendChild(obj)
        }
        return obj
      }

      /**
       * 元素全屏
       * @static
       * @method
       * @param   {dom}       dom
       * @returns {Object}                    this
       */

    }, {
      key: 'fullScreen',
      value: function fullScreen(dom)
      {
        var domNode = this.getDomNode(dom)
        if (domNode)
        {
          //W3C
          if (domNode.requestFullscreen) //FireFox
            domNode.requestFullscreen(); else if (domNode.mozRequestFullScreen) //IE11
            domNode.mozRequestFullScreen(); else if (domNode.msRequestFullscreen) //Chrome?
            domNode.msRequestFullscreen(); else if (domNode.webkitRequestFullscreen) domNode.webkitRequestFullScreen()
        }
        return this
      }

      /**
       * 返回DOM的键值对的文本(key='value')
       * @static
       * @method
       * @param   {String}  key              键
       * @param   {String}  value            值
       * @returns {String}
       */

    }, {
      key: 'getKeyVal',
      value: function getKeyVal(key, value)
      {
        return ' ' + key + '="' + value + '"'
      }

      /**
       * 返回DOM的Style文本(key:value)
       * @static
       * @method
       * @param   {String}    key              键
       * @param   {String}    value            值
       * @returns {String}
       */

    }, {
      key: 'getCssStr',
      value: function getCssStr(key, value)
      {
        if (value) return key + ':' + value + ''
        return ''
      }

      /**
       * 取/设置属性
       * @static
       * @method
       * @param  {dom}        dom             dom
       * @param  {String}     attName         属性名
       * @param  {String}     attValue        属性值(undefined时为取值，否则设值)
       */

    }, {
      key: 'attr',
      value: function attr(dom, attName, attValue)
      {
        var domNode = this.getDomNode(dom)
        if (attValue === undefined) return domNode ? domNode.getAttribute(attName) : null; else
        
        if (domNode) domNode.setAttribute(attName, attValue)
      }

      /**
       * 根据指定的位置调整DOM位置以适应屏幕
       * @static
       * @method
       * @param   {dom}       dom             dom
       * @param   {Object}    pos             位置{x, y}
       * @param   {Number}    horizontalAlign 水平对齐方式(cx.consts.ALIGN_LEFT/ALIGN_CENTER/ALIGN_RIGHT)
       * @param   {Number}    verticalAlign   垂直对齐方式(cx.consts.ALIGN_TOP/ALIGN_MIDDLE/ALIGN_BOTTOM)
       * @returns {Object}                    this
       */

    }, {
      key: 'fitPos',
      value: function fitPos(dom, pos, horizontalAlign, verticalAlign)
      {
        var posSize = this.getPosSizeBody(this.getDomNode(dom))
        var cs = Base.window.getClientSize()
        var x = posSize.x
        var y = posSize.y
        switch (horizontalAlign)
        {
        case Consts.ALIGN_LEFT:
          x = pos.x
          break
        case Consts.ALIGN_CENTER:
          x = pos.x - posSize.w / 2
          break
        case Consts.ALIGN_RIGHT:
          x = pos.x - posSize.w
          break
        }
        switch (verticalAlign)
        {
        case Consts.ALIGN_TOP:
          y = pos.y
          break
        case Consts.ALIGN_MIDDLE:
          y = pos.y - posSize.h / 2
          break
        case Consts.ALIGN_BOTTOM:
          y = pos.y - posSize.h
          break
        }
        //判断超出屏幕
        if (x + posSize.w >= cs.w) //右边超出屏幕则左移
          x = cs.w - posSize.w
        if (x < 0) //左边超出屏幕
          x = 0
        if (y + posSize.h >= cs.h) //下边超出屏幕则左移
          y = cs.y - posSize.h
        if (y < 0) //上边超出屏幕
          y = 0
        this.setStyle(dom, { left: x + Consts.PX, top: y + Consts.PX })
        return this
      }
    }])
    return Dom
  }())

  /**
   * cx.domClass
   * 类-dom辅助类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-01
   */

  var DomClass = (function()
  {
    function DomClass()
    {
      classCallCheck(this, DomClass)
    }

    createClass(DomClass, null, [{
      key: 'has',

      /**
       * 判断DOM是否具有指定的CSS类
       * @static
       * @method
       * @param   {dom}       dom
       * @param   {String}    className
       * @returns {Boolean}
       */
      value: function has(dom, className)
      {
        var domNode = Dom.getDomNode(dom)
        return domNode && domNode.className.indexOf(className) >= 0 ? true : false
      }

      /**
       * 增加类名
       * @static
       * @method
       * @param  {dom}    dom
       * @param  {String}  className
       */

    }, {
      key: 'add',
      value: function add(dom, className)
      {
        var domNode = Dom.getDomNode(dom)
        if (domNode && className) domNode.className += ' ' + className
      }

      /**
       * 删除类名
       * @static
       * @method
       * @param  {dom}    dom
       * @param  {String}  className
       */

    }, {
      key: 'remove',
      value: function remove(dom, className)
      {
        var domNode = Dom.getDomNode(dom)
        if (domNode && className) domNode.className = domNode.className.replace(className, '').trim()
      }

      /**
       * 替换类名
       * @static
       * @method
       * @param  {dom}    dom
       * @param  {String}  oldClassName
       * @param  {String}  newClassName
       */

    }, {
      key: 'replace',
      value: function replace(dom, oldClassName, newClassName)
      {
        var domNode = Dom.getDomNode(dom)
        if (domNode && oldClassName) domNode.className = domNode.className.replace(oldClassName, newClassName).trim()
      }
    }])
    return DomClass
  }())

  /**
   * $g.entities
   * 类-实体管理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Entities = (function()
  {
    /**
     * @constructor
     * @param   {Object}    data                数据
     */
    function Entities()
    {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []
      classCallCheck(this, Entities)

      this.list = data
      this.data = {}
      this.init()
    }

    /**
     * 预处理entity数据，按major、minor组织
     * @private
     * @method
     */


    createClass(Entities, [{
      key: 'init',
      value: function init()
      {
        var nMajor = void 0,
          nMinor = void 0
        var aSource = this.list
        for (var i = 0, iLen = aSource.length; i < iLen; i++)
        {
          nMajor = aSource[i].major
          nMinor = aSource[i].minor
          this.data[nMajor] = this.data[nMajor] || {}
          this.data[nMajor][nMinor] = aSource[i]
        }
      }

      /**
       * 取全部实体信息
       * @method
       * @returns {Array}
       */

    }, {
      key: 'getAll',
      value: function getAll()
      {
        return this.list
      }

      /**
       * 根据名称取实体信息
       * @method
       * @param   {String}    name                名称
       * @returns {Object}
       */

    }, {
      key: 'byName',
      value: function byName(name)
      {
        return Array$1.get1(this.list, { name: name })
      }

      /**
       * 根据属性表名取实体信息
       * @method
       * @param   {String}    name                表名
       * @returns {Object}
       */

    }, {
      key: 'byTabAtt',
      value: function byTabAtt(name)
      {
        return Array$1.get1(this.list, { tabatt: name })
      }

      /**
       * 根据主类型取实体集
       * @method
       * @param   {Number}    major               主类型
       * @returns {Object}
       */

    }, {
      key: 'byMaj',
      value: function byMaj(major)
      {
        return this.data[major]
      }

      /**
       * 根据主类型、子类型取实体信息
       * @method
       * @param   {Number}    major               主类型
       * @param   {Number}    minor               子类型
       * @returns {Object}
       */

    }, {
      key: 'byMajMin',
      value: function byMajMin(major, minor)
      {
        var majors = this.data[major]
        if (majors) return majors[minor]
      }
    }])
    return Entities
  }())

  /**
   * cx.error
   * 类-全局错误处理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-08-21
   */
  var Error$1 = (function()
  {
    function Error()
    {
      classCallCheck(this, Error)
    }

    createClass(Error, null, [{
      key: 'error',

      /**
       * 错误处理
       * @static
       * @method
       */
      value: function error(msg)
      {
        console.log(msg)
      }
    }])
    return Error
  }())

  /**
   * cx.events
   * 类-观察者
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-28
   */

  var Events = (function()
  {
    function Events()
    {
      classCallCheck(this, Events)
    }

    createClass(Events, null, [{
      key: 'destroy',

      //active      是否激活状态(false-非激活, true-激活)
      //able        是否一直保持激活状态(true-一直保持激活，false-可以被暂时挂起)

      /**
       * 销毁对象
       * @static
       * @method
       */
      value: function destroy()
      {
        delete this.list
      }

      /**
       * 初始化
       * @static
       * @method
       * @returns {Object}                      this
       */

    }, {
      key: 'init',
      value: function init()
      {}

      /**
       * 订阅消息
       * @static
       * @method
       * @param   {*}             id            id标识
       * @param   {String|Number} dataType      数据类型
       * @param   {cx.Caller}     caller        回调函数
       * @param   {Object}        [obsTar]      观察目标对象,有值的话就只接受该对象的的类型
       * @returns {Object}                      this
       */

    }, {
      key: 'subscribe',
      value: function subscribe(id, dataType, caller, obsTar)
      {
        this.list.push({ id: id, dataType: dataType, caller: caller, obsTar: obsTar, active: true, able: false })
        return this
      }

      /**
       * 取消订阅消息。没有obsTar时，删除所有注册id的记录；否则删除注册id记录中，订阅目标是obsTar对象的记录
       * @static
       * @method
       * @param   {*}             id            id标识
       * @param   {Object}        [obsTar]      观察目标对象
       * @param   {String|Number} dataType      数据类型
       * @param   {cx.Caller}     caller        回调函数
       * @returns {Object}                      this
       */

    }, {
      key: 'unsubscribe',
      value: function unsubscribe(id, obsTar, dataType, caller)
      {
        var exp = { id: id }
        if (obsTar) exp.obsTar = obsTar
        if (dataType) exp.dataType = dataType
        if (caller) exp.caller = caller
        Array$1.remove(this.list, exp)
        return this
      }

      /**
       * 发布消息
       * @static
       * @method
       * @param   {String}        dataType      数据类型
       * @param   {*}             params        调用回调函数的信息
       * @param   {Object}        [obsTar]      观察目标对象（广播该消息的对象）
       * @returns {Object}                      this
       */

    }, {
      key: 'publish',
      value: function publish(dataType, params, obsTar)
      {
        var exp = { dataType: dataType }
        if (obsTar !== undefined) exp.obsTar = obsTar

        var items = Array$1.gets(this.list, exp)
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var item = _step.value

            if (item.active) Base.call(item.caller, params)
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return this
      }

      /**
       * 监听消息
       * @static
       * @method
       * @param   {*}                      id            id标识
       * @param   {String}                 dataType      数据类型
       * @param   {cx.Caller|Function}     caller        回调函数
       * @param   {Object}                 [obsTar]      观察目标对象
       * @returns {Object}                               this
       */

    }, {
      key: 'listen',
      value: function listen(id, dataType, caller, obsTar)
      {
        this.subscribe(id, dataType, caller, obsTar)
        return this
      }

      /**
       * 取消监听。没有obsTar时，删除所有注册id的记录；否则删除注册id记录中，订阅目标是obsTar对象的记录
       * @static
       * @method
       * @param   {*}             id            id标识
       * @param   {Object}        [obsTar]      订阅的目标对象
       * @param   {String}        dataType      数据类型
       * @returns {Object}                      this
       */

    }, {
      key: 'unlisten',
      value: function unlisten(id, obsTar, dataType)
      {
        this.unsubscribe(id, obsTar, dataType)
        return this
      }

      /**
       * 使某一对象的监听一直保持激活
       * @static
       * @method
       * @param   {*}             id            id标识
       * @param   {Array}         dataTypes     数据类型列表（指定了类型则限定指定的类型，否则该对象的全部监听保持一直激活）
       * @returns {Object}                      this
       */

    }, {
      key: 'keepActive',
      value: function keepActive(id, dataTypes)
      {
        var dataType = void 0

        var _iteratorNormalCompletion2 = true
        var _didIteratorError2 = false
        var _iteratorError2 = undefined

        try
        {
          for (var _iterator2 = this.list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
          {
            var item = _step2.value

            if (item.id !== id) continue
            if (!dataTypes || dataTypes.length < 1) item.able = true; else
            {
              var _iteratorNormalCompletion3 = true
              var _didIteratorError3 = false
              var _iteratorError3 = undefined

              try
              {
                for (var _iterator3 = dataTypes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)
                {
                  dataType = _step3.value

                  if (dataType === item.dataType) item.able = true
                }
              }
              catch (err)
              {
                _didIteratorError3 = true
                _iteratorError3 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion3 && _iterator3.return)
                  
                    _iterator3.return()
                }
                finally
                {
                  if (_didIteratorError3)
                  
                    throw _iteratorError3
                }
              }
            }
          }
        }
        catch (err)
        {
          _didIteratorError2 = true
          _iteratorError2 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion2 && _iterator2.return)
            
              _iterator2.return()
          }
          finally
          {
            if (_didIteratorError2)
            
              throw _iteratorError2
          }
        }

        return this
      }

      /**
       * 激活某一个对象的监听，其他对象里面消息为dataTypes的监听全部关闭
       * @static
       * @method
       * @param   {*}             id            id标识
       * @param   {Array}         dataTypes     数据类型列表（指定了类型则限定指定的类型，否则该对象的全部监听保持一直激活）
       * @param   {Object}        [obsTar]      观察目标对象
       * @returns {Object}                      this
       */

    }, {
      key: 'active',
      value: function active(id, dataTypes, obsTar)
      {
        var dataType = void 0

        var _iteratorNormalCompletion4 = true
        var _didIteratorError4 = false
        var _iteratorError4 = undefined

        try
        {
          for (var _iterator4 = this.list[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true)
          {
            var item = _step4.value

            if (obsTar && item.obsTar !== obsTar) continue
            if (item.able) //true-一直激活, false-可以停用
            {
              item.active = true
              continue
            }
            if (item.id === id) item.active = true; else
            {
              if (!dataTypes || dataTypes.length < 1) //没有指定类型则挂起 supend
                item.active = false; else
              {
                var _iteratorNormalCompletion5 = true
                var _didIteratorError5 = false
                var _iteratorError5 = undefined

                try
                {
                  for (var _iterator5 = dataTypes[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true)
                  {
                    dataType = _step5.value

                    if (dataType === item.dataType) item.active = false
                  }
                }
                catch (err)
                {
                  _didIteratorError5 = true
                  _iteratorError5 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion5 && _iterator5.return)
                    
                      _iterator5.return()
                  }
                  finally
                  {
                    if (_didIteratorError5)
                    
                      throw _iteratorError5
                  }
                }
              }
            }
          }
        }
        catch (err)
        {
          _didIteratorError4 = true
          _iteratorError4 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion4 && _iterator4.return)
            
              _iterator4.return()
          }
          finally
          {
            if (_didIteratorError4)
            
              throw _iteratorError4
          }
        }

        return this
      }

      /**
       * 激活全部监听
       * @static
       * @method
       * @param   {Object}        [obsTar]      观察目标对象
       * @returns {Object}                      this
       */

    }, {
      key: 'activeAll',
      value: function activeAll(obsTar)
      {
        var _iteratorNormalCompletion6 = true
        var _didIteratorError6 = false
        var _iteratorError6 = undefined

        try
        {
          for (var _iterator6 = this.list[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true)
          {
            var item = _step6.value

            if (obsTar && item.obsTar !== obsTar) continue
            item.active = true
          }
        }
        catch (err)
        {
          _didIteratorError6 = true
          _iteratorError6 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion6 && _iterator6.return)
            
              _iterator6.return()
          }
          finally
          {
            if (_didIteratorError6)
            
              throw _iteratorError6
          }
        }

        return this
      }

      /**
       * 暂停某一个对象的监听（不影响别的对象）
       * @static
       * @method
       * @param   {Object}    id                id标识
       * @param   {Array}     dataTypes         数据类型列表（指定了类型则限定指定的类型，否则该对象的全部监听保持一直激活）
       * @returns {Object}                      this
       */

    }, {
      key: 'unactive',
      value: function unactive(id, dataTypes)
      {
        var item = void 0,
          dataType = void 0

        var _iteratorNormalCompletion7 = true
        var _didIteratorError7 = false
        var _iteratorError7 = undefined

        try
        {
          for (var _iterator7 = this.list[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true)
          {
            item = _step7.value

            if (item.id === id)
            {
              if (!dataTypes || dataTypes.length < 1) //没有指定类型则挂起 supend
                item.active = false; else
              {
                var _iteratorNormalCompletion8 = true
                var _didIteratorError8 = false
                var _iteratorError8 = undefined

                try
                {
                  for (var _iterator8 = dataTypes[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true)
                  {
                    dataType = _step8.value

                    if (dataType === item.dataType) item.active = false
                  }
                }
                catch (err)
                {
                  _didIteratorError8 = true
                  _iteratorError8 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion8 && _iterator8.return)
                    
                      _iterator8.return()
                  }
                  finally
                  {
                    if (_didIteratorError8)
                    
                      throw _iteratorError8
                  }
                }
              }
            }
          }
        }
        catch (err)
        {
          _didIteratorError7 = true
          _iteratorError7 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion7 && _iterator7.return)
            
              _iterator7.return()
          }
          finally
          {
            if (_didIteratorError7)
            
              throw _iteratorError7
          }
        }

        return this
      }
    }])
    return Events
  }())

  Events.list = []

  /**
   * cx.ExpExcel
   * 数据报表，导出Excel文件
   *
   * @class
   * @memberof    cx
   * @author      Gao Xulong
   * @since       2018-07-18
   */

  var ExpExcel = (function()
  {
    function ExpExcel()
    {
      classCallCheck(this, ExpExcel)
    }

    createClass(ExpExcel, null, [{
      key: 'exportToExcel',

      /**
      * 单元格Style样式使用说明。
      * @typedef	    {Object}	      ExcelStyle
       * @property    {Object}        fill                    填充样式
       * @property    {Object}        fill.patternType        图表类型(可取值： 'solid' or 'none')
       * @property    {COLOR_SPEC}    fill.fgColor            填充颜色
       * @property    {COLOR_SPEC}    fill.bgColor            边框颜色
       * @property    {Object}        font                    字体样式
       * @property    {String}        font.name               单元格内容的字体(如'宋体')
       * @property    {Number}        font.sz                 字体大小
       * @property    {COLOR_SPEC}    font.color              字体颜色
       * @property    {Boolean}       font.bold               是否加粗（默认false）
       * @property    {Boolean}       font.underline          是否加下划线（默认false）
       * @property    {Boolean}       font.italic             是否斜体（默认false）
       * @property    {Boolean}       font.strike             字体中间是否加入横划线（默认false）
       * @property    {Boolean}       font.outline            是否显示轮廓线（默认false）
       * @property    {Boolean}       font.shadow             是否有阴影（暂时未看出具体效果）
       * @property    {Boolean}       font.vertAlign          是否强制不准自动换行(默认false）
       * @property    {Object}        alignment                对齐样式
       * @property    {String}        alignment.vertical       单元格内字体垂直方向对齐方式。（可取值:"bottom"||"center"||"top" ,默认bottom,下对齐）
       * @property    {String}        alignment.horizontal     单元格内字体水平方向对齐方式。（可取值:"bottom"||"center"||"top" ,默认bottom,左对齐）
       * @property    {Boolean}       alignment.wrapText       单元格内容是否自动换行。（默认为false）
       * @property    {Number}        alignment.readingOrder   指定内容的阅读顺序。(可取值：2（for right-to-left）...,具体用法暂不清楚)
       * @property    {Boolean}       alignment.textRotation   单元格内容旋转角度。（取值范围（0~255）,默认角度为0）
       * @property    {Object}        border                   边框样式
       * @property    {Object}        border.top               上边框的样式
       * @property    {COLOR_SPEC}    border.top.color         上边框的线条颜色
       * @property    {BORDER_STYLE}  border.top.style         上边框的线条样式
       * @property    {Object}        border.bottom            下边框的样式
       * @property    {COLOR_SPEC}    border.bottom.color      下边框的线条颜色
       * @property    {BORDER_STYLE}  border.bottom.style      下边框的线条样式
       * @property    {Object}        border.left              左边框的样式
       * @property    {COLOR_SPEC}    border.left.color        左边框的线条颜色
       * @property    {BORDER_STYLE}  border.left.style        左边框的线条样式
       * @property    {Object}        border.right             右边框的样式
       * @property    {COLOR_SPEC}    border.right.color       右边框的线条颜色
       * @property    {BORDER_STYLE}  border.right.style       右边框的线条样式
       * @property    {Object}        border.diagonal          对角线的样式
       * @property    {COLOR_SPEC}    border.diagonal.color    对角线的线条颜色
       * @property    {BORDER_STYLE}  border.diagonal.style    对角线的线条样式
       * @property    {Boolean}       border.diagonalUp        具体用法暂不清楚
       * @property    {Boolean}       border.diagonalDown      具体用法暂不清楚
       * @property    {String}        numFmt                  格式化单元格内的数据（各种取值对应效果如下：）
       * "0"-----------------------------------> 将单元格内容格式化成数字格式
       * "0.00%"----------------------------> 将单元格内容格式化成百分数格式
       * "0.0%"------------------------------> (暂时不清楚用法)
       * "0.00%;\\(0.00%\\);\\-;@"---------> 将单元格内容指定自定义格式的字符串，可避开特殊字符
       * "m/dd/yy"--------------------------> 使用Excel格式表示字符串格式的日期格式
       */

      /**
       * @typedef     {Object}      COLOR_SPEC    为fill对象、font对象和border对象提供颜色样式
       * @property    {Number}      auto          指定自动值
       * @property    {Number}      theme         指定主题颜色
       * @property    {Number}      indexed       等于64时，就是fill.bgColor的默认值
       * @property    {Number}      tint          色调值的整数索引(默认值为0)
       */
      /**
       * @typedef     {String}      BORDER_STYLE  边框样式是一个字符串值，可以采用下列值之一
       * 'thin'------------------------>(效果暂未知)
       * 'medium'---------------------->(效果暂未知)
       * 'thick'----------------------->(效果暂未知)
       * 'dotted'---------------------->(效果暂未知)
       * 'hair'------------------------>(效果暂未知)
       * 'dashed'---------------------->(效果暂未知)
       * 'mediumDashed'---------------->(效果暂未知)
       * 'dashDot'--------------------->(效果暂未知)
       * 'mediumDashDot'--------------->(效果暂未知)
       * 'dashDotDot'------------------>(效果暂未知)
       * 'mediumDashDotDot'------------>长短不一的虚线
       * 'slantDashDot'---------------->(效果暂未知)
       */

      /**
       * json数据导出为Excel文件。
       * @static
       * @method
       * @param {Object}        param                         参数对象
       * @param {Array.Object}  param.json                    待导出的json数据
       * @param {Object}        param.columns                 列字段及别名的map集合。格式：{column1: column1title, column2: column2title, ...}
       * @param {Object}        [param.title]                 主标题。不传的话不显示。
       * @param {String}        [param.filename = 'mySheet']  待导出的文件的文件名
       * @param {Object}        [param.style]                 exce文件的主标题、列标题、单元格等样式。可传可不传。
       * @param {ExcelStyle}    [param.style.main]            主标题样式。格式为{fill:{}, font:{}, alignment:{}, border:{}}
       * @param {Object}        [param.style.main.fill]       主标题填充样式
       * @param {Object}        [param.style.main.font]       主标题字体样式
       * @param {Object}        [param.style.main.alignment]  主标题对齐样式
       * @param {Object}        [param.style.main.border]     主标题边框样式
       * @param {ExcelStyle}    [param.style.head]            列标题样式。（内部格式同上）
       * @param {ExcelStyle}    [param.style.comm]            普通单元格样式。（内部格式同上）
       */
      value: function exportToExcel(param)
      {
        var _this = this

        //1、初始化变量
        var filename = param.filename === undefined || param.filename === '' ? 'mySheet' : param.filename //sheet页名
        var sheetName = param.sheetName || filename //sheet页名，如果传入的有，用传入的；否则，用文件名前30位。
        //对文件名进行过滤，过滤非法字符  / \ " : | * ? < >
        filename = this.fillterFileName(filename)
        sheetName = this.fillterFileName(sheetName)
        var json = JSON.parse(JSON.stringify(param.json)) //json源数据
        var style = this.setStyle(param) //构造的主标题、列标题、单元格等样式
        var columns = param.columns //列字段及别名的map集合
        var downloadName = filename + '.xlsx' //最终下载的文件名(带格式后缀)。
        var keyMap = [] //excel列的keys集合。
        var tmpdata = [] //用来保存转换好的json
        json.unshift({}) //空出一行来存放列标题
        //2、构造列标题集合。
        for (var key in columns)
        {
          keyMap.push(key)
          json[0][key] = columns[key]
        }
        //3、如果传入主标题则空出两行来显示
        if (param.title)
        {
          json.unshift({})
          json.unshift({}) //空出两行来存放主标题
        }
        //4、遍历数据源json构造excel数据。
        json.map(function(v, i)
        {
          return keyMap.map(function(k, j)
          {
            return Object.assign({}, {
              v: v[k] === undefined ? '' : v[k],
              position: (j > 25 ? _this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
            })
          })
        }).reduce(function(prev, next)
        {
          return prev.concat(next)
        }).forEach(function(v, i)
        {
          tmpdata[v.position] = {
            v: v.v, //单元格内容
            s: style.comm //单元格样式
          }
          if (v.v && typeof v.v === 'string' && v.v.indexOf('错误:') !== -1)
          {
            tmpdata[v.position].s = Object.assign({}, style.comm, {
              font: {
                color: { rgb: 'FFFFAA00' }
              }
            })
          }
        })
        //5、设置数据填充区域以及Sheet页名称。
        var outputPos = Object.keys(tmpdata) //设置区域,比如表格从A1到D10
        var SheetNames = []
        var Sheets = {}
        SheetNames.push(sheetName)
        Sheets[sheetName] = Object.assign({}, tmpdata, //内容
          { '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] //设置填充区域
          })
        var tmpWB = {
          SheetNames: SheetNames, //保存的表标题
          Sheets: Sheets
          //6、针对主标题进行自定义合并以及样式的自定义设定。
        }; var dataInfo = tmpWB.Sheets[tmpWB.SheetNames[0]]
        if (param.title)
        {
          //设置合并方式。存的是一个对象数组，每个对象标识一个合并方式。其中s:{c:0, r:0}和 e: {c: keyMap.length - 1, r: 1}分别表示开始的单元格位置和结束的单元格位置，这两个位置的对角线所属矩形范围都将合并成一个单元格，
          //其中 c是列序号，r是行序号；
          dataInfo['!merges'] = [{ s: { c: 0, r: 0 }, e: { c: keyMap.length - 1, r: 1 } }]
          dataInfo['A1'].v = sheetName //设置表格标题         //设置主标题样式
          dataInfo['A1'].s = style.main
        }
        //7、自定义设置列标题的样式
        dataInfo[param.title ? 'A3' : 'A1'].s = style.head
        for (var i = 1; i < keyMap.length; i++)
        
          dataInfo[this.getCharCol(i) + (param.title ? '3' : '1')].s = style.head
        //8、创建二进制对象写入转换好的字节流
        var tmpDown = new Blob([this.stringToArrayBuffer(XLSX__default['default'].write(tmpWB, { bookType: 'xlsx', bookSST: false, type: 'binary' //这里的数据是用来定义导出的格式类型
        }))], { type: '' })
        //9、创建链接并下载文件
        var href = URL.createObjectURL(tmpDown) //创建对象超链接
        this.downloadFile(href, downloadName) //下载文件
        setTimeout(function() //延时释放
        {
          // URL.revokeObjectURL(tmpDown)    //用URL.revokeObjectURL()来释放这个object URL
        }, 100)
      }
    }, {
      key: 'downloadFile',
      value: function downloadFile(url, filename)
      {
        var domA = document.createElement('a') //创建一个a标签,用做后面的模拟点击下载操作。
        domA.href = url //绑定a标签的下载地址
        domA.download = filename //绑定a标签的下载文件名
        domA.click() //模拟点击实现下载
      }

      /**
       * 过滤掉名称中的特殊字符   / \ " : | * ? < >
       * @static
       * @method
       * @returns {fileName}  名称字符串
       */

    }, {
      key: 'fillterFileName',
      value: function fillterFileName(fileName)
      {
        return fileName.replace(/\\/g, '').replace(/\//g, '').replace(/"/g, '').replace(/:/g, '').replace(/\|/g, '').replace(/\*/g, '').replace(/\?/g, '').replace(/</g, '').replace(/>/g, '').substring(0, 30)
      }

      /**
       * 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
       * @static
       * @method
       * @param   {Number}  num 自然数
       * @returns {String}  自然数转成的字母
       */

    }, {
      key: 'getCharCol',
      value: function getCharCol(num)
      {
        var s = ''
        var m = 0
        while (num > 0)
        {
          m = num % 26 + 1
          s = String.fromCharCode(m + 64) + s
          num = (num - m) / 26
        }
        return s
      }
    }, {
      key: 'setStyle',
      value: function setStyle(param)
      {
        var style = {
          main: {
            font: {
              name: '宋体',
              sz: 20,
              color: { rgb: 'FFFFAA00' },
              bold: true
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true
            }
          },
          head: {
            font: {
              name: '宋体',
              sz: 14,
              bold: true
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true
            }
          },
          comm: {
            alignment: {
              vertical: 'center',
              horizontal: 'center',
              wrapText: true
            }
          }
        }
        style.main = param.style && param.style.main ? param.style.main : style.main
        style.head = param.style && param.style.head ? param.style.head : style.head
        style.comm = param.style && param.style.comm ? param.style.comm : style.comm
        return style
      }

      /**
       * 字符串转字符流
       * @static
       * @method
       * @param   {String}  str 待转成字符流的字符串
       * @returns {ArrayBuffer} 字符流
       */

    }, {
      key: 'stringToArrayBuffer',
      value: function stringToArrayBuffer(str)
      {
        var buf = new ArrayBuffer(str.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i !== str.length; ++i)
        
          view[i] = str.charCodeAt(i) & 0xFF
        return buf
      }

      /**
       * 导出多sheet页
       * @static
       * @method
       * @param {Object}        param                         参数对象
       * @param {Object.Array}  param.json                    待导出的json数据。格式{'tab1': [{},{}], 'tab2': [{},{}] };
       * @param {Object.Object} param.columns                 列字段及别名的map集合。格式：{ 'tab1': {column1: column1title, column2: column2title, ...}, 'tab2': {column1: column1title, column2: column2title, ...}}
       * @param {Object}        [param.sheets]                sheet页显示名。格式{'tab1': 名字, 'tab2': 名字 };不传默认显示表名
       * @param {String}        [param.filename = 'mySheet']  待导出的文件的文件名
       */

    }, {
      key: 'exportToSheets',
      value: function exportToSheets(param)
      {
        //1、初始化变量
        var filename = param.filename === undefined || param.filename === '' ? 'mySheet' : param.filename //sheet页名
        filename = this.fillterFileName(filename)
        var json = JSON.parse(JSON.stringify(param.json)) //json源数据
        var downloadName = filename + '.xlsx' //最终下载的文件名(带格式后缀)。

        var sheetNames = []
        var sheetsList = {}
        var wb = XLSX__default['default'].utils.book_new()

        var _loop = function _loop(key)
        {
          var sheetName = param.sheets ? param.sheets[key] : key
          sheetNames.push(sheetName)

          var columns = param.columns[key] // 此处是每个sheet的表头

          var content = []
          var columnHeader = []

          for (var i in columns)
          
            columnHeader.push(columns[i])
          content.push(columnHeader)

          json[key].forEach(function(item, index)
          {
            var arr = []
            for (var _i in columns)
            
              arr.push(item[_i])
            content.push(arr)
          })
          sheetsList[sheetName] = XLSX__default['default'].utils.aoa_to_sheet(content)
        }

        for (var key in json)
        
          _loop(key)
        

        wb['SheetNames'] = sheetNames
        wb['Sheets'] = sheetsList

        XLSX__default['default'].writeFile(wb, downloadName)
      }
    }])
    return ExpExcel
  }())

  /**
   * cx.FieldCfgs
   * 处理字段配置信息
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var FieldCfgs = (function()
  {
    /**
     * @constructor
     * @param  {Object}  data              数据
     */
    function FieldCfgs()
    {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []
      classCallCheck(this, FieldCfgs)

      this.list = data
      this.init()
    }

    /**
     * 初始化
     * @method
     */


    createClass(FieldCfgs, [{
      key: 'init',
      value: function init()
      {}

      /**
       * 根据插件名、功能取所有配置信息
       * @method
       * @param  {String}  plugin            插件名称
       * @param  {String}  func            功能
       * @returns  {Array}
       */

    }, {
      key: 'get',
      value: function get(plugin, func)
      {
        var atts = {}
        if (plugin) atts.plugin = plugin
        if (func) atts.func = func
        return Array$1.gets(this.list, atts)
      }
    }])
    return FieldCfgs
  }())

  /**
   * $g.field
   * 类-字段管理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Fields = (function()
  {
    /**
     * @constructor
     * @param   {Object}    data                数据
     */
    function Fields()
    {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, Fields)

      this.list = data
      this.fld = {}
      this.fldValue = {}
      this.init()
    }

    /**
     * 初始化
     * @method
     */


    createClass(Fields, [{
      key: 'init',
      value: function init()
      {
        var item = void 0,
          tabname = void 0,
          colname = void 0
        //字段
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.list.fld[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            item = _step.value

            tabname = item.tabname
            if (!this.fld[tabname]) this.fld[tabname] = []
            this.fld[tabname].push(item)
          }
          //字段取值
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        var _iteratorNormalCompletion2 = true
        var _didIteratorError2 = false
        var _iteratorError2 = undefined

        try
        {
          for (var _iterator2 = this.list.fldvalue[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
          {
            item = _step2.value

            tabname = item.tabname
            colname = item.colname
            if (!this.fldValue[tabname]) this.fldValue[tabname] = {}
            if (!this.fldValue[tabname][colname]) this.fldValue[tabname][colname] = []
            this.fldValue[tabname][colname].push(item)
          }
        }
        catch (err)
        {
          _didIteratorError2 = true
          _iteratorError2 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion2 && _iterator2.return)
            
              _iterator2.return()
          }
          finally
          {
            if (_didIteratorError2)
            
              throw _iteratorError2
          }
        }

        delete this.list
      }

      /**
       * 根据表名取字段信息
       * @method
       * @param   {String}    tabname             表名
       * @returns {Array.<Object>}
       */

    }, {
      key: 'getFlds',
      value: function getFlds(tabname)
      {
        if (this.fld[tabname]) return this.fld[tabname]; else return []
      }

      /**
       * 根据表名，取字段信息，并缓存到该类对象
       * @method
       * @param     {String}   tabName                         表名
       * @param     {Boolean}  [dbPrior=false]                 是否优先从数据库取，false是优先从缓存取
       * @param     {String}   [dbOrderBy='disporder ASC']     数据库获取时排序，默认用disporder升序
       * @returns   {Promise}
       */

    }, {
      key: 'getFldsDb',
      value: function getFldsDb(tabName, dbPrior)
      {
        var _this = this

        var dbOrderBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'disporder ASC'

        return new Promise(function(resolve, reject)
        {
          if (!dbPrior && _this.fld[tabName]) resolve(_this.fld[tabName]); else
          {
            var param = {
              _major: Consts.SYSTAB,
              _minor: Consts.TAB_FLD,
              _exp: 'tabname=?',
              types: 's',
              vals: tabName,
              orderby: dbOrderBy
            }
            cx.svr.area.query(param).then(function(ret)
            {
              _this.upt$g(ret, 'fld')
              _this.fld[tabName] = ret
              resolve(_this.fld[tabName])
            }).catch(function(err)
            {
              return reject(err)
            })
          }
        })
      }

      /**
       * 根据表名，字段名取字段取值信息
       * @method
       * @param   {String}    tabname             表名
       * @param   {String}    [colname]           列名，没传值时返回空数组 //整个表的fldvals
       * @param   {Boolean}   [isAll=false]       是否返回全部字段值，colname为空时生效
       * @returns {Array.<Object>}
       */

    }, {
      key: 'getFldvalues',
      value: function getFldvalues(tabname, colname, isAll)
      {
        var ret = []
        if (this.fldValue[tabname])
        {
          if (colname && this.fldValue[tabname][colname]) ret = this.fldValue[tabname][colname]

          if (!colname && isAll) ret = this.fldValue[tabname]
        }
        return ret
      }

      /**
       * 根据表名，字段名、字段值取字段取值信息
       * @method
       * @param   {String}    tabname             表名
       * @param   {String}    [colname]           列名，没传值时返回空数组 //整个表的fldvals
       * @param   {String}    [dbValue]           字段的值
       * @returns {Object}
       */

    }, {
      key: 'getFldvalue',
      value: function getFldvalue(tabname, colname, dbValue)
      {
        if (this.fldValue[tabname])
        
          if (this.fldValue[tabname][colname]) return Array$1.get1(this.fldValue[tabname][colname], { dbvalue: dbValue })
        
        return null
      }

      /**
       * 根据表名，取字段值信息，并缓存到该类对象
       * @method
       * @param     {String}   tabName                                 表名
       * @param     {Boolean}  [dbPrior=false]                         是否优先从数据库取，false是优先从缓存取
       * @param     {String}   [dbOrderBy='colname,disporder ASC']     数据库获取时排序，默认用disporder升序
       * @returns   {Promise}
       */

    }, {
      key: 'getFldvaluesDb',
      value: function getFldvaluesDb(tabName, dbPrior, dbOrderBy)
      {
        var _this2 = this

        return new Promise(function(resolve, reject)
        {
          if (!dbPrior && _this2.fldValue[tabName]) resolve(_this2.fldValue[tabName]); else
          {
            var param = {
              _major: Consts.SYSTAB,
              _minor: Consts.TAB_FLDVALUE,
              _exp: 'tabname=?',
              types: 's',
              vals: tabName,
              orderby: dbOrderBy
            }
            cx.svr.area.query(param).then(function(ret)
            {
              _this2.upt$g(ret, 'fldvalue')
              _this2.fldValue[tabName] = Array$1.listToMap(ret, 'colname')
              resolve(_this2.fldValue[tabName])
            }).catch(function(err)
            {
              return reject(err)
            })
          }
        })
      }

      /**
       * 根据表名，取fld和fldvalue数据，并缓存到该类对象
       * @method
       * @param     {String}   tabName                         表名
       * @param     {Boolean}  [dbPrior=false]                 是否优先从数据库取，false是优先从缓存取
       * @returns   {Promise}
       */

    }, {
      key: 'getFldValsDb',
      value: function getFldValsDb(tabName, dbPrior)
      {
        var promsList = [this.getFldsDb(tabName, dbPrior), this.getFldvaluesDb(tabName, dbPrior)]
        return new Promise(function(resolve, reject)
        {
          Promise.all(promsList).then(function(rets)
          {
            resolve({ fld: rets[0], fldvalue: rets[1] })
          }).catch(reject)
        })
      }

      /**
       * 根据字段对象和值取服务识别的字段类型信息
       * @method
       * @param   {Object}                fld                列名
       * @param   {String|Date|Number}    val                列对应的值
       * @returns {Object}                                   结构如 {type: String, value: String}
       */

    }, {
      key: 'getSvrType',
      value: function getSvrType(fld, val)
      {
        if (!Base.isObj(fld) || !Base.isNNull(val)) return null
        var ret = { type: null, value: val }
        if (this.isTypeNumByFld(fld))
        {
          if (parseInt(val) === parseFloat(val)) //整数
            ret.type = 'i'; else // 实数
            ret.type = 'r'
        }
        else if (this.isTypeDateByFld(fld)) ret.type = 'd'; else if (this.isTypeDateTimeByFld(fld)) ret.type = 't'; else if (this.isTypeStrByFld(fld)) ret.type = 's'
        return ret
      }

      /**
       * 根据表名，字段名取服务识别的字段类型信息
       * @method
       * @param   {String}    tabName             表名
       * @param   {String}    fldName             列名
       * @param   {*}         fldVal              列对应的值
       * @returns {Object}                        返回的结果对象{type, value}
       */

    }, {
      key: 'getSvrTypeByFld',
      value: function getSvrTypeByFld(tabName, fldName, fldVal)
      {
        var ret = { type: null, value: null }
        if (Base.isStr(fldName) && fldName.toLowerCase() === 'id') ret = this.getSvrType({ colname: fldName, isnum: 1 }, fldVal); else
        {
          var flds = this.getFlds(tabName)
          for (var i = 0; i < flds.length; i++)
          {
            if (flds[i].colname === fldName)
            {
              ret = this.getSvrType(flds[i], fldVal)
              break
            }
          }
        }
        return ret
      }

      /**
       * 根据表名，字段名序列取服务识别的字段类型信息
       * @method
       * @param   {String}            tabName             表名
       * @param   {Array.<String>}    fldNames            列名序列
       * @param   {Array.<*>}         fldVals             各列对应的值
       * @returns {Object}                                返回的结果对象{types, values}
       */

    }, {
      key: 'getSvrTypesByFlds',
      value: function getSvrTypesByFlds(tabName, fldNames, fldVals)
      {
        var temp = null
        var ret = { types: [], values: [] }
        var flds = this.getFlds(tabName)
        for (var j = 0; j < fldNames.length; j++)
        {
          if (Base.isStr(fldNames[j]) && fldNames[j].toLowerCase() === 'id')
          {
            temp = this.getSvrType({ colname: fldNames[j], isnum: 1 }, fldVals[j])
            if (temp)
            {
              ret.types.push(temp.type)
              ret.values.push(temp.value)
            }
          }
          else
          {
            for (var i = 0; i < flds.length; i++)
            {
              if (flds[i].colname === fldNames[j])
              {
                temp = this.getSvrType(flds[i], fldVals[j])
                if (temp)
                {
                  ret.types.push(temp.type)
                  ret.values.push(temp.value)
                  break
                }
              }
            }
          }
        }
        return ret
      }

      /**
       * 根据字段对象判断该字段是否为日期类型
       * @method
       * @param   {Object}    fld                 字段对象
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeDateByFld',
      value: function isTypeDateByFld(fld)
      {
        return !!(Base.isObj(fld) && fld.isnum === 0 && fld.disptype === Consts.DISP_DATE)
      }

      /**
       * 根据表名，字段名判断该字段是否为日期类型
       * @method
       * @param   {String}    tabName             表名
       * @param   {String}    fldName             列名序列
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeDateByName',
      value: function isTypeDateByName(tabName, fldName)
      {
        var ret = false
        var flds = this.getFlds(tabName)
        for (var i = 0; i < flds.length; i++)
        {
          if (flds[i].colname === fldName)
          {
            ret = this.isTypeDateByFld(flds[i])
            break
          }
        }
        return ret
      }

      /**
       * 根据字段对象判断该字段是否为日期时间类型
       * @method
       * @param   {Object}    fld                 字段对象
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeDateTimeByFld',
      value: function isTypeDateTimeByFld(fld)
      {
        return !!(Base.isObj(fld) && fld.isnum === 0 && fld.disptype === Consts.DISP_TIMESTAMP)
      }

      /**
       * 根据表名，字段名判断该字段是否为日期时间类型
       * @method
       * @param   {String}    tabName             表名
       * @param   {String}    fldName             列名序列
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeDateTimeByName',
      value: function isTypeDateTimeByName(tabName, fldName)
      {
        var ret = false
        var flds = this.getFlds(tabName)
        for (var i = 0; i < flds.length; i++)
        {
          if (flds[i].colname === fldName)
          {
            ret = this.isTypeDateTimeByFld(flds[i])
            break
          }
        }
        return ret
      }

      /**
       * 根据字段对象判断该字段是否为日期时间类型
       * @method
       * @param   {Object}    fld                 字段对象
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeNumByFld',
      value: function isTypeNumByFld(fld)
      {
        return !!(Base.isObj(fld) && fld.isnum !== 0)
      }

      /**
       * 根据表名，字段名判断该字段是否为数值类型
       * @method
       * @param   {String}    tabName             表名
       * @param   {String}    fldName             列名序列
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeNumByName',
      value: function isTypeNumByName(tabName, fldName)
      {
        var ret = false
        var flds = this.getFlds(tabName)
        for (var i = 0; i < flds.length; i++)
        {
          if (flds[i].colname === fldName)
          {
            ret = this.isTypeNumByFld(flds[i])
            break
          }
        }
        return ret
      }

      /**
       * 根据字段对象断该字段是否为字符串类型
       * @method
       * @param   {Object}    fld                 字段对象
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeStrByFld',
      value: function isTypeStrByFld(fld)
      {
        return !!(Base.isObj(fld) && !this.isTypeNumByFld(fld) && !this.isTypeDateByFld(fld) && !this.isTypeDateTimeByFld(fld))
      }

      /**
       * 根据表名，字段名判断该字段是否为字符串类型
       * @method
       * @param   {String}    tabName             表名
       * @param   {String}    fldName             列名序列
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isTypeStrByName',
      value: function isTypeStrByName(tabName, fldName)
      {
        var ret = false
        var flds = this.getFlds(tabName)
        for (var i = 0; i < flds.length; i++)
        {
          if (flds[i].colname === fldName)
          {
            ret = this.isTypeStrByFld(flds[i])
            break
          }
        }
        return ret
      }

      /**
       * 每次查库取fld和fldvalue后，更新缓存数据。
       * @method
       * @param     {Array<Object>}   data    fld或fldvalue的数据集合
       * @param     {String}          key     标识是fld或者fldvalue。值枚举：'fld', 'fldvalue'
       */

    }, {
      key: 'upt$g',
      value: function upt$g(data, key)
      {
        var accessData = localStorage.getItem('accessData')
        if (accessData && accessData[key])
        {
          accessData[key] = accessData[key].concat(data).filter(function(item, index, list)
          {
            return index === list.findIndex(function(li)
            {
              return li.id === item.id
            })
          })
          localStorage.setItem('accessData', JSON.stringify(accessData))
        }
      }
    }])
    return Fields
  }())

  var qs = require('qs')
  var CryptoJS = require('crypto-js')
  var secretKey = ''
  var count = 0
  var bUrlCrypt = false

  var encrypt = function encrypt(params)
  {
    var str = ''

    if (params.cmd)
    {
      str += 'cmd=' + params.cmd
      delete params.cmd
    }
    if (params._major !== undefined)
    {
      str += '&_major=' + params._major
      delete params._major
    }
    if (params._minor !== undefined)
    {
      str += '&_minor=' + params._minor
      delete params._minor
    }

    secretKey = (++count + '-whzbcx').substr(0, 8)
    params._count = count
    params._code = CryptoJS.DES.encrypt(str, CryptoJS.enc.Utf8.parse(secretKey), {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString()
  }

  /**
   * cx.http
   * 类-异步请求类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var Http = (function()
  {
    function Http()
    {
      classCallCheck(this, Http)
    }

    createClass(Http, null, [{
      key: 'init',

      /**
       * 初始化
       * @static
       * @method
       */
      value: function init()
      {
        axios__default['default'].defaults.withCredentials = true
      }

      /**
       * 全局错误处理
       * @private
       * @static
       * @method
       * @param   {Object}    data        传入错误的数据
       */

    }, {
      key: '_error',
      value: function _error(data)
      {}
      // console.log(data)


      /**
       * 判断是否返回数据
       * @private
       * @static
       * @method
       * @param   {*}         data        接收到的数据
       * @returns {Boolean}
       */

    }, {
      key: '_isStatus',
      value: function _isStatus(data)
      {
        if (data.code === 100) return false; else return true
      }

      /**
       * 设置URL是否进行加密
       * @static
       * @method
       * @param   {Boolean}   bCrypt            是否加密传输URL
       */

    }, {
      key: 'setUrlCrypt',
      value: function setUrlCrypt(bCrypt)
      {
        bUrlCrypt = bCrypt
      }

      /**
       * GET方式调用
       * @method
       * @static
       * @param   {String}    url         URL
       * @param   {Object}    params      参数
       * @param   {Object}    [urlConf]   请求的配置数据
       * @returns {Promise}
       */

    }, {
      key: 'get',
      value: function get(url, params, urlConf)
      {
        var _this = this

        return new Promise(function(resolve, reject)
        {
          if (Global && Global.user)
          {
            params._userId = params._userId || Global.user.id //切换账号是用params传入
            params._sys = params._sys || Global.user.sys
          }
          if (bUrlCrypt) encrypt(params)
          axios__default['default'].get(url, urlConf).then(function(ret)
          {
            if (_this._isStatus(ret.data)) resolve(ret.data)
          }).catch(function(ret)
          {
            _this._error(ret)
            reject(ret)
          })
        })
      }

      /**
       * POST方式调用
       * @method
       * @static
       * @param   {String}    url         URL
       * @param   {Object}    params      参数
       * @param   {Object}    [urlConf]   请求的配置数据
       * @returns {Promise}
       */

    }, {
      key: 'post',
      value: function post(url, params, urlConf)
      {
        var _this2 = this

        if (Global && Global.user)
        {
          params._userId = params._userId || Global.user.id //切换账号是用params传入
          params._sys = params._sys || Global.user.sys
        }
        if (bUrlCrypt) encrypt(params)

        //20210412 张清  徐州地质服务器环境变化，返回数据编码错误。经确认服务端代码统一范围utf-8格式，在前端统一设置请求头
        return axios__default['default'].post(url, qs.stringify(params), Object.assign({ headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }, urlConf)).then(function(ret)
        {
          if (_this2._isStatus(ret.data))
          
            if (ret.data && ret.data[0] && ret.data[0].ret !== undefined) return ret.data[0]
          
          return ret.data
        }).catch(function(ret)
        {
          _this2._error(ret)
        })
      }

      /**
       * GET方式调用
       * @method
       * @static
       * @param   {String}    url                             URL
       * @returns {Promise}
       */

    }, {
      key: 'loadText',
      value: function loadText(url)
      {
        var _this3 = this

        return new Promise(function(resolve, reject)
        {
          axios__default['default']({ url: url, data: {}, config: { responseType: 'text' } }).then(function(ret)
          {
            if (_this3._isStatus(ret.data)) resolve(ret.data)
          }).catch(function(ret)
          {
            reject(ret)
          })
        }).catch(function(ret)
        {
          return ret
        })
      }

      /**
       * GET方式调用
       * @method
       * @static
       * @param   {String}    url                             URL
       * @returns {Promise}
       */

    }, {
      key: 'loadBinary',
      value: function loadBinary(url)
      {
        var _this4 = this

        return new Promise(function(resolve, reject)
        {
          axios__default['default']({ url: url, data: {}, config: { responseType: 'arraybuffer' } }).then(function(ret)
          {
            if (_this4._isStatus(ret.data)) resolve(ret.data)
          }).catch(function(ret)
          {
            reject(ret)
          })
        }).catch(function(ret)
        {})
      }
    }])
    return Http
  }())

  axios__default['default'].defaults.withCredentials = true

  Http.CryptoJS = require('crypto-js')

  /**
   * cx.service
   * 类-服务包装类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Service = (function()
  {
    function Service()
    {
      classCallCheck(this, Service)
    }

    createClass(Service, null, [{
      key: 'add',

      /**
       * 增加URL
       * @static
       * @method
       * @param   {String}      name        服务名
       * @param   {String}      url         URL
       */
      value: function add(name, url)
      {
        if (name && url) this.urls[name] = url
      }

      /**
       * 根据Key取对应的服务URL
       * @static
       * @method
       * @param   {String}      name        服务名
       * @returns {String}
       */

    }, {
      key: 'url',
      value: function url(name)
      {
        if (this.urls[name]) return this.urls[name]

        return process.env.NODE_ENV === 'development' ? 'svr/' + name : name
      }

      /**
       * 执行后台服务
       * @static
       * @method
       * @param   {String}      url         服务的URL
       * @param   {String}      cmd         服务的命令码
       * @param   {Object}      params      其他参数
       * @returns {Promise}
       */

    }, {
      key: 'execute',
      value: function execute(url, cmd, params)
      {
        return new Promise(function(resolve, reject)
        {
          var tmpParams = { cmd: cmd }
          Base.extend(tmpParams, params)
          Http.post(url, tmpParams).then(function(ret)
          {
            if (ret instanceof Array)
            {
              if (ret.length < 1) //空数组
                resolve(ret); else if (ret.length === 1) //数组长度为1
              {
                if (ret[0].ret === undefined) //没有ret字段，默认为是数组
                  resolve(ret); else
                {
                  if (ret[0].ret === 0) //ret = 0 表示成功
                    resolve(ret[0]); else reject(ret[0])
                }
              }
              else //返回的数组
                resolve(ret)
            }
            else
            {
              if (ret.ret === undefined) //没有ret字段，默认为是对象
                resolve(ret); else
              {
                if (ret.ret === 0) //ret = 0 表示成功
                  resolve(ret); else reject(ret)
              }
            }
          }).catch(function(ret)
          {
            ret.ret = 1 //出错，需要注意错误信息的返回
            reject(ret)
          })
        })
      }
    }])
    return Service
  }())

  Service.urls = {}

  /**
   * cx.url
   * 类-URL工具
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-08-20
   */
  var Url = (function()
  {
    function Url()
    {
      classCallCheck(this, Url)
    }

    createClass(Url, null, [{
      key: 'getRequestUrl',

      /**
      * 生成http请求的url字符串
       * @static
       * @method
       * @param   {String}    url               url
       * @param   {Object}    params            可变参数
       * @returns {String}
      */
      value: function getRequestUrl(url)
      {
        var ret = url + '?'
        var param = void 0,
          key = void 0,
          count = 0

        for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)
        
          params[_key - 1] = arguments[_key]
        

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            param = _step.value

            if (!param) continue
            for (key in param)
            {
              ret += (count > 0 ? '&' : '') + key + '=' + param[key]
              count++
            }
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return ret
      }

      /**
       * 取url里面的键值
       * @static
       * @method
       * @param   {String}    url               url
       * @param   {String}    key               键值
       * @returns {String}                      值
       */

    }, {
      key: 'querySearch',
      value: function querySearch(url, key)
      {
        var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
        var r = url.match(reg)
        if (r) return r[2]
        return ''
      }

      /**
       * Get方式打开网址
       * @static
       * @method
       * @param   {String}    url               url
       */

    }, {
      key: 'open',
      value: function open(url)
      {
        window.open(url)
      }

      /**
       * 下载网址
       * @static
       * @method
       * @param   {String}    url               url
       */

    }, {
      key: 'download',
      value: function download(url)
      {
        var domA = document.createElement('a') //创建一个a标签,用做后面的模拟点击下载操作。
        domA.href = url //绑定a标签的下载地址
        domA.click() //模拟点击实现下载
      }
    }])
    return Url
  }())

  /**
   * cx.svr.doc
   * 服务-DocSvr
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Doc = (function()
  {
    function Doc()
    {
      classCallCheck(this, Doc)
    }

    createClass(Doc, null, [{
      key: 'url',

      /**
       * 取DocSvr服务对应的网址
       * @static
       * @method
       * @returns {String}                  服务网址
       */
      value: function url()
      {
        return Service.url('DocSvr')
      }

      /**
       * 取DocGetSvr服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */

    }, {
      key: 'urlGet',
      value: function urlGet()
      {
        return Service.url('DocGetSvr')
      }

      /**
       * 上载单个文件
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {Number}    params.major        实体主类型
       * @param   {Number}    params.minor        实体子类型
       * @param   {Number}    params.entityid     实体号(0-不存数据库)
       * @param   {String}    params.username     上传人
       * @param   {Number}    params.fid          fid
       * @param   {Number}    params.sys          系统号
       * @param   {Number}    params.glid         关联id(自关联ID，父实体号)
       * @param   {String}    params.task         流程环节
       * @param   {Number}    [params.tempFile=0] 是否临时文件(非0-临时文件,其他-归档文件)
       * @param   {String}    [params.dir]        保存到指定路径，路径不存在会自动创建
       * @returns {Promise}
       */

    }, {
      key: 'upload',
      value: function upload(params)
      {
        return Service.execute(this.url(), 'upload', params)
      }

      /**
       * 将多个文件信息存入到数据库(用于临时文件归档后)
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {Number}    params.major        实体主类型
       * @param   {Number}    params.minor        实体子类型
       * @param   {Number}    params.entityid     实体号
       * @param   {String}    params.username     上传人
       * @param   {Number}    params.fid          fid
       * @param   {Number}    params.sys          系统号
       * @param   {Number}    params.glid         关联id(自关联ID，父实体号)
       * @param   {String}    params.task         流程环节
       * @param   {String}    [params.separator]  分隔符(默认是”,”，可以指定)
       * @param   {String}    params.filenames    文件名（相对目录，多个用前述的分隔符分隔开）
       * @param   {String}    params.titles       标题（多个用前述的分隔符分隔开）
       * @param   {String}    params.filelens     文件长度（多个用前述的分隔符分隔开）
       * @returns {Promise}
       */

    }, {
      key: 'inserts',
      value: function inserts(params)
      {
        return Service.execute(this.url(), 'inserts', params)
      }

      /**
       * 删除文件
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.ids          文档ID列表(多个文件ID之间用,分隔)
       * @returns {Promise}
       */

    }, {
      key: 'del',
      value: function del(params)
      {
        return Service.execute(this.url(), 'delete', params)
      }

      /**
       * 根据实体删除文档
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {Number}    params.major        实体主类型
       * @param   {Number}    params.minor        实体子类型
       * @param   {Number}    params.entityid     实体ID
       * @returns {Promise}
       */

    }, {
      key: 'delEntity',
      value: function delEntity(params)
      {
        return Service.execute(this.url(), 'deleteEntity', params)
      }

      /**
       * 将临时文件存入文档库
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    [params.separator]  分隔符(默认是”,”，可以指定)
       * @param   {String}    params.filenames    文件名（相对目录，多个用前述的分隔符分隔开）
       * @returns {Promise}
       */

    }, {
      key: 'saveTempFile',
      value: function saveTempFile(params)
      {
        return Service.execute(this.url(), 'saveTempFile', params)
      }

      /**
       * 把文档转换成web可预览的swf文件
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.filename     文件名(相对于文档服务器的根目录)
       * @returns {Promise}
       */

    }, {
      key: 'toSwf',
      value: function toSwf(params)
      {
        return Service.execute(this.url(), 'toSwf', params)
      }

      /**
       * 把视频转换成可在线播放的flv流媒体
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.filename     文件名(相对于文档服务器的根目录)
       * @returns {Promise}
       */

    }, {
      key: 'toFlv',
      value: function toFlv(params)
      {
        return Service.execute(this.url(), 'toFlv', params)
      }

      /**
       * 生成缩略图
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {Number}    params.id           文档ID
       * @param   {Number}    params.width        缩略图宽度
       * @param   {Number}    params.height       缩略图高度
       * @param   {Boolean}   params.force        是否保持原图的高宽比(0-否，非0-是)
       * @returns {Promise}
       */

    }, {
      key: 'toThumbnail',
      value: function toThumbnail(params)
      {
        return Service.execute(this.url(), 'toThumbnail', params)
      }

      /**
       * 查询(支持条件/分页/部分列/排序等)
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params._exp         SQL条件表达式，参数用?代替
       * @param   {String}    [params.cols]       需要取的列(用,分隔)（不传参数默认取全部列）
       * @param   {String}    params.types        参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    params.vals         参数值(用,分隔)(与参数一一对应)
       * @param   {String}    [params.orderby]    排序（可以不传）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]       0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]     页码(1开始)
       * @param   {String}    [params.pagesize]   每页数据条数
       * @returns {Promise}
       */

    }, {
      key: 'query',
      value: function query(params)
      {
        return Service.execute(this.url(), 'query', params)
      }

      /**
       * 条件查询
       * @deprecated
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params._exp         SQL条件表达式
       * @returns {Promise}
       */

    }, {
      key: 'queryByExp',
      value: function queryByExp(params)
      {
        return Service.execute(this.url(), 'queryByExp', params)
      }

      /**
       * 通过ID(支持多个)下载原文件
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.ids          文档ID列表(多个文件ID之间用,分隔)
       */

    }, {
      key: 'download',
      value: function download(params)
      {
        Url.open(Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'download' }, params)))
      }

      /**
       * 通过ID下载缩略图
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {Number}    params.id           文档ID
       * @param   {Number}    params.width        缩略图宽度
       * @param   {Number}    params.height       缩略图高度
       */

    }, {
      key: 'downloadThumbnail',
      value: function downloadThumbnail(params)
      {
        Url.open(Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'downloadThumbnail' }, params)))
      }

      /**
       * 通过media文件id获取下载路径,多个id时返回zip
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.ids          文档ID列表(多个文件ID之间用,分隔)
       * @returns {String}                        获取文件路径url
       */

    }, {
      key: 'getDownloadUrl',
      value: function getDownloadUrl(params)
      {
        return Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'download' }, params))
      }

      /**
       * 通过文件名(支持多个)下载原文件
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.filenames    文件名(多个文件名之间用,分隔) (相对于文档服务器的根目录)
       * @param   {String}    [params.saveas]     另存为(只用于下载单个文件)
       * @param   {Number}    [params.tempFile=0] 是否临时文件(非0-临时文件,其他-归档文件)
       */

    }, {
      key: 'getFile',
      value: function getFile(params)
      {
        Url.open(Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'getFile' }, params)))
      }

      /**
       * 通过文件名下载缩略图
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.filename     文件名(相对于文档服务器的根目录)
       * @param   {Number}    params.width        缩略图宽度
       * @param   {Number}    params.height       缩略图高度
       * @param   {Number}    [params.tempFile=0] 是否临时文件(非0-临时文件,其他-归档文件)
       */

    }, {
      key: 'getThumbnail',
      value: function getThumbnail(params)
      {
        Url.open(Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'getThumbnail' }, params)))
      }

      /**
       * 通过ID取单个原文件到输出流
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {Number}    params.id           文档ID
       * @returns {String}
       */

    }, {
      key: 'stream',
      value: function stream(params)
      {
        return Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'stream' }, params))
      }

      /**
       * 通过文件名取单个原文件到输出流
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.filename     文件名(相对于文档服务器的根目录)
       * @param   {Number}    [params.tempFile=0] 是否临时文件(非0-临时文件,其他-归档文件)
       * @returns {String}
       */

    }, {
      key: 'streamFile',
      value: function streamFile(params)
      {
        return Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'streamFile' }, params))
      }

      /**
       * 通过文件名取单个原文件到输出流，输出流的效果和streamFile一样
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.filename     文件名(相对于文档服务器的根目录)
       * @param   {Number}    [params.tempFile=0] 是否临时文件(非0-临时文件,其他-归档文件)
       * @returns {String}
       * FlexPaper 不支持url中多参数 DocGetSvr?cmd=streamFile&filename=0/0/0/1.swf
       * 为了绕开这个错误，将参数传递为：DocGetSvr?filename=0/0/0/1.swf
       */

    }, {
      key: 'streamGetFile',
      value: function streamGetFile(params)
      {
        return this.urlGet() + '?filename=' + params.filename
      }

      /**
       * 通过文件名取单个文件缩略图到输出流
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.filename     文件名(相对于文档服务器的根目录)
       * @param   {Number}    params.width        缩略图宽度
       * @param   {Number}    params.height       缩略图高度
       * @returns {String}
       */

    }, {
      key: 'streamThumbnail',
      value: function streamThumbnail(params)
      {
        return Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'streamThumbnail' }, params))
      }

      /**
       * 根据实体的主类型,子类型,实体号查询附件
       * @static
       * @method
       * @param   {Number}    major               主类型
       * @param   {Number}    minor               子类型
       * @param   {Number}    entityid            实体ID
       * @returns {Promise}
       */

    }, {
      key: 'queryEntityId',
      value: function queryEntityId(major, minor, entityid)
      {
        var paras = {
          _exp: 'major=? AND minor=? AND entityid=?',
          types: 'i,i,i',
          vals: [major, minor, entityid].toString()
        }
        return Service.execute(this.url(), 'query', paras)
      }
    }])
    return Doc
  }())

  /**
   * cx.containers
   * 类-界面容器
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-06-01
   */
  var Containers = (function()
  {
    function Containers()
    {
      classCallCheck(this, Containers)
    }

    createClass(Containers, null, [{
      key: 'destroy',

      /**
       * 销毁对象
       * @static
       * @method
       */
      value: function destroy()
      {
        delete this.list
      }

      /**
       * 增加容器
       * @static
       * @method
       * @param   {String}    key                     键值
       * @param   {Object}    container               容器对象
       */

    }, {
      key: 'add',
      value: function add(key, container)
      {
        if (key && container) this.list[key] = container
      }

      /**
       * 根据键值取容器
       * @static
       * @method
       * @param   {String}    key                     键值
       * @returns {Object}                            返回key对应的对象
       */

    }, {
      key: 'get',
      value: function get(key)
      {
        return this.list[key]
      }

      /**
       * 移除容器
       * @static
       * @method
       * @param   {String}    key                     键值
       * @returns {Object}                            被移除的对象
       */

    }, {
      key: 'remove',
      value: function remove(key)
      {
        var ret = this.list[key]
        if (ret !== undefined) delete this.list[key]
        return ret
      }
    }])
    return Containers
  }())

  Containers.list = []

  /**
   * cx.localCache
   * 类-缓存对象
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */
  var LocalCache = (function()
  {
    function LocalCache()
    {
      classCallCheck(this, LocalCache)
    }

    createClass(LocalCache, null, [{
      key: 'formateKey',

      /**
       * 格式化键名
       * @method
       * @static
       * @param   {String}    key             键
       * @returns {String}                    格式化后的键
       */
      value: function formateKey(key)
      {
        return LocalCache.prefix + '_' + key
      }

      /**
       * 设置key的前缀
       * @method
       * @static
       * @param   {String}    prefix          键
       */

    }, {
      key: 'setPrefix',
      value: function setPrefix()
      {
        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''

        LocalCache.prefix = prefix
      }

      /**
       * 设置健-值对
       * @method
       * @static
       * @param   {String}    key             键
       * @param   {Object}    value           值
       * @returns {Object}                    this
       */

    }, {
      key: 'set',
      value: function set(key, value)
      {
        localStorage.setItem(this.formateKey(key), value)
        return this
      }

      /**
       * 根据健取健-值对的值
       * @method
       * @static
       * @param   {String}    key             键
       * @returns {Object}
       */

    }, {
      key: 'get',
      value: function get(key)
      {
        var ret = localStorage.getItem(this.formateKey(key))
        return ret === undefined || ret === null ? '' : ret
      }

      /**
       * 根据健删除健-值对
       * @method
       * @static
       * @param   {String}    key             键
       * @returns {Object}                    this
       */

    }, {
      key: 'remove',
      value: function remove(key)
      {
        localStorage.removeItem(this.formateKey(key))
        return this
      }

      /**
       * 清除所有
       * @method
       * @static
       * @returns {Object}                    this
       */

    }, {
      key: 'clear',
      value: function clear()
      {
        localStorage.clear()
        return this
      }
    }])
    return LocalCache
  }())

  /**
   * cx.runnings
   * 类-运行中的插件
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-06-01
   */

  var Runnings = (function()
  {
    function Runnings()
    {
      classCallCheck(this, Runnings)
    }

    createClass(Runnings, null, [{
      key: 'destroy',

      /**
       * 销毁对象
       * @static
       * @method
       */
      value: function destroy()
      {
        delete this.list
      }

      /**
       * 加入插件运行信息
       * @static
       * @method
       * @param   {Object}    plugInf                 插件运行信息
       * @param   {String}    plugInf.id              ID
       * @param   {String}    plugInf.name            名称
       * @param   {Number}    plugInf.type            类型(dialog, tabs, tabpage, pane)
       * @param   {dom}       plugInf.container       所在的DOM
       * @param   {Object}    plugInf.plugin          对象
       * @returns {Object}                            this
       */

    }, {
      key: 'add',
      value: function add(plugInf)
      {
        this.list.push(plugInf)
        return this
      }

      /**
       * 从列表中删除插件
       * @static
       * @method
       * @param   {Object}    exp                     插件运行信息
       * @param   {Number}    [exp.id]                ID
       * @param   {String}    [exp.name]              名字
       * @param   {Number}    [exp.type]              类型(dialog, tabs, tabpage, pane)
       * @param   {Object}    [exp.container]         所在的DOM
       * @param   {Object}    [exp.plugin]            插件
       * @returns {Object}                            this
       */

    }, {
      key: 'remove',
      value: function remove(exp)
      {
        Array$1.remove(this.list, exp)
        return this
      }

      /**
       * 关闭在运行插件
       * @static
       * @method
       * @param   {Object}    running                 插件的running对象
       */

    }, {
      key: 'close',
      value: function close(running)
      {
        if (running)
        {
          if (running.type === Consts.UI_TABPAGE || running.parent)
          {
            //tab页类型的插件，running.parent是tab对象
            running.parent.remove(running.name)
          }
          else if (running.type === Consts.UI_DIALOG || running.plugin)
          {
            //对话框类型的插件，running.plugin是对话框对象
            running.plugin.destroy()
          }
        }
      }

      /**
       * 销毁全部插件
       * @method
       * @static
       */

    }, {
      key: 'destroyAll',
      value: function destroyAll()
      {
        var plugs = this.list
        var i = void 0,
          plug = void 0

        for (i = plugs.length - 1; i >= 0; i--)
        {
          plug = plugs[i]
          if (plug && plug.plugin && plug.plugin.destroy) plug.plugin.destroy()
        }
      }

      /**
       * 根据名字找运行的插件
       * @static
       * @method
       * @param   {Object}    exp                     插件运行信息
       * @param   {Number}    [exp.id]                ID
       * @param   {String}    [exp.name]              名字
       * @param   {Number}    [exp.type]              类型(dialog, tabs, tabpage, pane)
       * @param   {Object}    [exp.container]         所在的DOM
       * @param   {Object}    [exp.plugin]            插件
       * @returns {Object}
       */

    }, {
      key: 'get',
      value: function get(exp)
      {
        return Array$1.get1(this.list, exp)
      }

      /**
       * 根据名字找运行的插件
       * @static
       * @method
       * @param   {Object}    exp                     插件运行信息
       * @param   {Number}    [exp.id]                ID
       * @param   {String}    [exp.name]              名字
       * @param   {Number}    [exp.type]              类型(dialog, tabs, tabpage, pane)
       * @param   {Object}    [exp.container]         所在的DOM
       * @param   {Object}    [exp.plugin]            插件
       * @returns {Array}
       */

    }, {
      key: 'find',
      value: function find(exp)
      {
        return Array$1.gets(this.list, exp)
      }

      /**
       * 切换容器
       * @method
       * @param   {String}  containerId   容器ID
       */

    }, {
      key: 'activeConatiner',
      value: function activeConatiner(containerId)
      {
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var running = _step.value

            if (running.type === Consts.UI_DIALOG)
            
              if (running.plugin && running.plugin.$refs.refDlg) running.plugin.$refs.refDlg.activeContainer(containerId)
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }
      }
    }])
    return Runnings
  }())

  Runnings.list = []

  var registers = {}

  /**
   * @class       cx.vue.RunVue
   *
   * 类-显示组件
   *
   * @author      zhang qing
   * @since       2018-05-08
   */

  var RunVue = (function()
  {
    function RunVue()
    {
      classCallCheck(this, RunVue)
    }

    createClass(RunVue, null, [{
      key: 'register',

      /**
       * 注册组件
       * @static
       * @method
       * @param   {Object}          def                         插件定义
       * @returns {Object}                                      注册的组件对象
       */
      value: function register(def)
      {
        var com = registers[def.name]
        if (com) return com

        com = this.loadModuleByDef(def)
        if (com)
        {
          Vue__default['default'].component(def.name, com)
          registers[def.name] = com
        }

        return com
      }

      /**
       * 根据配置容器获取dom对象
       * @static
       * @method
       * @param   {String|Dom} [container]                 父容器dom对象 或 id 或 tab页插件名
       * @return  {Dom}                                    容器dom对象
       */

    }, {
      key: 'getDlgContainer',
      value: function getDlgContainer(container)
      {
        //为什么要找当前容器，是因为对话框需要用到定位，每个容器的大小位置都不一样的
        if (!container)
        {
          //没有配置容器
          container = Containers.get(Global.container)
          if (container) container = container.$el
          if (!container)
          {
            container = Dom.byId('cx-scale')
            if (!container) container = Dom.body()
          }
        }
        else
        {
          //根据容器id获取对应的插件（没值是dom的id，有值是插件名）
          var plugCont = Runnings.get({ name: container, type: Consts.UI_TABPAGE })

          //容器是tab页插件，获取dom对象
          if (plugCont && plugCont.plugin)
          {
            container = Dom.byId('cx-scale')
            if (!container) container = Dom.body()
          }
        }

        return container
      }

      /**
       * 根据插件定义对象加载类模块
       * @static
       * @method
       * @param   {Object}          def         插件定义
       * @returns {Object|Class}                模块对象
       */

    }, {
      key: 'loadModuleByDef',
      value: function loadModuleByDef(def)
      {
        //def.classurl是文件名，如ManOrgan.vue 或 Base.js
        var dirs = window.plugDirs || ['plugins/cx/', 'plugins/gw/']
        var fileInf = def.classurl.split('.')

        var cat = ''
        var nameMode = dirs.some(function(item)
        {
          //压缩后的插件
          if (def.dir.indexOf(item) > -1)
          {
            //形如：plgcx plggw
            cat = 'plg' + item.split('/')[1]
            return true
          }
        })
        if (nameMode) return Vue__default['default'].component(cat + fileInf[0]) || require('@/' + def.dir + def.classurl).default; else return require('@/' + def.dir + def.classurl).default
      }

      /**
       * 根据Ui的type类型加载显示。
       * 插件初始化参数params中width、height、modal属性比def中的优先级高
       * @static
       * @method
       * @param   {Object}          def                         插件定义
       * @param   {Object}          params                      运行插件的参数
       */

    }, {
      key: 'loadPlugByDef',
      value: function loadPlugByDef(def, params)
      {
        var container = void 0,
          plug = void 0,
          plugCont = void 0
        var options = {
          name: def.name,
          type: def.uitype,
          title: Base.locale(def.titlec, def.titlee),
          closable: !!def.closeable,
          icon: def.icon,
          params: Base.extend({}, Global.dlgcfg, def.initpara, params)
        }

        options.params._pluginDef_ = def

        //对话框 且 指定了容器
        if (def.uitype === Consts.UI_DIALOG && def.container)
        {
          //根据容器id获取对应的插件（没值是dom的id，有值是插件名）
          plugCont = Runnings.get({ name: def.container, type: Consts.UI_TABPAGE })

          //容器是tab页插件，则需要激活该页容器
          if (plugCont && plugCont.plugin && plugCont.plugin.params._parent_) plugCont.plugin.params._parent_.active(def.container)
        }

        //如果插件存在则先销毁
        switch (def.uitype)
        {
        case Consts.UI_DIALOG:
          container = this.getDlgContainer(def.container)
          plug = Runnings.get({ name: def.name, type: def.uitype, container: container })
          if (plug)
          {
            if (plug.plugin.$refs.refDlg.minimized) plug.plugin.$refs.refDlg.minRestore()
            plug.plugin.destroy()
            Runnings.remove(plug)
          }
          break
        case Consts.UI_PANE:
        case Consts.UI_NONE:
          plug = Runnings.get({ name: def.name, type: def.uitype, container: def.container })
          if (plug)
          {
            plug.plugin.destroy()
            Runnings.remove(plug)
          }
          break
        }

        plug = this.register(def)
        switch (def.uitype)
        {
        case Consts.UI_DIALOG:
          options.width = Base.defVal(options.params.width, def.width)
          options.height = Base.defVal(options.params.height, def.height)

          //对话框宽高是小数时，作为相对容器尺寸的百分比
          options.width = options.width < 1 ? container.clientWidth * options.width : options.width
          options.height = options.height < 1 ? container.clientHeight * options.height : options.height

          options.modal = Base.defVal(options.params.modal, !!def.modal)
          options.alignH = Base.defVal(options.params.alignH, def.align)
          options.alignV = Base.defVal(options.params.alignV, 0)
          options.showMin = Base.defVal(options.params.showMin, true)
          options.showMax = Base.defVal(options.params.showMax, false)
          options.showSize = Base.defVal(options.params.showSize, true)
          options.dlgType = options.params.dlgType
          options.borderOuter = Base.defVal(options.params.borderOuter, 0)
          options.borderInner = Base.defVal(options.params.borderInner, 0)
          options.gapBorders = Base.defVal(options.params.gapBorders, 0)
          options.visible = Base.defVal(options.params._visible, true)
          options._pos = options.params._pos
          options.containerId = Global.container

          delete options.params.width
          delete options.params.height
          delete options.params.modal
          delete options.params.alignH
          delete options.params.alignV
          delete options.params.showMin
          delete options.params.showMax
          delete options.params.showSize
          delete options.params.dlgType
          delete options.params.borderOuter
          delete options.params.borderInner
          delete options.params.gapBorders
          delete options.params._visible
          delete options.params._pos

          this.load2Dlg(options, def.container, plug)
          break
        case Consts.UI_TABPAGE:
          this.load2Tab(options, def.container, plug)
          break
        case Consts.UI_PANE:
          this.load2Pane(options, def.container, plug)
          break
        case Consts.UI_NONE:
          this.load2None(options, def.container, plug)
          break
        }
      }

      /**
       * 加载到tabs
       * @static
       * @method
       * @param   {Object}    options
       * @param   {String}    options.name                    名字，作为唯一标识用
       * @param   {String}    options.title                   标题
       * @param   {Number}    options.type                    插件类型(Dialog, TabPage, Pane, None)
       * @param   {Boolean}   [options.closable = false]      是否可关闭
       * @param   {Boolean}   [options.selected = true]       是否选中
       * @param   {Object}    [options.params]                运行插件带的参数
       * @param   {Function}  [options.onDelete]              回调函数-删除时-function()
       * @param   {dom}       container                       容器ID
       * @param   {Object}    component                   组件
       */

    }, {
      key: 'load2Tab',
      value: function load2Tab(options, container, component)
      {
        var _container = Containers.get(container)
        if (_container)
        {
          options.container = container //记住TabPage所在的Tabs
          options.component = options.name
          options.params = options.params || {}
          _container.add(options)
        }
      }

      /**
       * 把指定内容显示到对话框,
       * 在运行的插件内初始化参数中可以增加onBefClose事件方法，对话框关闭前触发调用，其参数是回调函数，回调函数有一个参数isClose是否继续关闭对话框
       * @static
       * @method
       * @param   {Object}    options                     参数对象
       * @param   {String}    options.name                名字，作为唯一标识用
       * @param   {String}    options.title               标题
       * @param   {Number}    options.type                插件类型(Dialog, TabPage, Pane, None)
       * @param   {Number}    options.width               对话框宽度
       * @param   {Number}    options.height              对话框高度，根据内容自适应
       * @param   {Object}    options.params              运行插件带的参数
       * @param   {Number}    [options.alignH = 0]        水平对齐方式，-1左 0中 1右
       * @param   {Number}    [options.alignV = 0]        水平对齐方式，-1左 0中 1右
       * @param   {Boolean}   [options.modal = true]      是否模态
       * @param   {Boolean}   [options.showMin = true]    是否显示最小化按钮
       * @param   {Boolean}   [options.showMan = false]   是否显示最大化按钮
       * @param   {Boolean}   [options.showClose = true]  是否显示关闭按钮
       * @param   {String}    [options.dlgType = '']      对话框类型(unify, headerbody)
       * @param   {Number}    [options.borderOuter = 0]   外边框粗细
       * @param   {Number}    [options.borderInner = 0]   内边框粗细
       * @param   {Number}    [options.gapBorders = 0]    两个边框之间的大小
       * @param   {Number}    [options.visible = true]    是否可见
       * @param   {Object}    [options._pos]              位置信息
       * @param   {Function}  [options.onBeforeClose]     关闭前的回调,function(done)，done 用于关闭 Dialog
       * @param   {String}    [options.containerId]       容器ID(用于容器切换)
       * @param   {Function}  [options.onClose]           关闭的回调
       * @param   {Function}  [options.onOpen]            打开的回调
       * @param   {String|Dom}[container]                 父容器
       * @param   {Object}    component                   组件
       */

    }, {
      key: 'load2Dlg',
      value: function load2Dlg(options, container, component)
      {
        //模态不能显示最小化
        if (options.modal) options.showMin = false

        container = this.getDlgContainer(container)
        var conatinerDom = cx.dom.getDomNode(container)

        var el = Dom.create('div', null, conatinerDom, null)
        var template = '<cx-dialog :dlg="dlg" @close="onClose" @maximize="onMaximize" @minimize="onMinimize" @restore="onRestore" ref="refDlg">' + '<div style="overflow:hidden; position:absolute; left:0; right:0; top:0; bottom:0;">' + '<child :params="params" ref="plugTar"></child>' + '</div>' + '</cx-dialog>'

        return new Vue__default['default']({
          el: el,
          i18n: i18n,
          template: template,
          components: { child: component },
          data: function data()
          {
            return {
              dlg: {
                container: container,
                name: options.name,
                title: options.title,
                width: options.width,
                height: options.height,
                icon: options.icon,
                modal: options.modal,
                closable: options.closable,
                alignH: options.alignH,
                alignV: options.alignV,
                dlgType: options.dlgType,
                borderOuter: options.borderOuter,
                borderInner: options.borderInner,
                gapBorders: options.gapBorders,
                containerId: options.containerId,
                showMin: options.showMin,
                showMax: options.showMax,
                showSize: options.showSize,
                visible: options.visible,
                _pos: options._pos,
                close: options.close,
                beforeClose: options.beforeClose,
                onClose: options.onClose
              },
              params: options.params
            }
          },
          created: function created()
          {
            options.params._container_ = container //前面增加_是避免跟参数里面的属性冲突
            options.params._plugin_ = this

            var plugInf = {
              id: Base.nextId(),
              name: options.name,
              type: options.type,
              container: container,
              parent: null,
              plugin: this
            }
            Runnings.add(plugInf) //正在运行插件信息
          },
          beforeDestroy: function beforeDestroy()
          {
            //保留位置
            var dlgDom = this.getDlgDom()
            LocalCache.set(options.name + '.left', dlgDom.style.left)
            LocalCache.set(options.name + '.top', dlgDom.style.top)

            Runnings.remove({ plugin: this }) //删除运行插件
          },

          mounted: function mounted()
          {
            if (!this.dlg._pos)
            {
              //恢复之前的位置
              var dlgDom = this.getDlgDom()
              var val = void 0

              val = LocalCache.get(options.name + '.left')
              if (val) dlgDom.style.left = val

              val = LocalCache.get(options.name + '.top')
              if (val) dlgDom.style.top = val
            }
          },
          methods: {
            //取Dialog的DOM根节点
            getDlgDom: function getDlgDom()
            {
              return this.$el
            },


            //关闭窗口(发送 onClose 消息)
            destroy: function destroy()
            {
              Base.call(options.params.onClose)
              this.$destroy()
              Dom.remove(this.$el)
            },


            //取根节点的DOM
            dom: function dom()
            {
              return this.$el
            },


            //设置对话框标题
            setTitle: function setTitle(title)
            {
              this.dlg.title = title
            },
            //设置对话框最大化按钮
            hasMax: function hasMax()
            {
              this.dlg.showMax = true
            },

            //显示、隐藏
            show: function show(visible)
            {
              var _this = this

              Base.watch(function()
              {
                return _this.$refs.refDlg
              }, function()
              {
                return _this.$refs.refDlg.show(visible)
              }, 100)
            },


            //移动窗口
            moveTo: function moveTo(left, top)
            {
              var dlgDom = this.getDlgDom()
              dlgDom.style.left = left + 'px'
              dlgDom.style.top = top + 'px'
            },


            //点击 X 关闭(发送 onCancel 消息,然后再销毁窗口)
            onClose: function onClose()
            {
              var _this2 = this

              if (cx.base.isFunc(options.params.onBefDlgClose))
              {
                options.params.onBefDlgClose(function(isClose)
                {
                  if (isClose)
                  {
                    Base.call(options.params.onCancel)
                    _this2.destroy()
                  }
                })
              }
              else
              {
                Base.call(options.params.onCancel)
                this.destroy()
              }
            },


            //点击最大化按钮
            onMaximize: function onMaximize()
            {
              this.$refs.refDlg.maximize()
            },


            //点击还原按钮
            onRestore: function onRestore()
            {
              this.$refs.refDlg.restore()
            },


            //点击最小化按钮
            onMinimize: function onMinimize()
            {
              this.$refs.refDlg.minimize()
            },


            //最小化
            minimize: function minimize()
            {
              var _this3 = this

              Base.watch(function()
              {
                return _this3.$refs.refDlg
              }, function()
              {
                return _this3.$refs.refDlg.minimize()
              }, 100)
            },


            //最小化还原显示
            minRestore: function minRestore()
            {
              var _this4 = this

              Base.watch(function()
              {
                return _this4.$refs.refDlg
              }, function()
              {
                return _this4.$refs.refDlg.minRestore()
              }, 100)
            }
          }
        })
      }

      /**
       * 把指定内容显示到Pane
       * @static
       * @method
       * @param   {Object}    options                              参数对象
       * @param   {String}    options.name                         名字，作为唯一标识用
       * @param   {String}    options.title                        标题
       * @param   {Number}    options.type                         插件类型(Dialog, TabPage, Pane, None)
       * @param   {Object}    options.params                       运行插件带的参数
       * @param   {Boolean}   [options.params.isMultChild=false]   是否运行容器内有多个插件，默认false
       * @param   {Function}  [options.onClose]                    关闭的回调
       * @param   {dom}       container                            父容器
       * @param   {Object}    component                            组件
       */

    }, {
      key: 'load2Pane',
      value: function load2Pane(options, container, component)
      {
        var el = Dom.create('div', null, container, null)
        var template = '<child :params="params" ref="plugTar"></child>'

        //容器只能有一个子插件时，每次销毁其他插件
        if (!options.params.isMultChild)
        {
          var plugs = Runnings.find({ container: container })
          var _iteratorNormalCompletion = true
          var _didIteratorError = false
          var _iteratorError = undefined

          try
          {
            for (var _iterator = plugs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
            {
              var plug = _step.value

              if (plug.plugin.minimized) plug.plugin.minRestore()
              //如果前后对话框对应的回调函数不一样，应该先调用对话框的onClose回调函数
              //this.$set(plug, 'params', params)
              //return
              plug.plugin.destroy()
              Runnings.remove(plug)
            }
          }
          catch (err)
          {
            _didIteratorError = true
            _iteratorError = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion && _iterator.return)
              
                _iterator.return()
            }
            finally
            {
              if (_didIteratorError)
              
                throw _iteratorError
            }
          }
        }

        return new Vue__default['default']({
          el: el,
          i18n: i18n,
          template: template,
          components: { child: component },
          data: function data()
          {
            return {
              params: options.params
            }
          },
          created: function created()
          {
            options.params._container_ = container //前面增加_是避免跟参数里面的属性冲突
            options.params._plugin_ = this

            var plugInf = {
              id: Base.nextId(),
              name: options.name,
              type: options.type,
              container: container,
              parent: null,
              plugin: this
            }
            Runnings.add(plugInf) //正在运行插件信息
          },
          beforeDestroy: function beforeDestroy()
          {
            Runnings.remove({ plugin: this }) //删除运行插件
          },

          methods: {
            //销毁对象
            destroy: function destroy()
            {
              Base.call(options.onClose)
              this.$destroy()
              Dom.remove(this.$el)
            },


            //取根节点的DOM
            dom: function dom()
            {
              return this.$el
            }
          }
        })
      }

      /**
       * 把指定内容显示到Pane
       * @static
       * @method
       * @param   {Object}    options                 参数对象
       * @param   {String}    options.name            名字，作为唯一标识用
       * @param   {String}    [options.title]         标题
       * @param   {Number}    options.type            插件类型(Dialog, TabPage, Pane, None)
       * @param   {Object}    options.params          运行插件带的参数
       * @param   {Function}  [options.onClose]       关闭的回调
       * @param   {dom}       container               父容器
       * @param   {Object}    component               组件
       */

    }, {
      key: 'load2None',
      value: function load2None(options, container, component)
      {
        var el = Dom.create('div', null, container || Dom.body(), null)
        var template = '<child :params="params" ref="plugTar"></child>'

        return new Vue__default['default']({
          el: el,
          i18n: i18n,
          template: template,
          components: { child: component },
          data: function data()
          {
            return {
              params: options.params
            }
          },
          created: function created()
          {
            options.params._container_ = container //前面增加_是避免跟参数里面的属性冲突
            options.params._plugin_ = this

            var plugInf = {
              id: Base.nextId(),
              name: options.name,
              type: options.type,
              container: container,
              parent: null,
              plugin: this
            }
            Runnings.add(plugInf) //正在运行插件信息
          },
          beforeDestroy: function beforeDestroy()
          {
            Runnings.remove({ plugin: this }) //删除运行插件
          },

          methods: {
            //销毁对象
            destroy: function destroy()
            {
              Base.call(options.onClose)
              this.$destroy()
              Dom.remove(this.$el)
            },


            //取根节点的DOM
            dom: function dom()
            {
              return this.$el
            }
          }
        })
      }
    }])
    return RunVue
  }())

  /**
   * cx.run
   * 类-运行插件
   *
   * @class
   * @memberof    cx
   * @author      Zhang Qing
   * @since       2018-05-16
   */
  /**
   * 插件运行过程:
   *
   * runPlug -- vue.runPlug -- Tabs.add()
   *                                      1) 判断Tabs是否存在?
   *                                      2) if(tabs.asContainer)激活插件等信息
   *                                      3) runnings.add()
   *                        -- Dialog
   *                                      1) 如果dialog在plugin,看看是否需要激活该plugin
   *                                      2) DlgContainer.add()
   *                                      3) runnings.add()
   *                        -- Pane
   *                                      1) runnings.add()
   *
   * plugin.params    {Object}  传递给插件的运行参数
   * plugin.container {dom}     插件所在的DOM
   * plugin.parent    {Object}  插件的父亲对象 (dialog-外面套的Dialog壳子，tab-外面的Tabs, pane-无, none-无)
   * plugin.plugin    {Object}  指向插件对象
   */

  var Run = (function()
  {
    function Run()
    {
      classCallCheck(this, Run)
    }

    createClass(Run, null, [{
      key: 'closePlug',

      /**
       * 关闭指定插件
       * @method
       * @static
       * @param   {String}   plugName   插件名
       */
      value: function closePlug(plugName)
      {
        Runnings.close(Runnings.get({ name: plugName }))
      }

      /**
       * 根据插件名运行插件，对于插件的width、height、modal属性优先级：params > overDef > def
       * @static
       * @method
       * @param   {Object}    name              插件名
       * @param   {Object}    params            插件运行时的初始化参数
       * @param   {Object}    [overDef]         覆盖插件定义的参数
       * @param   {Object}    [operPPlug]       操作父插件
       * @param   {Object}    [operPPlug.plug]  父插件对象
       * @param   {Object}    [operPPlug.isMin] 是否最小化
       */

    }, {
      key: 'runPlug',
      value: function runPlug(name, params, overDef, operPPlug)
      {
        var def = $g.plugin.byName(name)

        if (operPPlug && operPPlug.plug && operPPlug.isMin) operPPlug.plug.minimize()

        if (def && overDef) def = Base.extend({}, def, overDef)

        if (def) this.runPlugByDef(def, params)
      }

      /**
       * 运行插件，同时大小和位置覆盖父插件
       * @method
       * @static
       * @param   {Plugin}   pPlug        父插件对象(调用该插件所属对象)
       * @param   {String}   plugName     待调用的插件名
       * @param   {Object}   param        待调用插件的调用参数对象
       */

    }, {
      key: 'runPlugOver',
      value: function runPlugOver(pPlug, plugName, param)
      {
        if (pPlug.$root.dlg)
        {
          var pEl = pPlug.$root.$el
          var _pos = { left: pEl.offsetLeft, top: pEl.offsetTop }
          RunVue.runPlug(plugName, Base.extend(param, { _pos: _pos }), { width: pEl.offsetWidth, height: pEl.offsetHeight })
        }
      }

      /**
       * 根据插件名运行路由
       * @method
       * @static
       * @param   {String}   plugName          插件名，插件名和路由名相同
       * @param   {Object}   [params]          参数对象
       * @param   {Boolean}  [newWinow=false]  是否在新窗口中打开
       */

    }, {
      key: 'runPlugRoute',
      value: function runPlugRoute(plugName)
      {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
        var newWinow = arguments[2]

        if (newWinow) window.open(cx.url.getRequestUrl('' + window.location.origin + window.location.pathname + '#/' + plugName, params)); else vm.$router.push({ name: plugName, query: params })
      }

      /**
       * 根据插件定义对象运行插件
       * @static
       * @method
       * @param   {Object}    def               插件定义对象
       * @param   {Object}    params            插件运行时的初始化参数
       */

    }, {
      key: 'runPlugByDef',
      value: function runPlugByDef(def, params)
      {
        if ($g.runType === Consts.RUN_VUE) RunVue.loadPlugByDef(def, params)
      }

      /**
       * 根据插件名加载类模块
       * @static
       * @method
       * @param   {String}          name        插件名
       * @returns {Object|Class}                模块对象
       */

    }, {
      key: 'loadModule',
      value: function loadModule(name)
      {
        var def = $g.plugin.byName(name)
        if (def) return this.loadModuleByDef(def)
      }

      /**
       * 根据插件定义对象加载类模块
       * @static
       * @method
       * @param   {Object}          def         插件名
       * @returns {Object|Class}                模块对象
       */

    }, {
      key: 'loadModuleByDef',
      value: function loadModuleByDef(def)
      {
        if ($g.runType === Consts.RUN_VUE) return RunVue.loadModuleByDef(def)
      }

      /**
       * 把指定内容显示到对话框
       * @static
       * @method
       * @param   {Object}    options           参数对象
       */

    }, {
      key: 'load2Dlg',
      value: function load2Dlg(options)
      {
        if ($g.runType === Consts.RUN_VUE) RunVue.load2Dlg(options)
      }

      /**
       * 把指定内容显示到tab页
       * @static
       * @method
       * @param   {Object}    options           参数对象
       */

    }, {
      key: 'load2Tab',
      value: function load2Tab(options)
      {
        if ($g.runType === Consts.RUN_VUE) RunVue.load2Tab(options)
      }
    }])
    return Run
  }())

  /**
   * cx.file
   * 类-文件处理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var File = (function()
  {
    function File()
    {
      classCallCheck(this, File)
    }

    createClass(File, null, [{
      key: 'deleteFile',

      /**
       * 删除文件
       * @static
       * @method
       * @param   {String}       filename            文件名
       * @param   {cx.Caller}    [onSuccess = null]  成功删除的回调函数( function(paras, ret) )
       */
      value: function deleteFile(filename, onSuccess)
      {
        var exe = Global.service.getExe('UploadDel')
        var paras = { filename: filename }
        Base.extend(paras, exe.getInitPara())
        Base.execute(paras, onSuccess)
      }

      /**
       * 取文件类型
       * @static
       * @method
       * @param   {String}    filename            文件名
       * @returns {String}
       */

    }, {
      key: 'getFileType',
      value: function getFileType(filename)
      {
        var pos = filename.lastIndexOf('.')
        return pos > 0 ? filename.slice(pos + 1, filename.length) : ''
      }

      /**
       * 取短文件名.(去掉目录)
       * @static
       * @method
       * @param   {String}    filename           文件名
       * @returns {String}
       */

    }, {
      key: 'getShortName',
      value: function getShortName(filename)
      {
        var pos = filename.lastIndexOf('/')
        if (pos < 0) pos = filename.lastIndexOf('\\')
        return filename.substring(pos + 1)
      }

      /**
       * 取文件名的名称部分(去掉后缀)
       * @static
       * @method
       * @param   {String}    filename            文件名
       * @returns {String}
       */

    }, {
      key: 'getFileName',
      value: function getFileName(filename)
      {
        return filename.slice(0, filename.lastIndexOf('.'))
      }

      /**
       * 在media表中根据文件的路径获取对应纪录，like查询
       * @method
       * @static
       * @param   {String}    path    文件路径，以文件名加格式后缀结尾。
       * @returns {Promise}
       */

    }, {
      key: 'getFileByPath',
      value: function getFileByPath(path)
      {
        var param = {
          _major: Consts.SYSTAB,
          _minor: Consts.MEDIA,
          _exp: 'filename like \'%' + path + '%\'',
          types: '',
          vals: ''
        }
        return cx.svr.area.query(param)
      }
      /**
       * 判断是否是文档文件
       * @static
       * @method
       * @param   {String}    filename            文件名
       * @returns {Boolean}
       */

    }, {
      key: 'isDoc',
      value: function isDoc(filename)
      {
        return Array$1.indexOf((Global.syscfg.DocTypes || '').split(','), this.getFileType(filename).toUpperCase()) >= 0
      }

      /**
       * 判断是否是图片文件
       * @static
       * @method
       * @param   {String}    filename            文件名
       * @returns {Boolean}
       */

    }, {
      key: 'isImage',
      value: function isImage(filename)
      {
        Global.syscfg.ImgTypes = Global.syscfg.ImgTypes || ['PNG', 'JPG', 'JPEG', 'BMP', 'TIF', 'GIF']
        return Array$1.indexOf((Global.syscfg.ImgTypes || '').split(','), this.getFileType(filename).toUpperCase()) >= 0
      }

      /**
       * 根据文件名判断是不是图片文件
       * @method
       * @static
       * @param   {String}      name    文件名称
       * @returns {Boolean}
       */

    }, {
      key: 'isPdf',
      value: function isPdf(name)
      {
        return name.split('.').pop().toUpperCase() === 'PDF'
      }

      /**
       * 判断是否是文档文件
       * @static
       * @method
       * @param   {String}    filename            文件名
       * @returns {Boolean}
       */

    }, {
      key: 'isVideo',
      value: function isVideo(filename)
      {
        Global.syscfg.VideoTypes = Global.syscfg.VideoTypes || ['3GP', 'AVI', 'ASF', 'ASX', 'FLV', 'MOV', 'MPG', 'MP4', 'OGG', 'WEBM', 'WMV']
        return Array$1.indexOf((Global.syscfg.VideoTypes || '').split(','), this.getFileType(filename).toUpperCase()) >= 0
      }

      /**
       * 判断是否是文档文件
       * @method
       * @static
       * @param   {String}    filename            文件名
       * @returns {Boolean}
       */

    }, {
      key: 'isAudio',
      value: function isAudio(filename)
      {
        return Array$1.indexOf((Global.syscfg.AudioTypes || '').split(','), this.getFileType(filename).toUpperCase()) >= 0
      }

      /**
       * 取文件的类型(cx.consts.FILE_***)
       * @static
       * @method
       * @param   {String}    filename            文件名
       * @returns {Number}
       */

    }, {
      key: 'type',
      value: function type(filename)
      {
        var type = this.getFileType(filename).toUpperCase()
        var index = void 0
        index = Array$1.indexOf((Global.syscfg.DocTypes || '').split(','), type)
        if (index >= 0) return Consts.FILE_DOC
        index = Array$1.indexOf((Global.syscfg.ImgTypes || '').split(','), type)
        if (index >= 0) return Consts.FILE_IMG
        index = Array$1.indexOf((Global.syscfg.VideoTypes || '').split(','), type)
        if (index >= 0) return Consts.FILE_VIDEO
        index = Array$1.indexOf((Global.syscfg.AudioTypes || '').split(','), type)
        if (index >= 0) return Consts.FILE_AUDIO
        return 0
      }

      /**
       * 检查文件名是否有效
       * @static
       * @method
       * @param   {String}    filename            文件名
       */

    }, {
      key: 'checkFilename',
      value: function checkFilename(filename)
      {
        var chars = ['\\', '/', ':', '*', '?', '\'', '<', '>', '|']
        var pos = void 0
        var i = void 0
        //长度 < 1
        if (!filename || filename.length < 1) return false
        //非法字符
        for (i = 0; i < chars.length; i++)
        
          if (filename.indexOf(chars[i]) > 0) return false
        
        //'.' 不能有多个,不能是第一个，也不能是最后一个
        pos = filename.indexOf('.')
        if (pos >= 0)
        {
          if (pos === 0) //第一个字符
            return false
          if (pos === filename.length - 1) //最后一个字符
            return false
          if (pos !== filename.lastIndexOf('.')) //多个'.'
            return false
        }
        return true
      }

      /**
       * 预览文件
       * @static
       * @method
       * @param   {String}    filename            文件名
       */

    }, {
      key: 'preview',
      value: function preview(filename)
      {
        var type = this.type(filename)
        var name = this.getFileName(filename)
        var filename2 = void 0
        switch (type)
        {
        case Consts.FILE_DOC:
          filename2 = name + '.swf'
          Run.runPlugin('FilePreview', { url: filename2 })
          break
        case Consts.FILE_IMG:
          Run.runPlugin('PicPreview', { url: filename })
          break
        case Consts.FILE_VIDEO:
          filename2 = name + '.flv'
          Run.runPlugin('VideoView', { url: filename2 })
          break
        case Consts.FILE_AUDIO:
          Run.runPlugin('AudioView', { url: filename })
          break
        }
      }

      /**
       * 下载文件另存为
       * @static
       * @method
       * @param   {String}    filename            文件名
       * @param   {String}    saveas              另存文件名
       */

    }, {
      key: 'saveAs',
      value: function saveAs(filename, saveas)
      {
        Doc.getFile({ filenames: filename, saveas: saveas })
      }

      /**
       * 根据URL下载文件
       * @static
       * @method
       * @param   {String}    url                 URL
       */

    }, {
      key: 'download',
      value: function download(url)
      {
        Url.download(url)
      }
    }])
    return File
  }())

  var qs$1 = require('qs')

  /**
   * cx.fileLoader
   * 类-加载文件器
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-01
   */

  var FileLoader = (function()
  {
    function FileLoader()
    {
      classCallCheck(this, FileLoader)
    }

    createClass(FileLoader, null, [{
      key: 'init',

      /**
       * 初始化
       * @static
       * @method
       */
      value: function init()
      {
        axios__default['default'].defaults.withCredentials = true
        this.inst = axios__default['default'].create({ responseType: 'arraybuffer' })
      }

      /**
       * 全局错误处理
       * @private
       * @static
       * @method
       * @param   {Object}    data        传入错误的数据
       */

    }, {
      key: '_error',
      value: function _error(data)
      {}
      // console.log(data)


      /**
       * 判断是否返回数据
       * @private
       * @static
       * @method
       * @param   {*}         data        接收到的数据
       * @returns {Boolean}
       */

    }, {
      key: '_isStatus',
      value: function _isStatus(data)
      {
        if (data.code === 100) return false; else return true
      }

      /**
       * GET方式调用
       * @static
       * @method
       * @param   {String}    url                             URL
       * @returns {Promise}
       */

    }, {
      key: 'loadBinary',
      value: function loadBinary(url)
      {
        var _this = this

        return new Promise(function(resolve, reject)
        {
          _this.inst.get(url, qs$1.stringify({})).then(function(ret)
          {
            if (_this._isStatus(ret.data)) resolve(ret.data)
          }).catch(function(ret)
          {
            reject(ret)
          })
        }).catch(function(ret)
        {
          return ret
        })
      }
    }])
    return FileLoader
  }())

  FileLoader.init()

  /**
   * $g.func
   * 处理系统功能类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Funcs = (function()
  {
    /**
     * @constructor
     * @param   {Object}    data    数据
     */
    function Funcs()
    {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, Funcs)

      this.list = data
      this.init()
    }

    /**
     * 销毁对象
     * @method
     */


    createClass(Funcs, [{
      key: 'destroy',
      value: function destroy()
      {
        this.list = null
      }

      /**
       * 初始化
       * @method
       */

    }, {
      key: 'init',
      value: function init()
      {}

      /**
       * 生成系统菜单
       * @method
       * @param   {String}    [rootGrpName = '']  根组名
       */

    }, {
      key: 'makeMenu',
      value: function makeMenu()
      {
        var rootGrpName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''

        var result = []
        var allGrps = Array$1.gets(this.list.group, { target: 'menu' })
        var allFuncs = this.list.func

        var makeSubMenu = function makeSubMenu(ret, grpName, level)
        {
          var grps = Array$1.gets(allGrps, { glgrp: grpName })
          var funcs = Array$1.gets(allFuncs, { grp: grpName })
          var grp = void 0,
            func = void 0,
            item = void 0

          // grpName的子菜单组
          var _iteratorNormalCompletion = true
          var _didIteratorError = false
          var _iteratorError = undefined

          try
          {
            for (var _iterator = grps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
            {
              grp = _step.value

              if ($g.access.isViewMenu(grp))
              {
                item = Object.assign({}, grp, { level: level, children: [] })
                item.title = Base.locale(grp.namec, grp.namee)
                delete item.namee
                delete item.namec
                // {
                //   title: base.locale(grp.namec, grp.namee),
                //   name: grp.name,
                //   icon: grp.icon,
                //   level: level,
                //   disporder: grp.disporder,
                //   children: []
                // }
                ret.push(item)
                makeSubMenu(item.children, grp.name, level + 1)
              }
            }

            // grpName的功能菜单
          }
          catch (err)
          {
            _didIteratorError = true
            _iteratorError = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion && _iterator.return)
              
                _iterator.return()
            }
            finally
            {
              if (_didIteratorError)
              
                throw _iteratorError
            }
          }

          var _iteratorNormalCompletion2 = true
          var _didIteratorError2 = false
          var _iteratorError2 = undefined

          try
          {
            for (var _iterator2 = funcs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
            {
              func = _step2.value

              if ($g.access.isViewMenu(func))
              {
                item = Object.assign({}, func, { level: level, name: func.plugin })
                item.title = Base.locale(func.namec, func.namee)
                delete item.namee
                delete item.namec
                // item =
                // {
                //   title: base.locale(func.namec, func.namee),
                //   name: func.plugin,
                //   icon: func.icon,
                //   plugin: func.plugin,
                //   level: level,
                //   disporder: func.disporder
                // }
                ret.push(item)
              }
            }

            //按disporder排序菜单
          }
          catch (err)
          {
            _didIteratorError2 = true
            _iteratorError2 = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion2 && _iterator2.return)
              
                _iterator2.return()
            }
            finally
            {
              if (_didIteratorError2)
              
                throw _iteratorError2
            }
          }

          ret.sort(function(a, b)
          {
            return a.disporder - b.disporder
          })
        }

        makeSubMenu(result, rootGrpName, 1)
        return result
      }
    }])
    return Funcs
  }())

  /**
   * cx.IAccess
   * 权限接口类
   *
   * @class
   * @memberof    cx
   * @author      zhang qing
   * @since       2018-06-15
   */

  var IAccess = (function()
  {
    /**
     * @constructor
     */
    function IAccess()
    {
      classCallCheck(this, IAccess)

      /** * @property  {Array.<String>}   funcPlugs            func功能菜单上绑定的插件名序列                @protected */
      /** * @property  {Object}           viewMenu             菜单是否创建显示的判断数据对象                 @protected */
      /** * @property  {Object}           viewMenu.func        可创建的菜单功能插件数据对象                   @protected */
      /** * @property  {Object}           viewMenu.funcGrp     可创建的菜单组数据对象                         @protected */
      /** * @property  {Object}           dataSrc              权限原始数据对象                              @protected */
      /** * @property  {Object}           access               处理后的权限数据对象                          @protected */
      /** * @property  {Object}           types                权限数据的类型，与sysroleobj表的type值对应     @protected */
      this.funcPlugs = null
      this.viewMenu = { func: {}, funcGrp: {} }
      this.dataSrc = null
      this.access = {}
      this.types = {}
    }

    /**
     * 设置原始权限数据
     * @method
     * @param   {Object}    data                权限原始数据
     * @returns {Boolean}
     */


    createClass(IAccess, [{
      key: 'setData',
      value: function setData(data)
      {
        this.dataSrc = data.obj

        //确保 $g.entity 已构建完成
        var ett = Global.entity.byMajMin(Consts.SYSTAB, Consts.TAB_SYSROLEOBJ)
        var fldVals = Global.field.getFldvalues(ett.tabatt, 'type')
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = fldVals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var val = _step.value

            this.types[val.dispe] = Number(val.dbvalue)
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        this.preData()
      }

      /**
       * 判断某类功能插件内的按钮是否可用
       * @method
       * @param   {String}    plugName                插件的名字
       * @param   {String}    btnName                 按钮的名字
       * @returns {Boolean}
       */

    }, {
      key: 'canUseBtn',
      value: function canUseBtn(plugName, btnName)
      {
        return this.isSuperAdmin(Global.init.user) || !this.access[this.types.btn] ? true : this.access[this.types.btn][plugName] && this.access[this.types.btn][plugName][btnName]
      }

      /**
       * 根据插件名在按钮权限中判断是否可用。部分插件没有配置到func中，以功能按钮的方式进行管理
       * 场景：按钮权限的根都是插件，子节点是该插件内的按钮；当改插件本身也是另一个插件内的按钮时，非admin用户进入按钮权限管理，会丢失树节点
       * @method
       * @param   {String}    name                插件的name
       * @returns {Boolean}
       */

    }, {
      key: 'canUseBtnPlug',
      value: function canUseBtnPlug(name)
      {
        if (this.isSuperAdmin(Global.init.user) || !this.access[this.types.btn]) return true; else
        {
          for (var plugName in this.access[this.types.btn])
          
            if (this.access[this.types.btn][plugName][name]) return true
          
          return false
        }
      }

      /**
       * 根据插件名判断功能插件是否可用
       * @method
       * @param   {String}    name                插件的name
       * @returns {Boolean}
       */

    }, {
      key: 'canUseFunc',
      value: function canUseFunc(name)
      {
        return this.isSuperAdmin(Global.init.user) || !this.access[this.types.func] ? true : this.access[this.types.func][name]
      }

      /**
       * 根据func的namee判断菜单是否可用(没有权限的大类数据默认可见)
       * @method
       * @param   {String}    name                func的namee
       * @returns {Boolean}
       */

    }, {
      key: 'canUseFuncName',
      value: function canUseFuncName(name)
      {
        return this.isSuperAdmin(Global.init.user) || !this.access[this.types.func] || !this.access[this.types.func]._func ? true : this.access[this.types.func]._func[name]
      }
      /**
       * 判断用户是否拥有部门权限
       * @method
       * @param   {Number}    id                  部门的id
       * @returns {Boolean}
       */

    }, {
      key: 'canUseOrgan',
      value: function canUseOrgan(id)
      {
        return this.isSuperAdmin(Global.init.user) || !this.access[this.types.organ] ? true : this.access[this.types.organ][id]
      }

      /**
       * 获取func功能菜单上绑定的插件名序列
       * @method
       * @returns {Array.<String>}                插件名序列
       */

    }, {
      key: 'getFuncPlugs',
      value: function getFuncPlugs()
      {
        if (this.funcPlugs) return this.funcPlugs

        this.funcPlugs = {}
        var funcs = Array$1.getsFuz(Global.init.func, 'grp', 'QX')
        var funcPlugs = Array$1.toString(funcs, 'plugin')
        funcPlugs = funcPlugs.split(',')

        //转化成hash对象，方便查询
        for (var j = 0; j < funcPlugs.length; j++)
        
          this.funcPlugs[funcPlugs[j]] = true
        return this.funcPlugs
      }

      /**
       * 是否超级管理员，超级关联员可以使用全部功能
       * @method
       * @param   {Object}    user                待判断用户的对象
       * @param   {String}    user.no             待判断用户的帐号名
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isSuperAdmin',
      value: function isSuperAdmin(user)
      {
        return user.no === 'admin'
      }

      /**
       * 是否普通管理员
       * @method
       * @param   {Object}    user                待判断用户的对象
       * @param   {String}    user.ismanager      是否管理员的属性
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isUserManager',
      value: function isUserManager(user)
      {
        return user.ismanager === 1
      }

      /**
       * 是否审核员
       * @method
       * @param   {Object}    user                待判断用户的对象
       * @param   {String}    user.ischeck        是否审核员的属性
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isUserAudit',
      value: function isUserAudit(user)
      {
        return Number(user.ischeck) === 1
      }

      /**
       * 判断菜单是否可见（由是否拥有可使用的功能插件决定）
       * @method
       * @param   {Object}    data                菜单的数据对象,func表记录 或 funcgrp表记录
       * @returns {Boolean}                       判断后的结果
       */

    }, {
      key: 'isViewMenu',
      value: function isViewMenu(data)
      {
        var ret = false
        if (this.isSuperAdmin(Global.init.user) || data.plugin && this.viewMenu.func[data.plugin] || data.name && data.target && this.viewMenu.funcGrp[data.name]) ret = true

        return ret
      }

      /**
       * 准备按钮的权限数据
       * @method
       */

    }, {
      key: 'preButton',
      value: function preButton()
      {
        var _this = this

        var data = this.dataSrc[this.types.btn]
        if (Base.isArr(data))
        {
          (function()
          {
            var ret = _this.access[_this.types.btn] = {}

            var _loop = function _loop(i)
            {
              ret[data[i].objectid] = ret[data[i].objectid] || {}
              data[i].opertype.split(',').forEach(function(obj)
              {
                ret[data[i].objectid][obj] = true
              })
            }

            for (var i = data.length - 1; i >= 0; i--)
            
              _loop(i)
          })()
        }
      }

      /**
       * 每次setData更新数据后，进行预处理
       * @method
       */

    }, {
      key: 'preData',
      value: function preData()
      {
        this.preFunc()
        this.preMenuView()
        this.preButton()
        this.preOrgan()
      }

      /**
       * 准备插件功能权限数据
       * @method
       */

    }, {
      key: 'preFunc',
      value: function preFunc()
      {
        var data = this.dataSrc[this.types.func]
        if (Base.isArr(data))
        {
          var ret = this.access[this.types.func] = { _func: {} }
          for (var i = data.length - 1; i >= 0; i--)
          {
            //保存func的plugin
            if (data[i].objectid) ret[data[i].objectid] = true

            //保存func的namee，用于功能菜单判断
            if (data[i].opertype) ret._func[data[i].opertype] = true
          }
        }
      }

      /**
       * 准备可创建的菜单数据，包括菜单各级组和功能插件
       * @method
       */

    }, {
      key: 'preMenuView',
      value: function preMenuView()
      {
        var data = Global.init.func
        for (var i = data.length - 1; i >= 0; i--)
        {
          //只处理菜单func记录
          if (data[i].grp.indexOf('QX') < 0 && this.canUseFunc(data[i].plugin) && Array$1.get1(Global.init.plugin, { name: data[i].plugin }))
          {
            this.viewMenu.func[data[i].plugin] = true
            this.preMenuViewGrp({ name: data[i].grp })
          }
        }
      }

      /**
       * 准备可创建的菜单组数据
       * @method
       * @param   {Object}    exp                 遍历菜单组的exp条件
       */

    }, {
      key: 'preMenuViewGrp',
      value: function preMenuViewGrp(exp)
      {
        var data = Array$1.get1(Global.init.funcgrp, exp)
        if (data)
        {
          this.viewMenu.funcGrp[data.name] = true
          this.preMenuViewGrp({ name: data.glgrp })
        }
      }

      /**
       * 准备部门权限数据
       * @method
       */

    }, {
      key: 'preOrgan',
      value: function preOrgan()
      {
        var data = this.dataSrc[this.types.organ]
        if (Base.isArr(data))
        {
          var ret = this.access[this.types.organ] = {}
          for (var i = data.length - 1; i >= 0; i--)
          
            ret[data[i].objectid] = true
        }
      }
    }])
    return IAccess
  }())

  /**
   * cx.IAttFactory
   * 接口-属性对象工厂
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-17
   */
  var IAttFactory = (function()
  {
    function IAttFactory()
    {
      classCallCheck(this, IAttFactory)
    }

    createClass(IAttFactory, [{
      key: 'byMajMin',

      /**
       * 构建属性框操作对象
       * @method
       * @param   {Number}    major               主类型
       * @param   {Number}    minor               子类型
       * @param   {Object}    options             其他参数
       * @param   {String}    [options.tabname]   表名
       * @param   {Array}     [options.flds]      字段列表
       * @param   {Object}    [options.att]       属性
       * @param   {cx.Caller} [options.onChange]  数据更改响应函数-function()
       * @returns {cx.AttBase}                    属性处理对象
       */
      value: function byMajMin(major, minor, options)
      {
        return null
      }
    }])
    return IAttFactory
  }())

  /**
   * cx.ICache
   * 接口-缓存
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-02
   */
  var ICache = (function()
  {
    function ICache()
    {
      classCallCheck(this, ICache)
    }

    createClass(ICache, [{
      key: 'clear',

      /**
       * 清除缓存数据
       * @method
       * @returns {Object}                            this
       */
      value: function clear()
      {
        return this
      }

      /**
       * 设置最大缓存数量
       * @method
       * @param   {Number}    limit                   最大门限值
       * @returns {Object}                            this
       */

    }, {
      key: 'setLimit',
      value: function setLimit(limit)
      {
        return this
      }

      /**
       * 移除最久未用对象
       * @method
       * @returns {Object}                            this
       */

    }, {
      key: 'remove',
      value: function remove(limit)
      {
        return this
      }

      /**
       * 根据键值取对象
       * @method
       * @param   {String}    key                     键值
       * @param   {Boolean}   returnEntry             是否返回键值对
       * @returns {Object}                            返回key对应的对象，或者是{key, value}对
       */

    }, {
      key: 'get',
      value: function get(key, returnEntry)
      {
        return undefined
      }

      /**
       * 增加键值对
       * @method
       * @param   {String}    key                     键值
       * @param   {Object}    value                   对象
       * @returns {Object}                            被删除的对象
       */

    }, {
      key: 'put',
      value: function put(key, value)
      {
        return this
      }
    }])
    return ICache
  }())

  /**
   * cx.imageLoader
   * 类-图片加载
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-30
   */

  var ImageLoader = (function()
  {
    function ImageLoader()
    {
      classCallCheck(this, ImageLoader)
    }

    createClass(ImageLoader, null, [{
      key: 'load',

      /**
       * 加载图片
       * @static
       * @method
       * @param   {String}   key                 缓存的KEY
       * @param   {String}   url                 URL
       * @returns {Promise}                      resolve(Image)
       */
      value: function load(key, url)
      {
        var _this = this

        return new Promise(function(resolve, reject)
        {
          var cached = null
          if (key) //没有Key表示不缓存
            cached = _this.cache.get(key)
          if (cached) //有缓存
            resolve(cached); else //没缓存
          {
            var image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img')
            image.onload = function()
            {
              _this.cache.put(key, image)
              resolve(image)
              image = null
            }
            image.onerror = function(event)
            {
              reject(event)
              image = null
            }
            image.crossOrigin = true
            image.src = url
          }
        })
      }
    }])
    return ImageLoader
  }())

  /** *@property  {cx.ICache} cache       缓存对象*/


  ImageLoader.cache = new CacheLru({
    limit: 4096,
    onRemove: function onRemove(image)
    {
    }
  }) //缓存对象

  /**
   * cx.util
   * 类-杂项工具
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var Util = (function()
  {
    function Util()
    {
      classCallCheck(this, Util)
    }

    createClass(Util, null, [{
      key: 'sortString',

      /**
       * 字符串排序
       * @static
       * @method
       * @param   {Array}     items           数组
       * @param   {String}    fldName         排序字段名
       * @param   {Boolean}   [desc = false]  是否降序
       * @returns {Object}                    this
       */
      value: function sortString(items, fldName, desc)
      {
        if (items)
        {
          items.sort(function(a, b)
          {
            if (desc) return b[fldName].localeCompare(a[fldName]); else return a[fldName].localeCompare(b[fldName])
          })
        }
        return this
      }

      /**
       * 日期排序
       * @static
       * @method
       * @param   {Array}     items           数组
       * @param   {String}    fldName         排序字段名
       * @param   {Boolean}   [desc = false]  是否降序
       * @returns {Object}                    this
       */

    }, {
      key: 'sortDate',
      value: function sortDate(items, fldName, desc)
      {
        if (items)
        {
          items.sort(function(a, b)
          {
            if (desc) return new Date(b[fldName]) - new Date(a[fldName]); else return new Date(a[fldName]) - new Date(b[fldName])
          })
        }
        return this
      }

      /**
       * 日期+时间排序
       * @static
       * @method
       * @param   {Array}     items           数组
       * @param   {String}    fldName         排序字段名
       * @param   {Boolean}   [desc = false]  是否降序
       * @returns {Object}                    this
       */

    }, {
      key: 'sortDatetime',
      value: function sortDatetime(items, fldName, desc)
      {
        if (items)
        {
          items.sort(function(a, b)
          {
            if (desc) return Datetime.parse(b[fldName]) - Datetime.parse(a[fldName]); else return Datetime.parse(a[fldName]) - Datetime.parse(b[fldName])
          })
        }
        return this
      }

      /**
       * 数值排序
       * @static
       * @method
       * @param   {Array}     items           数组
       * @param   {String}    fldName         排序字段名
       * @param   {Boolean}   [desc = false]  是否降序
       * @returns {Object}                    this
       */

    }, {
      key: 'sortNum',
      value: function sortNum(items, fldName, desc)
      {
        if (items)
        {
          items.sort(function(a, b)
          {
            if (desc) return b[fldName] - a[fldName]; else return a[fldName] - b[fldName]
          })
        }
        return this
      }

      /**
       * 拷贝对象
       * @method
       * @param   {Object}    source          源对象
       * @returns {Object}
       */

    }, {
      key: 'copyObject',
      value: function copyObject(source)
      {
        var obj = {}
        for (var i in source)
        
          obj[i] = source[i]
        return obj
      }

      /**
       * 拷贝对象到另一对象去
       * @static
       * @method
       * @param   {Object}    source          源对象
       * @param   {Object}    dest            目标对象
       * @returns {Object}                    this
       */

    }, {
      key: 'copyObjectTo',
      value: function copyObjectTo(source, dest)
      {
        for (var i in source)
        
          dest[i] = source[i]
        return this
      }

      /**
       * 把对象的key转为大写
       * @static
       * @method
       * @param   {Object}     data                  源对象
       * @param   {Boolean}    [isChangeSrc=false]   是否修改源对象
       * @returns {Object}                           修改后的数据对象
       */

    }, {
      key: 'upperJSONKey',
      value: function upperJSONKey(data, isChangeSrc)
      {
        var ret = {}
        var newKey = ''
        for (var key in data)
        {
          newKey = key.toUpperCase()
          if (isChangeSrc && !data.hasOwnProperty(newKey))
          {
            data[newKey] = data[key]
            delete data[key]
          }
          else ret[newKey] = data[key]
        }

        return isChangeSrc ? data : ret
      }

      /**
       * 把对象的key转为小写
       * @static
       * @method
       * @param   {Object}     data                  源对象
       * @param   {Boolean}    [isChangeSrc=false]   是否修改源对象
       * @returns {Object}                           修改后的数据对象
       */

    }, {
      key: 'lowerJSONKey',
      value: function lowerJSONKey(data, isChangeSrc)
      {
        var ret = {}
        var newKey = ''
        for (var key in data)
        {
          newKey = key.toLowerCase()
          if (isChangeSrc && !data.hasOwnProperty(newKey))
          {
            data[newKey] = data[key]
            delete data[key]
          }
          else ret[newKey] = data[key]
        }

        return isChangeSrc ? data : ret
      }

      /**
       * 拷贝对象到另一对象去
       * @method
       * @param   {Array}     source          源对象
       * @param   {Array}     dest            目标对象
       * @returns {Object}                    this
       */

    }, {
      key: 'copyArrayTo',
      value: function copyArrayTo(source, dest)
      {
        for (var i = 0; i < source.length; i++)
        
          dest.push(source[i])
        return this
      }

      /**
       * 深度拷贝对象
       * @static
       * @method
       * @param   {Object}    source          源对象
       * @returns {Object}
       */

    }, {
      key: 'deepCopy',
      value: function deepCopy(source)
      {
        var result = null
        if (source instanceof Array) result = []; else if (source instanceof Object) result = {}; else return result
        for (var i in source)
        
          result[i] = _typeof(source[i]) === 'object' ? this.deepCopy(source[i]) : source[i]
        return result
      }

      /**
       * 拷贝数组(2维)
       * @method
       * @param   {Object}    source          源对象
       * @returns {Array}
       */

    }, {
      key: 'copyArray2',
      value: function copyArray2(source)
      {
        var items = []
        var item = void 0
        var i = void 0,
          j = void 0
        for (i in source)
        {
          item = source[i]
          var obj = {}
          for (j in item)
          
            obj[j] = item[j]
          items[i] = obj
        }
        return items
      }

      /**
       * 将coordinate类型坐标转换成Number类型
       * @method
       * @static
       * @param {ol.Coordinate}  coor  feature的coordinate.
       */

    }, {
      key: 'coorToNum',
      value: function coorToNum(coor)
      {
        var _this = this

        return Base.isArr(coor[0]) ? coor.map(function(co)
        {
          return _this.coorToNum(co)
        }) : coor.map(Number)
      }

      /**
       * 删除对象里面的属性
       * @static
       * @method
       * @param   {Object}    dest            目标对象
       * @param   {Object}    obj             待删除的属性
       * @returns {Object}                    this
       */

    }, {
      key: 'delAtts',
      value: function delAtts(dest, obj)
      {
        for (var i in obj)
        
          if (dest[i] !== undefined) delete dest[i]
        
        return this
      }

      /**
       * 数组中值去重（数组中的元素均为字符串或数字）
       * @method
       * @static
       * @param   {Array<String|Number>}    list    字符数组
       * @returns {Array<String|Number>}    去重后的数组
       */

    }, {
      key: 'filterRepeat',
      value: function filterRepeat(list)
      {
        return list.filter(function(item, index, arr)
        {
          return index === arr.findIndex(function(li)
          {
            return li === item
          })
        })
      }

      /**
       * 对象数组去重（数组中的元素均为对象）
       * @method
       * @static
       * @param   {Array<Object>}    list    字符数组
       * @param   {String}           key     要根据哪个属性进行去重，默认为id
       * @returns {Array<Object>}    去重后的数组
       */

    }, {
      key: 'filterRepeatObj',
      value: function filterRepeatObj(list)
      {
        var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id'

        return list.filter(function(item, index, arr)
        {
          return index === arr.findIndex(function(li)
          {
            return li[key] === item[key]
          })
        })
      }

      /**
      * 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
      * @method
      * @static
      * @param   {Number}  num 自然数
      * @returns {String}  自然数转成的字母
      */

    }, {
      key: 'getCharCol',
      value: function getCharCol(num)
      {
        if (num === 0) return 'A'
        var s = ''
        var m = 0
        while (num > 0)
        {
          m = num % 26 + 1
          s = String.fromCharCode(m + 64) + s
          num = (num - m) / 26
        }
        return s
      }

      /**
       * 根据字体大小获取字符串的宽度
       * @static
       * @method
       * @param   {String}    textStr             字符串文本
       * @param   {Number}    fontSize            字体大小
       * @returns {Number}
       */

    }, {
      key: 'getStrWidth',
      value: function getStrWidth()
      {
        var textStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
        var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10

        var cnStr = String(textStr || '').match(/[^\x00-\xff]/g) || []
        var enStr = String(textStr || '').replace(/[^\x00-\xff]/g, '')
        return cnStr.length * fontSize + enStr.length * fontSize * 0.65
      }

      /**
       * 取对象长度
       * @static
       * @method
       * @param   {Object}    obj             对象
       * @returns {Number}
       */

    }, {
      key: 'getObjLength',
      value: function getObjLength(obj)
      {
        if (obj instanceof Array) return obj.length; else if (obj instanceof Object)
        {
          var count = 0
          for (var i in obj)
          {
            if (obj.hasOwnProperty(i)) count++
          }
          return count
        }
      }

      /**
       * 10进制转换为16进制(2位)
       * @method
       * @param   {Number}    comp            16进制数
       * @returns {string}
       */

    }, {
      key: 'compToHex',
      value: function compToHex(comp)
      {
        var hex = comp.toString(16)
        return hex.length === 1 ? '0' + hex : hex
      }

      /**
       * 根据values中keyfld对于的最大最小值 和 分组数量，构造等间距的数值序列
       * @static
       * @method
       * @param   {Array}             values          数组
       * @param   {String}            keyFld          key字段
       * @param   {Number}            partNum         等分数
       * @returns {Array.<Number>}
       */

    }, {
      key: 'partEqual',
      value: function partEqual(values, keyFld, partNum)
      {
        var ret = []
        var value = void 0,
          min = 0,
          max = 0
        var num = values.length
        var i = void 0
        //求最小最大值
        if (num > 0)
        {
          value = parseFloat(values[0][keyFld])
          min = max = value
        }
        for (i = 1; i < num; i++)
        {
          value = parseFloat(values[i][keyFld])
          if (value < min) min = value
          if (value > max) max = value
        }
        //确定每个分组的数值
        var gap = (max - min) / partNum
        ret[0] = min
        for (i = 1; i < partNum; i++)
        
          ret[i] = ret[i - 1] + gap
        ret.push(max)
        return ret
      }

      /**
       * 根据数据对象序列values和关键字段的值进行升序排序，并把把keyfld字段的值等间距分层partNum组
       * @static
       * @method
       * @param   {Array}             values          数组
       * @param   {String}            keyFld          key字段
       * @param   {Number}            partNum         等分数
       * @returns {Object}                            分组后的数据
       * @returns {Array}             returns.nums    每组的数量
       * @returns {Array}             returns.vals    分组的值界限
       * @returns {Array}             returns.items   每组的原数据对象序列
       */

    }, {
      key: 'equalValGap',
      value: function equalValGap(values, keyFld, partNum)
      {
        var ret = { nums: [], vals: [], items: [] }

        values.sort(function(a, b)
        {
          return a[keyFld] - b[keyFld]
        })

        //确定每个分组的数值
        var min = values[0][keyFld]
        var max = values[values.length - 1][keyFld]
        var gap = (max - min) / partNum
        var grp = 1 //第几组
        var count = 0 //每组原始格式
        var idxStart = 0 //每组第一个元素的序号

        ret.vals.push(min)
        for (var i = 0; i < values.length; i++)
        {
          var item = values[i]

          //统计每个组中元素个数
          if (item[keyFld] <= min + grp * gap) ++count; else
          {
            //循环到新组第一个元素时，保存前一组的数据
            ret.nums.push(count)
            ret.vals.push(min + grp * gap)
            ret.items.push(values.slice(idxStart, i))
            ++grp
            count = 1
            idxStart = i
          }
        }

        //最后一组信息
        ret.nums.push(count)
        ret.vals.push(min + grp * gap)
        ret.items.push(values.slice(idxStart))

        return ret
      }

      /**
       * 等数量分组，返回每组成员数量的数组
       * @static
       * @method
       * @param   {Array}             values          数组
       * @param   {String}            keyFld          key字段
       * @param   {Number}            partNum         等分数
       * @returns {Object}                            分组后的数据
       * @returns {Array}             returns.nums    每组的数量
       * @returns {Array}             returns.vals    分组的值界限
       * @returns {Array}             returns.items   每组的原数据对象序列
       */

    }, {
      key: 'equalValAmount',
      value: function equalValAmount(values, keyFld, partNum)
      {
        var ret = { nums: [], vals: [], items: [] }

        values.sort(function(a, b)
        {
          return a[keyFld] - b[keyFld]
        })

        var numPerGrp = Math.floor(values.length / partNum)
        var count = 0
        ret.vals.push(values[0][keyFld])
        for (var i = 0; i < partNum - 1; i++)
        {
          count += numPerGrp
          ret.nums.push(numPerGrp)
          ret.vals.push(values[count][keyFld])
          ret.items.push(values.slice(i * numPerGrp, count))
        }
        ret.nums.push(values.length - count)
        ret.vals.push(values[values.length - 1][keyFld])
        ret.items.push(values.slice(count))

        return ret
      }

      /**
       * 根据分组值域valRange和数据对象序列values的关键字段的值进行分组
       * @static
       * @method
       * @param   {Array}             values          数组
       * @param   {String}            keyFld          key字段
       * @param   {Array.<Number>}    valRange        分组的值域序列
       * @returns {Object}                            分组后的数据
       * @returns {Array}             returns.nums    每组的数量
       * @returns {Array}             returns.vals    分组的值界限
       * @returns {Array}             returns.items   每组的原数据对象序列
       */

    }, {
      key: 'grpByValRange',
      value: function grpByValRange(values, keyFld, valRange)
      {
        var ret = { nums: [], vals: valRange, items: [] }
        var range = valRange.slice(1, valRange.length - 1)
        var grpNo = -1

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var item = _step.value

            for (var i = 0; i < range.length; i++)
            {
              grpNo = -1

              //判断item属于哪个组
              if (i === 0 && item[keyFld] < range[i] || i > 0 && i < range.length && item[keyFld] >= range[i - 1] && item[keyFld] < range[i]) grpNo = i; else if (i === range.length - 1 && item[keyFld] >= range[i]) grpNo = range.length

              if (grpNo > -1)
              {
                //该组数量增加
                ret.nums[grpNo] = ret.nums[grpNo] || 0
                ret.nums[grpNo]++

                //改组数据项增加
                ret.items[grpNo] = ret.items[grpNo] || []
                ret.items[grpNo].push(item)

                break
              }
            }
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return ret
      }

      /**
       * 根据分组数据序列和颜色序列，生成各组的染色图例
       * @method
       * @method {Object}                     grpInfo               分组数据对象
       * @method {Array.<Array.<Object>>}     grpInfo.items         各组的数据对象序列
       * @method {Array.<Number>}             grpInfo.nums          各组的数据量
       * @method {Array.<Number>}             grpInfo.vals          分组的阀值序列
       * @method {Array.<String>}             colors                各分组的 rgba 颜色序列，如#00FBFF
       * @returns {Array.<Object>}                                  各组sublayer的图例数据序列，{color:, label:}
       */

    }, {
      key: 'makeGrpLegend',
      value: function makeGrpLegend(grpInfo, colors)
      {
        var label = ''
        var legends = []
        var numClass = grpInfo.items.length

        for (var i = 0; i < numClass; i++)
        {
          //该组中对象的关键属性序列
          if (!grpInfo.items[i]) continue

          //图例中该组的值域文字
          if (i === 0) label = '< ' + grpInfo.vals[i + 1]; else if (i === numClass - 1) label = '> ' + grpInfo.vals[i]; else label = grpInfo.vals[i] + ' - ' + grpInfo.vals[i + 1]

          //根据配置生成颜色和图例数据
          legends.push({ color: colors[i], label: label })
        }

        return legends
      }

      /**
       * 等数量分组，返回每组成员数量的数组
       * @static
       * @method
       * @param {Number} itemNum 目标对象的个数
       * @param {Number} grpNum 分成num组
       * @returns {Array} 分组数组，每个值是该组中元素的个数
       */

    }, {
      key: 'equalAmount',
      value: function equalAmount(itemNum, grpNum)
      {
        var rets = []
        var numPerGrp = Math.floor(itemNum / grpNum)
        var count = 0

        for (var i = 0; i < grpNum - 1; i++)
        {
          count += numPerGrp
          rets[i] = numPerGrp
        }
        rets.push(itemNum - count)
        return rets
      }
    }])
    return Util
  }())

  /* global MozWebSocket */

  /**
   * cx.IMessage
   * 消息接口类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var IMessage = (function()
  {
    /**
     * @constructor
     */
    function IMessage()
    {
      classCallCheck(this, IMessage)

      this.socket = null
    }

    /**
     * 销毁对象
     * @method
     */


    createClass(IMessage, [{
      key: 'destroy',
      value: function destroy()
      {
        this.disconnect()
      }

      /**
       * 连接到服务器
       * @method
       * @param   {String}    url             服务地址
       * @param   {String}    username        用户名
       * @returns {Object}                    this
       */

    }, {
      key: 'connect',
      value: function connect(url, username)
      {
        var _this = this

        var connStr = url + '?userid=' + username
        this.username = username
        if ('WebSocket' in window) this.socket = new WebSocket(connStr); else if ('MozWebSocket' in window) this.socket = new MozWebSocket(connStr); else return
        this.socket.onopen = function()
        {}
        this.socket.onclose = function()
        {}
        this.socket.onmessage = function(message)
        {
          _this.onMessage(Converter.toObject(message.data))
        }
      }

      /**
       * 断开连接
       * @method
       */

    }, {
      key: 'disconnect',
      value: function disconnect()
      {
        if (this.socket)
        {
          this.socket.close()
          this.socket = null
        }
      }

      /**
       * 发送消息
       * @method
       * @param {String}      to              接收者
       * @param {Object}      msg             消息体
       * @returns {Object}                    this
       */

    }, {
      key: 'send',
      value: function send(to, msg)
      {
        var paras = Util.copyObject(msg)
        paras.to = to
        this.socket.send(JSON.stringify(paras))
        return this
      }

      /**
       * 发送消息
       * @method
       * @param {Object}    msg        消息体
       */

    }, {
      key: 'onMessage',
      value: function onMessage(msg)
      {
        switch (msg.type)
        {
        case 'task':
          switch (msg.cmd)
          {
          case 'assign':
            Events.publish('assignTask', msg)
            break
          }
          break
        case 'progress':
          Events.publish('progress', msg)
          break
        case 'notify':
          Events.publish('notify', msg)
          break
        }
      }
    }])
    return IMessage
  }())

  /**
   * cx.iconCss
   * 图标的样式类处理类
   *
   * @class
   * @memberof    cx
   * @author    Zhang Qing
   */

  var IconCss = (function()
  {
    function IconCss()
    {
      classCallCheck(this, IconCss)
    }

    createClass(IconCss, null, [{
      key: 'createCls',

      /**
       * 根据给定的样式类名clsName，和资源路径url动态创建样式
       * @static
       * @method
       * @param  {String}  clsName      样式class名
       * @param  {String}  url          图标的路径
       */
      value: function createCls(clsName, url)
      {
        Dom.createCss('.' + clsName + '{background:url(' + url + ')}')
      }

      /**
       * 根据给图标名、大小，和资源路径url动态创建样式
       * @static
       * @method
       * @param   {String}  iconName  图标名字
       * @param   {Number}  iconSize  图标大小
       * @param   {String}  url       图标的路径
       * @returns {String}            样式的类名，如：icon-add24
       */

    }, {
      key: 'createClsByIcon',
      value: function createClsByIcon(iconName, iconSize, url)
      {
        var clsName = this.getClsBySize(iconName, iconSize)
        this.createCls(clsName, url)
        return clsName
      }

      /**
       * 获取icon的矢量图标样式类
       * @static
       * @method
       * @param   {String} [iconName]    图标名, 如：cx-fi icon-analysis
       * @param   {Number} [iconSize]    图标的宽度（宽高度相同）
       * @returns {String}               样式的类名，如：cx-fi icon-analysis fi-24
       */

    }, {
      key: 'getVecClss',
      value: function getVecClss(iconName, iconSize)
      {
        return iconName ? iconName + ' ' + this.getVecClssSize(iconSize) : ''
      }

      /**
       * 获取矢量图标大小样式
       * @static
       * @method
       * @param   {Number} [iconSize]    图标的宽度（宽高度相同）
       * @returns {String}               样式的类名，如：fi-24
       */

    }, {
      key: 'getVecClssSize',
      value: function getVecClssSize(iconSize)
      {
        return iconSize ? ' fi-' + iconSize : ''
      }

      /**
       * 获取插件icon的矢量图标样式类
       * @static
       * @method
       * @param   {String} [iconName]    图标名,可以是: .clsname(待处理类名)  或  clsname1 clsname2(直接使用类名)
       * @param   {Number} [iconSize]    图标的宽度（宽高度相同）
       * @returns {String}               样式的类名，如：cx-fi fi-24 icon-analysis
       */

    }, {
      key: 'getVecClssPlug',
      value: function getVecClssPlug()
      {
        var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''
        var iconSize = arguments[1]

        var cls = iconName
        var namSplit = iconName.split('.')
        if (namSplit[0] === '')
        {
          //插件图标是待处理类名
          cls = namSplit[1] ? 'cx-fi icon-' + namSplit[1] : ''
        }

        return this.getVecClss(cls, iconSize)
      }

      /**
       * 获取实体的图片路径 (对应img/dev/iconName.png)
       * @static
       * @method
       * @param   {String} iconName  图标名
       * @returns {String}
       */

    }, {
      key: 'getUrlDev',
      value: function getUrlDev(iconName)
      {
        return this.PATH_DEV + iconName + '.png'
      }

      /**
       * 获取实体的打印图标路径 (对应img/devPrt/iconName-prt.png)
       * @static
       * @method
       * @param   {String} iconName  图标名
       * @returns {String}
       */

    }, {
      key: 'getUrlDevPrt',
      value: function getUrlDevPrt(iconName)
      {
        //获取图纸打印的图标
        return this.PATH_DEV_PRT + iconName + '-prt.png'
      }
    }])
    return IconCss
  }())

  //相对服务器下工程目录


  IconCss.PATH_DEV = 'static/img/dev/'
  IconCss.PATH_DEV_PRT = 'static/img/devPrt/'

  /**
   * 前端浏览器数据库IndexDb 管理类
   *
   * 维护记录：
   * ——————— 创建 - 高旭龙 - 2021.7.9
   */

  /**
   * cx.MyIndexDb
   * 类-数组语法糖
   *
   * @class
   * @memberof    cx
   * @param       {Object}        option                 参数对象
   * @param       {String}        option.dbName          数据库名称
   * @param       {String}        [option.dbVersion]     数据库版本号，可不传
   * @param       {Array<Object>} [option.dbStores]      要创建的表配置集合，如：[{name:'person', conf: {keyPath: 'id'}}, {name: 'role', indexs: [{name: 'glid', conf: {unique: true}}]}]. 如果没有指定主键的属性，那么 会自动生成主键  { autoIncrement: true }。
   */
  var MyIndexDb = (function()
  {
    function MyIndexDb(opts)
    {
      classCallCheck(this, MyIndexDb)

      // 定义实例属性
      this.db = null // 数据库对象
      this.dbName = 'myIndexDb' // 数据库名称
      this.defStore = { name: 'indexStore', conf: { keyPath: 'key' } // 默认表配置对象（必定会创建）

      }; this.opts = opts
      if (!window.indexedDB) return console.log('你的浏览器不支持IndexDB,请更换浏览器')
    }

    // 使用取值函数（getter）设置默认的表名属性defStoreName


    createClass(MyIndexDb, [{
      key: 'add',


      /**
      * 增加数据
      * @method
      * @param     {Object}    option          参数对象
      * @param     {String}    option.name     表名
      * @param     {Object}    option.att      待新增的数据对象，必须包含配置主键字段key
      * @returns {Promise}
      */
      value: function add(_ref)
      {
        var _this = this

        var _ref$name = _ref.name,
          name = _ref$name === undefined ? this.defStoreName : _ref$name,
          att = _ref.att

        return new Promise(function(resolve, reject)
        {
          try
          {
            //此处须显式声明事物
            var request = _this.getStoreObj(name, 'readwrite').add(att)
            request.onsuccess = resolve
            request.onerror = reject
          }
          catch (err)
          {
            _this.onError(err, 'add')
          }
        })
      }

      /**
      * 批量添加数据
      * @method
      * @param     {Object}            option          参数对象
      * @param     {String}            option.name     表名
      * @param      {Array<Object>}     option.atts     包含主键的属性集合，比如[{key:1,name:'张三'},{key:2,name:'李四'}]
      * @returns {Promise}
      */

    }, {
      key: 'adds',
      value: async function adds(_ref2)
      {
        var _ref2$name = _ref2.name,
          name = _ref2$name === undefined ? this.defStoreName : _ref2$name,
          _ref2$atts = _ref2.atts,
          atts = _ref2$atts === undefined ? [] : _ref2$atts

        try
        {
          for (var att in atts)
          
            await this.add({ name: name, att: att })
        }
        catch (err)
        {
          this.onError(err, 'adds')
        }
      }

      /**
      * 清空整个对象存储(表)
      * @method
      * @param     {String}          name     表名
      * @returns {Promise}
      */

    }, {
      key: 'clear',
      value: function clear()
      {
        var _this2 = this

        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defStoreName

        return new Promise(function(resolve, reject)
        {
          try
          {
            var request = _this2.db.transaction(name, 'readwrite').objectStore(name).clear()
            request.onsuccess = resolve
            request.onerror = reject
          }
          catch (err)
          {
            _this2.onError(err, 'clear')
          }
        })
      }

      /**
      * 根据实例化参数，创建数据库
      * @method
      * @private
      * @returns {Promise}
      */

    }, {
      key: 'createDb',
      value: function createDb()
      {
        var _this3 = this

        return new Promise(function(resolve, reject)
        {
          try
          {
            _this3.db = null // 数据库对象
            _this3.dbName = _this3.opts.dbName || _this3.dbName // 数据库名称
            _this3.dbVersion = _this3.opts.dbVersion // 数据库版本,初始创建时默认为1

            var dbStores = [_this3.defStore]
            if (_this3.opts.dbStores && _this3.opts.dbStores.length > 0) // 默认创建的数据存储仓库(即表名)集合
              dbStores = dbStores.concat(_this3.opts.dbStores)

            var request = indexedDB.open(_this3.dbName, _this3.dbVersion)
            // 1、数据库创建失败的钩子
            request.onerror = function(event)
            {
              reject(event.target.errorCode)
              // console.log('不能打开数据库,错误代码: ' + event.target.errorCode)
            }

            // 2、数据库版本升级成功的钩子
            request.onupgradeneeded = function(event)
            {
              _this3.db = event.target.result
              _this3.createStores(dbStores, false) // 创建指定的默认表.【注意创建、删除表的操作只能在onupgradeneeded事件中去做】
            }

            // 3、数据库创建成功时的钩子
            request.onsuccess = function(event)
            {
              _this3.db = event.target.result
              // console.log(`indexDB连接成功，数据库名：${this.db.name},当前版本号：${this.db.version}`)
              _this3.createStores(dbStores)
              resolve()
            }
          }
          catch (err)
          {
            reject(err)
            _this3.onError(err, 'createDb')
          }
        })
      }

      /**
      * 批量创建表
      * @method
      * @param      {Array<Object>}     stores              待创建的表配置集合
      * @param      {Boolean}           [needUpgrade=true]  是否需要进行版本升级，默认都需要。
      * @returns {Promise}
      */

    }, {
      key: 'createStores',
      value: async function createStores()
      {
        var _this4 = this

        var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []
        var needUpgrade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true

        try
        {
          if (needUpgrade) await this.upgradeDb({ addStores: stores }); else
          {
            stores.forEach(function(store)
            {
              return _this4.createStore(store)
            })
          }
        }
        catch (err)
        {
          this.onError(err, 'createStores')
        }
      }

      /**
      * 创建表(不可在外部直接调用)
      * @method
      * @param      {Object}          option            参数对象
      * @param      {String}          option.name       表名
      * @param      {Object}          [option.conf]     创建表的配置参数对象，默认为{autoIncrement: true}
      * @param      {Array<Object>}   [option.indexs]   要创建的索引配置集合，如：[{name: 'glid', conf: {unique: true}}]
      */

    }, {
      key: 'createStore',
      value: function createStore(_ref3)
      {
        var name = _ref3.name,
          _ref3$conf = _ref3.conf,
          conf = _ref3$conf === undefined ? { autoIncrement: true } : _ref3$conf,
          _ref3$indexs = _ref3.indexs,
          indexs = _ref3$indexs === undefined ? [] : _ref3$indexs

        try
        {
          // 创建之前先判断一下，这张表格是否存在，如果不存在再新建
          if (!this.db.objectStoreNames.contains(name))
          {
            // 建表
            var objectStore = this.db.createObjectStore(name, conf)
            // 建索引
            indexs.forEach(function(index)
            {
              return objectStore.createIndex(index.name, index.name, index.conf || { unique: false })
            })
          }
        }
        catch (err)
        {
          this.onError(err, 'createStore')
        }
      }

      /**
      * 删除数据
      * @method
      * @param     {Object}    option          参数对象
      * @param     {String}    option.name     表名
      * @param     {String}    option.key      主键值，比如id
      * @returns {Promise}
      */

    }, {
      key: 'delete',
      value: function _delete(_ref4)
      {
        var _this5 = this

        var _ref4$name = _ref4.name,
          name = _ref4$name === undefined ? this.defStoreName : _ref4$name,
          key = _ref4.key

        return new Promise(function(resolve, reject)
        {
          try
          {
            var request = _this5.getStoreObj(name, 'readwrite').delete(key)
            request.onsuccess = function(_)
            {
              return resolve(name, key)
            }
            request.onerror = reject
          }
          catch (err)
          {
            _this5.onError(err, 'delete')
          }
        })
      }

      /**
      * 批量删除数据
      * @method
      * @param     {Object}           option          参数对象
      * @param     {String}           option.name     表名
      * @param     {Array<String>}    option.keys     主键值集合，比如[1,2,3]
      * @returns {Promise}
      */

    }, {
      key: 'dels',
      value: async function dels(_ref5)
      {
        var _ref5$name = _ref5.name,
          name = _ref5$name === undefined ? this.defStoreName : _ref5$name,
          _ref5$keys = _ref5.keys,
          keys = _ref5$keys === undefined ? [] : _ref5$keys

        try
        {
          for (var key in keys)
          
            await this.delete({ name: name, key: key })
        }
        catch (err)
        {
          this.onError(err, 'dels')
        }
      }

      /**
      * 批量删除表
      * @method
      * @param      {Array<String>}     stores              待删除的表名集合,如：['table1','table2']
      * @param      {Boolean}           [needUpgrade=true]  是否需要进行版本升级，默认都需要。
      * @returns {Promise}
      */

    }, {
      key: 'deleteStores',
      value: async function deleteStores()
      {
        var _this6 = this

        var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []
        var needUpgrade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true

        try
        {
          if (needUpgrade) await this.upgradeDb({ delStores: stores }); else
          {
            stores.forEach(function(store)
            {
              return _this6.deleteStore(store)
            })
          }
        }
        catch (err)
        {
          this.onError(err, 'deleteStores')
        }
      }

      /**
      * 删除表(不可在外部直接调用)
      * @method
      * @param     {String}           name     表名
      */

    }, {
      key: 'deleteStore',
      value: function deleteStore(name)
      {
        try
        {
          // 创建之前先判断一下，这张表格是否存在，如果存在再删除
          if (this.db.objectStoreNames.contains(name)) this.db.deleteObjectStore(name)
        }
        catch (err)
        {
          this.onError(err, 'deleteStore')
        }
      }

      /**
      * 查询指定表的所有数据
      * @method
      * @param     {String}           name     表名
      * @returns {Promise}
      */

    }, {
      key: 'getAlldata',
      value: function getAlldata()
      {
        var _this7 = this

        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defStoreName

        return new Promise(function(resolve, reject)
        {
          try
          {
            var request = _this7.db.transaction(name, 'readwrite').objectStore(name).getAll()
            request.onsuccess = function(_)
            {
              return resolve(request.result)
            }
            request.onerror = reject
          }
          catch (err)
          {
            _this7.onError(err, 'getAlldata')
          }
        })
      }

      /**
      * 根据表名和操作类型获取对应的 IDBObjectStore 对象
      * @method
      * @param     {String}              name        表名。不传为默认表名
      * @param     {String}              opertype    操作类型。默认为'readonly'.目前，操作类型只有两种：readonly（只读）和readwrite（读写）
      * @returns   {IDBObjectStore}      表的IDBObjectStore对象
      */

    }, {
      key: 'getStoreObj',
      value: function getStoreObj()
      {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defStoreName
        var opertype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'readonly'

        return this.db.transaction(name, opertype).objectStore(name)
      }

      /**
      * 判断一个变量是否是数组
      * @method
      * @param     {any}     obj       变量
      * @returns   {Boolean}
      */

    }, {
      key: 'isArray',
      value: function isArray(obj)
      {
        return Object.prototype.toString.call(obj) === '[object Array]'
      }

      /**
      * 判断一个变量是否是对象
      * @method
      * @param     {any}     obj       变量
      * @returns   {Boolean}
      */

    }, {
      key: 'isObject',
      value: function isObject(obj)
      {
        return Object.prototype.toString.call(obj) === '[object Object]'
      }

      /**
      * 查询操作
      * @method
      * @param     {Object}    option               参数对象
      * @param     {String}    option.name          表名
      * @param     {String}    option.key           主键值，比如id
      * @param     {Object}    option.index         索引的检索条件.比key的优先级低，当没有传入key时，才会用index去检索。如：{name: 'name', value: '张三'}
      * @param     {String}    option.index.name    索引名称
      * @param     {String}    option.index.value   索引字段对应的值
      * @returns {Promise}
      */

    }, {
      key: 'query',
      value: function query(_ref6)
      {
        var _this8 = this

        var _ref6$name = _ref6.name,
          name = _ref6$name === undefined ? this.defStoreName : _ref6$name,
          key = _ref6.key,
          index = _ref6.index

        return new Promise(function(resolve, reject)
        {
          try
          {
            var _store = _this8.getStoreObj(name)
            var request = key ? _store.get(key) : index && index.name ? _store.index(index.name).get(index.value) : _store.getAll()
            request.onsuccess = function(_)
            {
              return resolve(request.result)
            }
            request.onerror = reject
          }
          catch (err)
          {
            _this8.onError(err, 'query')
          }
        })
      }

      /**
      * 批量查询数据
      * @method
      * @param     {Object}           option          参数对象
      * @param     {String}           option.name     表名
      * @param     {Array<String>}    option.keys     主键值集合，比如[1,2,3]
      * @param     {Array<Object>}    option.indexs   索引集合,如：[{name: 'name', value: '张三'}, {name: 'name', value: '李四'}]
      * @returns {Promise}
      */

    }, {
      key: 'querys',
      value: async function querys(_ref7)
      {
        var _ref7$name = _ref7.name,
          name = _ref7$name === undefined ? this.defStoreName : _ref7$name,
          _ref7$keys = _ref7.keys,
          keys = _ref7$keys === undefined ? [] : _ref7$keys,
          _ref7$indexs = _ref7.indexs,
          indexs = _ref7$indexs === undefined ? [] : _ref7$indexs

        try
        {
          var data = []
          // 根据主键查询的结果
          for (var key in keys)
          
            data.push((await this.query({ name: name, key: key })))
          // 根据索引查询的结果
          for (var index in indexs)
          {
            var result = await this.query({ name: name, index: index })
            // result 可能是对象，也可能是数组。
            this.isArray(result) ? data.push.apply(data, toConsumableArray(result)) : data.push(result)
          }
          return data
        }
        catch (err)
        {
          this.onError(err, 'querys')
        }
      }
    }, {
      key: 'onError',
      value: function onError(err, fnName)
      {}
      // console.log(`MyIndexDb_err_in_${fnName}`, err)


      /**
      * 增加和编辑操作
      * @method
      * @param     {Object}    option          参数对象
      * @param     {String}    option.name     表名
      * @param     {Object}    option.att   待更新的数据对象
      * @returns {Promise}
      */

    }, {
      key: 'update',
      value: function update(_ref8)
      {
        var _this9 = this

        var _ref8$name = _ref8.name,
          name = _ref8$name === undefined ? this.defStoreName : _ref8$name,
          att = _ref8.att

        return new Promise(function(resolve, reject)
        {
          try
          {
            var _store2 = _this9.getStoreObj(name, 'readwrite')
            var request = _store2.put(att)
            request.onsuccess = resolve
            request.onerror = reject
          }
          catch (err)
          {
            _this9.onError(err, 'update')
          }
        })
      }

      /**
      * 批量查询数据
      * @method
      * @param     {Object}           option          参数对象
      * @param     {String}           option.name     表名
      * @param     {Array<Object>}    option.atts     包含主键的属性集合，比如[{key:1,name:'张三'},{key:2,name:'李四'}]
      * @returns {Promise}
      */

    }, {
      key: 'updates',
      value: async function updates(_ref9)
      {
        var _ref9$name = _ref9.name,
          name = _ref9$name === undefined ? this.defStoreName : _ref9$name,
          atts = _ref9.atts

        try
        {
          for (var att in atts)
          
            await this.update({ name: name, att: att })
        }
        catch (err)
        {
          this.onError(err, 'updates')
        }
      }

      /**
      * 更新数据库版本（创建新表或者移除表）
      * @method
      * @param   {Object}            option                参数对象
      * @param   {Array<Object>}     option.addStores      待新增的表配置集合，如：[{name:'person', conf: {keyPath: 'id'}}, {name: 'role'}]. 如果没有指定主键的属性，那么 会自动生成主键  { autoIncrement: true }
      * @param   {Array<String>}     option.delStores      待删除的表名集合，如：['xzq1','xzq2']
      * @returns {Promise}
      */

    }, {
      key: 'upgradeDb',
      value: function upgradeDb(_ref10)
      {
        var _this10 = this

        var _ref10$addStores = _ref10.addStores,
          addStores = _ref10$addStores === undefined ? [] : _ref10$addStores,
          _ref10$delStores = _ref10.delStores,
          delStores = _ref10$delStores === undefined ? [] : _ref10$delStores

        return new Promise(function(resolve, reject)
        {
          try
          {
            // 1、首先判断stores中的表是否全部已经在数据库中存在，全都存在时不需要升级。
            if (addStores.every(function(store)
            {
              return _this10.db.objectStoreNames.contains(store.name)
            }) && delStores.every(function(name)
            {
              return !_this10.db.objectStoreNames.contains(store.name)
            })) return resolve()
            // 2、重要！重要！版本更新之前一定要先调用close()将上次的数据库连接关闭。
            _this10.db.close()
            // 3、首先获取当前数据库版本号
            var curVersion = _this10.db.version + 1
            // 4、更新版本
            var request = indexedDB.open(_this10.dbName, curVersion)
            // 4、1、在onupgradeneeded钩子中创建新表
            request.onupgradeneeded = function(event)
            {
              // console.log(`数据库【${this.db.name}】升级成功，数据库名：${this.db.name}，当前版本号：${this.db.version}`, event)
              _this10.db = event.target.result
              // 创建表
              addStores.forEach(function(store)
              {
                return _this10.createStore(store)
              })
              // 删除表
              delStores.forEach(function(name)
              {
                return _this10.deleteStore(name)
              })
              resolve()
            }
            // 4.2、数据库创建失败的钩子
            request.onerror = function(event)
            {
              // console.log('不能打开数据库,错误代码: ' + event.target.errorCode)
              reject(event)
            }
            // 4.3、数据库创建成功时的钩子
            request.onsuccess = function(event)
            {
              _this10.db = event.target.result
              // console.log(`数据库【${this.db.name}】升级成功，数据库名：${this.db.name}，当前版本号：${this.db.version}`, event)
            }
          }
          catch (err)
          {
            _this10.onError(err, 'upgradeDb')
          }
        })
      }
    }, {
      key: 'defStoreName',
      get: function get()
      {
        return this.defStore.name
      }
    }])
    return MyIndexDb
  }())

  /**
   * cx.geo.ILayer
   * 接口类：业务逻辑图层管理、逻辑图层开关数据控制
   *
   * @class
   * @memberof    cx.geo
   * @author      zhang qing
   * @since       2018-07-02
   */

  var ILayer = (function()
  {
    /**
     * @constructs
     */
    function ILayer()
    {
      classCallCheck(this, ILayer)

      /**
       * @private
       * @property {Array.<Object>}  layer    图层对象数组，来自Layer表
       */
      this.layer = null

      /**
       * @private
       * @property {Object}  _domains   空间数据域的序列对象
       */
      this._domains = null

      /**
       * @private
       * @property {Object}  _majors   空间数据主类型的序列对象
       */
      this._majors = {}

      /**
       * @private
       * @property {Object}  _layerHash   根据图层数据数组，按域、主类型、图层号逐级组织的哈希数据（子类型可能重复）
       */
      this._layerHash = null

      /**
       * @private
       * @property {Object}  _layerHashByLyrNo   根据图层数据数组，按图层号组织哈希数据
       */
      this._layerHashByLyrNo = null

      /**
       * @property {Object}  layerTree          图层树，用于图层选中
       */
      this.layerTree = []

      /**
       * @property {Object}  rootLayer          主子类型对应的根图层，用于图层选中
       */
      this.rootLayer = {}
    }

    /**
     * 根据图层号，取业务逻辑图层数据
     * @method
     * @param {Number} layerNum 图层号
     * @returns {Object} [object | null] 业务逻辑图层数据
     */


    createClass(ILayer, [{
      key: 'byLyrNum',
      value: function byLyrNum(layerNum)
      {
        return this._layerHashByLyrNo[layerNum]
      }

      /**
       * 根据主、子类型和属性，取业务逻辑图层数据
       * @method
       * @param {Number} major 主类型
       * @param {Number} minor 子类型
       * @param {object} [att] 与layer对象的exp深度匹配
       * @returns {Object} [object | null] 业务逻辑图层数据
       */

    }, {
      key: 'byMajMin',
      value: function byMajMin(major, minor, att)
      {
        var ret = null
        var bFind = true
        var oItem = null
        var layers = null
        for (var i in this._layerHash)
        {
          layers = this._layerHash[i][major]
          if (layers)
          {
            for (var j in layers)
            {
              oItem = layers[j]
              if (Number(oItem.minor) === Number(minor))
              {
                bFind = true
                //att属性对象不为空时，就用实体的exp深度匹配
                if (Base.isObj(att) && Base.isObj(oItem.exp))
                {
                  for (var n in oItem.exp)
                  
                    if (att[n] != oItem.exp[n]) bFind = false
                }
                if (bFind)
                {
                  ret = oItem
                  if (Base.isObj(oItem.exp) && Object.keys(oItem.exp).length > 0) return ret
                }
              }
            }
          }
        }
        return ret
      }

      /**
       * 根据主子类型取目标空间数据的域
       * @method
       * @param {Number} major 主类型
       * @param {Number} minor 子类型
       * @returns {Number} [number | null] 目标域
       */

    }, {
      key: 'getDomain',
      value: function getDomain(major, minor)
      {
        var oEtty = $g.entity.byMajMin(major, minor)
        if (Base.isObj(oEtty)) return oEtty.domain

        return null
      }

      /**
       * 取空间数据域类别，来自entity表
       * @method
       * @returns {Object} 域数据集
       */

    }, {
      key: 'getDomains',
      value: function getDomains()
      {
        if (this._domains) return this._domains

        var oItem = null
        var aList = $g.field.getFldvalues('entity', 'domain')
        //删除后台部分
        Array$1.remove(aList, { dbvalue: '99' })
        this._domains = {}
        for (var i = 0, lenI = aList.length; i < lenI; i++)
        {
          oItem = {}
          oItem.domain = parseInt(aList[i].dbvalue)
          oItem.name = Base.locale(aList[i].dispc, aList[i].dispe)
          oItem.namec = aList[i].dispc
          oItem.namee = aList[i].dispe
          this._domains[oItem.domain] = oItem
        }
        return this._domains
      }

      /**
       * 根据主类型取逻辑图层开关状态数据集
       * @method
       * @param {Number} major 主类型
       * @returns {Object} 业务逻辑图层数据集
       */

    }, {
      key: 'getLogcLyrByMajor',
      value: function getLogcLyrByMajor(major)
      {
        var data = {}
        if (this.isLogcLyrByMajor(major))
        {
          var majors = null
          for (var domain in this._layerHash)
          {
            majors = this._layerHash[domain]
            data = majors[major]
          }
        }
        return data
      }

      /**
       * 取全部逻辑图层数据（来自Layer表）
       * @method
       * @returns {Array.<Object>} 图层数据集
       */

    }, {
      key: 'getLyrList',
      value: function getLyrList()
      {
        return this.layer
      }

      /**
       * 取全部空间数据主类型类别，来自vector表
       * @method
       * @returns {Object} 主类型数据集
       */

    }, {
      key: 'getMajors',
      value: function getMajors()
      {
        if (this._majors.phys) return this._majors.phys
        var nMajor = null
        var aList = $g.init.vector
        this._majors.phys = {}
        for (var i = aList.length - 1; i >= 0; i--)
        {
          nMajor = aList[i].major
          if (nMajor !== 0) this._majors.phys[nMajor] = $g.entity.byMajMin(nMajor, 0)
        }
        return this._majors.phys
      }

      /**
       * 取逻辑矢量图层表中空间数据主类型类别，来自layer表
       * @method
       * @returns {Object} 主类型数据集
       */

    }, {
      key: 'getMajorsLogc',
      value: function getMajorsLogc()
      {
        if (this._majors.logc) return this._majors.logc

        var majors = null
        this._majors.logc = {}
        for (var i in this._layerHash)
        {
          majors = this._layerHash[i]
          for (var j in majors)
          
            this._majors.logc[j] = true
        }
        return this._majors.logc
      }

      /**
       * 根据域、主类型和属性取目标空间数据的子类型
       * @method
       * @param {Number} domain 域
       * @param {Number} major 主类型
       * @param {Object} [att] 与layer对象的exp深度匹配
       * @param {Boolean} [isAttach=false] 是否取附属物的子类型
       * @returns {Number} [number | null] 子类型
       */

    }, {
      key: 'getMinor',
      value: function getMinor(domain, major, att, isAttach)
      {
        var ret = null
        var oItem = null
        var bFind = true
        var layers = null
        var majors = this._layerHash[domain]
        if (majors) layers = majors[major]
        if (!layers) return null
        for (var i in layers)
        {
          oItem = layers[i]
          if (!!oItem.isattach === !!isAttach)
          {
            bFind = true
            //att属性对象不为空时，就用实体的exp深度匹配
            if (Base.isObj(att) && Base.isObj(oItem.exp))
            {
              for (var j in oItem.exp)
              
                if (att[j] != oItem.exp[j]) bFind = false
            }
            if (bFind)
            {
              ret = oItem.minor
              if (Base.isObj(oItem.exp) && Object.keys(oItem.exp).length > 0) return ret
            }
          }
        }
        return ret
      }

      /**
       * 根据域、主类型和属性取目标空间数据的子类型哈希对象
       * @method
       * @param {Number} domain 域
       * @param {Number} major 主类型
       * @returns {Object} 子类型哈希对象
       */

    }, {
      key: 'getMinors',
      value: function getMinors(domain, major)
      {
        var data = {}
        var layers = null
        var majors = this._layerHash[domain]
        if (majors) layers = majors[major]
        if (!layers) return null
        for (var i in layers)
        
          data[layers[i].minor] = layers[i]
        return data
      }

      /**
       * 判断major是否属于layer表中逻辑图层（逻辑图层才可以读属性表）
       * @method
       * @returns {Boolean} 判断的结果
       */

    }, {
      key: 'isLogcLyrByMajor',
      value: function isLogcLyrByMajor(major)
      {
        return this.getMajorsLogc()[major]
      }

      /**
       * 设置原始数据
       * @method
       * @param   {Array.<Object>}    data               图层数据对象
       */

    }, {
      key: 'setData',
      value: function setData(data)
      {
        this.layer = data

        //数据预处理
        this._parseExp(this)
        this._prepLyrHash(this)
        this._prepLyrHashByLyrNo(this)

        this._prepLayerTree(this.layerTree, 0) //构建图层选择树
        this._prepRootLayer() //构建主子类型的根图层信息，用于查询/统计/分类
      }

      /**
       * 把layer数据中的exp字段值解析成对象
       * @method
       * @private
       */

    }, {
      key: '_parseExp',
      value: function _parseExp()
      {
        //解析数据里面的Exp字段，把他转换成JSON对象
        var aList = this.layer
        var oItem = null
        for (var i = 0, lenI = aList.length; i < lenI; i++)
        {
          oItem = aList[i]
          if (oItem.exp === undefined || oItem.exp == null || oItem.exp === '') oItem.exp = {}; else if (Base.isStr(oItem.exp)) oItem.exp = Converter.toObject(oItem.exp)
        }
      }

      /**
       * 根据图层数据数组，按域、主类型、图层号逐级组织的哈希数据（子类型可能重复）
       * @private
       * @method
       */

    }, {
      key: '_prepLyrHash',
      value: function _prepLyrHash()
      {
        this._layerHash = {}
        var list = this.layer
        var item = void 0,
          objDomain = void 0,
          objMaj = void 0
        for (var i = list.length - 1; i >= 0; i--)
        {
          item = list[i]
          if (item.major === 0) continue
          objDomain = this._layerHash[item.domain]
          if (!objDomain) objDomain = this._layerHash[item.domain] = {}
          objMaj = objDomain[item.major]
          if (!objMaj) objMaj = objDomain[item.major] = {}
          objMaj[item.layer] = item
        }
      }

      /**
       * 根据图层数据数组，按图层号组织的哈希数据
       * @private
       * @method
       */

    }, {
      key: '_prepLyrHashByLyrNo',
      value: function _prepLyrHashByLyrNo()
      {
        this._layerHashByLyrNo = {}
        var list = this.layer
        for (var i = list.length - 1; i >= 0; i--)
        
          this._layerHashByLyrNo[list[i].layer] = list[i]
      }

      /**
       * 生成图层树
       * @method
       * @private
       * @param   {Array}     layerList         图层列表
       * @param   {Number}    parentLayerId     父图层号
       */

    }, {
      key: '_prepLayerTree',
      value: function _prepLayerTree(layerList, parentLayerId)
      {
        var items = Array$1.gets(this.layer, { glid: parentLayerId })
        var item = void 0,
          obj = void 0

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            item = _step.value

            obj = {
              label: Base.locale(item.namec, item.namee),
              icon: item.icon,
              children: []
            }
            layerList.push(obj)
            this._prepLayerTree(obj.children, item.layer)

            //如果没有儿子，则删除
            if (obj.children.length < 1)
            {
              //叶子节点
              delete obj.children
              obj.value = Object.keys(item.exp).length === 0 ? item.major + '_' + item.minor : item.major + '_' + item.minor + '_' + Converter.data2String(item.exp)
              obj.layer = item.layer
            }
            else
            {
              //非叶子节点
              obj.value = item.layer
            }
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }
      }

      /**
       * 选择默认图层
       * @method
       * @returns {String}                      逗号分隔开的图层号
       */

    }, {
      key: 'selectDefLayer',
      value: function selectDefLayer()
      {
        var ret = []

        var makeData = function makeData(obj)
        {
          if (!obj) return
          if (obj.value !== undefined) ret.push(obj.value)
          if (obj.children) makeData(obj.children[0])
        }
        makeData(this.layerTree[0])
        return ret.toString()
      }

      /**
       * 准备每个主子类型对应的根图层
       * @method
       */

    }, {
      key: '_prepRootLayer',
      value: function _prepRootLayer()
      {
        var rootLayer = {}

        //递归找
        var brecive = function brecive(root, list)
        {
          if (Base.isArr(list))
          {
            var _iteratorNormalCompletion2 = true
            var _didIteratorError2 = false
            var _iteratorError2 = undefined

            try
            {
              for (var _iterator2 = list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
              {
                var item = _step2.value

                if (item.children === undefined) rootLayer[item.layer] = root; else brecive(root, item.children)
              }
            }
            catch (err)
            {
              _didIteratorError2 = true
              _iteratorError2 = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion2 && _iterator2.return)
                
                  _iterator2.return()
              }
              finally
              {
                if (_didIteratorError2)
                
                  throw _iteratorError2
              }
            }
          }
        }

        //把第一层当根节点
        var _iteratorNormalCompletion3 = true
        var _didIteratorError3 = false
        var _iteratorError3 = undefined

        try
        {
          for (var _iterator3 = this.layerTree[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)
          {
            var item = _step3.value

            brecive(item, item.children)
          }
        }
        catch (err)
        {
          _didIteratorError3 = true
          _iteratorError3 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion3 && _iterator3.return)
            
              _iterator3.return()
          }
          finally
          {
            if (_didIteratorError3)
            
              throw _iteratorError3
          }
        }

        this.rootLayer = rootLayer
      }
    }])
    return ILayer
  }())

  /**
   * cx.geo.Mapara
   * 业务逻辑图层管理、逻辑图层开关数据控制
   *
   * @class
   * @memberof    cx.geo
   * @author      zhang qing
   * @since       2018-07-02
   */

  var Mapara = (function()
  {
    /**
     * @constructs
     */
    function Mapara()
    {
      classCallCheck(this, Mapara)

      this.mappara = null
      this.index = null
    }

    /**
     * 设置原始数据
     * @method
     * @param   {Array.<Object>}    data               图层数据对象
     */


    createClass(Mapara, [{
      key: 'setData',
      value: function setData(data)
      {
        this.mappara = data

        //数据预处理
        this.parseExp()
        this.buildIndex()
      }

      /**
       * 把图形中的exp参数解析成对象
       * @method
       */

    }, {
      key: 'parseExp',
      value: function parseExp()
      {
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.mappara[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var item = _step.value

            if (_typeof(item.exp) !== 'object') item.exp = {}
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }
      }
      /**
       * 把图形按主子类型分层组织成索引对象
       * @method
       */

    }, {
      key: 'buildIndex',
      value: function buildIndex()
      {
        var rets = {}
        var ms = this.mappara
        var m = void 0,
          Major = void 0,
          Minor = void 0
        for (var i in ms)
        {
          m = ms[i]
          Major = rets[m.major]
          if (!Major) Major = rets[m.major] = {}
          Minor = Major[m.minor]
          if (!Minor) Minor = Major[m.minor] = {}
          Minor[m.map] = m
        }
        this.index = rets
      }
      /**
       * 获取全部图形数据
       * @method
       * @returns {Object} 图形参数对象
       */

    }, {
      key: 'getAll',
      value: function getAll()
      {
        return this.mappara
      }
      /**
       * 根据主类型、子类型、图形索引取图形参数,没有返回null
       * @method
       * @param {Number} major 主类型
       * @param {Number} minor 子类型
       * @param {Number} map 图形号
       * @returns {Object} 图形参数对象
       */

    }, {
      key: 'byMap',
      value: function byMap(major, minor, map)
      {
        var Major = void 0,
          Minor = void 0
        Major = this.index[major]
        if (!Major) return null
        Minor = Major[minor]
        if (!Minor) return null
        return Minor[map]
      }
      /**
       * 根据主类型、子类型、图形索引取图形参数,没有返回null
       * @method
       * @param {Number} major 主类型
       * @param {Number} minor 子类型
       * @param {Object} [att] 属性取图形参数对象
       * @returns {Object} 图形参数对象
       */

    }, {
      key: 'byAtt',
      value: function byAtt(major, minor, att)
      {
        var item = void 0
        var is = void 0
        var Major = void 0,
          Minor = void 0
        Major = this.index[major]
        if (!Major) return null
        Minor = Major[minor]
        if (!Minor) return null
        for (var i in Minor)
        {
          item = Minor[i]
          is = true
          if (Base.isObj(att) && Base.isObj(item.exp))
          {
            for (var j in item.exp)
            
              if (att[j] != item.exp[j]) is = false
          }
          if (is) return item
        }
        return null
      }
    }])
    return Mapara
  }())

  /**
   * cx.geo.IViewport
   * 接口类：业务逻辑图层管理、逻辑图层开关数据控制
   *
   * @class
   * @memberof    cx.geo
   * @author      zhang qing
   * @since       2018-07-02
   */

  var IViewport = (function()
  {
    /**
     * @constructs
     */
    function IViewport()
    {
      classCallCheck(this, IViewport)

      /**
       * @private
       * @property {Array.<Object>}  _dataSrc        来自viewport表的原始数据
       */
      this._dataSrc = null

      /**
       * @private
       * @property {Object}          _confView       处理后的数据对象，包含zoom、center、extent、resolutions对象
       */
      this._confView = {}

      /**
       * @private
       * @property {Object}          _confViewDiagram 处理后的数据对象，包含scales、resolutions对象
       */
      this._confViewDiagram = {}
    }

    /**
     * 获取地图视图数据数据，包含zoom、center、extent、resolutions等对象
     * @method
     * @returns   {Object}                   地图视图数据数据
     */


    createClass(IViewport, [{
      key: 'getData',
      value: function getData()
      {
        return this._confView
      }
      /**
       * 获取图纸地图视图数据数据，包含scales、resolutions对象
       * @method
       * @returns   {Object}                   地图视图数据数据
       */

    }, {
      key: 'getDiagramData',
      value: function getDiagramData()
      {
        return this._confViewDiagram
      }
      /**
       * 设置原始数据
       * @method
       * @param   {Array.<Object>}    data               地图视图数据数据
       */

    }, {
      key: 'setData',
      value: function setData(data)
      {
        this._dataSrc = data

        //数据预处理
        this.prepData()
      }

      /**
       * 数据预处理
       * @protected
       * @method
       */

    }, {
      key: 'prepData',
      value: function prepData()
      {
        var data = this._dataSrc[0]

        //地图相关参数
        this._confView = {
          zoom: data.zoom,
          zooms: data.zooms,
          zoome: data.zoome,
          center: data.center,
          extent: data.extent,
          initextent: data.initextent,
          resolutions: data.resolution

          //图纸相关参数
        }; Base.extend(this._confViewDiagram, data.mapview)
        this._confViewDiagram.resolutions = []
        for (var scale in data.mapview.scales)
        
          this._confViewDiagram.resolutions.push(data.mapview.scales[scale])
      }
    }])
    return IViewport
  }())

  /**
   * $g.plugin
   * 类-插件管理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Plugins = (function()
  {
    /**
     * @constructor
     * @param   {Object}    data                数据
     */
    function Plugins()
    {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []
      classCallCheck(this, Plugins)

      this.list = data
      this.conntainers = {}
      this.init()
    }

    /**
     * 销毁对象
     * @method
     */


    createClass(Plugins, [{
      key: 'destroy',
      value: function destroy()
      {
        this.conntains = null
      }

      /**
       * 初始化
       * @method
       * @returns {Object}                    this
       */

    }, {
      key: 'init',
      value: function init()
      {
        var iconSize = [16, 24, 32]
        var att = void 0,
          pos = void 0,
          j = void 0
        var cssStr = ''
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var item = _step.value

            //container ID
            att = item.container
            if (att)
            
              if (!this.conntainers[att]) this.conntainers[att] = true
            
            //解析初始化参数
            att = item.initpara
            if (!att) item.initpara = null
            //初始化图标
            item.iconClass = null
            att = item.icon
            if (!att) // 没有设置图标，则用默认的图标
              item.iconClass = 'plugin'; else
            {
              pos = att.indexOf('.')
              if (pos === 0) // 类名 .iconAbcd
                item.iconClass = att.substring(1); else if (pos < 0) // Abc ,拼装成CSS类
              {
                item.iconClass = att
                for (j = 0; j < iconSize.length; j++)
                
                  cssStr = cssStr + '.icon-' + item.iconClass + iconSize[j] + '{background-image:url(' + item.dir + att + iconSize[j] + '.png)} '
              }
            }
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        if (cssStr) Dom.createCss(cssStr)
        return this
      }

      /**
       * 根据名称取对应的插件信息
       * @method
       * @param   {String}    name                名称
       * @returns {Object}
       */

    }, {
      key: 'byName',
      value: function byName(name)
      {
        var items = Array$1.gets(this.list, { name: name })

        //排序,优先返回系统号匹配的
        Util.sortNum(items, 'sys')
        if (items.length > 0) return items[items.length - 1]

        return null
      }

      /**
       * 根据路径和文件名取完整的路径(文件名里面:1.如果没有目录存在则跟dir拼完整路径，2.如果有目录存在则使用自身路径))
       * @method
       * @param   {String}    dir                 插件目录
       * @param   {String}    filename            文件名
       * @returns {String}
       */

    }, {
      key: 'getPath',
      value: function getPath(dir, filename)
      {
        if (!filename) return filename
        if (filename.indexOf('/') >= 0) return filename
        return dir + filename
      }

      /**
       * 取图标的CSS类名
       * @method
       * @param   {String}    dir                 插件目录[必须有值]
       * @param   {String}    iconName            图标名字(支持:1.类名-.iconAbcd 2. 文件名-Abcd.png 3.没有后缀的名称-Abcd
       * @param   {Number}    iconSize            图标大小
       * @returns {String}
       */

    }, {
      key: 'getIconCls',
      value: function getIconCls(dir, iconName, iconSize)
      {
        //如果是图标CSS类		(.iconAbcd)	，直接返回
        //如果是文件名			(abcd.png)	，则直接生成图标
        //如果是没有后缀的文件名(abcd)		，则根据图标的尺寸自动拼接文件名，然后创建CSS类
        if (!iconName) return ''
        var iconClass = void 0
        var pos = iconName.indexOf('.')
        if (pos === 0) // 类名 .iconAbcd
        {
          // icon-Abcd32 icon-32
          iconClass = 'icon-' + iconName.substring(1) + iconSize // + ' ' + 'icon-' + iconSize;
          return iconClass
        }
        else if (pos > 0) // 文件名 Abcd.png
        {
          iconClass = 'icon-' + iconName.substring(0, pos)
          //.icon-Abcd32{background-image:url(plugin/Abcd/Abcd.png)}
          Dom.createCss('.' + iconClass + '{background-image:url(' + dir + iconName + ')}')
          return iconClass
        }
        else //没有后缀的名称(Abcd)
        {
          //iconAbcd32
          iconClass = 'icon-' + iconName + iconSize
          //.iconAbcd{background-image:url(plugin/Abcd/Abcd32.png)}
          Dom.createCss('.' + iconClass + '{background-image:url(' + dir + iconName + iconSize + '.png)}')
          //iconAbcd32 icon-32
          return iconClass // + ' ' + 'icon-' + iconSize;
        }
      }

      /**
       * 判断ID是否是插件容器的ID
       * @method
       * @param   {String}    id                  ID
       * @returns {Boolean}
       */

    }, {
      key: 'isContainerID',
      value: function isContainerID(id)
      {
        return !!this.conntainers[id]
      }
    }])
    return Plugins
  }())

  /**
   * cx.ProcAssign
   * 流程指派
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var ProcAssign = (function()
  {
    /**
     * @constructor
     * @param   {Array}     data                procassi表数据数组
     */
    function ProcAssign(data)
    {
      classCallCheck(this, ProcAssign)

      this.list = []
      if (Base.isArr(data))
      {
        var item = void 0
        var obj = void 0,
          key = void 0,
          arr = void 0
        var j = void 0,
          k = void 0,
          kl = void 0
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            item = _step.value

            obj = {
              name: item.name,
              fld1: item.fld1,
              fld2: item.fld2,
              fld3: item.fld3,
              sel: item.sel,
              val1: null,
              val2: null,
              val3: null,
              params: []
              //把N个val变成数组
            }; for (j = 1; j <= 3; j++)
            {
              key = 'val' + j
              obj[key] = item[key].split(';')
            }
            //params
            if (item.params)
            {
              arr = item.params.split(',')
              for (k = 0, kl = arr.length; k < kl; k++)
              
                obj.params.push(arr[k])
            }
            this.list.push(obj)
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }
      }
    }

    /**
     * 初始化
     * @method
     * @returns {Object}                        this
     */


    createClass(ProcAssign, [{
      key: 'init',
      value: function init()
      {
        return this
      }

      /**
       * 根据字段名，配置的字段值，传递进来的键值对对象判断是否匹配
       * @method
       * @param   {String}    fldname             字段名
       * @param   {Array}     vals                配置的字段值
       * @param   {Object}    att                 传递进来的属性对象
       * @returns {Boolean}                       是否匹配(true/匹配，false/不匹配)
       */

    }, {
      key: 'match',
      value: function match(fldname, vals, att)
      {
        if (fldname && vals)
        {
          if (att[fldname])
          {
            for (var i = 0; i < vals.length; i++)
            
              if (vals[i] === att[fldname]) return true
          }
          return false
        }
        return true
      }

      /**
       * 生成参数
       * @method
       * @param   {Array}     params              配置的参数数组
       * @param   {Object}    att                 传递进来的属性对象
       * @returns {Array}                         返回参数数组
       */

    }, {
      key: 'makeParams',
      value: function makeParams(params, att)
      {
        var ret = []
        var matches = void 0
        for (var i = 0; i < params.length; i++)
        {
          if (RegEx.refId.test(params[i]))
          {
            matches = params[i].match(RegEx.refId)
            ret.push(att[matches[1]])
          }
          else ret.push(params[i])
        }
        return ret
      }

      /**
       * 根据名字，属性取配置
       * @method
       * @param   {String}    name                名字
       * @param   {Object}    att                 属性配置
       * @returns {Object}
       */

    }, {
      key: 'get',
      value: function get(name, att)
      {
        for (var i = 0; i < this.list.length; i++)
        {
          var item = this.list[i]
          if (item.name !== name) continue
          if (item.fld1 && !this.match(item.fld1, item.val1, att)) continue
          if (item.fld2 && !this.match(item.fld2, item.val2, att)) continue
          if (item.fld3 && !this.match(item.fld3, item.val3, att)) continue
          return {
            sel: item.sel,
            params: this.makeParams(item.params, att)
          }
        }
      }
    }])
    return ProcAssign
  }())

  /**
   * cx.resizes
   * 类-窗口大小发生变化处理对象
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-06-02
   */
  var Resizes = (function()
  {
    function Resizes()
    {
      classCallCheck(this, Resizes)
    }

    createClass(Resizes, null, [{
      key: 'destroy',

      /**
       * 销毁对象
       * @static
       * @method
       */
      value: function destroy()
      {
        delete this.list
      }

      /**
       * 增加需要处理的对象
       * @static
       * @method
       * @param   {Object}    obj                     对象
       * @param   {Function}  obj.onResize            回调函数-窗口发生变化-function()
       */

    }, {
      key: 'add',
      value: function add(obj)
      {
        if (obj) this.list.push(obj)
      }

      /**
       * 移除对象
       * @static
       * @method
       * @param   {Object}    obj                     对象
       */

    }, {
      key: 'remove',
      value: function remove(obj)
      {
        var items = this.list
        for (var i = items.length - 1; i >= 0; i--)
        
          if (items[i] === obj) items.splice(i, 1)
      }

      /**
       * 窗口发生变化之后处理函数
       * @static
       * @method
       */

    }, {
      key: 'resize',
      value: function resize()
      {
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var obj = _step.value

            if (obj.onResize) obj.onResize()
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }
      }
    }])
    return Resizes
  }())

  Resizes.list = []

  /**
   * cx.Stack
   * 类-栈
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */
  var Stack = (function()
  {
    /**
     * @constructor
     * @param   {Object}    options
     * @param   {Boolean}   [options.maxSize = 0]   栈大小，如果<1,则不限制栈大小
     */
    function Stack(options)
    {
      classCallCheck(this, Stack)

      this.maxSize = 0
      this.stack = []
      options = options || {}
      if (options.maxSize) this.maxSize = options.maxSize
    }

    /**
     * 销毁对象
     * @method
     */


    createClass(Stack, [{
      key: 'destroy',
      value: function destroy()
      {
        this.stack = null
      }

      /**
       * 清空栈
       * @method
       * @returns {Object}                    this
       */

    }, {
      key: 'clear',
      value: function clear()
      {
        this.stack = []
        return this
      }

      /**
       * 压栈
       * @method
       * @param   {Object}    obj             待压栈的对象
       * @returns {Object}                    this
       */

    }, {
      key: 'push',
      value: function push(obj)
      {
        //如果超过数量则删除
        if (this.maxSize > 0)
        
          if (this.stack.length >= this.maxSize) this.stack.splice(0, 1)
        
        this.stack.push(obj)
        return this
      }

      /**
       * 弹栈-将栈顶元素弹出
       * @method
       * @returns {Object}
       */

    }, {
      key: 'pop',
      value: function pop()
      {
        if (this.stack.length > 0)
        {
          var obj = this.stack[this.stack.length - 1]
          this.stack.splice(this.stack.length - 1, 1)
          return obj
        }
        return null
      }

      /**
       * 取栈顶元素(不弹栈)
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getTop',
      value: function getTop()
      {
        if (this.stack.length > 0) return this.stack[this.stack.length - 1]
        return null
      }

      /**
       * 取栈中全部元素(不弹栈)
       * @method
       * @returns {Array.<Object>}
       */

    }, {
      key: 'getAll',
      value: function getAll()
      {
        return this.stack
      }

      /**
       * 取栈中元素个数
       * @method
       * @returns {Number}
       */

    }, {
      key: 'size',
      value: function size()
      {
        return this.stack.length
      }
    }])
    return Stack
  }())

  /**
   * cx.undo.Manager
   * 回退管理
   *
   * @class
   * @memberof    cx.undo
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Manager = (function()
  {
    /**
     * @constructor
     * @param   {Object}    [options = {}]
     * @param   {Number}    [options.maxSize]   回退记录数的最大值
     */
    function Manager()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, Manager)

      /** * @property {Number} id             * 加入的step对象的id计数器 */
      this.id = 1
      /*** @property {cx.Stack} steps         * step对象堆栈管理对象 */
      this.steps = new Stack(options)
      this.init()
    }

    /**
     * 初始化
     * @method
     */


    createClass(Manager, [{
      key: 'init',
      value: function init()
      {}

      /**
       * 析构函数
       * @method
       */

    }, {
      key: 'destroy',
      value: function destroy()
      {
        Events.unlisten(this)
        this.steps = null
      }

      /**
       * 获取可管理的回退数
       * @method
       * @returns {Number}                回退步数最大值
       */

    }, {
      key: 'size',
      value: function size()
      {
        return this.steps.size()
      }

      /**
       * 添加一个回退步骤
       * @method
       * @param   {undo.Step} step        在管理对象中添加一个回退步骤对象
       */

    }, {
      key: 'push',
      value: function push(step)
      {
        // 因为打包依赖没解决，使用的是plugCx中的Step类，所以这里先不用实例类型判断
        // if (step && step instanceof Step)
        if (step)
        {
          step.setStepId(this.id++)
          this.steps.push(step)
          Events.publish('UndoAdd', step)
        }
      }

      /**
       * 弹出一个回退步骤
       * @method
       */

    }, {
      key: 'pop',
      value: function pop()
      {
        this.steps.pop()
      }

      /**
       * 执行一步回退操作
       * @method
       */

    }, {
      key: 'undo',
      value: function undo()
      {
        var step = this.steps.pop()
        if (step)
        {
          Events.publish('UndoDel', step)
          step.undo()
          step = null
        }
      }

      /**
       * 根据id获取一个回退步骤对象
       * @method
       * @param   {Number}    stepId      回退步骤的id
       * @returns {undo.Step | null}      回退步骤对象
       */

    }, {
      key: 'get',
      value: function get(stepId)
      {
        var steps = this.getAll(),
          step = void 0

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = steps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            step = _step.value

            if (step.stepId === stepId) return step
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return null
      }

      /**
       * 获取管理对象中最后添加进的回退步骤对象
       * @method
       * @returns {cx.undo.Step | null}   回退步骤对象
       */

    }, {
      key: 'getTop',
      value: function getTop()
      {
        return this.steps.getTop()
      }

      /**
       * 获取管理对象中全部回退步骤对象
       * @method
       * @returns {Array.<undo.Step>}     回退步骤对象序列
       */

    }, {
      key: 'getAll',
      value: function getAll()
      {
        return this.steps.getAll()
      }
    }])
    return Manager
  }())

  /**
   * cx.InitRunenv
   * 类-初始化
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-28
   */

  /**
   * 修改记录:
   * 2020-11-26 张发勇    增加回调函数
   */

  var InitRunenv = (function()
  {
    function InitRunenv()
    {
      classCallCheck(this, InitRunenv)
    }

    createClass(InitRunenv, [{
      key: 'init',

      /**
       * 初始化运行环境
       * @method
       * @param   {Object}            options
       * @param   {String}            options.initSvr                                      InitSvr URL, 如 'svr/InitSvr'
       * @param   {Object}            [options.initSvrOpts={_userId:, _sys:, _userNo: }]   InitSvr的参数，需要传入用户id、用户编号、系统号
       * @param   {Boolean}           [options.urlCrypt = false]                           URL是否加密传输
       * @param   {cx.IAccess}        [options.access]                                     权限处理对象
       * @param   {cx.geo.ILayer}     [options.layer]                                      layer表功能对象
       * @param   {cx.geo.IMapara}    [options.mapara]                                     mapara表功能对象
       * @param   {cx.geo.IViewport}  [options.viewport]                                   viewport表功能对象
       * @param   {Number}            [options.runType = consts.RUN_VUE]                   运行环境
       * @param   {Number}            [options.disp = consts.DISPC]                        语言显示类型
       * @param   {Boolean}           [options.initMsg = false]                            是否开启消息服务器
       * @param   {Boolean}           [options.initUndo = false]                           是否开启Undo
       * @param   {String}            [options.attClass]                                   属性类对照表
       * @param   {String}            [options.appDbName]                                  前端缓存数据库名
       * @param   {Function}          [options.onLoad]                                     回调函数-成功之后的回调函数 - onLoad()
       * @returns {Promise}
       */
      value: function init(options)
      {
        window.$g = Global
        Global.loc = Base.defVal(options.disp, Consts.DISPC)
        Http.setUrlCrypt(Base.defVal(options.urlCrypt, false))

        //窗口大小变化
        var onResize = function onResize()
        {
          Resizes.resize()
          Events.publish('onResize')
        }
        window.addEventListener('resize', onResize, false)

        return Http.post(options.initSvr, Base.extend({ cmd: 'get' }, options.initSvrOpts)).then(function(ret)
        {
          return InitRunenv.init$g(ret[0], options).then(function(ret1)
          {
            return ret
          })
        })
      }

      /**
       * 根据数据构造$g对象
       * @static
       * @method
       * @param   {Object}            ret                                 调用initsvr返回的初始化数据对象
       * @param   {Object}            options
       * @param   {String}            options.initSvr                     InitSvr URL, 如 'svr/InitSvr'
       * @param   {Boolean}           [options.urlCrypt = false]          URL是否加密传输
       * @param   {cx.IAccess}        [options.access]                    权限处理对象
       * @param   {cx.geo.ILayer}     [options.layer]                     layer表功能对象
       * @param   {cx.geo.IMapara}    [options.mapara]                    mapara表功能对象
       * @param   {cx.geo.IViewport}  [options.viewport]                  viewport表功能对象
       * @param   {Number}            [options.runType = consts.RUN_VUE]  运行环境
       * @param   {Number}            [options.disp = consts.DISPC]       语言显示类型
       * @param   {Boolean}           [options.initMsg = false]           是否开启消息服务器
       * @param   {Boolean}           [options.initUndo = false]          是否开启Undo
       * @param   {String}            [options.attClass]                  属性类对照表
       * @param   {String}            [options.appDbName]                 前端缓存数据库名
       * @param   {Function}          [options.onLoad]                    回调函数-成功之后的回调函数 - onLoad()
       * @returns {Promise}
       */

    }], [{
      key: 'init$g',
      value: async function init$g(ret, options)
      {
        var data = ret
        var items = void 0,
          item = void 0
        var i = void 0

        Http.setUrlCrypt(Base.defVal(options.urlCrypt, false))

        window.$g = Global
        Global.loc = Base.defVal(options.disp, Consts.DISPC)
        Global.runType = Base.defVal(options.runType, Consts.RUN_VUE)
        Global.attFactory = new AttFactory({ attClass: options.attClass })

        //新服务返回数据进行解析
        if (data.entity && data.entity.cols && data.entity.types) this.parseCache(data)

        Global.init = data

        //初始化系统配置对象
        Global.syscfg = {}
        items = data.syscfg
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            item = _step.value

            if (item.keyno === 'urlCrypt') continue
            Global.syscfg[item.keyno] = item.value
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        Global.myIndexDb = new MyIndexDb({ dbName: (Global.syscfg.sysName || '') + (options.appDbName || '') })
        await Global.myIndexDb.createDb()

        //数据库类型
        Global.syscfg['dbType'] = data.dbType

        //改为代码的config中配置；数据库配置系统名，刷新的时候取不到系统名
        if (Global.syscfg.sysName) cx.localCache.setPrefix(Global.syscfg.sysName)

        if (cx.constApp && cx.constApp.SYS_NAME) cx.localCache.setPrefix(cx.constApp.SYS_NAME)

        //用户
        Global.user = data.user
        Global.loginTime = Datetime.parse(data.user.time) //用户登录时间

        //定时联系服务器，并取得当前的时间，用于系统验证时间要求
        setInterval(function()
        {
          Http.post(options.initSvr, { cmd: 'check' }).then(function(ret)
          {
            if (ret.time)
            {
              var newDate = Datetime.parse(ret.time)

              if (newDate)
              {
                if (!DateCx.equals(newDate, Global.loginTime)) Events.publish('dateChange', newDate) //广播消息，通知当前时间已经改变
                Global.loginTime = newDate
              }
            }
          })
        }, 1800000) //30 分钟定时联系服务器并取时间

        //服务网址映射替换
        items = data.urlmap
        if (items)
        {
          var _iteratorNormalCompletion2 = true
          var _didIteratorError2 = false
          var _iteratorError2 = undefined

          try
          {
            for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
            {
              item = _step2.value

              Service.add(item.name, item.url)
            }
          }
          catch (err)
          {
            _didIteratorError2 = true
            _iteratorError2 = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion2 && _iterator2.return)
              
                _iterator2.return()
            }
            finally
            {
              if (_didIteratorError2)
              
                throw _iteratorError2
            }
          }
        }

        //替换服务里面的url
        items = data.service
        if (items)
        {
          var _iteratorNormalCompletion3 = true
          var _didIteratorError3 = false
          var _iteratorError3 = undefined

          try
          {
            for (var _iterator3 = items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)
            {
              item = _step3.value

              item.url = Service.url(item.url)
            }
          }
          catch (err)
          {
            _didIteratorError3 = true
            _iteratorError3 = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion3 && _iterator3.return)
              
                _iterator3.return()
            }
            finally
            {
              if (_didIteratorError3)
              
                throw _iteratorError3
            }
          }
        }
        Global.entity = new Entities(data.entity)
        Global.field = new Fields({ fld: data.fld, fldvalue: data.fldvalue })
        Global.plugin = new Plugins(data.plugin)
        Global.func = new Funcs({ group: data.funcgrp, func: data.func })

        //权限
        Global.access = options.access || new IAccess()
        Global.access.setData(data.access)

        //layer、mapara和viewport
        if (data.layer)
        {
          Global.layer = options.layer || new ILayer()
          Global.layer.setData(data.layer)
        }
        if (data.mapara)
        {
          Global.mapara = options.mapara || new Mapara()
          Global.mapara.setData(data.mapara)
        }
        if (data.viewport && data.viewport.length > 0)
        {
          Global.viewport = options.viewport || new IViewport()
          Global.viewport.setData(data.viewport)
        }

        //流程指派
        if (data.procassi)
        {
          Global.prosAssi = new ProcAssign(data.procassi)
          delete data.procassi
        }

        //MsgSvr
        if (options.initMsg)
        {
          item = Array$1.get1(data.urlmap, { name: 'MsgSvr' })
          if (item)
          {
            Global.message = new IMessage()
            Global.message.connect(item.url, Global.user.no)
          }
        }

        //撤销
        if (options.initUndo)
        {
          var undoMax = 0
          if (Global.syscfg.undoMax) undoMax = parseInt(Global.syscfg.undoMax)
          Global.undo = new Manager({ maxSize: undoMax })
        }

        //自动运行插件
        InitRunenv.autoRun()

        //删除没有权限的菜单组
        items = Array$1.gets(data.funcgrp, { target: 'qxtree' })
        if (items)
        {
          var funcs = void 0,
            j = void 0

          for (i = items.length - 1; i >= 0; i--)
          {
            if (!Global.access.isViewMenu(items[i]))
            {
              items.splice(i, 1)
              continue
            }

            //删除菜单
            funcs = Array$1.gets(data.func, { grp: items[i].name })
            for (j = funcs.length - 1; j >= 0; j--)
            {
              if (!Global.access.isViewMenu(funcs[i]))
              {
                //删除插件
                Array$1.remove(Global.init.plugin, { name: funcs[i].plugin })
                //删除功能
                funcs.splice(i, 1)
              }
            }
          }
        }

        //回调函数
        if (options.onLoad) options.onLoad()
        //删除多余数据
        // delete $g.syscfg.undoMax
        // delete data.dbType
        // delete data.urlmap
        // delete data.syscfg                //$g.syscfg 替代
      }

      /**
       * 自动运行插件
       * @static
       * @method
       */

    }, {
      key: 'autoRun',
      value: function autoRun()
      {
        var plugs = Array$1.gets(Global.plugin.list, { autorun: 1 })

        var exePlug = function exePlug(plug)
        {
          if (Global.access.isSuperAdmin(Global.init.user) || Global.access.canUseFunc(plug.name))
          {
            //有运行权限
            if (plug.prereq)
            {
              //检查插件是否在运行，如果没有运行，则延迟运行插件
              var runs = Runnings.find({ name: plug.prereq })
              if (runs.length > 0)
              {
                setTimeout(function()
                {
                  Run.runPlug(plug.name, {})
                }, 100)
              }
              else
              {
                Base.log(plug.name + ' is waiting ' + plug.prereq)
                setTimeout(function()
                {
                  exePlug(plug)
                }, 100)
              }
            }
            else Run.runPlug(plug.name, {})
          }
        }

        //执行全部插件
        var _iteratorNormalCompletion4 = true
        var _didIteratorError4 = false
        var _iteratorError4 = undefined

        try
        {
          for (var _iterator4 = plugs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true)
          {
            var plug = _step4.value

            exePlug(plug)
          }
        }
        catch (err)
        {
          _didIteratorError4 = true
          _iteratorError4 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion4 && _iterator4.return)
            
              _iterator4.return()
          }
          finally
          {
            if (_didIteratorError4)
            
              throw _iteratorError4
          }
        }
      }
    }, {
      key: 'parseCache',
      value: function parseCache(data)
      {
        var key = void 0,
          obj = void 0,
          datas = void 0,
          data2 = void 0,
          type2 = void 0,
          cols2 = void 0,
          obj2 = void 0,
          jsonTem = void 0
        var arrtype = void 0,
          arrcol = void 0,
          arrdata = void 0,
          value = void 0
        var i = void 0,
          il = void 0,
          j = void 0,
          jl = void 0

        for (key in data)
        {
          obj = data[key]
          data2 = obj.data
          type2 = obj.types
          cols2 = obj.cols
          if (data2 && type2 && cols2)
          {
            datas = []
            arrtype = type2.split(',')
            arrcol = cols2.split(',')
            jl = arrtype.length

            for (i = 0, il = data2.length; i < il; i++)
            {
              arrdata = data2[i].split(';')
              obj2 = {}
              for (j = 0; j < jl; j++)
              {
                value = arrdata[j]
                switch (arrtype[j])
                {
                case 'i':
                  obj2[arrcol[j]] = value === '' ? 0 : parseInt(value)
                  break
                case 'r':
                  obj2[arrcol[j]] = value === '' ? 0 : parseFloat(value)
                  break
                case 's':
                  try
                  {
                    jsonTem = JSON.parse(value)
                    if ((typeof jsonTem === 'undefined' ? 'undefined' : _typeof(jsonTem)) == 'object' && jsonTem) obj2[arrcol[j]] = jsonTem; else obj2[arrcol[j]] = value
                  }
                  catch (e)
                  {
                    obj2[arrcol[j]] = value
                  }
                  break
                default:
                  obj2[arrcol[j]] = value
                  break
                }
              }
              datas.push(obj2)
            }
            data[key] = datas
          }
        }
      }
    }])
    return InitRunenv
  }())

  /**
   * cx.ProcBase
   * 类-流程处理基类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var ProcBase = (function()
  {
    function ProcBase()
    {
      classCallCheck(this, ProcBase)
    }

    createClass(ProcBase, [{
      key: 'destroy',

      /**
       * 销毁对象
       * @method
       */
      value: function destroy()
      {
        delete this.entity
        delete this.proc
      }

      /**
       * 初始化对象
       * @method
       * @param   {Object}    proc            流程信息
       * @returns {Object}                    this
       */

    }, {
      key: 'init',
      value: function init(proc)
      {
        this.proc = proc //流程信息
        this.entity = Global.entity.byTabAtt(proc.tabname) //实体信息
        return this
      }

      /**
       * 取发起流程对应的流程Key
       * @method
       * @returns {String}
       */

    }, {
      key: 'getProcKey',
      value: function getProcKey()
      {
        return this.proc.prockey
      }

      /**
       * 取流程信息
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getProc',
      value: function getProc()
      {
        return this.proc
      }

      /**
       * 取实体信息
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getEntity',
      value: function getEntity()
      {
        return this.entity
      }

      /**
       * 取流程启动插件
       * @method
       * @returns {String}
       */

    }, {
      key: 'getStartPlug',
      value: function getStartPlug()
      {
        return 'ProcStart'
      }

      /**
       * 取流程参数
       * @abstract
       * @method
       * @param   {Object}    variables           流程变量
       * @param   {Object}    att                 属性(当前需要发起流程的属性)
       * @returns {Object}                        this
       */

    }, {
      key: 'getProcVariables',
      value: function getProcVariables(variables, att)
      {
        return this
      }

      /**
       * 取选择办理人的条件
       * @abstract
       * @method
       * @param   {Object}    exp                 流程变量
       * @param   {Object}    att                 属性(当前需要发起流程的属性)
       * @returns {Object}                        this
       */

    }, {
      key: 'getSelAssignee',
      value: function getSelAssignee(exp, att)
      {
        return this
      }
    }])
    return ProcBase
  }())

  /**
   * cx.Services
   * 类-Services
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Services = (function()
  {
    /**
     * @constructor
     * @param   {Array}     data                数据
     */
    function Services()
    {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []
      classCallCheck(this, Services)

      this.list = data
      this.init()
    }

    /**
     * 初始化
     * @method
     * @returns {Object}                    this
     */


    createClass(Services, [{
      key: 'init',
      value: function init()
      {
        var att = void 0
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var item = _step.value

            //initpara
            att = item.initpara
            if (att)
            
              if (!att) item.initpara = null
            
            item.exp = ''
            item.exe = null
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return this
      }

      /**
       * 根据名称取实体信息
       * @method
       * @param   {String}    name                名称
       * @returns {Object}
       */

    }, {
      key: 'byName',
      value: function byName(name)
      {
        return Array$1.get1(this.list, { name: name })
      }
    }])
    return Services
  }())

  /**
   * cx.sqlexp
   * 数据库条件表达式
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-23
   */

  var SqlExp = (function()
  {
    function SqlExp()
    {
      classCallCheck(this, SqlExp)
    }

    createClass(SqlExp, null, [{
      key: 'getType',

      /**
       * 根据字段及值取SQL表达式的值类型
       * @static
       * @method
       * @param   {Object}    fld               字段信息
       * @param   {String}    value             值
       * @returns {String}
       */
      value: function getType(fld, value)
      {
        var type = 's'
        var dispType = void 0

        dispType = fld.type !== undefined ? fld.type : fld.disptype //兼容数据库fld 和 UI里面的fld
        if (fld.isnum)
        {
          if (typeof value === 'number') //数值型转换为字符串
            value = '' + value
          if (value.indexOf('.') < 0) //整数
            type = 'i'; else type = 'r' //实数
        }
        else
        {
          switch (dispType)
          {
          case Consts.DISP_DATE:
            type = 'd' //日期型
            break
          case Consts.DISP_TIMESTAMP:
            type = 't' //邮戳类型
            break
          default:
            type = 's' //字符串
            break
          }
        }
        return type
      }

      /**
       * 取默认的条件表达式
       * @static
       * @method
       * @param   {Object}    [unionQuery]      联合查询参数
       * @returns {Object}
       */

    }, {
      key: 'getDefExp',
      value: function getDefExp(unionQuery)
      {
        var ret = {
          _exp: '',
          types: [],
          vals: [],
          cols: [],
          orderby: ''
        }

        if (unionQuery)
        {
          ret.tables = ''
          ret.cols = ''
        }
        return ret
      }

      /**
       * 根据一个字段、值、SQL操作符取SQL条件表达式信息
       * @static
       * @method
       * @param   {Object}    fld                         字段信息
       * @param   {String}    value                       值
       * @param   {String}    [operator = '=']            操作符
       * @param   {Object}    [unionQuery]                联合查询参数
       * @param   {String}    [unionQuery.mainAlias]      联合查询主表的别名，与tables中的别名一致
       * @returns {Object}                      条件表达式
       */

    }, {
      key: 'getExp',
      value: function getExp(fld, value, operator, unionQuery)
      {
        var exp = '',
          types = [],
          vals = []

        if (value !== undefined && value !== null && value !== '')
        {
          var dispType = fld.type !== undefined ? fld.type : fld.disptype //兼容数据库fld 和 UI里面的fld
          var type = 's'

          if (!operator) operator = '='

          //类型
          if (fld.isnum)
          {
            if (('' + value).indexOf('.') < 0) type = 'i' //整数
            else type = 'r' //实数
          }
          else
          {
            switch (dispType)
            {
            case Consts.DISP_DATE:
              type = 'd' //日期型
              break
            case Consts.DISP_TIMESTAMP:
              type = 't' //邮戳类型
              break
            default:
              type = 's' //字符串
              break
            }
          }

          //拼装
          if (type === 's' && operator === '=')
          {
            //=
            exp = (unionQuery ? unionQuery.mainAlias + '.' : '') + fld.colname + '=?' //AAA=?
          }
          else if (type === 's' && operator === 'like')
          {
            value = '%' + value + '%'
            exp = (unionQuery ? unionQuery.mainAlias + '.' : '') + fld.colname + ' LIKE ?' //AAA LIKE ?
          }
          else if (operator === 'in') exp = (unionQuery ? unionQuery.mainAlias + '.' : '') + fld.colname + ' ' + operator + ' (?)' //a.AAA IN ()
          else exp = (unionQuery ? unionQuery.mainAlias + '.' : '') + fld.colname + operator + '?' //a.AAA oper ?

          types.push(type)
          vals.push(value)
        }

        //返回数据
        return { _exp: exp, types: types, vals: vals }
      }

      /**
       * 根据一个字段取SQL条件表达式
       * @static
       * @method
       * @param   {Object}    result                      返回结果
       * @param   {Object}    fld                         字段信息
       * @param   {Object}    [unionQuery]                联合查询参数
       * @param   {String}    [unionQuery.mainAlias]      联合查询主表的别名
       * @returns {Object}                                条件表达式
       */

    }, {
      key: 'getFldExp',
      value: function getFldExp(result, fld, unionQuery)
      {
        if (fld.mode === 'range')
        {
          if (fld.value1) this.merge(result, this.getExp(fld, fld.value1, '>=', unionQuery))
          if (fld.value2) this.merge(result, this.getExp(fld, fld.value2, '<=', unionQuery))
        }
        else if (fld.mode === 'value')
        {
          var op = '='

          if (fld.value)
          {
            if (!fld.isnum)
            {
              var dispType = fld.type !== undefined ? fld.type : fld.disptype //兼容数据库fld 和 UI里面的fld

              switch (dispType)
              {
              case Consts.DISP_DATE:
              case Consts.DISP_TIMESTAMP:
                break
              default:
                op = 'like'
                break
              }
            }
          }
          this.merge(result, this.getExp(fld, fld.value, op, unionQuery))
        }
      }

      /**
       * 根据一个字段取SQL条件表达式 (More模式)
       * @static
       * @method
       * @param   {Object}    result            返回结果
       * @param   {Object}    fld               字段信息
       * @param   {Object}    [unionQuery]      联合查询参数
       * @param   {String}    [unionQuery.mainAlias]      联合查询主表的别名
       * @returns {Object}                      条件表达式
       */

    }, {
      key: 'getFldExpMore',
      value: function getFldExpMore(result, fld, unionQuery)
      {
        if (fld.mode === 'range')
        {
          if (fld.value1) this.merge(result, this.getExp(fld, fld.value1, '>=', unionQuery))
          if (fld.value2) this.merge(result, this.getExp(fld, fld.value2, '<=', unionQuery))
        }
        else if (fld.mode === 'value')
        {
          var op = '='

          if (fld.value)
          {
            if (!fld.isnum)
            {
              var dispType = fld.type !== undefined ? fld.type : fld.disptype //兼容数据库fld 和 UI里面的fld

              switch (dispType)
              {
              case Consts.DISP_DATE:
              case Consts.DISP_TIMESTAMP:
                break
              default:
                op = 'like'
                break
              }
            }
          }
          this.merge(result, this.getExp(fld, fld.value, op, unionQuery))
        }
      }

      /**
       * 合并多个条件,返回合并后的条件
       * @static
       * @method
       * @param   {Object}    result            返回结果
       * @param   {Object}    argvs             可变参数
       * @param   {String}    argvs._exp        SQL条件表达式(参数用?代替)
       * @param   {Array}     argvs.types       每个参数对应的SQL类型数组(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {Array}     argvs.vals        每个参数对应的值数组
       * @param   {String}    [argvs.orderby]   排序方式(后面的表达式优先)(默认升序, ASC-升序 DESC-降序)
       * @param   {String}    [argvs.tables]    联合查询的表，如 a:1,0;b:99,12
       * @returns {Object}                      result
       */

    }, {
      key: 'merge',
      value: function merge(result)
      {
        for (var _len = arguments.length, argvs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)
        
          argvs[_key - 1] = arguments[_key]
        

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = argvs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var argv = _step.value

            //判断是否undefined or null
            if (!argv || !argv._exp) continue

            //合并tables
            if (argv.tables) result.tables = (result.tables ? result.tables + ';' : '') + argv.tables; else result.tables = argv.tables

            //合并_exp
            result._exp += (result._exp ? ' AND ' : '') + argv._exp

            //合并types
            Array$1.appendArr(result.types, argv.types)

            //合并vals
            Array$1.appendArr(result.vals, argv.vals)

            //合并cols
            Array$1.appendArr(result.cols, argv.cols)

            //orderby后者优先
            if (argv.orderby) result.orderby = argv.orderby
          }

          //去掉无用的
          // if (!result.tables)
          //   delete result.tables

          // if (!result.cols)
          //   delete result.cols

          // if (!result.orderby)
          //   delete result.orderby
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return result
      }

      /**
       * 根据条件表达式对象生成查询对象
       * @static
       * @method
       * @param   {Object}    exp               表达式对象
       * @param   {String}    exp._exp          SQL条件表达式(参数用?代替)
       * @param   {Array}     exp.types         每个参数对应的SQL类型数组(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {Array}     exp.vals          每个参数对应的值数组
       * @param   {String}    [exp.orderby]     排序方式(后面的表达式优先)(默认升序, ASC-升序 DESC-降序)
       * @param   {String}    [exp.tables]      表信息(用于 queryUnion)
       * @param   {String}    [exp.cols]        需要返回的列信息
       * @param   {Number}    major             实体主类型
       * @param   {Number}    minor             实体子类型
       * @param   {Number}    [pageSize]        分页大小(如果>0则分页,否则不分页)
       * @param   {Object}    [unionQuery]      联合查询参数
       * @returns {Object}                      返回用于 Area.query 的查询对象
       */

    }, {
      key: 'queryPara',
      value: function queryPara(exp, major, minor, pageSize, unionQuery)
      {
        var ret = {
          _major: major,
          _minor: minor,
          _exp: exp._exp,
          types: exp.types.toString(),
          separator: ':@:',
          orderby: exp.orderby
        }

        if (exp.cols && exp.cols.length > 0) ret.cols = exp.cols.toString()

        if (unionQuery)
        {
          ret.tables = unionQuery.tables
          ret.cols = unionQuery.cols
        }

        //值
        ret.vals = ''
        var _iteratorNormalCompletion2 = true
        var _didIteratorError2 = false
        var _iteratorError2 = undefined

        try
        {
          for (var _iterator2 = exp.vals[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
          {
            var val = _step2.value

            ret.vals += (ret.vals === '' ? '' : ret.separator) + val
          } //分页
        }
        catch (err)
        {
          _didIteratorError2 = true
          _iteratorError2 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion2 && _iterator2.return)
            
              _iterator2.return()
          }
          finally
          {
            if (_didIteratorError2)
            
              throw _iteratorError2
          }
        }

        if (pageSize !== undefined && pageSize > 0)
        {
          ret.init = 0
          ret.pageno = 1
          ret.pagesize = pageSize
        }

        //删除未设置信息
        if (!ret.orderby) delete ret.orderby

        return ret
      }

      /**
       * 表达式对象转SQL
       * @static
       * @method
       * @param   {Object}    exp               表达式对象
       * @returns {String}                      SQL表达式
       */

    }, {
      key: 'exp2Sql',
      value: function exp2Sql(exp)
      {
        var ret = exp._exp
        var val = void 0,
          i = void 0

        //依次把?修改成值
        for (i = 0; i < exp.types.length; i++)
        {
          switch (exp.types[i])
          {
          case 'i':
          case 'r':
            val = exp.vals[i]
            break
          case 's':
            val = "'" + exp.vals[i] + "'"
            break
          case 'd':
            val = DateCx.toSqlDate(exp.vals[i])
            break
          case 't':
            val = DateCx.toSqlDatetime(exp.vals[i])
            break
          }
          ret = ret.replace('?', val)
        }
        return ret
      }

      /**
       * 默认条件表达式(id>0 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpDef',
      value: function getExpDef()
      {
        return {
          _exp: 'id>?',
          types: ['i'],
          vals: [0],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(id0=? ORDER BY id DESC)
       * @static
       * @method
       * @param   {Number}    id0               ID0
       * @returns {Object}
       */

    }, {
      key: 'getExpGlid',
      value: function getExpGlid(id0)
      {
        return {
          _exp: 'id0=?',
          types: ['i'],
          vals: [id0],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(completed=1 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpCompleted',
      value: function getExpCompleted()
      {
        return {
          _exp: 'completed=?',
          types: ['i'],
          vals: [1],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(completed=0 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpUncompleted',
      value: function getExpUncompleted()
      {
        return {
          _exp: 'completed=?',
          types: ['i'],
          vals: [0],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(userid=myid AND completed=1 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpMyCompleted',
      value: function getExpMyCompleted()
      {
        return {
          _exp: 'userid=? AND completed=?',
          types: ['i', 'i'],
          vals: [$g.user.id, 1],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(effect=1 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpEffect',
      value: function getExpEffect()
      {
        return {
          _exp: 'effect!=?',
          types: ['i'],
          vals: [0],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(userid=myid AND effect=1 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpMyEffect',
      value: function getExpMyEffect()
      {
        return {
          _exp: 'userid=? AND effect=?',
          types: ['i', 'i'],
          vals: [$g.user.id, 1],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(inuse=1 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpInuse',
      value: function getExpInuse()
      {
        return {
          _exp: 'inuse=?',
          types: ['i'],
          vals: [1],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(id0=? AND inuse=1 ORDER BY id DESC)
       * @static
       * @method
       * @param   {Number}    id0               ID0
       * @returns {Object}
       */

    }, {
      key: 'getExpId0Inuse',
      value: function getExpId0Inuse(id0)
      {
        return {
          _exp: 'id0=? AND inuse=?',
          types: ['i', 'i'],
          vals: [id0, 1],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(userid=myid AND inuse=1 ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpMyInuse',
      value: function getExpMyInuse()
      {
        return {
          _exp: 'userid=? AND inuse=?',
          types: ['i', 'i'],
          vals: [$g.user.id, 1],
          orderby: 'id DESC'
        }
      }

      /**
       * 默认条件表达式(id=userid ORDER BY id DESC)
       * @static
       * @method
       * @returns {Object}
       */

    }, {
      key: 'getExpMy',
      value: function getExpMy()
      {
        return {
          _exp: 'userid=?',
          types: ['i'],
          vals: [$g.user.id],
          orderby: 'id DESC'
        }
      }
    }])
    return SqlExp
  }())

  var Theme = (function()
  {
    function Theme()
    {
      classCallCheck(this, Theme)
    }

    createClass(Theme, null, [{
      key: 'register',
      value: function register(obj)
      {
        var add = function add(parent, key, value)
        {
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object')
          {
            var newObj = void 0

            if (parent[key]) newObj = parent[key]; else
            {
              newObj = {}
              parent[key] = newObj
            }
            for (var i in value)
            
              add(newObj, i, value[i])
          }
          else parent[key] = value
        }

        for (var i in obj)
        
          add(this.list, i, obj[i])
      }
    }, {
      key: 'get',
      value: function get(key)
      {
        var obj = this.list
        var strs = key.split('.')

        for (var i = 0; i < strs.length; i++)
        {
          obj = obj[strs[i]]
          if (!obj) return undefined
        }

        return obj
      }
    }])
    return Theme
  }())

  Theme.list = {}

  /**
   * cx.time
   * 类-Time处理
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-04-27
   */

  var Time = (function()
  {
    function Time()
    {
      classCallCheck(this, Time)
    }

    createClass(Time, null, [{
      key: 'parse',

      /**
       * 根据字符串解析时间(格式: 09:00:00 或者 09:00)
       * @static
       * @method
       * @param   {String}    str         时间字符串
       * @returns {Object}
       */
      value: function parse(str)
      {
        if (!RegEx.time.test(str)) return null

        var matches = str.match(RegEx.time)
        var _time = {}

        _time.hour = parseInt(matches[1])
        _time.minute = parseInt(matches[2])

        return _time
      }

      /**
       * 拷贝时间
       * @static
       * @method
       * @param   {Object}    time        时间
       * @returns {Object}                {hour: Numer, minute: Number}
       */

    }, {
      key: 'copy',
      value: function copy(time)
      {
        return { hour: time.hour, minute: time.minute }
      }

      /**
       * 比较两个时间大小, 1=time1 > time2 / 0=time1 == time2 / -1=time1 < time2
       * @static
       * @method
       * @param   {Object}    time1
       * @param   {Object}    time2
       * @returns {Number}
       */

    }, {
      key: 'compare',
      value: function compare(time1, time2)
      {
        if (time1.hour > time2.hour) return 1; else if (time1.hour === time2.hour)
        {
          if (time1.minute > time2.minute) return 1; else if (time1.minute < time2.minute) return -1
          return 0
        }
        else return -1
      }

      /**
       * 判断一个时间点是否在两个时间点之间
       * @static
       * @method
       * @param   {Object}    time            时间点
       * @param   {Object}    stTime          起始时间
       * @param   {Object}    endTime         结束时间
       * @returns {Boolean}                   在范围内返回True,不在范围内返回false
       */

    }, {
      key: 'isIn',
      value: function isIn(time, stTime, endTime)
      {
        var a = time.hour > stTime.hour || time.hour === stTime.hour && time.minute >= stTime.minute
        var b = time.hour < endTime.hour || time.hour === endTime.hour && time.minute <= endTime.minute

        return a && b
      }

      /**
       * 判断是不是同一天
       * @static
       * @method
       * @param   {Date}      timestamp1      邮戳1
       * @param   {Date}      timestamp2      邮戳1
       * @returns {Boolean}                   是一天返回True,不是一天返回false
       */

    }, {
      key: 'isSameDay',
      value: function isSameDay(timestamp1, timestamp2)
      {
        return timestamp1.getYear() === timestamp2.getYear() && timestamp1.getMonth() === timestamp2.getMonth() && timestamp1.getDate() === timestamp2.getDate()
      }

      /**
       * 计算一天内两个时间点之间的分钟数
       * @static
       * @method
       * @param   {Object}    stTime          起始时间
       * @param   {Object}    endTime         结束时间
       * @returns {Number}                    分钟数
       */

    }, {
      key: 'diffMinutes',
      value: function diffMinutes(stTime, endTime)
      {
        var sum = 0
        var i = this.copy(stTime)
        if (i.hour < endTime.hour)
        {
          sum = 60 - i.minute
          i.hour++
          i.minute = 0
        }
        while (i.hour < endTime.hour)
        {
          sum += 60
          i.hour++
        }
        if (i.hour === endTime.hour && i.minute <= endTime.minute) sum += endTime.minute - i.minute
        return sum
      }

      /**
       * 取一天内两个时间点之间的工作时间分钟数
       * @static
       * @method
       * @param   {Object}    stTime          起始时间
       * @param   {Object}    endTime         结束时间
       * @param   {Array}     workTime        工作时间数组
       * @returns {Number}                    分钟数
       */

    }, {
      key: 'diffWorkMinutes',
      value: function diffWorkMinutes(stTime, endTime, workTime)
      {
        var sum = 0
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = workTime[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var seg = _step.value

            var st = this.copy(stTime)
            var end = this.copy(endTime)
            if (this.compare(seg.start, stTime) >= 0) st = this.copy(seg.start)
            if (this.compare(stTime, seg.end) >= 0) st = this.copy(seg.end)
            if (this.compare(seg.start, endTime) >= 0) end = this.copy(seg.start)
            if (this.compare(endTime, seg.end) >= 0) end = this.copy(seg.end)
            sum += this.diffMinutes(st, end)
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return sum
      }

      /**
       * 取一天的工作分钟数
       * @static
       * @method
       * @param   {Array}     workTime        工作时间数组
       * @returns {Number}                    分钟数
       */

    }, {
      key: 'calcDayMinutes',
      value: function calcDayMinutes(workTime)
      {
        var sum = 0
        var _iteratorNormalCompletion2 = true
        var _didIteratorError2 = false
        var _iteratorError2 = undefined

        try
        {
          for (var _iterator2 = workTime[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
          {
            var seg = _step2.value

            sum += this.diffMinutes(seg.start, seg.end)
          }
        }
        catch (err)
        {
          _didIteratorError2 = true
          _iteratorError2 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion2 && _iterator2.return)
            
              _iterator2.return()
          }
          finally
          {
            if (_didIteratorError2)
            
              throw _iteratorError2
          }
        }

        return sum
      }

      /**
       * 增加分钟数量
       * @static
       * @method
       * @param   {Object}    time            时间对象
       * @param   {Number}    minutes         分钟数量
       */

    }, {
      key: 'addMinutes',
      value: function addMinutes(time, minutes)
      {
        time.minute += minutes
        while (time.minute >= 60)
        {
          time.minute -= 60
          time.hour++
          if (time.hour >= 24) time.hour -= 24
        }
        while (time.minute < 0)
        {
          time.minute += 60
          time.hour--
          if (time.hour < 0) time.hour += 24
        }
      }

      /**
       * 时间早于
       * @static
       * @method
       * @param   {Object}    time            时间
       * @param   {Object}    refTime         参照时间
       */

    }, {
      key: 'et',
      value: function et(time, refTime)
      {
        return time.hour < refTime.hour || time.hour === refTime.hour && time.minute <= refTime.minute
      }

      /**
       * 时间晚于
       * @static
       * @method
       * @param   {Object}    time            时间
       * @param   {Object}    refTime         参照时间
       */

    }, {
      key: 'lt',
      value: function lt(time, refTime)
      {
        return time.hour > refTime.hour || time.hour === refTime.hour && time.minute >= refTime.minute
      }
    }])
    return Time
  }())

  /**
   * cx.bpm.IProcBase
   * 接口-流程个性化基类
   *
   * @class
   * @memberof    cx.bpm
   * @author      Zhang Fayong
   * @since       2018-08-21
   */

  /**
   * 修改记录
   *
   * 20-12-12   张发勇      增加 beforeHandle(att)， 用于在数据显示出来之前对数据进行处理（比如数据解密)
   */

  var IProcBase = (function()
  {
    function IProcBase()
    {
      classCallCheck(this, IProcBase)
    }

    createClass(IProcBase, [{
      key: 'getVarStart',

      /**
       * 取流程参数(发起)
       * @abstract
       * @method
       * @param   {Object}    variables         流程变量
       * @param   {Object}    att               属性
       * @param   {Object}    proc              流程信息
       */
      value: function getVarStart(variables, att, proc)
      {}

      /**
       * 取流程参数(办理)
       * @abstract
       * @method
       * @param   {Object}    variables         流程变量
       * @param   {Object}    att               属性
       * @param   {String}    task              流程环节
       */

    }, {
      key: 'getVarHandle',
      value: function getVarHandle(variables, att, task)
      {}

      /**
       * 取选择办理人的条件
       * @abstract
       * @method
       * @param	{Object}      exp			          办理人的条件
       * @param	{Object}      att			          属性
       */

    }, {
      key: 'getSelAssignee',
      value: function getSelAssignee(exp, att)
      {}

      /**
       * 属性数据处理
       * @abstract
       * @method
       * @param	{Object}      att			          属性
       */

    }, {
      key: 'beforeHandle',
      value: function beforeHandle(att)
      {}
    }])
    return IProcBase
  }())

  /**
   * cx.svr.bpm
   * 服务-BpmSvr
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Bpm = (function()
  {
    function Bpm()
    {
      classCallCheck(this, Bpm)
    }

    createClass(Bpm, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                      服务网址
       */
      value: function url()
      {
        return Service.url('BpmSvr')
      }

      /**
       * 部署流程
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.filename   文件名(上载后是内部名称，用户看不到)
       * @param   {String}    params.name       本次部署的名称
       * @returns {Promise}
       */

    }, {
      key: 'addDeployment',
      value: function addDeployment(params)
      {
        return Service.execute(this.url(), 'addDeploy', params)
      }

      /**
       * 删除部署
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         部署ID
       * @returns {Promise}
       */

    }, {
      key: 'delDeployment',
      value: function delDeployment(params)
      {
        return Service.execute(this.url(), 'delDeploy', params)
      }

      /**
       * 取全部部署
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {Number}    [params.init]     分页初始化
       * @param   {Number}    [params.pageno]   分页页码
       * @param   {Number}    [params.pagesize] 分页大小
       * @returns {Promise}
       */

    }, {
      key: 'getAllDeploy',
      value: function getAllDeploy(params)
      {
        return Service.execute(this.url(), 'getAllDeploy', params)
      }

      /**
       * 取流程定义
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         流程定义ID
       * @returns {Promise}
       */

    }, {
      key: 'getProcDef',
      value: function getProcDef(params)
      {
        return Service.execute(this.url(), 'getProcDef', params)
      }

      /**
       * 根据部署ID取流程定义
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         部署ID
       * @returns {Promise}
       */

    }, {
      key: 'getProcDefByDeploy',
      value: function getProcDefByDeploy(params)
      {
        return Service.execute(this.url(), 'getProcDefByDeploy', params)
      }

      /**
       * 取全部流程定义
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {Number}    [params.init]     分页初始化
       * @param   {Number}    [params.pageno]   分页页码
       * @param   {Number}    [params.pagesize] 分页大小
       * @returns {Promise}
       */

    }, {
      key: 'getAllProcDef',
      value: function getAllProcDef(params)
      {
        return Service.execute(this.url(), 'getAllProcDef', params)
      }

      /**
       * 取某个人的待办任务
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.userid     用户ID
       * @param   {String}    [params.procKey]  流程KEY
       * @param   {Number}    [params.init]     分页是否初始化(首次调用为0, 非第一次为1)
       * @param   {Number}    [params.pageno]   分页页码(1开始)
       * @param   {Number}    [params.pagesize] 分页每页记录数
       * @returns {Promise}
       */

    }, {
      key: 'queryMyTask',
      value: function queryMyTask(params)
      {
        return Service.execute(this.url(), 'queryMyTask', params)
      }

      /**
       * 取某个人的候选任务
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.userid     用户ID
       * @param   {String}    [params.procKey]  流程KEY
       * @param   {Number}    [params.init]     分页是否初始化(首次调用为0, 非第一次为1)
       * @param   {Number}    [params.pageno]   分页页码(1开始)
       * @param   {Number}    [params.pagesize] 分页每页记录数
       * @returns {Promise}
       */

    }, {
      key: 'queryUserTask',
      value: function queryUserTask(params)
      {
        return Service.execute(this.url(), 'queryUserTask', params)
      }

      /**
       * 取某个人发起的流程
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.userid     用户ID
       * @param   {String}    [params.procKey]  流程KEY
       * @param   {Number}    [params.init]     分页是否初始化(首次调用为0, 非第一次为1)
       * @param   {Number}    [params.pageno]   分页页码(1开始)
       * @param   {Number}    [params.pagesize] 分页每页记录数
       * @returns {Promise}
       */

    }, {
      key: 'queryMyStarted',
      value: function queryMyStarted(params)
      {
        return Service.execute(this.url(), 'queryMyStarted', params)
      }

      /**
       * 查询未完成流程
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    [params.userid]   用户ID
       * @param   {String}    [params.procKey]  流程KEY
       * @param   {Number}    [params.init]     分页是否初始化(首次调用为0, 非第一次为1)
       * @param   {Number}    [params.pageno]   分页页码(1开始)
       * @param   {Number}    [params.pagesize] 分页每页记录数
       * @returns {Promise}
       */

    }, {
      key: 'unfinished',
      value: function unfinished(params)
      {
        return Service.execute(this.url(), 'unfinished', params)
      }

      /**
       * 查询历史
       * @static
       * @method
       * @param   {Object}    params                  参数
       * @param   {Number}    [params.finished]       是否结案(1-结案,0-未结案)
       * @param   {String}    [params.startedBy]      发起人
       * @param   {String}    [params.involvedUser]   参与人
       * @param   {String}    [params.finishedAfter]  在...日期之后完成
       * @param   {String}    [params.finishedBefore] 在...日期之前完成
       * @param   {String}    [params.startedAfter]   在...日期之后发起
       * @param   {String}    [params.startedBefore]  在...日期之前发起
       * @param   {String}    [params.procKey]        流程Key
       * @param   {String}    [params.applyName]      发起人的姓名
       * @param   {Number}    [params.init]           分页是否初始化(首次调用为0, 非第一次为1)
       * @param   {Number}    [params.pageno]         分页页码(1开始)
       * @param   {Number}    [params.pagesize]       分页每页记录数
       * @returns {Promise}
       */

    }, {
      key: 'queryHisProc',
      value: function queryHisProc(params)
      {
        return Service.execute(this.url(), 'queryHisProc', params)
      }

      /**
       * 查询完结流程的历史反馈信息
       * @static
       * @method
       * @param   {Object}    params                  参数
       * @param   {Number}    [params.id]             流程实例ID
       * @returns {Promise}
       */

    }, {
      key: 'queryHisComment',
      value: function queryHisComment(params)
      {
        return Service.execute(this.url(), 'queryHisComment', params)
      }

      /**
       * 查询流程实例信息
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         流程实例ID
       * @returns {Promise}
       */

    }, {
      key: 'queryProcInst',
      value: function queryProcInst(params)
      {
        return Service.execute(this.url(), 'queryProcInst', params)
      }

      /**
       * 查询流程的进度
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         流程实例ID
       * @returns {Promise}
       */

    }, {
      key: 'queryProcProg',
      value: function queryProcProg(params)
      {
        return Service.execute(this.url(), 'queryProcProg', params)
      }

      /**
       * 查询流程的跟踪图
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         流程实例ID
       * @returns {Promise}
       */

    }, {
      key: 'queryProcDgm',
      value: function queryProcDgm(params)
      {
        return Service.execute(this.url(), 'queryProcDgm', params)
      }

      /**
       * 启动流程
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         流程定义ID
       * @param   {String}    params.userid     用户ID
       * @param   {String}    params.FILES_     附件列表
       * @param   {String}    params.FK_        变量(支持多个变量，变量名以 'FK_' 开头)
       * @returns {Promise}
       */

    }, {
      key: 'startProcess',
      value: function startProcess(params)
      {
        params.userid = Global.user.no
        params.FK_applyUserId = Global.user.no
        params.FK_applyUserName = Global.user.name
        params.FK_applyId = Global.user.id

        return Service.execute(this.url(), 'startProcess', params)
      }

      /**
       * 删除部署
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         任务ID
       * @param   {String}    [params.userid]   用户ID
       * @returns {Promise}
       */

    }, {
      key: 'claimTask',
      value: function claimTask(params)
      {
        params.userid = Global.user.no
        return Service.execute(this.url(), 'claimTask', params)
      }

      /**
       * 删除部署
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         任务ID
       * @returns {Promise}
       */

    }, {
      key: 'unclaimTask',
      value: function unclaimTask(params)
      {
        return Service.execute(this.url(), 'unclaimTask', params)
      }

      /**
       * 完成任务
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         任务ID
       * @param   {String}    params.FILES_     附件列表
       * @param   {String}    params.FK_        变量(支持多个变量，变量名以 'FK_' 开头)
       * @param   {String}    params.COMMENT_   反馈意见
       * @returns {Promise}
       */

    }, {
      key: 'completeTask',
      value: function completeTask(params)
      {
        params.userid = Global.user.no
        params.username = Global.user.name
        return Service.execute(this.url(), 'completeTask', params)
      }

      /**
       * 回退任务
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         任务ID
       * @param   {String}    params.backto     退回任务ID
       * @param   {String}    params.COMMENT_   反馈意见
       * @returns {Promise}
       */

    }, {
      key: 'returnTask',
      value: function returnTask(params)
      {
        params.userid = Global.user.no
        return Service.execute(this.url(), 'returnTask', params)
      }

      /**
       * 指派任务（被指派人完成后任务不会回来）
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         任务ID
       * @param   {String}    params.userid     委托用户
       * @returns {Promise}
       */

    }, {
      key: 'assignTask',
      value: function assignTask(params)
      {
        return Service.execute(this.url(), 'assignTask', params)
      }

      /**
       * 委托任务
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         任务ID
       * @param   {String}    params.touser     委托用户
       * @returns {Promise}
       */

    }, {
      key: 'delegateTask',
      value: function delegateTask(params)
      {
        params.fromuser = Global.user.no
        return Service.execute(this.url(), 'delegateTask', params)
      }

      /**
       * 撤销流程
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         流程实例ID
       * @param   {String}    [params.userid]   发起人的登录名
       * @returns {Promise}
       */

    }, {
      key: 'revokeProcess',
      value: function revokeProcess(params)
      {
        if (!params.userid) params.userid = Global.user.no
        return Service.execute(this.url(), 'revokeProcess', params)
      }

      /**
       * 设置流程变量
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         任务ID
       * @param   {String}    params.variables  变量(多个变量之间用,分隔)(每个变量及其值采用键值对方式放在params里面)
       * @returns {Promise}
       */

    }, {
      key: 'setVariables',
      value: function setVariables(params)
      {
        return Service.execute(this.url(), 'setVariables', params)
      }

      /**
       * 取流程变量
       * @static
       * @method
       * @param   {Object}    params            参数
       * @param   {String}    params.id         流程实例ID
       * @returns {Promise}
       */

    }, {
      key: 'getVariables',
      value: function getVariables(params)
      {
        return Service.execute(this.url(), 'getVariables', params)
      }

      /**
       * 取工单号
       * @static
       * @method
       * @param   {String}    name              工单名字
       * @returns {Promise}
       */

    }, {
      key: 'getBillM',
      value: function getBillM(name)
      {
        return Service.execute(this.url(), 'getBill', { name: name })
      }

      /**
       * 取当前时间
       * @static
       * @method
       * @returns {Promise}
       */

    }, {
      key: 'getTimeM',
      value: function getTimeM()
      {
        return Service.execute(this.url(), 'getTime')
      }
    }])
    return Bpm
  }())

  /**
   * cx.bpm.bpm
   * cx.bpm.bpm常用接口
   *
   * @class
   * @memberof    cx.bpm
   * @author      Zhang Fayong
   * @since       2017-08-02
   */

  var Bpm$1 = (function()
  {
    function Bpm$1()
    {
      classCallCheck(this, Bpm$1)
    }

    createClass(Bpm$1, null, [{
      key: 'getProcsAll',

      /**
       * 取所有的流程信息
       * @method
       * @static
       * @returns	{Promise}
       */
      value: function getProcsAll()
      {
        return new Promise(function(resolve, reject)
        {
          resolve($g.init.procs)
        })
      }

      /**
       * 根据流程ID取流程的Key
       * @method
       * @static
       * @param		{String}    procId    		流程ID
       * @returns	{String}									流程的Key
       */

    }, {
      key: 'getProcKey',
      value: function getProcKey(procId)
      {
        return procId.substr(0, procId.indexOf(':'))
      }

      /**
       * 根据task查看流程进展
       * @method
       * @static
       * @param		{Object}  	task      		任务信息
       * @param		{Object}  	pluginName    插件名称
       */

    }, {
      key: 'procProgressByTask',
      value: function procProgressByTask(task, pluginName)
      {
        var procInst = {
          id: task.processInstanceId,
          processDefinitionId: task.processDefinitionId,
          businessKey: task.variables.businessKey,
          startTime: task.createTime
        }
        Run.runPlug(pluginName || 'ProcProgress', { procInst: procInst })
      }

      /**
       * 根据流程实例查看流程进展
       * @method
       * @static
       * @param		{Object}		procInst			流程实例
       * @param		{Object}		pluginName    插件名称
       */

    }, {
      key: 'procProgressByProcInst',
      value: function procProgressByProcInst(procInst, pluginName)
      {
        Run.runPlug(pluginName, { procInst: procInst })
      }

      /**
       * 根据task查看流程跟踪图
       * @method
       * @static
       * @param  	{Object}  	task      		任务信息
       * @param  	{Object}  	pluginName    插件名称
       */

    }, {
      key: 'procTraceByTask',
      value: function procTraceByTask(task, pluginName)
      {
        var procInst = {
          id: task.processInstanceId,
          processDefinitionId: task.processDefinitionId
        }

        Run.runPlug(pluginName, {
          urlImg: Url.getRequestUrl(Bpm.url(), { cmd: 'getProcDefDgm', id: task.processDefinitionId }),
          procInst: procInst
        })
      }

      /**
       * 根据流程实例查看流程跟踪图
       * @method
       * @static
       * @param  {Object}  procInst    流程实例
       * @param  {Object}  pluginName    插件名称
       */

    }, {
      key: 'procTraceByProcInst',
      value: function procTraceByProcInst(procInst, pluginName)
      {
        Run.runPlug(pluginName, {
          urlImg: Url.getRequestUrl(Bpm.url(), { cmd: 'getProcDefDgm', id: procInst.processDefinitionId }),
          procInst: procInst
        })
      }

      /**
       * 指派给某人
       * @method
       * @static
       * @param  	{String}  	assignType  	指派类型(group/deppos/selassi/any)
       * @param  	{Object}  	params    		参数(group:grp1;grp2 deppos:dep,pos1;pos2 selassi:name1 any:s)
       * @param  	{Object}  	variables  		流程里面的属性
       * @param  	{Caller}  	onSuccess  		选择数据-function(user)
       */

    }, {
      key: 'assignTo',
      value: function assignTo(assignType, params, variables, onSuccess)
      {
        var arrStr = (params || '').split(',')

        switch (assignType)
        {
        case 'group':
          Run.runPlug('SelGroupUser', {
            group: arrStr[0],
            onOk: function onOk(user)
            {
              Base.call(onSuccess, user)
            }
          })
          break
        case 'deppos':
          Run.runPlug('SelDepartUser', {
            orgNo: arrStr[0],
            position: arrStr[1],
            onOk: function onOk(user)
            {
              Base.call(onSuccess, user)
            }
          })
          break
        case 'selassi':
          var item = $g.prosAssi.get(arrStr[0], variables)
          if (item)
          {
            switch (item.sel)
            {
            case 'group':
              Run.runPlug('SelGroupUser', {
                group: item.params[0],
                onOk: function onOk(user)
                {
                  Base.call(onSuccess, user)
                }
              })
              break
            case 'deppos':
              Run.runPlug('SelDepartUser', {
                orgNo: item.params[0],
                position: item.params[1],
                onOk: function onOk(user)
                {
                  Base.call(onSuccess, user)
                }
              })
              break
            }
          }
          break
        case 'all':
          Run.runPlug('SelOrganUser', {
            onOk: function onOk(user)
            {
              Base.call(onSuccess, user)
            }
          })
          break
        }
      }

      /**
       * 根据proc启动流程(采用模板-取流程定义,最后再启动)
       * @static
       * @method
       * @param   {Object}    proc                  流程信息
       * @param   {String}    startPlugin           处理启动Form的插件名
       * @param   {Object}    params                发起流程的参数
       * @param   {Object}    [params.att]          已经存在的属性
       * @param   {Function}  [params.onBeforeAdd]  回调函数-添加属性之前-function(att)
       * @param   {Function}  [params.onAdd]        回调函数-添加属性成功-function(att)
       * @param   {Function}  [params.onStart]      回调函数-发起流程成功-function(id)
       */

    }, {
      key: 'startWithTmpl',
      value: function startWithTmpl(proc, startPlugin, params)
      {
        //弹出启动流程的界面
        var startWithForm = function startWithForm()
        {
          //实体信息
          var entity = $g.entity.byName(proc.tabname)

          //参数
          var params1 = {
            major: entity.major,
            minor: entity.minor,
            proc: proc,
            title: Base.locale(proc.namec, proc.namee)
          }
          Base.extend(params1, params)
          Run.runPlug(startPlugin, params1)
        }

        //加载流程定义
        var loadProcDef = function loadProcDef()
        {
          Bpm.getProcDef({ id: proc.procid }).then(function(ret)
          {
            //缓存数据
            proc.def = ret[0]
            startWithForm()
          }).catch(Error$1.error)
        }

        //如果已经缓存了流程定义，则直接启动否则先缓存流程定义
        if (proc.def) startWithForm(); else loadProcDef()
      }

      /**
       * 根据proc(表proc)启动流程(需要取流程定义,最后再启动)
       * @static
       * @method
       * @param   {Object}    proc              流程信息
       * @param   {Object}    [variables]       启动流程的额外变量
       * @returns {Promise}
       */

    }, {
      key: 'startByProc',
      value: function startByProc(proc, variables)
      {
        return new Promise(function(resolve, reject)
        {
          //启动流程
          var startProc = function startProc()
          {
            var options = {
              id: proc.def.id, //流程ID
              FK_table: proc.tabname, //对应的表名
              bill: proc.bill //生成工单号的名字


              //设置流程办理人
            }; if (variables.ASSIGNEE_) options.ASSIGNEE_ = variables.ASSIGNEE_
            delete variables.ASSIGNEE_

            //把传进来的参数送进去
            if (variables)
            {
              for (var i in variables)
              
                options['FK_' + i] = variables[i]
            }

            //发起
            return Bpm.startProcess(options).then(function(ret)
            {
              resolve(ret)
            }).catch(function(ret)
            {
              reject(ret)
            })
          }

          //加载流程定义
          var loadProcDef = function loadProcDef()
          {
            Bpm.getProcDef({ id: proc.procid }).then(function(ret)
            {
              //缓存数据
              proc.def = ret[0]
              startProc()
            }).catch(function(ret)
            {
              reject(ret)
            })
          }

          //如果已经缓存了流程定义，则直接启动否则先缓存流程定义
          if (proc.def) startProc(); else loadProcDef()
        })
      }
    }])
    return Bpm$1
  }())

  /**
   * 流程处理对象
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-08-11
   */
  var ProcHandle = (function()
  {
    /**
     * @constructor
     */
    function ProcHandle()
    {
      classCallCheck(this, ProcHandle)

      this.list = []
      this.customs = []
    }

    /**
     * 解析配置
     * @param   {Object}    config            配置信息
     */


    createClass(ProcHandle, [{
      key: 'parse',
      value: function parse(config)
      {
        if (!config || !config.buttons) return

        var btns = config.buttons.split(',')
        var i = void 0,
          il = void 0
        var obj = void 0

        for (i = 0, il = btns.length; i < il; i += 2)
        {
          obj = {
            type: parseInt(btns[i]),
            title: btns[i + 1]
          }
          switch (obj.type)
          {
          case -1:
            //回退
            obj.backto = config.backto
            this.list.push(obj)
            break
          case -2: //详情
          case 0: //同意
          case 1:
            //不同意
            this.list.push(obj)
            break
          case 2:
            //移交
            obj.transferType = config.transferType
            obj.transferParams = config.transferParams
            obj.value = ''
            this.list.push(obj)
            break
          case 3:
            //指定办理人
            obj.assigneeType = config.assigneeType
            obj.assigneeParams = config.assigneeParams
            obj.value = ''
            this.list.push(obj)
            break

          default:
            obj.func = config['func' + obj.type] //函数调用
            obj.plugin = config['plugin' + obj.type] //插件调用
            obj.params = config['params' + obj.type] //参数
            obj.icon = config['icon' + obj.type] //图标CSS类名
            obj.onok = config['onok' + obj.type] //回调
            obj.icon = obj.icon ? obj.icon : 'el-icon-download'
            this.customs.push(obj)
            break
          }
        }

        // obj =
        // {
        //   type: '9',
        //   title: '报销单',
        //   func: 'oa.api.test22',
        //   params: '#{variables}',
        //   onok: '#{test}:test',
        //   icon: 'el-icon-setting'
        // }
        // this.customs.push(obj)

        // obj =
        // {
        //   type: '8',
        //   title: 'test1',
        //   func: 'oa.api.test',
        //   params: '#{id},#{value},#{applyId}',
        //   onok: '#{value}:value',
        //   icon: 'el-icon-setting'
        // }
        // this.customs.push(obj)

        // obj =
        // {
        //   type: '9',
        //   title: 'test2',
        //   plugin: 'oa.api.test',
        //   params: 'id-#{id},value-#{value},applyId-#{applyId}',
        //   onok: '#{value}:value',
        //   icon: 'el-icon-setting'
        // }
        // this.customs.push(obj)
      }

      /**
       * 验证数据有效性
       * @method
       * @returns {Boolean}
       */

    }, {
      key: 'valid',
      value: function valid()
      {
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var btn = _step.value

            switch (btn.type)
            {
            case 2:
            case 3:
              //指定办理人
              if (!btn.value) return false
            }
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return true
      }
    }])
    return ProcHandle
  }())

  /**
   * @class       cx.layer.ITileLayer
   * 接口-地图图层
   *
   * @class
   * @memberof    cx.layer
   * @author      Zhang Fayong
   * @since       2020-11-16
   */

  var ITileLayer = (function()
  {
    /**
     * @constructor
     * @param   {Object}    options                     options
     * @param   {String}    options.url                 URL
     * @param   {String}    [options.id]                图层ID
     * @param   {String}    [options.name = '']         图层名
     * @param   {Boolean}   [options.visible = true]    是否可见
     * @param   {Array}     [options.domains]           子域
     * @param   {Number}    [options.alpha = 1]         图层的透明度
     */
    function ITileLayer(options)
    {
      classCallCheck(this, ITileLayer)

      /** * @property {String}    id                    ID */
      this.id = options.id
      if (this.id === undefined || this.id === '') this.id = Base.nextId()
      /** * @property {String}    name                  瓦片子图层名字 */
      this.name = Base.defVal(options.name, '')
      /** * @property {Boolean}   visible               是否可见 */
      this.visible = Base.defVal(options.visible, true)
      /** * @property {String}    url                   URL */
      this.url = options.url
      /** * @property {Array}     domains               子域 */
      this.domains = options.domains
      this.domainIdx = 0 //子域索引
      this.alpha = Base.defVal(options.alpha, 1) //透明度
    }

    /**
     * 销毁对象
     * @method
     */


    createClass(ITileLayer, [{
      key: 'destroy',
      value: function destroy()
      {}

      /**
       * 取组名称
       * @method
       * @returns {String}
       */

    }, {
      key: 'getName',
      value: function getName()
      {
        return this.name
      }

      /**
       * 设置组名
       * @method
       * @param   {String}    newVal          新值
       * @returns {Object}                    this
       */

    }, {
      key: 'setName',
      value: function setName(newVal)
      {
        this.name = newVal
        return this
      }

      /**
       * 设置是否显示/取显示状态 (带参数为设置状态，不带参数为取状态)
       * @method
       * @param   {Boolean}    [visible]      是否显示
       * @returns {Object|Boolean}            设置状态返回this,取显示状态返回显示状态
       */

    }, {
      key: 'show',
      value: function show(visible)
      {
        if (visible === undefined) return this.visible; else this.visible = visible
      }

      /**
       * 根据级别/行号/列号取瓦片的URL
       * @method
       * @param   {Object}    grid          瓦片格子 {level, row, col}
       * @returns {String}                  URL
       */

    }, {
      key: 'getUrl',
      value: function getUrl(grid)
      {
        var ret = this.url
        if (this.domains)
        {
          ret = ret.replace('{s}', this.domains[this.domainIdx++])
          if (this.domainIdx >= this.domains.length) this.domainIdx = 0
        }
        ret = ret.replace('{z}', grid.level)
        ret = ret.replace('{y}', grid.row)
        ret = ret.replace('{x}', grid.col)
        return ret
      }
    }])
    return ITileLayer
  }())

  /**
   * cx.layer
   * 类-WMS图层
   *
   * @class
   * @memberof    cx.layer
   * @extends     cx.layer.ITileLayer
   * @author      Zhang Fayong
   * @since       2020-11-16
   */

  //GetMap示例:
  //http://101.200.77.180:9000/gishadgz/service/wms?service=WMS&request=GetMap&version=1.1.0&format=image%2Fpng&styles=&transparent=true&layers=gishadgz%3Abhmap&srs=EPSG%3A4326&bbox=109.3359375%2C21.445312500000004%2C109.51171875000001%2C 21.621093749999996&width=256&height=256

  //GetFeatureInfo示例:
  //http://192.168.2.200:8091/geoserver/gisxbgd/wms?service=WMS&version=1.1.1&request=GetFeatureInfo&format=image/png&transparent=true&query_layers=gisxbgd:demo&styles=&layers=gisxbgd:demo&info_format=application/json&feature_count=50&x=50&y=50&srs=EPSG:4326&width=101&height=101&bbox=79.60693359375,43.79150390625,84.04541015625,48.22998046875

  var Wms = (function(_ITileLayer)
  {
    inherits(Wms, _ITileLayer)

    /**
     * @constructor
     * @param   {cx3.Wmts}        wmts                                    WMTS切片对象
     * @param   {Object}          options
     * @param   {String}          options.url                             url
     * @param   {String}          options.layer                           图层名
     * @param   {String}          options.srs                             投影代码 (EPSG:4326, 3857, 900913)
     * @param   {String}          [options.name]                          图层名称
     * @param   {String}          [options.version = '1.1.0']             WMS版本
     * @param   {String}          [options.format = 'image/png']          图片格式
     * @param   {Boolean}         [options.transparent = true]            背景是否透明
     * @param   {String}          [options.styles]                        渲染
     * @param   {Number}          [options.width = 256]                   图片宽度
     * @param   {Number}          [options.height = 256]                  图片高度
     * @param   {Array.<String>}  [options.domains]                       子域
     * @param   {Number}          [options.alpha = 1]                     透明度
     */
    function Wms(wmts, options)
    {
      classCallCheck(this, Wms)

      var cfg = cx.base.extend({}, options)
      cfg.version = Base.defVal(options.version, '1.1.0')
      cfg.format = Base.defVal(options.format, 'image/png')
      cfg.srs = Base.defVal(options.srs, 'EPSG:3857')
      cfg.transparent = Base.defVal(options.transparent, true)
      cfg.styles = Base.defVal(options.styles, '')
      cfg.width = Base.defVal(options.width, 256)
      cfg.height = Base.defVal(options.height, 256)
      cfg.domains = Base.defVal(options.domains, null)

      //GetMap
      var urlGetMap = cfg.url + '?service=WMS&request=GetMap' + '&version=' + cfg.version + '&format=' + cfg.format + '&styles=' + cfg.styles + '&transparent=' + (cfg.transparent ? 'true' : 'false') + '&layers=' + cfg.layer + '&crs=' + cfg.srs + '&width=' + cfg.width + '&height=' + cfg.height + '&bbox='

      var _this = possibleConstructorReturn(this, (Wms.__proto__ || Object.getPrototypeOf(Wms)).call(this, { id: cfg.layer, url: urlGetMap, name: cfg.layer, domains: cfg.domains, alpha: options.alpha }))

      _this.wmts = wmts
      _this.cfg = cfg
      _this.urlGetMap = urlGetMap
      _this.rect = {}

      //GetFeatureInfo
      //this.urlGetFea = cfg.url + '?service=WMS&request=GetFeatureInfo' +
      //'&version=' + cfg.version +
      //'&format=' + cfg.format +
      //'&styles=' + cfg.styles +
      //'&transparent=' + (cfg.transparent ? 'true' : 'false') +
      //'&layers=' + cfg.layer +
      //'&srs=' + cfg.srs +
      //'&query_layers=' + cfg.layer +
      //'&info_format=application/json' +
      //'&feature_count=1' +
      //'&width=' + cfg.width +
      //'&height=' + cfg.height +
      //'&bbox='
      return _this
    }

    /**
     * 根据级别/行号/列号取瓦片的URL
     * @method
     * @param   {Object}    grid          瓦片格子 {level, row, col}
     * @returns {String}                  URL
     */


    createClass(Wms, [{
      key: 'getUrl',
      value: function getUrl(grid)
      {
        var ret = this.urlGetMap

        this.wmts.getTileRect(grid, this.rect)
        if (this.domains)
        {
          ret = ret.replace('{s}', this.domains[this.domainIdx++])
          if (this.domainIdx >= this.domains.length) this.domainIdx = 0
        }
        return ret + this.rect.minx + ',' + this.rect.miny + ',' + this.rect.maxx + ',' + this.rect.maxy
      }

      /**
       * 根据笛卡尔坐标取WMS里面 getFeatureInfo 的URL
       * @method
       * @param   {Object}    xyz           笛卡尔坐标(x, y, z)
       * @param   {Number}    level         瓦片级别
       * @returns {String}                  URL
       */
      //getUrlFea(xyz, level)
      //{
      //  let ret = this.urlGetFea
      //
      //  if (this.domains)
      //  {
      //    ret = ret.replace('{s}', this.domains[this.domainIdx++])
      //    if (this.domainIdx >= this.domains.length)
      //      this.domainIdx = 0
      //  }
      //
      //  this.bbox = ''
      //  switch (this.srs)
      //  {
      //  case 3857:    //墨卡托瓦片
      //    math3.Cartesian2Wgs(xyz, this.lonlat)
      //    math3.Wgs2Mercator(this.lonlat.x, this.lonlat.y, this.mercator)
      //    math3.Mercator2Tilemct(this.mercator.x, this.mercator.y, level, this.tileInfo, true)
      //    math3.tilemctRect(this.tileInfo, this.rect)
      //    this.bbox += this.rect.minx + ',' + this.rect.miny + ',' + this.rect.maxx + ',' + this.rect.maxy + '&x=' + this.tileInfo.offsetX + '&y=' + this.tileInfo.offsetY
      //    break
      //  case 4326:    //经纬度瓦片
      //    //math3.tilewgsRect({level, row, col}, this.rect)
      //    //this.bbox = math3.toDegree(this.rect.minx) + ',' + math3.toDegree(this.rect.miny) + ',' + math3.toDegree(this.rect.maxx) + ',' + math3.toDegree(this.rect.maxy)
      //    break
      //  }
      //
      //  return ret + this.bbox
      //}

    }])
    return Wms
  }(ITileLayer))

  /**
   * cx.layer
   * 类-ArcGIS WMS图层
   *
   * @class
   * @memberof    cx.layer
   * @extends     cx.layer.ITileLayer
   * @author      Zhang Fayong
   * @since       2020-11-16
   */

  //GetMap示例:
  //https://122.112.155.221:6443/arcgis/services/sq/BASEGO/MapServer/WMSServer?service=WMS&request=GetMap&version=1.3.0&format=image%2Fpng&styles=&transparent=true&layers=1&crs=EPSG%3A2345&width=256&height=256&bbox=3710644.0000251657%2C578431.9999771938%2C3776180.0000249036%2C643967.9999769316

  //GetFeatureInfo示例:


  var WmsArcgis = (function(_ITileLayer)
  {
    inherits(WmsArcgis, _ITileLayer)

    /**
     * @constructor
     * @param   {cx3.Wmts}        wmts                                    WMTS切片对象
     * @param   {Object}          options
     * @param   {String}          options.url                             url
     * @param   {String}          options.layer                           图层名
     * @param   {String}          options.srs                             投影代码 (EPSG:4326, 3857, 900913)
     * @param   {String}          [options.name]                          图层名称
     * @param   {String}          [options.version = '1.3.0']             WMS版本
     * @param   {String}          [options.format = 'image/png']          图片格式
     * @param   {Boolean}         [options.transparent = true]            背景是否透明
     * @param   {String}          [options.styles]                        渲染
     * @param   {Number}          [options.width = 256]                   图片宽度
     * @param   {Number}          [options.height = 256]                  图片高度
     * @param   {Array.<String>}  [options.domains]                       子域
     * @param   {Number}          [options.alpha = 1]                     透明度
     */
    function WmsArcgis(wmts, options)
    {
      classCallCheck(this, WmsArcgis)

      var cfg = cx.base.extend({}, options)
      cfg.version = Base.defVal(options.version, '1.3.0')
      cfg.format = Base.defVal(options.format, 'image/png')
      cfg.srs = Base.defVal(options.srs, 'EPSG:3857')
      cfg.transparent = Base.defVal(options.transparent, true)
      cfg.styles = Base.defVal(options.styles, '')
      cfg.width = Base.defVal(options.width, 256)
      cfg.height = Base.defVal(options.height, 256)
      cfg.domains = Base.defVal(options.domains, null)

      //GetMap
      var urlGetMap = cfg.url + '?service=WMS&request=GetMap' + '&version=' + cfg.version + '&format=' + cfg.format + '&styles=' + cfg.styles + '&transparent=' + (cfg.transparent ? 'true' : 'false') + '&layers=' + cfg.layer + '&crs=' + cfg.srs + '&width=' + cfg.width + '&height=' + cfg.height + '&bbox='

      var _this = possibleConstructorReturn(this, (WmsArcgis.__proto__ || Object.getPrototypeOf(WmsArcgis)).call(this, { url: urlGetMap, name: cfg.layer, domains: cfg.domains, alpha: options.alpha }))

      _this.wmts = wmts
      _this.cfg = cfg
      _this.urlGetMap = urlGetMap
      _this.rect = {}

      ////GetFeatureInfo
      //this.urlGetFea = cfg.url + '?service=WMS&request=GetFeatureInfo' +
      //'&version=' + cfg.version +
      //'&format=' + cfg.format +
      //'&styles=' + cfg.styles +
      //'&transparent=' + (cfg.transparent ? 'true' : 'false') +
      //'&layers=' + cfg.layer +
      //'&crs=' + cfg.srs +
      //'&query_layers=' + cfg.layer +
      //'&info_format=application/json' +
      //'&feature_count=1' +
      //'&width=' + cfg.width +
      //'&height=' + cfg.height +
      //'&bbox='
      return _this
    }

    /**
     * 根据级别/行号/列号取瓦片的URL
     * @method
     * @param   {Object}    grid          瓦片格子 {level, row, col}
     * @returns {String}                  URL
     */


    createClass(WmsArcgis, [{
      key: 'getUrl',
      value: function getUrl(grid)
      {
        var ret = this.urlGetMap

        this.wmts.getTileRect(grid, this.rect)
        if (this.domains)
        {
          ret = ret.replace('{s}', this.domains[this.domainIdx++])
          if (this.domainIdx >= this.domains.length) this.domainIdx = 0
        }

        return ret + this.rect.miny + ',' + this.rect.minx + ',' + this.rect.maxy + ',' + this.rect.maxx
      }

      /**
       * 根据笛卡尔坐标取WMS里面 getFeatureInfo 的URL
       * @method
       * @param   {Object}    rect          范围(minx, miny, maxx, maxy)
       * @returns {String}                  URL
       */
      //getUrlFea(rect)
      //{
      //  let ret = this.urlGetFea
      //
      //  if (this.domains)
      //  {
      //    ret = ret.replace('{s}', this.domains[this.domainIdx++])
      //    if (this.domainIdx >= this.domains.length)
      //      this.domainIdx = 0
      //  }
      //  return  ret + rect.minx + ' ' + rect.miny + ' ' + rect.maxx + ' ' + rect.maxy
      //}

    }])
    return WmsArcgis
  }(ITileLayer))

  var CryptoJS$1 = require('crypto-js')

  /**
   * cx.security.encrypt
   * 加密类
   *
   * @class
   * @memberof    cx.security
   * @author      Zhang Fayong
   * @since       2019-07-18
   */

  var Encrypt = (function()
  {
    function Encrypt()
    {
      classCallCheck(this, Encrypt)
    }

    createClass(Encrypt, null, [{
      key: 'encrypt',

      /**
       * 数据加密
       * @static
       * @method
       * @param   {String}    code          源码
       * @param   {String}    secretKey     加密码
       * @param   {String}    type          加密方式(DES ..)
       * @returns {String}                  加密后的串
       */
      value: function encrypt(code, secretKey, type)
      {
        return CryptoJS$1.DES.encrypt(code, CryptoJS$1.enc.Utf8.parse(secretKey), {
          mode: CryptoJS$1.mode.ECB,
          padding: CryptoJS$1.pad.Pkcs7
        }).toString()
      }

      /**
       * 解密字符串
       * @static
       * @method
       * @param   {String}    str               待加密的字符串
       * @param   {String}    secretKey         安全key
       * @returns {String}                      加密后的字符串
       */

    }, {
      key: 'decrypt',
      value: function decrypt(str, secretKey)
      {
        return CryptoJS$1.DES.decrypt({ ciphertext: CryptoJS$1.enc.Base64.parse(str) }, CryptoJS$1.enc.Utf8.parse(secretKey), {
          mode: CryptoJS$1.mode.ECB,
          padding: CryptoJS$1.pad.Pkcs7
        }).toString(CryptoJS$1.enc.Utf8)
      }
    }])
    return Encrypt
  }())

  /**
   * cx.svr.area
   * 空间基础服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-07-02
   */

  var Area = (function()
  {
    function Area()
    {
      classCallCheck(this, Area)
    }

    createClass(Area, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('AreaSvr')
      }

      /**
       * 缓存数据
       * @static
       * @method
       * @param   {Number}    major               实体主类型
       * @param   {Number}    minor               实体子类型
       * @param   {String}    cacheKey            缓存键
       * @param   {Object}    data                待缓存的数据
       * @returns {Object}                        this
       */

    }, {
      key: 'putCache',
      value: function putCache(major, minor, cacheKey, data)
      {
        if (cacheKey && data) this.cache.put(major + '_' + minor + '_' + cacheKey, data)
        return this
      }

      /**
       * 取缓存数据
       * @static
       * @method
       * @param   {Number}  major            实体主类型
       * @param   {Number}  minor            实体子类型
       * @param   {String}  cacheKey         缓存键
       * @returns {Promise}
       */

    }, {
      key: 'getCache',
      value: function getCache(major, minor, cacheKey)
      {
        var cached = this.cache.get(major + '_' + minor + '_' + cacheKey)
        if (cached)
        {
          return new Promise(function(resolve)
          {
            resolve(cached)
          })
        }
        return null
      }

      /**
       * 添加记录
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Object}    att                       待添加的属性数据对象
       * @param   {Number}    [retAtt=0]                是否返回整条记录，0-不返回，1-返回
       * @returns {Promise}
       */

    }, {
      key: 'add',
      value: function add(major, minor, att)
      {
        var retAtt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0

        return Service.execute(this.url(), 'add', Base.extend({ _major: major, _minor: minor, retAtt: retAtt }, att))
      }

      /**
       * 向数据库添加一个图形，同时写入属性表和图形表，id会自动创建
       * @static
       * @method
       * @param {Number}     major          实体主类型
       * @param {Number}     minor          实体子类型
       * @param {Object}     attData        实体的属性表数据
       * @param {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addByAttGra',
      value: function addByAttGra(major, minor, attData, graData)
      {
        var paras = { _major: major, _minor: minor }
        Base.extend(paras, attData, graData)
        return Service.execute(this.url(), 'add', paras)
      }

      /**
       * 向数据库添加一个图形，同时写入属性表和图形表，id不自动创建，使用传入的值
       * @static
       * @method
       * @param {Number}     major          实体主类型
       * @param {Number}     minor          实体子类型
       * @param {Object}     attData        实体的属性表数据，必须要有id属性值
       * @param {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addByAttGraId',
      value: function addByAttGraId(major, minor, attData, graData)
      {
        var paras = { _major: major, _minor: minor }
        Base.extend(paras, attData, graData)
        return Service.execute(this.url(), 'addWithId', paras)
      }

      /**
       * 添加记录，并保持id不变
       * @static
       * @method
       * @param {Number}     major          实体主类型
       * @param {Number}     minor          实体子类型
       * @param {Object}     att            待添加的属性数据对象，必须要有id属性值
       * @param {Number}     [retAtt=0]      是否返回整条记录，0-不返回，1-返回
       * @returns {Promise}
       */

    }, {
      key: 'addById',
      value: function addById(major, minor, att)
      {
        var retAtt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0

        var paras = { _major: major, _minor: minor, retAtt: retAtt }
        Base.extend(paras, att)
        return Service.execute(this.url(), 'addWithId', paras)
      }

      /**
       * 仅仅只向数据库添加一个图形，不填加属性表。id不自动创建，使用传入的值
       * @static
       * @method
       * @param {Number}     major          实体主类型
       * @param {Number}     minor          实体子类型
       * @param {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addGraWithId',
      value: function addGraWithId(major, minor, graData)
      {
        var paras = { _major: major, _minor: 0 }
        Base.extend(paras, graData)
        return Service.execute(this.url(), 'addGraWithId', paras)
      }

      /**
       * 批量添加记录
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Array.<Object>} attList              待添加的属性数据对象
       * @returns {Promise}
       */

    }, {
      key: 'adds',
      value: function adds(major, minor, attList)
      {
        return Service.execute(this.url(), 'adds', { _major: major, _minor: minor, json: Converter.data2String(attList) })
      }

      /**
       * 仅仅只向数据库添加一个图形，不填加属性表。id不自动创建，使用传入的值
       * @static
       * @method
       * @param {Number}     major          实体主类型
       * @param {Number}     minor          实体子类型
       * @param {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addGra',
      value: function addGra(major, minor, graData)
      {
        var paras = { _major: major, _minor: 0 }
        Base.extend(paras, graData)
        return Service.execute(this.url(), 'addGra', paras)
      }

      /**
       * 向数据库批量添加图形
       * @static
       * @method
       * @param {Number}             major           图形表主类型
       * @param {Number}             minor           图形表子类型
       * @param {Array.<Object>}     graDatas        图形表数据对象序列
       * @returns {Promise}
       */

    }, {
      key: 'addGras',
      value: function addGras(major, minor, graDatas)
      {
        var paras = { _major: major, _minor: minor, json: Converter.data2String(graDatas) }
        return Service.execute(this.url(), 'addGras', paras)
      }

      /**
       * 根据主、子类型和id删除数据。是空间对象时删除属性表和图形表数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        对象的id
       * @returns {Promise}
       */

    }, {
      key: 'del',
      value: function del(major, minor, id)
      {
        return Service.execute(this.url(), 'delete', { _major: major, _minor: minor, id: id })
      }

      /**
       * 根据主、子类型和id删除图形表数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        对象的id
       * @returns {Promise}
       */

    }, {
      key: 'delGra',
      value: function delGra(major, minor, id)
      {
        return Service.execute(this.url(), 'deleteGra', { _major: major, _minor: minor, id: id })
      }

      /**
       * 根据主、子类型和id列表删除数据。目前仅支持删除属性表数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    ids                       对象的id列表(,分隔)
       * @returns {Promise}
       */

    }, {
      key: 'dels',
      value: function dels(major, minor, ids)
      {
        return Service.execute(this.url(), 'deletes', { _major: major, _minor: minor, ids: ids })
      }

      /**
       * 服务-根据ID取属性
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params.id                 实体ID
       * @returns {Promise}
       */

    }, {
      key: 'getAtt',
      value: function getAtt(params)
      {
        return Service.execute(this.url(), 'getAtt', params)
      }

      /**
       * 服务-根据ID取属性
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        实体ID
       * @returns {Promise}
       */

    }, {
      key: 'getAttM',
      value: function getAttM(major, minor, id)
      {
        return Service.execute(this.url(), 'getAtt', { _major: major, _minor: minor, id: id })
      }

      /**
       * 获取目标对象的属性数据和图形数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        实体的id
       * @returns {Promise}
       */

    }, {
      key: 'getAttGra',
      value: function getAttGra(major, minor, id)
      {
        return Service.execute(this.url(), 'getattgra', { _major: major, _minor: minor, id: id })
      }

      /**
       * 批量获取目标对象的属性数据和图形数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {String}    ids                       实体的id序列，用逗号分割
       * @returns {Promise}
       */

    }, {
      key: 'getAttGras',
      value: function getAttGras(major, minor, ids)
      {
        return Service.execute(this.url(), 'getattgras', { _major: major, _minor: minor, ids: ids })
      }

      /**
       * 根据主、子类型和id取图形表数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        实体的id
       * @returns {Promise}
       */

    }, {
      key: 'getGraph',
      value: function getGraph(major, minor, id)
      {
        return Service.execute(this.url(), 'getGraph', { _major: major, _minor: 0, id: id })
      }

      /**
       * 根据主、子类型和id取图形表数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {String}    ids                       实体的id序列，用逗号分割
       * @returns {Promise}
       */

    }, {
      key: 'getGraphs',
      value: function getGraphs(major, minor, ids)
      {
        return Service.execute(this.url(), 'getGraphs', { _major: major, _minor: 0, ids: ids })
      }

      /**
       * 取点对象的拓扑线图形数据序列
       * @static
       * @method
       * @param {Number}     major          实体主类型
       * @param {Number}     minor          实体子类型
       * @param {Number}     id             实体的id
       * @returns {Promise}
       */

    }, {
      key: 'getTopGraph',
      value: function getTopGraph(major, minor, id)
      {
        var paras = { _major: major, _minor: minor, id: id }
        return Service.execute(this.url(), 'getTopGraph', paras)
      }

      /**
       * 服务-一次添加多条记录
       * @static
       * @method
       * @param   {Object}  params                      参数
       * @param   {Number}  params._major               实体主类型
       * @param   {Number}  params._minor               实体子类型
       * @param   {Number}  params._rcdnum              记录数量
       * @param   {String}  [params.separator = ',']    分隔符,特殊情况下需设置
       * @returns {Promise}
       */

    }, {
      key: 'inserts',
      value: function inserts(params)
      {
        return Service.execute(this.url(), 'inserts', params)
      }

      /**
       * 查询(支持条件/分页/部分列/排序/自定义分隔符等)
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params._exp               SQL条件表达式，参数用?代替，如 'fld1 = ? and fld2 like ?'
       * @param   {String}    [params.cols]             需要取的列，默认取全部列（用,分隔）
       * @param   {String}    [params.types]            exp中有？时必传，参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    [params.vals]             exp中有？时必传，参数值，与_exp参数一一对应(用separator参数分隔)
       * @param   {String}    [params.orderby]          排序,默认不排序（降序 - fldname DESC, 升序 - fldname ASC）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'query',
      value: function query(params, cacheKey)
      {
        var _this = this

        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'query', params).then(function(ret)
        {
          if (cacheKey) _this.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 联合查询(支持条件/分页/部分列/排序/自定义分隔符/字段别名等)
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params.tables             联合查询的表名(例'a;b:5,7' 1.'a'代表主表别名(只有主表不需要指定主子类型) 2.'b:5,7'表别名b,对应的主类型5,子类型7)
       * @param   {String}    params._exp               SQL条件表达式(1.列名前需要带表别名;2.参数使用?代替))
       * @param   {String}    params.cols               需要取的列(例'a:*;b:fldb1,fldb2;c:fldc1 as TTT' 1.'a.*'代表a表的全部列;2.'b:fldb1,fldb2'代表b表的fldb1,fldb2字段;3.'c:fldc1 as TTT'代表c表的fldc1字段, 返回时用名字TTT)
       * @param   {String}    params.types              参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    params.vals               参数值(用,分隔)(与参数一一对应)
       * @param   {String}    [params.orderby]          排序（可以不传）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       * @example
       *    SQL:    select u.*,ud.organid from userdep ud,user1 u where ud.organid=123 and u.id=ud.userid
       *    tables: u;ud:99,123                         99,123-对应的是userdep主子类型
       *    _exp:   ud.organid=? and u.id=ud.userid
       *    vals:   123
       *    types:  i
       *    cols:   u:*;ud:organid as organid
       */

    }, {
      key: 'queryUnion',
      value: function queryUnion(params, cacheKey)
      {
        var _this2 = this

        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'queryUnion', params).then(function(ret)
        {
          if (cacheKey) _this2.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 范围查询-根据主、子类型查询实体图形
       * 如果gtype=1,2，则传入r ,通过缓冲区查询范围内的图形列表；如果gtype=4，则传入 gr；其他图形，gr与r都传0；
       * @static
       * @method
       * @param   {Object}   params             请求参数对象
       * @param   {Number}   params._major      实体主类型
       * @param   {Number}   params._minor      实体子类型
       * @param   {Number}   params.gtype       查询类型，1-点 2-线 3-矩形 4-多边形 5-圆
       * @param   {String}   [params.xy='']     查询范围，用逗号分隔的坐标序列（gtype=5）
       * @param   {Number}   [params.gr=0]      圆形半径，单位m（gtype=4）
       * @param   {Number}   [params.r=0]       缓冲区半径，单位m（gtype=1，2）
       * @returns {Promise}
       */

    }, {
      key: 'queryByRange',
      value: function queryByRange(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          gtype: 0,
          xy: '',
          gr: 0,
          r: 0
        }
        Base.extend(newParams, params)
        newParams._minor = 0
        return Service.execute(this.url(), 'queryByRange', newParams)
      }

      /**
       * 根据矩形范围查询实体图形
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             图形表主类型
       * @param   {Number}    params._minor             图形表子类型
       * @param   {String}    params.coor               坐标串，如：xmin,ymin,xmax,ymax
       * @param   {String}    [params.layer]            目标layer过滤序列
       * @returns {Promise}
       */

    }, {
      key: 'queryByWin',
      value: function queryByWin(params)
      {
        return Service.execute(this.url(), 'queryByWin', params)
      }

      /**
       * 根据条件查询空间实体数据
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             图形表主类型
       * @param   {Number}    params._minor             图形表子类型
       * @param   {String}    params._exp               SQL条件表达式，参数用?代替，如 'fld1 = ? and fld2 like ?'
       * @param   {String}    [params.cols]             需要取的列，默认取全部列（用,分隔）
       * @param   {String}    params.types              参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    params.vals               参数值，与_exp参数一一对应(用separator参数分隔)
       * @param   {String}    [params.orderby]          排序,默认不排序（降序 - fldname DESC, 升序 - fldname ASC）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {Number}    [params.geometry=1]       是否返回图形数据，1-返回，0-不返回
       * @param   {String}    [params.xy]               空间查询的范围坐标串，xy有值时开启空间查询模式，gtype必须要传
       * @param   {Number}    [params.gtype]            空间范围的几何对象类型，3-矩形，4-多边形，5-圆心半径圆，1-缓冲区圆
       * @param   {Number}    [params.gr=0]             圆形空间查询时的半径，gtype是圆时必须传
       * @param   {Number}    [params.r=0]              缓冲区圆半径，gtype是圆时必须传
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryGra',
      value: function queryGra(params)
      {
        params.geometry = params.geometry || 1
        params.gr = params.gr || 0
        params.r = params.r || 0

        return Service.execute(this.url(), 'queryGra', params)
      }

      /**
       * 根据条件查询空间实体数据,主表包含geom字段
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             图形表主类型
       * @param   {Number}    params._minor             图形表子类型
       * @param   {String}    params.tables             联合查询的表名(例'a;b:5,7' 1.'a'代表主表别名(只有主表不需要指定主子类型) 2.'b:5,7'表别名b,对应的主类型5,子类型7)
       * @param   {String}    params._exp               SQL条件表达式(1.列名前需要带表别名;2.参数使用?代替))
       * @param   {String}    params.cols               需要取的列(例'a:*;b:fldb1,fldb2;c:fldc1 as TTT' 1.'a.*'代表a表的全部列;2.'b:fldb1,fldb2'代表b表的fldb1,fldb2字段;3.'c:fldc1 as TTT'代表c表的fldc1字段, 返回时用名字TTT)
       * @param   {String}    params.types              参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    params.vals               参数值(用,分隔)(与参数一一对应)
       * @param   {String}    [params.orderby]          排序（可以不传）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {Number}    [params.geometry=1]       是否返回图形数据，1-返回，0-不返回
       * @param   {String}    [params.xy]               空间查询的范围坐标串，xy有值时开启空间查询模式，gtype必须要传
       * @param   {Number}    [params.gtype]            空间范围的几何对象类型，3-矩形，4-多边形，5-圆心半径圆，1-缓冲区圆
       * @param   {Number}    [params.gr=0]             圆形空间查询时的半径，gtype是圆时必须传
       * @param   {Number}    [params.r=0]              缓冲区圆半径，gtype是圆时必须传
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryUnionGra',
      value: function queryUnionGra(params)
      {
        params.geometry = params.geometry || 1
        params.gr = params.gr || 0
        params.r = params.r || 0

        return Service.execute(this.url(), 'queryUnionGra', params)
      }

      /**
       * 根据配置的自定义sql查询数据
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {String}    params.keyno              唯一编号名
       * @param   {String}    [params.vals]             sql中传入的值序列，与paratype配套使用，并与sqlstr中的条件？参数一一对应(用separator参数分隔)
       * @param   {String}    [params.exp]              替换sqlstr中的 @exp 字符串，如：'select qymajor from @exp'
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'querySql',
      value: function querySql(params, cacheKey)
      {
        var _this3 = this

        params._major = Consts.SYSTAB
        params._minor = Consts.TAB_USERSQL
        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }

        return Service.execute(this.url(), 'querySQL', params).then(function(ret)
        {
          if (cacheKey) _this3.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 取全部数据(内部调用query())
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Object}    [params]                  参数(除已给参数外，别的要求同query函数)
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryAll',
      value: function queryAll(major, minor, params, cacheKey)
      {
        var _this4 = this

        if (cacheKey)
        {
          var cached = this.getCache(major, minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'query', Base.extend({}, params, {
          _major: major,
          _minor: minor,
          _exp: 'id>?',
          types: 'i',
          vals: '0'
        })).then(function(ret)
        {
          if (cacheKey) _this4.putCache(major, minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 根据id取实体(主要用去取部分列)
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        实体id0
       * @param   {String}    [cols]                    列信息
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryId',
      value: function queryId(major, minor, id, cols, cacheKey)
      {
        var _this5 = this

        if (cacheKey)
        {
          var cached = this.getCache(major, minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'query', {
          _major: major,
          _minor: minor,
          _exp: 'id=?',
          types: 'i',
          vals: id,
          cols: cols
        }).then(function(ret)
        {
          if (cacheKey) _this5.putCache(major, minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 根据id0取所有实体
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id0                       实体id0
       * @param   {Object}    [params]                  参数(除已给参数外，别的要求同query函数)
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryId0',
      value: function queryId0(major, minor, id0, params, cacheKey)
      {
        var _this6 = this

        if (cacheKey)
        {
          var cached = this.getCache(major, minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'query', Base.extend({
          _major: major,
          _minor: minor,
          _exp: 'id0=?',
          types: 'i',
          vals: id0
        }, params)).then(function(ret)
        {
          if (cacheKey) _this6.putCache(major, minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 查询(支持条件/分页/部分列/排序/自定义分隔符等)
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {String}    exp                       表达式
       * @param   {String}    types                     参数类型
       * @param   {String}    vals                      值
       * @param   {Object}    [params]                  参数
       * @param   {String}    [params.orderby]          排序,默认不排序（降序 - fldname DESC, 升序 - fldname ASC）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryM',
      value: function queryM(major, minor, exp, types, vals, params, cacheKey)
      {
        var _this7 = this

        if (cacheKey)
        {
          var cached = this.getCache(major, minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'query', Base.extend({
          _major: major,
          _minor: minor,
          _exp: exp,
          types: types,
          vals: vals
        }, params)).then(function(ret)
        {
          if (cacheKey) _this7.putCache(major, minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 修改属性
       * @static
       * @method
       * @param   {Object}    params                    参数对象，要更新的属性添加到对象中
       * @param   {Number}    params._major             主类型
       * @param   {Number}    params._major             子类型
       * @param   {Number}    params.id                 实体ID
       * @param   {String}    [params.cols]             如果只想更新部分列，可以用这个参数指明需要更新的列名(,分隔)
       * @param   {Number}    [params.retAtt=0]         是否返回整条记录，0-不返回，1-返回
       * @example {_major: 1, _minor: 1, id: 1, fld: 'A', fldb: 'B'}
       * @returns {Promise}
       */

    }, {
      key: 'updateAtt',
      value: function updateAtt(params)
      {
        params.retAtt = params.retAtt || 0
        return Service.execute(this.url(), 'updateAtt', params)
      }

      /**
       * 修改多个属性
       * @static
       * @method
       * @param   {Object}    params                    参数，要更新的属性添加到对象中
       * @param   {Number}    params._major             主类型
       * @param   {Number}    params._major             子类型
       * @param   {String}    params.ids                需要更新的多个实体的ID串，用逗号','隔开
       * @param   {String}    [params.separator=',']    分割符
       * @param   {String}    [params.cols]             如果只想更新部分列，可以用这个参数指明需要更新的列名(,分隔)
       * @example {_major: 1, _minor: 1, ids: '1,2,3', separator: ',', fld1: '9,8,7', fld2: 'a,b,c'}
       * @returns {Promise}
       */

    }, {
      key: 'updateAtts',
      value: function updateAtts(params)
      {
        return Service.execute(this.url(), 'updateAtts', params)
      }

      /**
       * 根据主、子类型和id更新目标对象的属性和图形
       * @static
       * @method
       * @param {Number}     major          表主类型
       * @param {Number}     minor          表子类型
       * @param {Number}     id             对象id
       * @param {Object}     att            待添加的属性数据对象
       * @param {Object}     gra            待添加的属性数据对象
       * @param {Number}     [retAtt=0]     是否返回整条记录，0-不返回，1-返回
       * @returns {Promise}
       */

    }, {
      key: 'updAttGra',
      value: function updAttGra(major, minor, id, att, gra)
      {
        var retAtt = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0

        var paras = { _major: major, _minor: minor, id: id, retAtt: retAtt }
        Base.extend(paras, att, gra)
        return Service.execute(this.url(), 'updateAttGra', paras)
      }

      /**
       * 根据载体的实体id更新与它关联的设备坐标
       * @static
       * @method
       * @param {Number}     major          点图形表主类型
       * @param {Number}     minor          点图形表子类型
       * @param {Number}     id             载体对象id
       * @returns {Promise}
       */

    }, {
      key: 'updCoorByZt',
      value: function updCoorByZt(major, minor, id)
      {
        var paras = { _major: major, _minor: minor, ztid: id }
        return Service.execute(this.url(), 'updateZTCoor', paras)
      }

      /**
       * 根据主、子类型和id更新图形表的属性字段
       * @static
       * @method
       * @param {Number}     major          表主类型
       * @param {Number}     minor          表子类型
       * @param {Number}     id             对象id
       * @param {Object}     gra            待添加的属性数据对象
       * @returns {Promise}
       */

    }, {
      key: 'updGra',
      value: function updGra(major, minor, id, gra)
      {
        var paras = { _major: major, _minor: 0, id: id }
        Base.extend(paras, gra)
        return Service.execute(this.url(), 'updateGra', paras)
      }

      /**
       * 根据主、子类型和id批量更新图形表的属性字段
       * @static
       * @method
       * @param {Number}            major          图形表主类型
       * @param {Number}            minor          图形表子类型
       * @param {Array.<Object>}    gras           待更新的图形对象序列，每个对象至少保护id，和待更新的属性，坐标必须转为字符串。结果如: [{id: 1, st: 0, coor: '34.1,60.2'}, {}, ..]
       * @returns {Promise}
       */

    }, {
      key: 'updGras',
      value: function updGras(major, minor, gras)
      {
        var paras = { _major: major, _minor: minor, data: JSON.stringify(gras) }
        return Service.execute(this.url(), 'updateGras', paras)
      }
    }])
    return Area
  }())

  /**
   * @property {cx.CacheLru} cache       缓存对象
   */


  Area.cache = new CacheLru({
    limit: 1024
  })

  /**
   * cx.svr.area3
   * 空间基础服务-三维工作区
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-12-15
   */

  var Area3 = (function()
  {
    function Area3()
    {
      classCallCheck(this, Area3)
    }

    createClass(Area3, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('AreaSvr3')
      }

      /**
       * 缓存数据
       * @static
       * @method
       * @param   {Number}    major               实体主类型
       * @param   {Number}    minor               实体子类型
       * @param   {String}    cacheKey            缓存键
       * @param   {Object}    data                待缓存的数据
       * @returns {Object}                        this
       */

    }, {
      key: 'putCache',
      value: function putCache(major, minor, cacheKey, data)
      {
        if (cacheKey && data) this.cache.put(major + '_' + minor + '_' + cacheKey, data)
        return this
      }

      /**
       * 取缓存数据
       * @static
       * @method
       * @param   {Number}  major            实体主类型
       * @param   {Number}  minor            实体子类型
       * @param   {String}  cacheKey          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'getCache',
      value: function getCache(major, minor, cacheKey)
      {
        var cached = this.cache.get(major + '_' + minor + '_' + cacheKey)
        if (cached)
        {
          return new Promise(function(resolve)
          {
            resolve(cached)
          })
        }
        return null
      }

      /**
       * 根据主、子类型和id取图形表数据
       * @static
       * @method
       * @param   {Number}    major                     图形表主类型
       * @param   {Number}    minor                     图形表子类型
       * @param   {Number}    id                        实体的id
       * @returns {Promise}
       */

    }, {
      key: 'getGraph',
      value: function getGraph(major, minor, id)
      {
        return Service.execute(this.url(), 'getGraph', { _major: major, _minor: minor, id: id })
      }

      /**
       * 根据主、子类型和id取图形表数据
       * @static
       * @method
       * @param   {Number}    major                     图形表主类型
       * @param   {Number}    minor                     图形表子类型
       * @param   {Number}    ids                       实体的id序列，用逗号分割
       * @returns {Promise}
       */

    }, {
      key: 'getGraphs',
      value: function getGraphs(major, minor, ids)
      {
        return Service.execute(this.url(), 'getGraphs', { _major: major, _minor: minor, ids: ids })
      }

      /**
       * 根据主、子类型获取该类设备的唯一序号
       * @static
       * @method
       * @param {Number}     major          图形表主类型
       * @param {Number}     minor          图形表子类型
       * @returns {Promise}
       */

    }, {
      key: 'getSequence',
      value: function getSequence(major, minor)
      {
        return Service.execute(this.url(), 'getSequence', { _major: major, _minor: minor })
      }

      /**
       * 取点对象的拓扑线图形数据序列
       * @static
       * @method
       * @param {Number}     major          图形表主类型
       * @param {Number}     minor          图形表子类型
       * @param {Number}     id             实体的id
       * @returns {Promise}
       */

    }, {
      key: 'getTopGraph',
      value: function getTopGraph(major, minor, id)
      {
        var paras = { _major: major, _minor: minor, id: id }
        return Service.execute(this.url(), 'getTopGraph', paras)
      }

      /**
       * 获取目标对象的属性数据和图形数据
       * @static
       * @method
       * @param   {Number}    major                     图形表主类型
       * @param   {Number}    minor                     图形表子类型
       * @param   {Number}    id                        实体的id
       * @returns {Promise}
       */

    }, {
      key: 'getAttGra',
      value: function getAttGra(major, minor, id)
      {
        return Service.execute(this.url(), 'getAttGra', { _major: major, _minor: minor, id: id })
      }

      /**
       * 批量获取目标对象的属性数据和图形数据
       * @static
       * @method
       * @param   {Number}    major                     图形表主类型
       * @param   {Number}    minor                     图形表子类型
       * @param   {String}    ids                       实体的id序列，用逗号分割
       * @returns {Promise}
       */

    }, {
      key: 'getAttGras',
      value: function getAttGras(major, minor, ids)
      {
        return Service.execute(this.url(), 'getAttGras', { _major: major, _minor: minor, ids: ids })
      }

      /**
       * 服务-根据ID取属性
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params.id                 实体ID
       * @returns {Promise}
       */

    }, {
      key: 'getAtt',
      value: function getAtt(params)
      {
        return Service.execute(this.url(), 'getAtt', params)
      }

      /**
       * 查询(支持条件/分页/部分列/排序/自定义分隔符等)
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params._exp               SQL条件表达式，参数用?代替，如 'fld1 = ? and fld2 like ?'
       * @param   {String}    [params.cols]             需要取的列，默认取全部列（用,分隔）
       * @param   {String}    params.types              参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    params.vals               参数值，与_exp参数一一对应(用separator参数分隔)
       * @param   {String}    [params.orderby]          排序,默认不排序（降序 - fldname DESC, 升序 - fldname ASC）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'query',
      value: function query(params, cacheKey)
      {
        var _this = this

        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'query', params).then(function(ret)
        {
          if (cacheKey) _this.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 查询(支持条件/分页/部分列/排序/自定义分隔符等)
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {String}    exp                       表达式
       * @param   {String}    types                     参数类型
       * @param   {String}    vals                      值
       * @param   {Object}    params                    参数
       * @param   {String}    [params.orderby]          排序,默认不排序（降序 - fldname DESC, 升序 - fldname ASC）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryM',
      value: function queryM(major, minor, exp, types, vals, params, cacheKey)
      {
        var _this2 = this

        if (cacheKey)
        {
          var cached = this.getCache(major, minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'query', Base.extend({
          _major: major,
          _minor: minor,
          _exp: exp,
          types: types,
          vals: vals
        }, params)).then(function(ret)
        {
          if (cacheKey) _this2.putCache(major, minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 联合查询(支持条件/分页/部分列/排序/自定义分隔符/字段别名等)
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params.tables             联合查询的表名(例'a;b:5,7' 1.'a'代表主表别名(只有主表不需要指定主子类型) 2.'b:5,7'表别名b,对应的主类型5,子类型7)
       * @param   {String}    params._exp               SQL条件表达式(1.列名前需要带表别名;2.参数使用?代替))
       * @param   {String}    [params.cols]             需要取的列(例'a:*;b:fldb1,fldb2;c:fldc1 as TTT' 1.'a.*'代表a表的全部列;2.'b:fldb1,fldb2'代表b表的fldb1,fldb2字段;3.'c:fldc1 as TTT'代表c表的fldc1字段, 返回时用名字TTT)
       * @param   {String}    params.types              参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    params.vals               参数值(用,分隔)(与参数一一对应)
       * @param   {String}    [params.orderby]          排序（可以不传）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       * @example
       *    SQL:    select u.*,ud.organid from userdep ud,user1 u where ud.organid=123 and u.id=ud.userid
       *    tables: u;ud:99,123                         99,123-对应的是userdep主子类型
       *    _exp:   ud.organid=? and u.id=ud.userid
       *    vals:   123
       *    types:  i
       *    cols:   u:*;ud:organid as organid
       */

    }, {
      key: 'queryUnion',
      value: function queryUnion(params, cacheKey)
      {
        var _this3 = this

        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), 'queryUnion', params).then(function(ret)
        {
          if (cacheKey) _this3.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 向数据库添加一个实体，同时写入属性表和图形表，id会自动创建
       * @static
       * @method
       * @param   {Number}     major          实体主类型
       * @param   {Number}     minor          实体子类型
       * @param   {Object}     attData        实体的属性表数据
       * @param   {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'add',
      value: function add(major, minor, attData, graData)
      {
        var paras = { _major: major, _minor: minor, minor: minor }
        Base.extend(paras, attData, graData)
        return Service.execute(this.url(), 'add', paras)
      }

      /**
       * 向数据库添加一个点，同时写入属性表和图形表，id会自动创建
       * @static
       * @method
       * @param   {Number}     major          实体主类型
       * @param   {Number}     minor          实体子类型
       * @param   {Object}     attData        实体的属性表数据
       * @param   {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addPnt',
      value: function addPnt(major, minor, attData, graData)
      {
        var params = {
          _major: major,
          _minor: minor,
          minor: minor,
          map: 0,
          reg: 0,
          reg2: 0,
          zt: 0,
          zttyp: 0,
          ang: '0,0,0',
          scal: '1,1,1',
          tran: '0,0,0',
          lx: 0,
          typ: 0,
          len: 0,
          coora: '',
          note: '',
          a_coors: '',
          a_norms: '',
          a_ws: '',
          a_hs: ''
        }
        return Service.execute(this.url(), 'add', Base.extend(params, attData, graData))
      }

      /**
       * 向数据库添加一个线，同时写入属性表和图形表，id会自动创建
       * @static
       * @method
       * @param   {Number}     major          实体主类型
       * @param   {Number}     minor          实体子类型
       * @param   {Object}     attData        实体的属性表数据
       * @param   {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addLin',
      value: function addLin(major, minor, attData, graData)
      {
        var params = {
          _major: major,
          _minor: minor,
          minor: minor,
          map: 0,
          reg: 0,
          reg2: 0,
          ang: '0,0,0',
          scal: '1,1,1',
          tran: '0,0,0',
          typ: 0,
          note: ''
        }
        return Service.execute(this.url(), 'add', Base.extend(params, attData, graData))
      }

      /**
       * 向数据库添加一个图形，id会自动创建
       * @static
       * @method
       * @param   {Number}     major          实体主类型
       * @param   {Number}     minor          实体子类型
       * @param   {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addGra',
      value: function addGra(major, minor, graData)
      {
        var paras = { _major: major, _minor: minor, minor: minor }
        Base.extend(paras, graData)
        return Service.execute(this.url(), 'addGra', paras)
      }

      /**
       * 向数据库添加一个点图形，id会自动创建
       * @static
       * @method
       * @param   {Number}     major          实体主类型
       * @param   {Number}     minor          实体子类型
       * @param   {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addGraPnt',
      value: function addGraPnt(major, minor, graData)
      {
        var params = {
          _major: major,
          _minor: minor,
          minor: minor,
          map: 0,
          reg: 0,
          reg2: 0,
          zt: 0,
          zttyp: 0,
          ang: '0,0,0',
          scal: '1,1,1',
          tran: '0,0,0',
          lx: 0,
          typ: 0,
          len: 0,
          coora: '',
          note: '',
          a_coors: '',
          a_norms: '',
          a_ws: '',
          a_hs: ''
        }
        return Service.execute(this.url(), 'addGra', Base.extend(params, graData))
      }

      /**
       * 向数据库添加一个线图形，id会自动创建
       * @static
       * @method
       * @param   {Number}     major          实体主类型
       * @param   {Number}     minor          实体子类型
       * @param   {Object}     graData        实体的图形表数据
       * @returns {Promise}
       */

    }, {
      key: 'addGraLin',
      value: function addGraLin(major, minor, graData)
      {
        var params = {
          _major: major,
          _minor: minor,
          minor: minor,
          map: 0,
          reg: 0,
          reg2: 0,
          ang: '0,0,0',
          scal: '1,1,1',
          tran: '0,0,0',
          typ: 0,
          note: ''
        }
        return Service.execute(this.url(), 'addGra', Base.extend(params, graData))
      }

      /**
       * 添加属性
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Object}    att                       待添加的属性数据对象
       * @returns {Promise}
       */

    }, {
      key: 'addAtt',
      value: function addAtt(major, minor, att)
      {
        return Service.execute(this.url(), 'addAtt', Base.extend({ _major: major, _minor: minor }, att))
      }

      /**
       * 根据主、子类型和id删除数据。是空间对象时删除属性表和图形表数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        对象的id
       * @returns {Promise}
       */

    }, {
      key: 'del',
      value: function del(major, minor, id)
      {
        return Service.execute(this.url(), 'delete', { _major: major, _minor: minor, id: id })
      }

      /**
       * 根据主、子类型删除多条数据。是空间对象时删除属性表和图形表数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {String}    ids                       对象的id列表
       * @param   {String}    minors                    对象的minor列表
       * @returns {Promise}
       */

    }, {
      key: 'dels',
      value: function dels(major, minor, ids, minors)
      {
        return Service.execute(this.url(), 'deletes', { _major: major, _minor: minor, ids: ids, minors: minors })
      }

      /**
       * 根据主、子类型和id删除图形数据
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        对象的id
       * @returns {Promise}
       */

    }, {
      key: 'deleteGra',
      value: function deleteGra(major, minor, id)
      {
        return Service.execute(this.url(), 'deleteGra', { _major: major, _minor: minor, id: id })
      }

      /**
       * 修改图形
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        ID
       * @param   {Object}    params                    其他参数
       * @returns {Promise}
       */

    }, {
      key: 'updateGra',
      value: function updateGra(major, minor, id, params)
      {
        return Service.execute(this.url(), 'updateGra', Base.extend({ _major: major, _minor: 0, id: id }, params))
      }

      /**
       * 条件修改图形
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {String}    exp                       表达式
       * @param   {String}    types                     参数类型
       * @param   {String}    vals                      值
       * @param   {Object}    params                    其他参数
       * @returns {Promise}
       */

    }, {
      key: 'updateGraExp',
      value: function updateGraExp(major, minor, exp, types, vals, params)
      {
        return Service.execute(this.url(), 'updateGraExp', Base.extend({ _major: major, _minor: minor, _exp: exp, types: types, vals: vals }, params))
      }

      /**
       * 修改属性
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Object}    params                    其他参数
       * @returns {Promise}
       */

    }, {
      key: 'updateAtt',
      value: function updateAtt(major, minor, params)
      {
        return Service.execute(this.url(), 'updateAtt', Base.extend({ _major: major, _minor: minor }, params))
      }

      /**
       * 修改多个属性
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Object}    params                    其他参数
       * @returns {Promise}
       */

    }, {
      key: 'updateAtts',
      value: function updateAtts(major, minor, params)
      {
        return Service.execute(this.url(), 'updateAtts', Base.extend({ _major: major, _minor: minor }, params))
      }

      /**
       * 加锁
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        对象的id
       * @param   {Number}    lockid                    锁ID(一般情况可以用登录号)
       * @returns {Promise}
       */

    }, {
      key: 'lock',
      value: function lock(major, minor, id, lockid)
      {
        return Service.execute(this.url(), 'lock', { _major: major, _minor: minor, id: id, lockid: lockid })
      }

      /**
       * 解锁
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        对象的id
       * @param   {Number}    lockid                    锁ID(一般情况可以用登录号)
       * @returns {Promise}
       */

    }, {
      key: 'unlock',
      value: function unlock(major, minor, id, lockid)
      {
        return Service.execute(this.url(), 'unlock', { _major: major, _minor: minor, id: id, lockid: lockid })
      }

      /**
       * 取全部图形
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @returns {Promise}
       */

    }, {
      key: 'getAllGras',
      value: function getAllGras(major, minor, exp, types, vals, params)
      {
        return Service.execute(this.url(), 'getAllGras', { _major: major, _minor: minor })
      }

      /**
       * 条件查询图形
       * @static
       * @method
       * @param   {Object}    opts
       * @param   {Number}    opts._major                     实体主类型
       * @param   {Number}    opts._minor                     实体子类型
       * @param   {String}    opts._exp                       表达式
       * @param   {String}    opts.types                     参数类型
       * @param   {String}    opts.vals                      值
       * @param   {Object}    opts.params                    其他参数
       * @returns {Promise}
       */

    }, {
      key: 'queryGra',
      value: function queryGra(opts)
      {
        return Service.execute(this.url(), 'queryGra', Base.extend(opts, opts.params))
      }

      /**
       * 修改锚点信息
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Number}    id                        节点id
       * @param   {Object}    params                    其他参数
       * @param   {String}    [params.a_coors]          坐标（“;”分隔开多个数据）
       * @param   {String}    [params.a_norms]          法线（“;”分隔开多个数据）
       * @param   {String}    [params.a_ws]             宽度（“;”分隔开多个数据）
       * @param   {String}    [params.a_hs]             高度（“;”分隔开多个数据）
       * @returns {Promise}
       */

    }, {
      key: 'anchorsUpd',
      value: function anchorsUpd(major, minor, id, params)
      {
        return Service.execute(this.url(), 'anchorsUpd', Base.extend({ _major: major, _minor: minor, id: id }, params))
      }

      /**
       * 取多个点的锚点
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Object}    params                    参数
       * @param   {Number}    params.reg                区域
       * @param   {Number}    params.st                 状态
       * @returns {Promise}
       */

    }, {
      key: 'getAnchors',
      value: function getAnchors(major, minor, params)
      {
        return Service.execute(this.url(), 'getAnchors', Base.extend({ _major: major, _minor: minor }, params))
      }

      /**
       * 按照区域统计数量
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @returns {Promise}
       */

    }, {
      key: 'statCnt',
      value: function statCnt(major, minor)
      {
        return Service.execute(this.url(), 'statCnt', { _major: major, _minor: minor })
      }
    }])
    return Area3
  }())

  /**
   * @property {cx.CacheLru} cache       缓存对象
   */


  Area3.cache = new CacheLru({
    limit: 1024
  })

  /**
   * cx.svr.attOper
   * 类-属性处理操作
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-05-17
   */

  var AttOper = (function()
  {
    function AttOper()
    {
      classCallCheck(this, AttOper)
    }

    createClass(AttOper, null, [{
      key: 'insert',

      /**
       * 插入操作(不带ID)
       * @method
       * @static
       * @param   {Number}      major           主类型
       * @param   {Number}      minor           子类型
       * @param   {Object}      newAtt          插入数据对象
       * @param   {Number}      [retAtt = 0]    是否返回整条记录，0-不返回，1-返回
       * @returns {Promise}
       */
      value: function insert(major, minor, newAtt)
      {
        var retAtt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0

        return Area.add(major, minor, newAtt, retAtt).then(function(ret)
        {
          if (ret.ret === 0)
          {
            if (retAtt)
            {
              Base.extend(newAtt, ret)
              delete newAtt.ret
            }
            else newAtt.id = ret.id

            Events.publish('AttInsert', { major: major, minor: minor, id: ret.id, newAtt: retAtt ? ret : newAtt })
          }
          return ret
        })
      }

      /**
       * 插入操作(带ID)
       * @method
       * @static
       * @param   {Number}      major           主类型
       * @param   {Number}      minor           子类型
       * @param   {Object}      newAtt          插入数据对象
       * @param   {Number}      [retAtt = 0]    是否返回整条记录，0-不返回，1-返回
       * @returns {Promise}
       */

    }, {
      key: 'insertWithId',
      value: function insertWithId(major, minor, newAtt)
      {
        var retAtt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0

        return Area.addById(major, minor, newAtt).then(function(ret)
        {
          if (ret.ret === 0)
          {
            if (retAtt)
            {
              Base.extend(newAtt, ret)
              delete newAtt.ret
            }

            Events.publish('AttInsert', { major: major, minor: minor, id: ret.id, newAtt: retAtt ? ret : newAtt })
          }
          return ret
        })
      }

      /**
       * 插入操作
       * @method
       * @static
       * @param   {Number}      major           主类型
       * @param   {Number}      minor           子类型
       * @param   {Object}      newAtt          插入数据对象
       * @param   {Number}      [retAtt = 0]    是否返回整条记录，0-不返回，1-返回
       * @returns {Promise}
       */

    }, {
      key: 'insertWithFile',
      value: function insertWithFile(major, minor, newAtt)
      {
        var retAtt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0

        return Area.add(major, minor, newAtt).then(function(ret)
        {
          if (ret.ret === 0)
          {
            if (retAtt)
            {
              Base.extend(newAtt, ret)
              delete newAtt.ret
            }
            else newAtt.id = ret.id

            Events.publish('AttInsert', { major: major, minor: minor, id: ret.id, newAtt: newAtt })
          }
          return ret
        })
      }

      /**
       * 删除操作
       * @method
       * @static
       * @param   {Number}      major           主类型
       * @param   {Number}      minor           子类型
       * @param   {Object}      oldAtt          原始数据对象
       * @returns {Promise}
       */

    }, {
      key: 'del',
      value: function del(major, minor, oldAtt)
      {
        return Area.del(major, minor, oldAtt.id).then(function(ret)
        {
          if (ret.ret === 0) Events.publish('AttDelete', { major: major, minor: minor, id: oldAtt.id, oldAtt: oldAtt })
          return ret
        })
      }

      /**
       * 删除操作
       * @method
       * @static
       * @param   {Number}      major           主类型
       * @param   {Number}      minor           子类型
       * @param   {Object}      oldAtt          原始数据对象
       * @returns {Promise}
       */

    }, {
      key: 'delWithFile',
      value: function delWithFile(major, minor, oldAtt)
      {
        return Area.del(major, minor, oldAtt.id).then(function(ret)
        {
          if (ret.ret === 0) Events.publish('AttDelete', { major: major, minor: minor, id: oldAtt.id, oldAtt: oldAtt })
          return ret
        })
      }

      /**
       * 更新操作
       * @method
       * @static
       * @param   {Number}      major           主类型
       * @param   {Number}      minor           子类型
       * @param   {Object}      newAtt          插入数据对象
       * @param   {Object}      oldAtt          原始数据对象
       * @param   {Number}      [retAtt = 0]    是否返回整条记录，0-不返回，1-返回
       * @returns {Promise}
       */

    }, {
      key: 'update',
      value: function update(major, minor, newAtt, oldAtt)
      {
        var retAtt = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0

        var params = Base.extend({ _major: major, _minor: minor, id: oldAtt.id, retAtt: retAtt }, newAtt)

        return Area.updateAtt(params).then(function(ret)
        {
          if (ret.ret === 0)
          {
            if (retAtt)
            {
              Base.extend(newAtt, ret)
              delete newAtt.ret
            }

            Events.publish('AttUpdate', { major: major, minor: minor, id: oldAtt.id, newAtt: newAtt, oldAtt: oldAtt })
          }
          return ret
        })
      }
    }])
    return AttOper
  }())

  /**
   * cx.svr.feature
   * 服务-FileSvr 空间查询服务服务，针对entity表中type为12，13，14的图层要素表
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Feature = (function()
  {
    function Feature()
    {
      classCallCheck(this, Feature)
    }

    createClass(Feature, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('FeatureSvr')
      }

      /**
       * 缓存数据
       * @static
       * @method
       * @param   {Number}    major               实体主类型
       * @param   {Number}    minor               实体子类型
       * @param   {String}    cacheKey            缓存键
       * @param   {Object}    data                待缓存的数据
       * @returns {Object}                        this
       */

    }, {
      key: 'putCache',
      value: function putCache(major, minor, cacheKey, data)
      {
        if (cacheKey && data) this.cache.put(major + '_' + minor + '_' + cacheKey, data)
        return this
      }

      /**
       * 取缓存数据
       * @static
       * @method
       * @param   {Number}  major            实体主类型
       * @param   {Number}  minor            实体子类型
       * @param   {String}  cacheKey          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'getCache',
      value: function getCache(major, minor, cacheKey)
      {
        var cached = this.cache.get(major + '_' + minor + '_' + cacheKey)
        if (cached)
        {
          return new Promise(function(resolve)
          {
            resolve(cached)
          })
        }
        return null
      }

      /**
       * 根据属性条件和空间范围查询数据
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params._exp               SQL条件表达式，参数用?代替，如 'fld1 = ? and fld2 like ?'
       * @param   {String}    [params.cols]             需要取的列，默认取全部列（用,分隔）
       * @param   {String}    [params.types]            exp中有？时必传，参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    [params.vals]             exp中有？时必传，参数值，与_exp参数一一对应(用separator参数分隔)
       * @param   {String}    [params.orderby]          排序,默认不排序（降序 - fldname DESC, 升序 - fldname ASC）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {Number}    [params.geometry=0]       是否返回图形数据，1-返回，0-不返回
       * @param   {String}    [params.xy]               空间查询的范围坐标串，xy有值时开启空间查询模式，gtype必须要传
       * @param   {Number}    [params.gtype]            空间范围的几何对象类型，3-矩形，4-多边形，5-圆心半径圆，1-缓冲区圆
       * @param   {Number}    [params.gr=0]             圆形空间查询时的半径，gtype是圆时必须传
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'query',
      value: function query(params, cacheKey)
      {
        var _this = this

        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }

        params.geometry = params.geometry || 0
        params.gr = params.gr || 0
        return Service.execute(this.url(), 'query', params).then(function(ret)
        {
          if (cacheKey) _this.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 取全部数据(内部调用query())
       * @static
       * @method
       * @param   {Number}    major                     实体主类型
       * @param   {Number}    minor                     实体子类型
       * @param   {Object}    params                    参数(除已给参数外，别的要求同query函数)
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       */

    }, {
      key: 'queryAll',
      value: function queryAll(major, minor)
      {
        var _this2 = this

        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
        var cacheKey = arguments[3]

        if (cacheKey)
        {
          var cached = this.getCache(major, minor, cacheKey)
          if (cached) return cached
        }
        params.geometry = params.geometry || 0
        params.gr = params.gr || 0
        return Service.execute(this.url(), 'query', cx.base.extend({}, params, {
          _major: major,
          _minor: minor,
          _exp: 'id>?',
          types: 'i',
          vals: '0'
        })).then(function(ret)
        {
          if (cacheKey) _this2.putCache(major, minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 联合查询(支持条件/分页/部分列/排序/自定义分隔符/字段别名等)
       * @static
       * @method
       * @param   {Object}    params                    参数
       * @param   {Number}    params._major             实体主类型
       * @param   {Number}    params._minor             实体子类型
       * @param   {String}    params.tables             联合查询的表名(例'a;b:5,7' 1.'a'代表主表别名(只有主表不需要指定主子类型) 2.'b:5,7'表别名b,对应的主类型5,子类型7)
       * @param   {String}    params._exp               SQL条件表达式(1.列名前需要带表别名;2.参数使用?代替))
       * @param   {String}    [params.cols]             需要取的列(例'a:*;b:fldb1,fldb2;c:fldc1 as TTT' 1.'a.*'代表a表的全部列;2.'b:fldb1,fldb2'代表b表的fldb1,fldb2字段;3.'c:fldc1 as TTT'代表c表的fldc1字段, 返回时用名字TTT)
       * @param   {String}    [params.types]            exp中有？时必传，参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param   {String}    [params.vals]             exp中有？时必传，参数值，与_exp参数一一对应(用separator参数分隔)
       * @param   {String}    [params.orderby]          排序（可以不传）
       * @param   {String}    [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param   {String}    [params.init]             0/1  首次调用为0, 非第一次为1
       * @param   {String}    [params.pageno]           页码(1开始)
       * @param   {String}    [params.pagesize]         每页数据条数
       * @param   {Number}    [params.geometry=0]       是否返回图形数据，1-返回，0-不返回
       * @param   {String}    [cacheKey]                缓存键
       * @returns {Promise}
       * @example
       *    SQL:    select u.*,ud.organid from userdep ud,user1 u where ud.organid=123 and u.id=ud.userid
       *    tables: u;ud:99,123                         99,123-对应的是userdep主子类型
       *    _exp:   ud.organid=? and u.id=ud.userid and SDO_RELATE(ud.geom,u.geom,'MASK=ANYINTERACT QUERYTYPE=WINDOW')='TRUE'
       *    vals:   123
       *    types:  i
       *    cols:   u:*;ud:organid as organid
       */

    }, {
      key: 'queryUnion',
      value: function queryUnion(params, cacheKey)
      {
        var _this3 = this

        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }

        params.geometry = params.geometry || 0
        return Service.execute(this.url(), 'queryUnion', params).then(function(ret)
        {
          if (cacheKey) _this3.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 用oracle的sdo和根据简单图形 查询空间数据
       * @param {Object}            params                    参数对象
       * @param {Number}            params._major             实体主类型
       * @param {Number}            params._minor             实体子类型
       * @param {String}            [params._exp]             SQL条件表达式，参数用?代替，如 'fld1 = ? and fld2 like ?'
       * @param {String}            [params.cols]             需要取的列，默认取全部列（用,分隔）
       * @param {String}            [params.types]            exp中有？时必传，参数类型(用,分隔)(1/i/long-整数,2/r/double-实数,3/s/string-字符串,4/d/date-日期,5/t/datetime-日期时间)
       * @param {String}            [params.vals]             exp中有？时必传，参数值，与_exp参数一一对应(用separator参数分隔)
       * @param {String}            [params.orderby]          排序,默认不排序（降序 - fldname DESC, 升序 - fldname ASC）
       * @param {String}            [params.separator = ',']  数值中的分隔符（可以不传,默认是,）(考虑到字符串中可能有,可以设置特别分隔符)
       * @param {String}            [params.init]             0/1  首次调用为0, 非第一次为1
       * @param {String}            [params.pageno]           页码(1开始)
       * @param {String}            [params.pagesize]         每页数据条数
       * @param {Number}            [params.geometry=0]       是否返回图形数据，1-返回，0-不返回
       * @param {Object}            params.gra                图形对象
       * @param {Coordinates}       params.gra.coor           图形坐标串，与crs一致
       * @param {String}            params.gra.type           图形类型，Point\LineString\Polygon
       * @param {String}            params.gra.crs            图形的wkid投影值
       * @returns {Promise}                                   查询返回
       */

    }, {
      key: 'qryByAnyInteractSDO',
      value: function qryByAnyInteractSDO(params)
      {
        var geomExp = ''
        var opts = Object.assign({}, params)
        switch (opts.gra.type)
        {
        case 'Point':
          geomExp = 'SDO_GEOMETRY(2001,' + opts.gra.crs + ',MDSYS.SDO_POINT_TYPE(' + opts.gra.coor.toString() + ',NULL),NULL,NULL)'; break
        case 'LineString':
          geomExp = 'SDO_GEOMETRY(2002,' + opts.gra.crs + ',NULL,SDO_ELEM_INFO_ARRAY(1,2,1),SDO_ORDINATE_ARRAY(' + opts.gra.coor.toString() + '))'; break
        case 'Polygon':
          geomExp = 'SDO_GEOMETRY(2003,' + opts.gra.crs + ',NULL,SDO_ELEM_INFO_ARRAY(1,1003,1),SDO_ORDINATE_ARRAY(' + opts.gra.coor.toString() + '))'; break
        }
        delete opts.gra
        opts._exp = (opts._exp ? opts._exp + ' and ' : '') + ('SDO_RELATE(geom,' + geomExp + ',\'MASK=ANYINTERACT QUERYTYPE=WINDOW\')=\'TRUE\'')
        return cx.svr.feature.query(opts)
      }
    }])
    return Feature
  }())

  /**
   * @property {cx.CacheLru} cache       缓存对象
   */


  Feature.cache = new CacheLru({
    limit: 1024
  })

  /**
   * cx.svr.file
   * 服务-FileSvr 文件服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  /**
    * 修改记录:
    * 2020-07-15  张发勇    增加下载文件 download
    */

  var File$1 = (function()
  {
    function File$1()
    {
      classCallCheck(this, File$1)
    }

    createClass(File$1, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('FileSvr')
      }

      /**
       * 取DocGetSvr服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */

    }, {
      key: 'urlGet',
      value: function urlGet()
      {
        return Service.url('FileGetSvr')
      }

      /**
       * 服务-取指定目录下的所有目录及子目录
       * @static
       * @method
       * @param   {Object}  params          参数
       * @param   {String}  params.dir        指定目录(格式如: 'process/'，相当于 'web目录/process/')
       * @returns {Promise}
       */

    }, {
      key: 'getDirs',
      value: function getDirs(params)
      {
        return Service.execute(this.url(), 'getDirs', params)
      }

      /**
       * 服务-取指定目录下指定类型的文件，含子目录
       * @static
       * @method
       * @param   {Object}  params              参数
       * @param   {String}  params.dir          指定目录(格式如: 'process/'，相当于 'web目录/process/')
       * @param   {String}  params.types        文件类型(如 '*', 'docx', 'docx,doc')
       * @returns {Promise}
       */

    }, {
      key: 'getDirFiles',
      value: function getDirFiles(params)
      {
        return Service.execute(this.url(), 'getDirFiles', params)
      }

      /**
       * 服务-在服务器上创建目录
       * @static
       * @method
       * @param  {Object}  params          参数
       * @param  {String}  params.dir        待创建目录(格式如: 'process/leave/'，相当于 'web目录/process/leave/')
       * @returns {Promise}
       */

    }, {
      key: 'createDir',
      value: function createDir(params)
      {
        return Service.execute(this.url(), 'createDir', params)
      }

      /**
       * 服务-把内容存为文件
       * @static
       * @method
       * @param  {Object}    params              参数
       * @param  {String}    params.filename     文件名(格式如: 'process/leave/hr.html')
       * @param  {String}    params.content      文件内容
       * @returns {Promise}
       */

    }, {
      key: 'saveFile',
      value: function saveFile(params)
      {
        return Service.execute(this.url(), 'saveFile', params)
      }

      /**
       * 服务-在服务器上删除目录
       * @static
       * @method
       * @param  {Object}    params              参数
       * @param  {String}    params.dir          待删除的目录(格式如: 'process/leave/'，相当于 'web目录/process/leave/')
       * @returns {Promise}
       */

    }, {
      key: 'deleteDir',
      value: function deleteDir(params)
      {
        return Service.execute(this.url(), 'deleteDir', params)
      }

      /**
       * 服务-在服务器上删除文件
       * @static
       * @method
       * @param  {Object}    params              参数
       * @param  {String}    params.filename     文件名(格式如: 'process/leave/hr.html')
       * @returns {Promise}
       */

    }, {
      key: 'deleteFile',
      value: function deleteFile(params)
      {
        return Service.execute(this.url(), 'deleteFile', params)
      }

      /**
       * 通过ID(支持多个)下载原文件
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param  {String}     params.filename     文件名(格式如: 'process/leave/hr.html')
       * @param   {String}    [params.saveas]     另存为
       */

    }, {
      key: 'download',
      value: function download(params)
      {
        if (!params.saveas) params.saveas = File.getShortName(params.filename)
        Url.open(Url.getRequestUrl(this.urlGet(), Base.extend({ cmd: 'download' }, params)))
      }
    }])
    return File$1
  }())

  /**
   * cx.svr.identity
   * 服务-IdentitySvr 用户服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Identity = (function()
  {
    function Identity()
    {
      classCallCheck(this, Identity)
    }

    createClass(Identity, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('IdentitySvr')
      }

      /**
       * 缓存数据
       * @static
       * @method
       * @param   {String}    cmd                 命令
       * @param   {String}    cacheKey            缓存键
       * @param   {Object}    data                待缓存的数据
       * @returns {Object}                        this
       */

    }, {
      key: 'putCache',
      value: function putCache(cmd, cacheKey, data)
      {
        if (cacheKey && data) this.cache.put(cmd + '_' + cacheKey, data)
        return this
      }

      /**
       * 取缓存数据
       * @static
       * @method
       * @param   {String}    cmd                 命令
       * @param   {String}    cacheKey            缓存键
       * @returns {Promise}
       */

    }, {
      key: 'getCache',
      value: function getCache(cmd, cacheKey)
      {
        var cached = this.cache.get(cmd + '_' + cacheKey)
        if (cached)
        {
          return new Promise(function(resolve)
          {
            resolve(cached)
          })
        }
        return null
      }

      /**
       * 删除系统号为sys的用户被赋予的角色
       * @static
       * @method
       * @param   {int}       userid              用户id
       * @param   {int}       sys                 系统号
       * @returns {Promise}
       */

    }, {
      key: 'delUserRole',
      value: function delUserRole(userid, sys)
      {
        return Service.execute(this.url(), 'delUserRole', { userid: userid, sys: sys })
      }

      /**
       * 根据一个用户ID取用户所在的部门(0个或者多个部门)
       * @static
       * @method
       * @param   {Object}    params
       * @param   {int}       params.id           用户id
       * @param   {String}    [cacheKey]          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'userInOrgan',
      value: function userInOrgan(params, cacheKey)
      {
        var _this = this

        var cmd = 'userInOrgan'
        if (cacheKey)
        {
          var cached = this.getCache(cmd, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), cmd, params).then(function(ret)
        {
          if (cacheKey) _this.putCache(cmd, cacheKey, ret)
          return ret
        })
      }

      /**
       * 根据一个用户ID取用户所在的部门(0个或者多个部门)
       * @static
       * @method
       * @param   {int}       id                  用户id
       * @param   {String}    [cacheKey]          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'userInOrganM',
      value: function userInOrganM(id, cacheKey)
      {
        var _this2 = this

        var cmd = 'userInOrgan'
        if (cacheKey)
        {
          var cached = this.getCache(cmd, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), cmd, { id: id }).then(function(ret)
        {
          if (cacheKey) _this2.putCache(cmd, cacheKey, ret)
          return ret
        })
      }

      /**
       * 取指定组(1个或者多个)里面的所有成员
       * @static
       * @method
       * @param   {Object}    params
       * @param   {String}    params.no           组编码(多个之间用;分隔)
       * @param   {String}    [cacheKey]          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'memberOfGroup',
      value: function memberOfGroup(params, cacheKey)
      {
        var _this3 = this

        var cmd = 'memberOfGroup'
        if (cacheKey)
        {
          var cached = this.getCache(cmd, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), cmd, params).then(function(ret)
        {
          if (cacheKey) _this3.putCache(cmd, cacheKey, ret)
          return ret
        })
      }

      /**
       * 取指定组(1个或者多个)里面的所有成员
       * @static
       * @method
       * @param   {String}    no                  组编码(多个之间用;分隔)
       * @param   {String}    [cacheKey]          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'memberOfGroupM',
      value: function memberOfGroupM(no, cacheKey)
      {
        var _this4 = this

        var cmd = 'memberOfGroup'
        if (cacheKey)
        {
          var cached = this.getCache(cmd, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), cmd, { no: no }).then(function(ret)
        {
          if (cacheKey) _this4.putCache(cmd, cacheKey, ret)
          return ret
        })
      }

      /**
       * 取一个部门里面指定职位(1个或者多个)的用户
       * @static
       * @method
       * @param   {Object}    params
       * @param   {String}    params.no           部门编码
       * @param   {String}    params.position     职务(多个之间用;分隔)
       * @param   {String}    [cacheKey]          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'memberOfOrganPos',
      value: function memberOfOrganPos(params, cacheKey)
      {
        var _this5 = this

        var cmd = 'memberOfOrganPos'
        if (cacheKey)
        {
          var cached = this.getCache(cmd, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), cmd, params).then(function(ret)
        {
          if (cacheKey) _this5.putCache(cmd, cacheKey, ret)
          return ret
        })
      }

      /**
       * 取一个部门里面指定职位(1个或者多个)的用户
       * @static
       * @method
       * @param   {String}    no                  部门编码
       * @param   {String}    position            职务(多个之间用;分隔)
       * @param   {String}    [cacheKey]          缓存键
       * @returns {Promise}
       */

    }, {
      key: 'memberOfOrganPosM',
      value: function memberOfOrganPosM(no, position, cacheKey)
      {
        var _this6 = this

        var cmd = 'memberOfOrganPos'
        if (cacheKey)
        {
          var cached = this.getCache(cmd, cacheKey)
          if (cached) return cached
        }
        return Service.execute(this.url(), cmd, { no: no, position: position }).then(function(ret)
        {
          if (cacheKey) _this6.putCache(cmd, cacheKey, ret)
          return ret
        })
      }

      /**
       * 删除角色权限类型为当前type的旧数据
       * @static
       * @method
       * @param   {String}    roleid              角色id
       * @param   {String}    type                角色户的类型
       * @param   {String}    sys                 角色系统号
       * @returns {Promise}
       */

    }, {
      key: 'delRoleObj',
      value: function delRoleObj(roleid, type, sys)
      {
        return Service.execute(this.url(), 'delRoleObj', { roleid: roleid, type: type, sys: sys })
      }

      /**
       * 保持连接，避免超时
       * @static
       * @method
       * @returns {Promise}
       */

    }, {
      key: 'keepConn',
      value: function keepConn()
      {
        return Service.execute(this.url(), 'keepConn', {})
      }
    }])
    return Identity
  }())

  /** * @property {cx.CacheLru} cache       缓存对象*/

  Identity.cache = new CacheLru({
    limit: 256
  }) //缓存对象

  /**
   * cx.svr.login
   * 登录服务
   *
   * @class
   * @memberof    cx.svr
   * @author      zhang qing
   * @since       2018-07-02
   */

  var Login = (function()
  {
    function Login()
    {
      classCallCheck(this, Login)
    }

    createClass(Login, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                服务网址
       */
      value: function url()
      {
        return Service.url('LoginSvr')
      }

      /**
       * 服务-取在线用户列表
       * @static
       * @method
       * @param   {Object}    params      参数
       * @returns {Promise}
       */

    }, {
      key: 'getOlUsers',
      value: function getOlUsers(params)
      {
        return Service.execute(this.url(), 'getOlUsers', params)
      }

      /**
       * 服务-重置用户密码
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.userid       旧密码
       * @returns {Promise}
       */

    }, {
      key: 'reSetPsw',
      value: function reSetPsw(params)
      {
        params.userid = params.userid || $g.user.id

        return Service.execute(this.url(), 'reSetPsw', params)
      }

      /**
       * 服务-修改密码
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.oldpassword  旧密码
       * @param   {String}    params.newpassword  新密码
       * @returns {Promise}
       */

    }, {
      key: 'setPassword',
      value: function setPassword(params)
      {
        params.userid = $g.user.id

        return Service.execute(this.url(), 'setPsw', params)
      }

      /**
       * 服务-取用户登录信息
       * @static
       * @method
       * @param   {Object}    params      参数
       * @returns {Promise}
       */

    }, {
      key: 'userLog',
      value: function userLog(params)
      {
        return Service.execute(this.url(), 'userlog', params)
      }
    }])
    return Login
  }())

  /**
   * cx.svr.mail
   * 服务-MailSvr 邮件服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2019-04-09
   */

  var Mail = (function()
  {
    function Mail()
    {
      classCallCheck(this, Mail)
    }

    createClass(Mail, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('MailSvr')
      }

      /**
       * 服务-发送邮件
       * @static
       * @method
       * @param   {Object}    params              参数
       * @param   {String}    params.to           发送给(多个用,分隔开)
       * @param   {String}    [params.cc]         抄送(多个用,分隔开)
       * @param   {String}    [params.subject]    主题
       * @param   {String}    [params.content]    内容
       * @returns {Promise}
       */

    }, {
      key: 'sendMail',
      value: function sendMail(params)
      {
        return Service.execute(this.url(), 'semdMail', params)
      }
    }])
    return Mail
  }())

  /**
   * cx.svr.network
   * 空间网络拓扑服务
   * @class
   * @memberof    cx.svr
   * @author      zhang qing
   * @since       2018-07-02
   */

  var Network = (function()
  {
    function Network()
    {
      classCallCheck(this, Network)
    }

    createClass(Network, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}  服务网址
       */
      value: function url()
      {
        return Service.url('NetworkSvr')
      }

      /**
       * 求一个结点周围指定类型的点(第一层)
       * @static
       * @method
       * @param {Number}      pntMajor          实体主类型(点)
       * @param {Number}      pntMinor          实体子类型(点)
       * @param {Number}      pntId             点id
       * @param {String}      destPntMins       目标点子类型序列，用逗号分隔
       * @param {String}      endPntMins        是停止搜索的点子类型序列，用逗号分隔
       * @param {String}      maskLinIds        是停止搜索的线id序列，用逗号分隔
       * @param {String}      maskPntIds        是停止搜索的点id序列，用逗号分隔
       * @param {String}      invalid           无效点id序列，用逗号分隔
       * @returns {Promise}
       */

    }, {
      key: 'adjacent',
      value: function adjacent(pntMajor, pntMinor, pntId, destPntMins, endPntMins, maskLinIds, maskPntIds, invalid)
      {
        var paras = {
          _major: pntMajor,
          _minor: pntMinor,
          id: pntId,
          dest: destPntMins,
          end: endPntMins,
          maskLin: maskLinIds,
          maskPnt: maskPntIds,
          invalid: invalid
        }
        return Service.execute(this.url(), 'adjacent', paras)
      }

      /**
       * 根据主、子类型和id更新点对象的主子类型
       * @static
       * @method
       * @param {Number}      major             实体主类型
       * @param {Number}      minor             实体子类型
       * @param {Number}      id                实体的id
       * @param {Number}      tarMaj            新实体主类型
       * @param {Number}      tarMin            新实体子类型
       * @returns {Promise}
       */

    }, {
      key: 'cvtMajMin',
      value: function cvtMajMin(major, minor, id, tarMaj, tarMin)
      {
        var paras = { _major: major, _minor: minor, id: id, maj: tarMaj, min: tarMin }
        return Service.execute(this.url(), 'updpntminor', paras)
      }

      /**
       * 根据主、子类型和id批量更新点对象的主子类型
       * @static
       * @method
       * @param {Array.<Object>}      datas             待转换的实体对象序列，每个对象包含如下
       * @param {Number}              datas.major       实体主类型
       * @param {Number}              datas.minor       实体子类型
       * @param {Number}              datas.id          实体的id
       * @param {Number}              datas.maj         新实体主类型
       * @param {Number}              datas.min         新实体子类型
       * @returns {Promise}
       */

    }, {
      key: 'cvtMajMins',
      value: function cvtMajMins(datas)
      {
        datas = datas || []
        var paras = { _major: cx.major.POINT, _minor: 0, data: JSON.stringify(datas) }
        return Service.execute(this.url(), 'updpntminors', paras)
      }

      /**
       * 删除线和它的附属物
       * @static
       * @method
       * @param {Number}      major             实体主类型
       * @param {Number}      minor             实体子类型
       * @param {Number}      id                实体的id
       * @returns {Promise}
       */

    }, {
      key: 'delLin',
      value: function delLin(major, minor, id)
      {
        var paras = { _major: major, _minor: minor, id: id }
        return Service.execute(this.url(), 'dellin', paras)
      }

      /**
       * 删除点及拓扑线、附属物
       * @static
       * @method
       * @param {Number}      major             实体主类型
       * @param {Number}      minor             实体子类型
       * @param {Number}      id                实体的id
       * @returns {Promise}
       */

    }, {
      key: 'delPnt',
      value: function delPnt(major, minor, id)
      {
        var paras = { _major: major, _minor: minor, id: id }
        return Service.execute(this.url(), 'delpnt', paras)
      }

      /**
       * 删除面和它的附属物
       * @static
       * @method
       * @param {Number}      major             实体主类型
       * @param {Number}      minor             实体子类型
       * @param {Number}      id                实体的id
       * @returns {Promise}
       */

    }, {
      key: 'delPol',
      value: function delPol(major, minor, id)
      {
        var paras = { _major: major, _minor: minor, id: id }
        return Service.execute(this.url(), 'delpol', paras)
      }

      /**
       * 修改线的拓扑关系,把连接到一个点上的线，移动连接到另一个点上
       * @static
       * @method
       * @param {Number}      linMajor          实体主类型(线)
       * @param {Number}      linMinor          实体子类型(线)
       * @param {Number}      linId             线id
       * @param {String}      destMinor         目标点子类型序列，用逗号分隔
       * @param {String}      invalid           无效点id序列，用逗号分隔
       * @returns {Promise}
       */

    }, {
      key: 'explosion',
      value: function explosion(linMajor, linMinor, linId, destMinor, invalid)
      {
        var paras = {
          _major: linMajor,
          _minor: linMinor,
          id: linId,
          dest: destMinor,
          invalid: invalid
        }
        return Service.execute(this.url(), 'explosion', paras)
      }

      /**
       * 取点对象的拓扑线的信息数据，返回拓扑线信息对象数组 [{id:127017,minor:2,fntid:158310,talid:158311},{}..]
       * @static
       * @method
       * @param {Number}      major             实体主类型
       * @param {Number}      minor             实体子类型
       * @param {Number}      id                点对象的id
       * @returns {Promise}
       */

    }, {
      key: 'getPntTop',
      value: function getPntTop(major, minor, id)
      {
        var paras = { _major: major, _minor: 0, id: id }
        return Service.execute(this.url(), 'getpnttop', paras)
      }

      /**
       * 取点对象拓扑线的图形和属性数据序列
       * @static
       * @method
       * @param {Number}     major          图形表主类型
       * @param {Number}     minor          图形表子类型
       * @param {Number}     id             实体的id
       * @returns {Promise}
       */

    }, {
      key: 'getPntTopAttGra',
      value: function getPntTopAttGra(major, minor, id)
      {
        var paras = { _major: major, _minor: minor, id: id }
        return Service.execute(this.url(), 'getTopAttGraph', paras)
      }

      /**
       * 移动点及拓扑线的坐标
       * @static
       * @method
       * @param {Number}      major             实体主类型
       * @param {Number}      minor             实体子类型
       * @param {Number}      id                实体id
       * @param {String}      coor              新的坐标序列，"x,y"
       * @returns {Promise}
       */

    }, {
      key: 'movPnt',
      value: function movPnt(major, minor, id, coor)
      {
        var paras = { _major: major, _minor: minor, id: id, coor: coor }
        return Service.execute(this.url(), 'movpnt', paras)
      }

      /**
       * 横断面分析
       * @static
       * @method
       * @param {Number}      lineMajor         线主类型
       * @param {String}      start             x,y
       * @param {String}      end               x,y
       * @returns {Promise}
       */

    }, {
      key: 'sectionCross',
      value: function sectionCross(lineMajor, start, end)
      {
        var paras = {
          _major: lineMajor,
          _minor: 0,
          start: start,
          end: end
        }
        return Service.execute(this.url(), 'sectioncross', paras)
      }

      /**
       * 求两点间最短路径
       * @static
       * @method
       * @param {Number}      pntMajor          点主类型
       * @param {Number}      pntid1            点id
       * @param {Number}      pntid2            点id
       * @param {Number}      [retAtt=0]        是否范围路径上的属性，1时返回
       * @returns {Promise}
       */

    }, {
      key: 'shortestPath',
      value: function shortestPath(pntMajor, pntid1, pntid2, retAtt)
      {
        var paras = {
          _major: pntMajor,
          _minor: 0,
          pnt1: pntid1,
          pnt2: pntid2,
          retAtt: retAtt || 0
        }
        return Service.execute(this.url(), 'shortestpath', paras)
      }

      /**
       * 批量修改实体的图形和属性数据
       * @static
       * @method
       * @param {Array.<Object>}      attList             待更新属性对象序列,每个对象中必须包含major,minor,id,支持同时修改属性表和图形表
       * @returns {Promise}
       */

    }, {
      key: 'updatesByJosn',
      value: function updatesByJosn(attList)
      {
        var paras = { _major: cx.major.POINT, _minor: 0, json: JSON.stringify(attList) }
        return Service.execute(this.url(), 'updatesByJosn', paras)
      }

      /**
       * 修改线的拓扑关系,把连接到一个点上的线，移动连接到另一个点上
       * @static
       * @method
       * @param {Number}      major             线实体主类型
       * @param {Number}      minor             线实体子类型
       * @param {String}      line              待更新的线数据,格式："id1,fntid,talid;id2,fntid,talid;.."
       * @param {Number}      oldid             更新前线的老点id
       * @param {Number}      newid             更新后线的新点id
       * @param {Number}      [delpnt=0]        是否删除旧点,0不删除，非0删除
       * @returns {Promise}
       */

    }, {
      key: 'updTopLin',
      value: function updTopLin(major, minor, line, oldid, newid)
      {
        var delpnt = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0

        var paras = {
          _major: major,
          _minor: 0,
          line: line,
          oldid: oldid,
          newid: newid,
          delpnt: delpnt
        }
        return Service.execute(this.url(), 'updTopLin', paras)
      }
    }])
    return Network
  }())

  /**
   * cx.svr.network3
   * 空间三维网络拓扑服务
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2019-01-06
   */

  var Network3 = (function()
  {
    function Network3()
    {
      classCallCheck(this, Network3)
    }

    createClass(Network3, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}  服务网址
       */
      value: function url()
      {
        return Service.url('Network3Svr')
      }

      /**
       * 删除点及拓扑线、附属物
       * @static
       * @method
       * @param   {Number}    major             实体主类型
       * @param   {Number}    minor             实体子类型
       * @param   {Number}    id                实体的id
       * @returns {Promise}
       */

    }, {
      key: 'delPnt',
      value: function delPnt(major, minor, id)
      {
        return Service.execute(this.url(), 'delPnt', { _major: major, _minor: minor, id: id })
      }

      /**
       * 删除多个点、线
       * @static
       * @method
       * @param   {Number}    major             点实体主类型
       * @param   {String}    majors            实体主类型(用","分隔)
       * @param   {String}    minors            实体子类型(用","分隔)
       * @param   {String}    ids               实体ID(用","分隔)
       * @returns {Promise}
       */

    }, {
      key: 'dels',
      value: function dels(major, majors, minors, ids)
      {
        return Service.execute(this.url(), 'dels', { _major: major, majors: majors, minors: minors, ids: ids })
      }

      /**
       * 取点对象的拓扑线的信息数据，返回拓扑线信息对象数组
       * @static
       * @method
       * @param   {Number}    major             点图形表主类型
       * @param   {Number}    id                点对象的id
       * @returns {Promise}
       */

    }, {
      key: 'getPntTop',
      value: function getPntTop(major, id)
      {
        return Service.execute(this.url(), 'getPntTop', { _major: major, id: id })
      }

      /**
       * 取多点对象的拓扑线的信息数据
       * @static
       * @method
       * @param   {Number}    major             点图形表主类型
       * @param   {String}    ids               点实体ID(用","分隔)
       * @returns {Promise}
       */

    }, {
      key: 'getPntTops',
      value: function getPntTops(major, ids)
      {
        return Service.execute(this.url(), 'getPntTops', { _major: major, ids: ids })
      }
      /**
       * 批量添加
       * @static
       * @method
       * @param   {String}    pnts             点图形对象
       * @param   {String}    lins             线图形对象
       * @returns {Promise}
       */

    }, {
      key: 'addsBatch',
      value: function addsBatch(pnts, lins)
      {
        return Service.execute(this.url(), 'addsBatch', { _major: 11, pnts: pnts, lins: lins })
      }
    }])
    return Network3
  }())

  /**
   * cx.svr.stat
   * 统计服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-07-02
   */

  var Statistic = (function()
  {
    function Statistic()
    {
      classCallCheck(this, Statistic)
    }

    createClass(Statistic, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}  服务网址
       */
      value: function url()
      {
        return Service.url('StatisticSvr')
      }
      /**
       * 实体操作查询-根据主、子类型查询预警
       * @static
       * @method
       * @param {Object}     params             请求参数对象
       * @param {Number}     params._major      实体表主类型
       * @param {Number}     params._minor      实体表子类型
       * @param {Number}     params.exp         查询类型，1-根据用户名，2-根据图层名
       * @param {Number}     params.init        是否第一次调用，0是第一次查询
       * @param {Number}     params.pagesize    分页后一页数据量
       * @param {Number}     params.pageno      页码
       * @returns {Promise}
       */

    }, {
      key: 'alarmstat',
      value: function alarmstat(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          exp: 0,
          init: 0,
          pagesize: Consts.PAGE_SIZE,
          pageno: 1
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'alarmstat', newParams)
      }

      /**
       * 实体操作查询-根据主、子类型查询实体的操作类型
       * @static
       * @method
       * @param {Object}     params             请求参数对象
       * @param {Number}     params._major      实体表主类型
       * @param {Number}     params._minor      实体表子类型
       * @param {Number}     params.sqltype     查询类型，1-根据用户名，2-根据图层名
       * @param {Number}     params.init        是否第一次调用，0是第一次查询
       * @param {Number}     params.pagesize    分页后一页数据量
       * @param {Number}     params.pageno      页码
       * @returns {Promise}
       */

    }, {
      key: 'entLogstat',
      value: function entLogstat(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          sqltype: 0,
          init: 0,
          pagesize: Consts.PAGE_SIZE,
          pageno: 1
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'entlogstat', newParams)
      }

      /**
       * 根据主、子类型和ids取对象的附属物数据
       * @static
       * @method
       * @param   {Object}    params            请求参数对象
       * @param   {Number}    params._major     主类型
       * @param   {Number}    params._minor     数据表子类型
       * @param   {String}    params.ids        对象的id字符串序列，用逗号分隔
       * @returns {Promise}
       */

    }, {
      key: 'getAttach',
      value: function getAttach(params)
      {
        //{_major: major, _minor: minor, ids: id}
        return Service.execute(this.url(), 'getattachs', params)
      }

      /**
       * 缓冲区查询-根据主、子类型查询某种实体的的数量
       * @static
       * @method
       * @param   {Object}   params             请求参数对象
       * @param   {Number}   params._major      实体主类型
       * @param   {Number}   params._minor      实体子类型
       * @param   {Number}   params.layer       实体所在图层号
       * @param   {Number}   params.gtype       查询类型，1-点，2-线
       * @param   {String}   params.xy          查询范围，用逗号分隔的坐标序列
       * @param   {Number}   params.r           缓冲区半径，单位m
       * @param   {String}   params.regids      查询区域id序列,非区域模式是"0"，区域模式且无权限时"-1"
       * @param   {Number}   params.init        是否第一次调用，0是第一次查询
       * @param   {Number}   params.pagesize    分页后一页数据量
       * @param   {Number}   params.pageno      页码
       * @returns {Promise}
       */

    }, {
      key: 'queryBuffer',
      value: function queryBuffer(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          layer: 0,
          gtype: 0,
          xy: '',
          gr: 0,
          r: 0,
          regids: '0',
          init: 0,
          pagesize: Consts.PAGE_SIZE,
          pageno: 1
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'querybybuffer', newParams)
      }

      /**
       * 根据主、子类型和范围取该类实体的数量及信息
       * @static
       * @method
       * @param   {Object}    params            请求参数对象
       * @param   {Number}    params._major     实体主类型
       * @param   {Number}    params._minor     实体子类型
       * @param   {Number}    params.layer      实体所在图层号
       * @param   {String}    params.gtype      查询类型，3-矩形，4-多边形，5-圆心半径圆，1-缓冲区圆
       * @param   {String}    params.xy         查询范围，用逗号分隔的坐标序列
       * @param   {String}    params.gr         圆形——半径
       * @param   {String}    params.r          缓冲区——半径
       * @param   {String}    params.regids     查询区域id序列,非区域模式是"0"，区域模式且无权限时"-1"
       * @param   {Number}    params.init       是否第一次调用，0是第一次查询
       * @param   {Number}    params.pagesize   分页后一页数据量
       * @param   {Number}    params.pageno     页码
       * @returns {Promise}
       */

    }, {
      key: 'queryRange',
      value: function queryRange(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          layer: 0,
          gtype: 0,
          xy: '',
          gr: 0,
          r: 0,
          regids: '0',
          init: 0,
          pagesize: Consts.PAGE_SIZE,
          pageno: 1
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'querybyrange', newParams)
      }

      /**
       * 范围查询-根据主、子类型查询实体
       * @static
       * @method
       * @param   {Object}   params             请求参数对象
       * @param   {Number}   params._major      实体主类型
       * @param   {Number}   params._minor      实体子类型
       * @param   {Number}   params.gtype       查询类型，1-点，2-线
       * @param   {String}   params.xy          查询范围，用逗号分隔的坐标序列
       * @param   {Number}   params.r           缓冲区半径，单位m
       * @returns {Promise}
       */

    }, {
      key: 'rangequery',
      value: function rangequery(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          gtype: 0,
          xy: '',
          gr: 0,
          r: 0
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'rangequery', newParams)
      }

      /**
       * 按类别统计缓冲区内的数据
       * @static
       * @method
       * @param   {Object}    params            请求参数对象
       * @param   {Number}    params._major     实体主类型
       * @param   {Number}    params._minor     实体子类型
       * @param   {Number}    params.gtype      缓冲区类型，1-点，2-线
       * @param   {String}    params.xy         查询范围，用逗号分隔的坐标序列
       * @param   {Number}    params.r          缓冲区半径，单位m
       * @param   {String}    params.regids     查询区域id序列,非区域模式是"0"，区域模式且无权限时"-1"
       * @returns {Promise}
       */

    }, {
      key: 'statBuffer',
      value: function statBuffer(params)
      {
        return this.statBufferAll(params)
      }

      /**
       * 统计缓冲区内的全部数据
       * @static
       * @method
       * @param   {Object}    params            请求参数对象
       * @param   {Number}    params.gtype      缓冲区类型，1-点，2-线
       * @param   {String}    params.xy         查询范围，用逗号分隔的坐标序列
       * @param   {Number}    params.r          缓冲区半径，单位m
       * @param   {String}    params.regids     查询区域id序列,非区域模式是"0"，区域模式且无权限时"-1"
       * @returns {Promise}
       */

    }, {
      key: 'statBufferAll',
      value: function statBufferAll(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          gtype: 0,
          xy: '',
          gr: 0,
          r: 0,
          regids: '0'
        }

        Base.extend(newParams, params)
        return Service.execute(this.url(), 'bufferstat', newParams)
      }

      /**
       * 根据范围、统计分组、条件表达式统计实体
       * @static
       * @method
       * @param   {Object}    params            请求参数对象
       * @param   {Number}    params._major     实体主类型
       * @param   {Number}    params._minor     实体子类型
       * @param   {String}    params.gtype      查询类型，3-矩形，4-多边形，1-缓冲区圆
       * @param   {String}    params.xy         查询范围，用逗号分隔的坐标序列
       * @param   {String}    params.r          缓冲区半径
       * @param   {String}    params.group      统计分组字段，用逗号分隔的字段名
       * @param   {String}    params.exp        条件表达式
       * @param   {String}    params.regids     查询区域id序列,非区域模式是"0"，区域模式且无权限时"-1"
       * @param   {Number}    params.detail     是否取详细属性
       * @returns {Promise}
       */

    }, {
      key: 'statEntity',
      value: function statEntity(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          gtype: 0,
          xy: '',
          r: 0,
          gr: 0,
          group: '',
          exp: '',
          regids: '0',
          detail: 0,
          init: 0,
          pageno: 1,
          pagesize: Consts.PAGE_SIZE
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'entitystat', newParams)
      }

      /**
       * 根据范围统计实体类型
       * @static
       * @method
       * @param   {Object}    params            请求参数对象
       * @param   {Number}    params._major     实体主类型
       * @param   {Number}    params._minor     实体子类型
       * @param   {String}    params.gtype      查询类型，3-矩形，4-多边形，5-圆心半径圆，1-缓冲区圆
       * @param   {String}    params.xy         查询范围，用逗号分隔的坐标序列
       * @param   {String}    params.gr         圆形半径
       * @param   {String}    params.r          缓冲区半径
       * @param   {String}    params.regids     查询区域id序列,非区域模式是"0"，区域模式且无权限时"-1"
       * @returns {Promise}
       */

    }, {
      key: 'statRange',
      value: function statRange(params, cacheKey)
      {
        var _this = this

        if (cacheKey)
        {
          var cached = this.getCache(params._major, params._minor, cacheKey)
          if (cached) return cached
        }
        return this.statRangeAll(params).then(function(ret)
        {
          if (cacheKey) _this.putCache(params._major, params._minor, cacheKey, ret)
          return ret
        })
      }

      /**
       * 统计范围区内的全部数据
       * @static
       * @method
       * @param   {Object}    params            请求参数对象
       * @param   {String}    params.gtype      查询类型，3-矩形，4-多边形，5-圆心半径圆，1-缓冲区圆
       * @param   {String}    params.xy         查询范围，用逗号分隔的坐标序列
       * @param   {String}    params.gr         圆形半径
       * @param   {String}    params.r          缓冲区半径
       * @param   {String}    params.regids     查询区域id序列,非区域模式是"0"，区域模式且无权限时"-1"
       * @returns {Promise}
       */

    }, {
      key: 'statRangeAll',
      value: function statRangeAll(params)
      {
        var newParams = {
          _major: 0,
          _minor: 0,
          gtype: 0,
          xy: '',
          gr: 0,
          r: 0,
          regids: '0'
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'rangestat', newParams)
      }

      /**
       * 工单统计
       * @static
       * @method
       * @param   {Object}    params                 请求参数对象
       * @param   {Number}    params._major          工单表主类型
       * @param   {Number}    params._minor          工单表子类型
       * @param   {Number}    params.userid          统计的目标用户
       * @param   {Number}    [params.isadmin=0]     该用户是否管理员,0-否，1-是
       * @returns {Promise}
       */

    }, {
      key: 'statTicket',
      value: function statTicket(params)
      {
        params.isadmin = params.isadmin || 0
        return Service.execute(this.url(), 'ticketstat', params)
      }
    }])
    return Statistic
  }())

  /**
   * cx.svr.dataCheck
   * 数据检查服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-07-02
   */

  var DataCheck = (function()
  {
    function DataCheck()
    {
      classCallCheck(this, DataCheck)
    }

    createClass(DataCheck, null, [{
      key: 'assetBackup',

      /**
       * 对编辑对象资产管理
       * @static
       * @method
       * @param {Number}     major            操作对象的主类型
       * @param {Number}     minor            操作对象的子类型
       * @param {Number}     id               操作对象的id
       * @param {Number}     prjId            当前编辑工单的id
       * @param {Number}     type             操作的类型
       * @example
       *    type值和实际含义
       *    1    cut            NetwPntAddOnLin
       *    2    merge          NetwPntMerge
       *    3    move           NetwPntMdfCoor    NetwPntMov
       *    4    del            NetwPntDel
       *    5    updAtt         InfoControl
       *    6    mergeLin       NetwLinMerge
       * @param {String}     flds             属性编辑操作时，修改的字段名序列，用逗号分隔
       * @returns {Promise}
       */
      value: function assetBackup(major, minor, id, prjId, type, flds)
      {
        var para = {
          _major: major,
          _minor: minor,
          id: id,
          prj: prjId,
          flds: flds,
          type: type
        }
        return Service.execute(this.url(), 'assetbackup', para)
      }
      /**
       * 根据工单id资产数据更新，更新成功的资产数据就从库中删除
       * @static
       * @method
       * @param {Number}     prjId            待更新资产所属的工单id
       * @returns {Promise}
       */

    }, {
      key: 'assetUpdate',
      value: function assetUpdate(prjId)
      {
        var para = { _major: 1, _minor: 0, prj: prjId }
        return Service.execute(this.url(), 'assetupdate', para)
      }

      /**
       * 根据工单id删除tabname中的表中所关联的数据。
       * @static
       * @method
       * @param {Number}     prjId            待更新资产所属的工单id
       * @param {String}     tabname          需要操作删除数据的表，多个表中间用,号隔开。如'imptabp,imptabl'
       * @returns {Promise}
       */

    }, {
      key: 'delprjdata',
      value: function delprjdata(prjId, tabname)
      {
        var para = { _major: 5, _minor: 6, prj: prjId, tabname: tabname }
        return Service.execute(this.url(), 'delprjdata', para)
      }

      /**
       * 根据工单id检查导入中间点表的数据
       * @static
       * @method
       * @param {Number}     prjId            待检查的点表中间表数据关联的工单id
       * @param {String}     regids           当前用户拥有权限的区域id串
       * @returns {Promise}
       */

    }, {
      key: 'impCheckPnt',
      value: function impCheckPnt(prjId, regids)
      {
        var para = { _major: 5, _minor: 5, prj: prjId }
        if (regids !== undefined) para.regids = regids
        return Service.execute(this.url(), 'impcheckpoint', para)
      }

      /**
       * 根据工单id检查导入中间线表的数据
       * @static
       * @method
       * @param {Number}     prjId            待检查的线表中间表数据关联的工单id
       * @param {String}     regids           当前用户拥有权限的区域id串
       * @returns {Promise}
       */

    }, {
      key: 'impCheckLin',
      value: function impCheckLin(prjId, regids)
      {
        var para = { _major: 5, _minor: 6, prj: prjId }
        if (regids !== undefined) para.regids = regids
        return Service.execute(this.url(), 'impcheckline', para)
      }

      /**
       * CAD点表数据检查 - 根据工单id检查导入CAD中间点表的数据
       * @static
       * @method
       * @param {Number}     prjId            待检查的CAD点表中间表数据关联的工单id
       * @param {String}     regids           当前用户拥有权限的区域id串
       * @returns {Promise}
       */

    }, {
      key: 'impCadCheckPoint',
      value: function impCadCheckPoint(prjId, regids)
      {
        var para = { _major: 5, _minor: 10, prj: prjId }
        if (regids !== undefined) para.regids = regids
        return Service.execute(this.url(), 'impcadcheckpoint', para)
      }

      /**
       * CAD线表数据检查 - 根据工单id检查导入CAD中间线表的数据
       * @static
       * @method
       * @param {Number}     prjId            待检查的CAD线表中间表数据关联的工单id
       * @param {String}     regids           当前用户拥有权限的区域id串
       * @returns {Promise}
       */

    }, {
      key: 'impCadCheckLine',
      value: function impCadCheckLine(prjId, regids)
      {
        var para = { _major: 5, _minor: 11, prj: prjId }
        if (regids !== undefined) para.regids = regids
        return Service.execute(this.url(), 'impcadcheckline', para)
      }

      /**
       * 辅助点表数据检查 - 根据工单id检查导入辅助点中间表的数据
       * @static
       * @method
       * @param {Number}     prjId            待检查的辅助点中间表数据关联的工单id
       * @param {String}     regids           当前用户拥有权限的区域id串
       * @returns {Promise}
       */

    }, {
      key: 'impFzdCheckPoint',
      value: function impFzdCheckPoint(prjId, regids)
      {
        var para = { _major: 5, _minor: 16, prj: prjId }
        if (regids !== undefined) para.regids = regids
        return Service.execute(this.url(), 'impfzdcheckpoint', para)
      }

      /**
       * CAD导入点 - 根据工单id将CAD点表中间表数据导入正式表
       * @static
       * @method
       * @param {Number}     prjId            待导入的CAD点表中间表数据关联的工单id
       * @returns {Promise}
       */

    }, {
      key: 'impCadPoint',
      value: function impCadPoint(prjId)
      {
        var para = { _major: 5, _minor: 10, prj: prjId, flag: 0 }
        return Service.execute(this.url(), 'impcadpoint', para)
      }

      /**
       * CAD导入线 - 根据工单id将CAD线表中间表数据导入正式表。
       * @static
       * @method
       * @param {Number}     prjId            待导入的CAD线表中间表数据关联的工单id
       * @returns {Promise}
       */

    }, {
      key: 'impCadLine',
      value: function impCadLine(prjId)
      {
        var para = { _major: 5, _minor: 11, prj: prjId, flag: 0 }
        return Service.execute(this.url(), 'impcadline', para)
      }

      /**
       * 辅助点导入 - 根据工单id将无属性点表中间表数据导入正式表
       * @static
       * @method
       * @param {Number}     prjId            待导入的无属性点表中间表数据关联的工单id
       * @returns {Promise}
       */

    }, {
      key: 'impFzdPoint',
      value: function impFzdPoint(prjId)
      {
        var para = { _major: 5, _minor: 16, prj: prjId, flag: 0 }
        return Service.execute(this.url(), 'impfzdpoint', para)
      }

      /**
       * 根据工单id将点表中间表数据导入正式表
       * @static
       * @method
       * @param {Number}     prjId            待导入的点表中间表数据关联的工单id
       * @returns {Promise}
       */

    }, {
      key: 'impPnt',
      value: function impPnt(prjId)
      {
        var para = { _major: 5, _minor: 5, prj: prjId, flag: 0 }
        return Service.execute(this.url(), 'imppoint', para)
      }

      /**
       * 根据工单id将线表中间表数据导入正式表。
       * @static
       * @method
       * @param {Number}     prjId            待导入的线表中间表数据关联的工单id
       * @returns {Promise}
       */

    }, {
      key: 'impLin',
      value: function impLin(prjId)
      {
        var para = { _major: 5, _minor: 6, prj: prjId, flag: 0 }
        return Service.execute(this.url(), 'impline', para)
      }

      /**
       * 获取导入的进度条。返回结果：lfincnt、lsumcnt、pfincnt、psumcnt。
       * @static
       * @method
       * @param {Number}      prjId            待导入的线表中间表数据关联的工单id
       * @returns {Promise}   返回结果包含：lfincnt（线表已导入数量）、lsumcnt（线表未导入数量）、pfincnt（点表已导入数量）、psumcnt（点表未导入数量）四个值。
       */

    }, {
      key: 'impPro',
      value: function impPro(prjId)
      {
        var para = { _major: 5, _minor: 6, prj: prjId, flag: 0 }
        return Service.execute(this.url(), 'imppro', para)
      }

      /**
       * 数据质量检查
       * @static
       * @method
       * @param {Object}     varParas         请求参数对象
       * @param {String}     varParas.cmd 命令
       * @example
       *  "pointcheck"     悬挂点检查
       *  "linecheck"      悬挂线检查
       *  "topcheck"       三通、四通、其他检查
       *  "presscheck"     压力检查
       *  "statecheck"     设施状态检查
       *  "sizecheck"      管径检查
       * @param {String}     varParas._major 主类型
       * @param {String}     varParas._minor 子类型
       * @param {String}     varParas.xy     查询范围，用逗号分隔
       * @param {String}     varParas.gtype  查询类型
       * @param {String}     varParas.gr     类型为圆时的半径
       * @returns {Promise}
       */

    }, {
      key: 'checkData',
      value: function checkData(varParas)
      {
        varParas._minor = varParas._minor || 0
        var cmd = varParas.cmd
        delete varParas.cmd
        return Service.execute(this.url(), cmd, varParas)
      }

      /**
       * 工单数据质量检查
       * @static
       * @method
       * @param {Object}     varParas         请求参数对象
       * @param {String}     varParas.cmd 命令
       * @example
       *   prjchecktop         连接性检查
       *   prjcheckline        悬挂线检查
       *   prjcheckpoint       孤立点检查
       *   prjcheckpress       管网压力检查
       *   prjchecksize        管径检查
       *   prjcheckmatl        管网材质检查
       *   prjcheckstate       设计状态检查
       *
       * @param {Number}     varParas._major   检查实体主类型
       * @param {Number}     varParas._minor   检查实体子类型
       * @param {Number}     varParas.prj      工单id
       * @returns {Promise}
       */

    }, {
      key: 'checkDataTicket',
      value: function checkDataTicket(varParas)
      {
        var cmd = varParas.cmd
        delete varParas.cmd
        return Service.execute(this.url(), cmd, varParas)
      }

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}  服务网址
       */

    }, {
      key: 'url',
      value: function url()
      {
        return Service.url('DatacheckSvr')
      }
    }])
    return DataCheck
  }())

  /**
   * cx.svr.threeanly
   * 三维分析服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Hanning
   * @since       2018-08-11
   */

  var ThreeAnly = (function()
  {
    function ThreeAnly()
    {
      classCallCheck(this, ThreeAnly)
    }

    createClass(ThreeAnly, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}  服务网址
       */
      value: function url()
      {
        return Service.url('ThreeDSvr')
      }

      /**
       * 碰撞分析-根据主、子类型和id查询相交部分
       * @static
       * @method
       * @param {Object}     params             请求参数对象
       * @param {Number}     params._major      实体表主类型
       * @param {Number}     params._minor      实体表子类型
       * @param {Number}     params.type        查询类型
       * @returns {Promise}
       */

    }, {
      key: 'collision',
      value: function collision(params)
      {
        var newParams = {
          _major: 2,
          _minor: 0,
          type: 1
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'collision', newParams)
      }

      /**
       * 覆土分析-根据主、子类型和id查询相交部分
       * @static
       * @method
       * @param {Object}     params             请求参数对象
       * @param {Number}     params._major      实体表主类型
       * @param {Number}     params._minor      实体表子类型
       * @param {Number}     params.type        查询类型
       * @returns {Promise}
       */

    }, {
      key: 'coversoil',
      value: function coversoil(params)
      {
        var newParams = {
          _major: 2,
          _minor: 0,
          type: 3
        }
        Base.extend(newParams, params)
        return Service.execute(this.url(), 'coversoil', newParams)
      }
    }])
    return ThreeAnly
  }())

  /**
   * cx.svr.util
   * 服务-UtilSvr 通用工具服务类
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var UtilSvr = (function()
  {
    function UtilSvr()
    {
      classCallCheck(this, UtilSvr)
    }

    createClass(UtilSvr, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('UtilSvr')
      }

      /**
       * 根据主、子类型获取该类对象的唯一序号
       * @static
       * @method
       * @param {Number}     major          图形表主类型
       * @param {Number}     minor          图形表子类型
       * @returns {Promise}
       */

    }, {
      key: 'getSequence',
      value: function getSequence(major, minor)
      {
        return Service.execute(this.url(), 'getSequence', { _major: major, _minor: minor })
      }

      /**
       * 根据序列配置seqbill表和配置序列名 生成唯一序号
       * @static
       * @method
       * @param {Number}     major          序列配置seqbill表主类型
       * @param {Number}     minor          序列配置seqbill表子类型
       * @param {String}     name           配置名称
       * @returns {Promise}
       */

    }, {
      key: 'getBill',
      value: function getBill(major, minor, name)
      {
        return Service.execute(this.url(), 'getBill', { _major: major, _minor: minor, name: name })
      }
    }])
    return UtilSvr
  }())

  /**
   * cx.svr.gaspipe
   * 服务-GaspipeSvr 燃气管线服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2019-04-09
   */

  var Gaspipe = (function()
  {
    function Gaspipe()
    {
      classCallCheck(this, Gaspipe)
    }

    createClass(Gaspipe, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('GaspipeSvr')
      }

      /**
       * 根据工单id删除工单下的业务数据
       * @static
       * @method
       * @param {Number}      ticketId          工单id
       * @returns {Promise}
       */

    }, {
      key: 'delByPrj',
      value: function delByPrj(ticketId)
      {
        var paras = { _major: cx.major.POINT, _minor: 0, prj: ticketId }
        return Service.execute(this.url(), 'delbyprj', paras)
      }

      /**
       * 移动点及拓扑线的坐标
       * @static
       * @method
       * @param {Number}      major             实体主类型
       * @param {Number}      minor             实体子类型
       * @param {Number}      id                实体id
       * @param {String}      coor              新的坐标序列，"x,y"
       * @param {Number}      ticketId          工单id
       * @returns {Promise}
       */

    }, {
      key: 'movPntByPrj',
      value: function movPntByPrj(major, minor, id, coor, ticketId)
      {
        var paras = { _major: major, _minor: minor, id: id, coor: coor, prj: ticketId }

        if (!ticketId) return Service.execute(cx.svr.network.url(), 'movpnt', paras); else return Service.execute(this.url(), 'movpntbyprj', paras)
      }

      /**
       * 修改线的拓扑关系,把连接到一个点上的线，移动连接到另一个点上
       * @static
       * @method
       * @param {Number}      major             线实体主类型
       * @param {Number}      minor             线实体子类型
       * @param {String}      line              待更新的线数据,格式："id1,fntid,talid;id2,fntid,talid;.."
       * @param {Number}      oldid             更新前线的老点id
       * @param {Number}      newid             更新后线的新点id
       * @param {Number}      [delpnt=0]        是否删除旧点,0不删除，非0删除
       * @param {Number}      ticketId          工单id
       * @returns {Promise}
       */

    }, {
      key: 'updTopLinByPrj',
      value: function updTopLinByPrj(major, minor, line, oldid, newid)
      {
        var delpnt = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0
        var ticketId = arguments[6]

        var paras = {
          _major: major,
          _minor: 0,
          line: line,
          oldid: oldid,
          newid: newid,
          delpnt: delpnt,
          prj: ticketId
        }
        if (!ticketId) return Service.execute(cx.svr.network.url(), 'updTopLin', paras); else return Service.execute(this.url(), 'updtoplinbyprj', paras)
      }

      /**
       * 批量修改图形
       * @static
       * @method
       * @param {Array.<Object>}    datas          待更新的数据序列，结构如：[{major:1,minor:15,id:190050,coor:"11536,21330"},{major:2,minor:2,id:179373,coor:"12813,10748,12821,10745"}]
       * @param {Number}            [ticketId=0]   工单id
       * @returns {Promise}
       */

    }, {
      key: 'updateGras',
      value: function updateGras(datas)
      {
        var ticketId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0

        var paras = {
          _major: 1,
          _minor: 0,
          prj: ticketId,
          data: JSON.stringify(datas)
        }
        return Service.execute(this.url(), 'updateGras', paras)
      }

      /**
       * 根据工单回滚批量修改图形
       * @static
       * @method
       * @param {Number}            [ticketId=0]   工单id
       * @returns {Promise}
       */

    }, {
      key: 'rollbackUpdateGras',
      value: function rollbackUpdateGras()
      {
        var ticketId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0

        var paras = {
          _major: 1,
          _minor: 0,
          prj: ticketId
        }
        return Service.execute(this.url(), 'rollbackupdateGras', paras)
      }

      /**
       * 求两点间最短路径（与network下面的不同，分析时候排除了报废管道）
       * @static
       * @method
       * @pntMajor	Number			点主类型
       * @pntid1	  Number			点id
       * @pntid2	  Number			点id
       * @retAtt	  Number	    <optional>0	是否返回路径上的属性，1时返回
       * @returns {Promise}
       */

    }, {
      key: 'shortestPath',
      value: function shortestPath(pntMajor, pntid1, pntid2, retAtt)
      {
        var paras = {
          _major: pntMajor,
          _minor: 0,
          pnt1: pntid1,
          pnt2: pntid2,
          retAtt: retAtt || 0
        }
        return Service.execute(this.url(), 'shortestpath', paras)
      }
    }])
    return Gaspipe
  }())

  /**
   * cx.svr.secret
   * 服务-SecretSvr 安全服务
   *
   * @class
   * @memberof    cx.svr
   * @author      Zhang Fayong
   * @since       2020-10-16
   */

  /**
    * 修改记录:
    */

  var Secret = (function()
  {
    function Secret()
    {
      classCallCheck(this, Secret)
    }

    createClass(Secret, null, [{
      key: 'url',

      /**
       * 取服务对应的网址
       * @static
       * @method
       * @returns {String}                        服务网址
       */
      value: function url()
      {
        return Service.url('SecretSvr')
      }

      /**
       * 服务-转发 Post 服务
       * @static
       * @method
       * @param   {Object}  params                参数
       * @param   {String}  params.path           待转发的URL
       *
       * @returns {Promise}
       */

    }, {
      key: 'transPost',
      value: function transPost(params)
      {
        return Service.execute(this.url(), 'transPost', params)
      }
    }])
    return Secret
  }())

  /**
   * cx.tile.Wmts
   * 瓦片切片类-自定义切片
   *
   * @class
   * @memberof    cx.tile
   * @author      Zhang Fayong
   * @since       2020-11-10
   */

  var Wmts = (function()
  {
    /**
     * @constructor
     * @param   {Object}      options
     * @param   {Number}      options.originx       切图的X原点
     * @param   {Number}      options.originy       切图的Y原点
     * @param   {Number}      options.scale         起始切图比例尺
     * @param   {Number}      [options.levelMin=0]  切图的起始级别
     * @param   {Number}      options.levelMax      切图的最大
     */
    function Wmts()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, Wmts)

      this.originx = options.originx //原点x
      this.originy = options.originy //原点y
      this.scale = options.scale //起始切图比例尺
      this.levelMin = Base.defVal(options.levelMin, 0) //初始切图级别
      this.levelMax = options.levelMax //最大地图级别
      this.sizes = []

      //计算每一级的格子大小
      var size = 0.0254000508 * options.scale * 256 / 96
      var i = void 0

      for (i = 0; i <= this.levelMax; i++)
      {
        this.sizes.push(size)
        size = size / 2
      }
    }

    /**
     * @method
     * 取第0级瓦片的高度
     */


    createClass(Wmts, [{
      key: 'getTileHeight',
      value: function getTileHeight()
      {
        return 0.0254000508 * this.scale * 256 / 96
      }

      /**
       * @method
       * 根据瓦片取范围
       * @param   {Obj}           grid          切片网格 {level, row, col}
       * @param   {Object}        rect          返回 {minx, miny, maxx, maxy}
       */

    }, {
      key: 'getTileRect',
      value: function getTileRect(grid, rect)
      {
        var size = this.sizes[grid.level]

        rect.minx = this.originx + grid.col * size
        rect.maxy = this.originy - grid.row * size
        rect.maxx = rect.minx + size
        rect.miny = rect.maxy - size
      }

      /**
       * @method
       * 根据坐标取网格号
       * @param   {Number}        x             x横坐标
       * @param   {Number}        y             y纵坐标
       * @param   {Number}        level         瓦片级别
       * @param   {Object}        ret           返回 {level, row, col}
       */

    }, {
      key: 'getGrid',
      value: function getGrid(x, y, level, ret)
      {
        var size = this.sizes[level]

        ret.level = level
        ret.col = Math.floor((x - this.originx) / size)
        ret.row = Math.floor((this.originy - y) / size)
      }
    }, {
      key: 'getSize',
      value: function getSize(level)
      {
        return this.sizes[level]
      }
    }])
    return Wmts
  }())

  /**
   * cx.tile.TileImages
   * 类-瓦片切片合成器(根据多个瓦片生成合并后的图片)
   *
   * @class
   * @memberof    cx.tile
   * @author      Zhang Fayong
   * @since       2020-11-10
   */

  /**
   * @constructor
   * @param   {cx3.Grid}                  grid    瓦片网格
   * @param   {Array.<cx3.ITileLayer>}    layers  瓦片子图层列表
   */
  var TileImages = function TileImages(grid, layers)
  {
    var images = [] //Image列表

    /**
     * 销毁对象
     * @method
     */
    var destroy = function destroy()
    {
      images = null
    }

    /**
     * 根据多个图层加载瓦片
     * @method
     * @private
     * @returns {Promise}
     */
    var _loadTiles = function _loadTiles()
    {
      var all = [],
        i = void 0

      for (i = layers.length - 1; i >= 0; i--)
      {
        if (layers[i].visible) //可见的情况下加载地图
          all.push(_loadTile(layers[i], i, grid.key + '_' + layers[i].id))
      }
      if (all.length > 0) //加载多个瓦片
        return Promise.all(all); else //采用默认的瓦片
      {
        return new Promise(function(resolve)
        {
          resolve(null)
        })
      }
    }

    /**
     * 加载一个瓦片子图层的图片
     * @method
     * @private
     * @param   {cx3.ITileLayer}    layer         子图层
     * @param   {Number}            layerIndex    子图层的索引值
     * @param   {String}            cacheKey      缓存KEY
     * @returns {Promise}
     */
    var _loadTile = function _loadTile(layer, layerIndex, cacheKey)
    {
      images[layerIndex] = null
      //每次重新取URL是因为每一次可能采用不同的子域
      return ImageLoader.load(cacheKey, layer.getUrl(grid)).then(function(img)
      {
        images[layerIndex] = img
      }).catch(function(ret)
      {
        images[layerIndex] = global.defTile
      })
    }

    /**
     * 合并图片
     * @method
     * @private
     * @returns {Promise}                         resolve(Image)
     */
    var _mergeTiles = function _mergeTiles()
    {
      //如果一个子图层都不显示则直接返回默认瓦片
      //如果只有一个子图层显示，则直接返回;如果是多个图层显示的话，必须把多个瓦片进行合并显示才能返回
      return new Promise(function(resolve)
      {
        var i = void 0,
          il = layers.length,
          num = 0

        //计算图片个数
        for (i = 0; i < il; i++)
        {
          if (images[i]) num++
        }
        if (num === 0) //没有一个瓦片，返回默认的图片
          resolve(global.defTile); else if (num === 1) //有且仅有一个瓦片,直接返回瓦片(单个图层，透明度不起效,否则性能低)
        {
          for (i = 0; i < il; i++)
          {
            if (images[i])
            {
              resolve(images[i])
              return
            }
          }
        }
        else //多个图片，需要合并
        {
          var canvas = void 0,
            ctx = void 0,
            image = void 0

          canvas = Dom.create('canvas')
          ctx = canvas.getContext('2d')
          canvas.width = 256
          canvas.height = 256
          for (i = 0; i < il; i++)
          {
            if (images[i])
            {
              ctx.globalAlpha = layers[i].alpha
              ctx.drawImage(images[i], 0, 0, 256, 256)
              ctx.globalAlpha = 1
            }
          }
          image = Dom.createNS('http://www.w3.org/1999/xhtml', 'img')
          image.onload = function()
          {
            resolve(image)
            image = null
            ctx = null
            canvas = null
          }
          image.src = canvas.toDataURL('image/png')
        }
      })
    }

    //  加载过程如下:
    //
    //  加载瓦片1--\
    //             \
    //  加载瓦片2--   合并瓦片
    //             /
    //  加载瓦片3--/
    //
    /**
     * 根据多个瓦片子图层加载瓦片
     * @method
     * @returns {Promise}                       resolve(Image)
     */
    var load = function load()
    {
      return Promise.resolve(_loadTiles()).then(_mergeTiles)
    }

    this.destroy = destroy
    this.load = load
  }

  /**
   * cx.tile.TileImages
   * 类-根据选择的范围生成背景图
   *
   * @class
   * @memberof    cx.tile
   * @author      Zhang Fayong
   * @since       2020-11-10
   */

  var MAX_REQUESTS = 5

  var GenImage = function GenImage()
  {
    var layers = []
    var gra = void 0
    var x0 = void 0,
      y0 = void 0,
      deltaX = void 0,
      deltaY = void 0
    var wmts = void 0
    var canvas = void 0,
      ctx = void 0
    var grids = []
    var onSuccess = void 0

    var updTotal = 0 //更新-总数
    var updSent = 0 //更新-已发送
    var updReceived = 0 //更新-已收到

    /**
     * 销毁对象
     * @method
     */
    var destroy = function destroy()
    {
      onSuccess = null
      grids = null
      ctx = null
      canvas = null
      wmts = null
      layers = null
    }

    /**
     * 生成图像
     * @method
     * @param   {Object}    params            传递的参数
     * @param   {Function}  onLoad            回调函数 - function(image)
     * @example
     {
       boundary: [503139.1440100225, 3774942.520498293, 558834.0470664955, 3816746.7707734606],
       gra:
       {
         geometry:
         {
           type: 'polygon',
           coordinates:
           [[[509224.57284754695, 3810595.19597031],
             [553145.4940227226, 3810595.19597031],
             [553145.4940227226, 3780035.7598514375],
             [509224.57284754695, 3780035.7598514375],
             [509224.57284754695, 3810595.19597031]]
           ]
         },
         style:
         {
           stroke: 'black',
           fill: 'rgba(128, 0, 0, 0.4)'
         }
       },
       mapSvr:
       [
         {
           url: 'http://122.112.155.221:6080/arcgis/rest/services/xzdz/JCDZSJ/MapServer/tile/{z}/{y}/{x}',
           origin: [-5123200, 10002100],
           scale: 967557.12,
           level: 1
         }
       ]
     }
    */

    var generate = function generate(params, onLoad)
    {
      var boundary = void 0
      var i = void 0,
        j = void 0

      //边界
      boundary = params.boundary
      gra = params.gra
      onSuccess = onLoad

      //WMTS
      var map = void 0,
        size = void 0
      map = params.mapSvr[0] //用 第 1 个图层计算
      wmts = new Wmts({
        originx: map.origin[0],
        originy: map.origin[1],
        scale: map.scale,
        levelMax: map.level
      })
      size = wmts.getSize(map.level)

      //图层
      //let layerID = 1
      var layer = void 0
      var _iteratorNormalCompletion = true
      var _didIteratorError = false
      var _iteratorError = undefined

      try
      {
        for (var _iterator = params.mapSvr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
        {
          map = _step.value

          layer = new WmsArcgis(wmts, {
            url: map.url,
            layer: map.layer,
            srs: map.epsg
          })

          //layer =
          //{
          //  id: layerID++,
          //  visible: true,
          //  url: map.url,
          //  getUrl: function(grid)
          //  {
          //    let ret = this.url
          //    ret = ret.replace('{z}', grid.level)
          //    ret = ret.replace('{y}', grid.row)
          //    ret = ret.replace('{x}', grid.col)
          //    return ret
          //  }
          //}
          layers.push(layer)
        }

        //计算全部格子
      }
      catch (err)
      {
        _didIteratorError = true
        _iteratorError = err
      }
      finally
      {
        try
        {
          if (!_iteratorNormalCompletion && _iterator.return)
          
            _iterator.return()
        }
        finally
        {
          if (_didIteratorError)
          
            throw _iteratorError
        }
      }

      var grid1 = {},
        grid2 = {},
        grid = void 0
      var rect = {}

      wmts.getGrid(boundary[0], boundary[3], map.level, grid1)
      wmts.getGrid(boundary[2], boundary[1], map.level, grid2)

      //左上角
      wmts.getTileRect(grid1, rect)
      x0 = boundary[0]
      y0 = boundary[3]
      deltaX = deltaY = size / 256.0

      for (i = grid1.row; i <= grid2.row; i++)
      {
        for (j = grid1.col; j <= grid2.col; j++)
        {
          grid = {
            level: map.level,
            row: i,
            col: j,
            key: map.level + '_' + i + '_' + j
          }
          wmts.getTileRect(grid, rect)

          //计算瓦片的位置
          grid.x = Math.floor((rect.minx - x0) / deltaX)
          grid.y = Math.floor((y0 - rect.maxy) / deltaY)

          grids.push(grid)
        }
      }

      //画图
      canvas = Dom.create('canvas')
      ctx = canvas.getContext('2d')
      canvas.width = Math.floor((boundary[2] - boundary[0]) / deltaX)
      canvas.height = Math.floor((boundary[3] - boundary[1]) / deltaY)

      //开始发请求数据
      updTotal = grids.length

      var first = updTotal >= MAX_REQUESTS ? MAX_REQUESTS : updTotal //首先发出N个请求

      //首先发出N个请求
      for (i = 0; i < first; i++)
      
        _loadTile(grids[updSent++]).then(_onLoadTile)
    }

    var _draw = function _draw()
    {
      //外边框
      ctx.strokeStyle = 'gray'
      ctx.strokeRect(0, 0, canvas.width, canvas.height)

      //选择框
      var coors = gra.geometry.coordinates[0]
      var x = void 0,
        y = void 0
      var i = void 0,
        il = void 0

      ctx.beginPath()
      x = Math.floor((coors[0][0] - x0) / deltaX)
      y = Math.floor((y0 - coors[0][1]) / deltaY)
      ctx.moveTo(x, y)
      for (i = 1, il = coors.length; i < il; i++)
      {
        x = Math.floor((coors[i][0] - x0) / deltaX)
        y = Math.floor((y0 - coors[i][1]) / deltaY)
        ctx.lineTo(x, y)
      }
      ctx.closePath()
      ctx.lineWidth = 1
      ctx.fillStyle = gra.style.fill
      ctx.strokeStyle = gra.style.stroke
      ctx.fill()
      ctx.stroke()
    }

    /**加载全部瓦片完成
     * @method
     * @private
     */
    var _finish = function _finish()
    {
      _draw()

      var image = Dom.createNS('http://www.w3.org/1999/xhtml', 'img')

      image.onload = function()
      {
        if (onSuccess) onSuccess(image)

        image = null
        destroy()
      }
      image.src = canvas.toDataURL('image/png')
    }

    /**
     * 加载一个瓦片的所有图片
     * @method
     * @private
     * @param   {Grid}        grid            网格信息 {level, row, col, key}
     * @param   {Promise}
     */
    var _loadTile = function _loadTile(grid)
    {
      var tileImage = new TileImages(grid, layers)

      return tileImage.load().then(function(image)
      {
        //画图
        if (image) ctx.drawImage(image, grid.x, grid.y, 256, 256)
        return tileImage
      })
    }

    /**
     * 回调函数-加载一个瓦片的所有图片
     * @method
     * @private
     * @param   {TileImages}  tileImgs        瓦片对应的图层加载对象
    */
    var _onLoadTile = function _onLoadTile(tileImgs)
    {
      updReceived++
      if (updReceived >= updTotal) //已经收到全部请求
        _finish(); else
      
      if (updSent < updTotal) _loadTile(grids[updSent++]).then(_onLoadTile)
    }

    this.generate = generate
  }

  /**
   * cx.tile.WmtsWeb
   * 瓦片切片类-Web墨卡托
   *
   * @class
   * @memberof    cx.tile
   * @author      Zhang Fayong
   * @since       2020-11-10
   */

  var MCT_LEN_2 = 20037508.3427892

  var WmtsWeb = (function()
  {
    /**
     * @constructor
     * @param   {Object}      options
     * @param   {Number}      [options.levelMax = 18]     切图的最大
     */
    function WmtsWeb()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, WmtsWeb)

      this.scale = MCT_LEN_2 + MCT_LEN_2 //起始切图比例尺
      this.levelMin = 0 //初始切图级别
      this.levelMax = Base.defVal(options.levelMax, 18) //最大地图级别
      this.sizes = []

      //计算每一级的格子大小
      var size = MCT_LEN_2 + MCT_LEN_2
      var i = void 0

      for (i = 0; i < this.levelMax; i++)
      {
        this.sizes.push(size)
        size = size / 2
      }
    }

    /**
     * @method
     * 取第0级瓦片的高度
     */


    createClass(WmtsWeb, [{
      key: 'getTileHeight',
      value: function getTileHeight()
      {
        return MCT_LEN_2 + MCT_LEN_2
      }

      /**
       * @method
       * 根据瓦片取范围
       * @param   {Object}        grid          切片网格 {level, row, col}
       * @param   {Object}        rect          返回 {minx, miny, maxx, maxy}
       */

    }, {
      key: 'getTileRect',
      value: function getTileRect(grid, rect)
      {
        var size = this.sizes[grid.level]

        rect.minx = grid.col * size - MCT_LEN_2
        rect.maxy = MCT_LEN_2 - grid.row * size
        rect.maxx = rect.minx + size
        rect.miny = rect.maxy - size
      }

      /**
       * @method
       * 根据坐标取网格号
       * @param   {Number}        x             x横坐标
       * @param   {Number}        y             y纵坐标
       * @param   {Number}        level         瓦片级别
       * @param   {Object}        ret           返回 {level, row, col}
       */

    }, {
      key: 'getGrid',
      value: function getGrid(x, y, level, ret)
      {
        var size = this.sizes[level]

        ret.level = level
        ret.col = Math.floor((MCT_LEN_2 + x) / size)
        ret.row = Math.floor((MCT_LEN_2 - y) / size)
      }
    }])
    return WmtsWeb
  }())

  /**
   * cx.datagrid
   * 类-datagrid辅助类
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-05-23
   */

  var DataGrid = (function()
  {
    function DataGrid()
    {
      classCallCheck(this, DataGrid)
    }

    createClass(DataGrid, null, [{
      key: 'getCol',

      /**
       * 产生DataGrid列信息
       * @static
       * @method
       * @param   {String}    colname                           列名
       * @param   {String}    title                             显示标题
       * @param   {Number}    width                             列宽度
       * @param   {String}    [align = cx.consts.ALIGN_CENTER]  对齐方式(ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT)
       * @param   {Boolean}   [sortable = true]                 是否可排序
       * @returns {Object}
       */
      value: function getCol(colname, title, width)
      {
        var align = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Consts.ALIGN_CENTER
        var sortable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true

        var ret = {
          colname: colname,
          title: title,
          width: width,
          align: align,
          sortable: sortable,
          overflowTooltip: false
        }
        switch (align)
        {
        case Consts.ALIGN_LEFT:
          ret.align = 'left'; break
        case Consts.ALIGN_CENTER:
          ret.align = 'center'; break
        case Consts.ALIGN_RIGHT:
          ret.align = 'right'; break
        }

        return ret
      }

      /**
       * 产生DataGrid操作列信息
       * @static
       * @method
       * @param   {String}    colname                           列名
       * @param   {String}    title                             显示标题
       * @param   {Number}    width                             列宽度
       * @param   {String}    [align = cx.consts.ALIGN_CENTER]  对齐方式(ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT)
       * @returns {Object}
       */

    }, {
      key: 'getOperCol',
      value: function getOperCol(colname, title, width)
      {
        var align = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Consts.ALIGN_CENTER

        var ret = {
          colname: colname,
          title: title,
          width: width,
          align: align,
          sortable: false,
          overflowTooltip: false,
          btns: []
        }
        switch (align)
        {
        case Consts.ALIGN_LEFT:
          ret.align = 'left'; break
        case Consts.ALIGN_CENTER:
          ret.align = 'center'; break
        case Consts.ALIGN_RIGHT:
          ret.align = 'right'; break
        }

        return ret
      }

      /**
       * 产生DataGrid操作信息
       * @static
       * @method
       * @param   {String}    name                              名称
       * @param   {String}    title                             显示标题
       * @param   {String}    icon                              图标Class
       * @returns {Object}
       */

    }, {
      key: 'getOper',
      value: function getOper(name, title, icon)
      {
        var ret = {
          name: name,
          title: title,
          icon: icon,
          onClick: null,
          enable: function enable(att)
          {
            return true
          },
          show: function show(att)
          {
            return true
          }
        }

        return ret
      }

      /**
       * 取得默认的列信息
       * @static
       * @method
       * @param   {Array}     flds                              字段信息列表
       * @param   {Boolean}   [sortable = false]                是否可以排序
       * @param   {Number}    [align = cx.consts.ALIGN_CENTER]  对齐方式
       * @returns {Array.<Object>}                              构造好的列对象序列
       */

    }, {
      key: 'getDefCols',
      value: function getDefCols(flds, sortable)
      {
        var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Consts.ALIGN_CENTER

        var cols = []
        var width = void 0,
          obj = void 0
        flds = flds || []
        switch (align)
        {
        case Consts.ALIGN_LEFT:
          align = 'left'; break
        case Consts.ALIGN_CENTER:
          align = 'center'; break
        case Consts.ALIGN_RIGHT:
          align = 'right'; break
        }

        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = flds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var fld = _step.value

            if (fld.disporder < 1) continue

            obj = {
              colname: fld.colname, //列名
              title: Base.locale(fld.namec, fld.namee), //标题
              align: align, //对齐方式
              show: true, //是否显示
              sortable: !!sortable, //字段是否可排序
              overflowTooltip: false //当内容过长被隐藏时显示tooltip


              //宽度
            }; width = 150
            if (fld.isnum) width = 125

            switch (fld.disptype)
            {
            case Consts.DISP_LIST:
            case Consts.DISP_SELDYNA:
            case Consts.DISP_DROPDOWN:
            case Consts.DISP_DATE:
            case Consts.DISP_TIMESTAMP:
              obj.colname = '_' + fld.colname
              break
            }
            switch (fld.disptype)
            {
            case Consts.DISP_LIST:
            case Consts.DISP_DROPDOWN:
              width = 125
              break
            case Consts.DISP_DATE:
              width = 125
              break
            case Consts.DISP_TIMESTAMP:
              width = 150
              break
            case Consts.DISP_TIME:
              width = 75
              break
            }
            obj.width = width
            cols.push(obj)
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return cols
      }

      /**
       * 产生列信息
       * @static
       * @method
       * @param   {Array}     cols              列数组({title, colname, width, align = cx.consts.HORIZEN_CENTER, sortable = true})
       * @param   {Array}     colInfs           列信息({[colname], width, align = consts.HORIZEN_CENTER, sortable = true})
       * @param   {Array}     flds              字段信息(主要用于设置title)
       */

    }, {
      key: 'makeCols',
      value: function makeCols(cols, colInfs, flds)
      {
        var col = void 0,
          inf = void 0,
          fld = void 0,
          colname = void 0

        cols = cols || []
        colInfs = colInfs || []
        flds = flds || []

        var _iteratorNormalCompletion2 = true
        var _didIteratorError2 = false
        var _iteratorError2 = undefined

        try
        {
          for (var _iterator2 = cols[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
          {
            col = _step2.value

            colname = col.colname
            if (colname.charAt(0) === '_') colname = colname.substring(1)

            //找到对应的列
            inf = Array$1.get1(colInfs, { colname: colname }) //用列名找
            if (!inf) //用 _colname 查找
              inf = Array$1.get1(colInfs, '_' + colname)

            if (inf && inf.title) //title
              col.title = inf.title

            if (!col.title) //没有 title  属性，则从字段里面去找
            {
              fld = Array$1.get1(flds, { colname: colname })
              if (fld) col.title = Base.locale(fld.namec, fld.namee)
            }
            if (inf && Base.isDef(inf.width)) //宽度
              col.width = inf.width

            if (!Base.isDef(col.align)) //对齐方式
              col.align = Consts.ALIGN_CENTER

            if (inf && Base.isDef(inf.align)) col.align = inf.align

            switch (col.align)
            {
            case Consts.ALIGN_LEFT:
              col.align = 'left'
              break
            case Consts.ALIGN_CENTER:
              col.align = 'center'
              break
            case Consts.ALIGN_RIGHT:
              col.align = 'right'
              break
            }
            if (!Base.isDef(col.sortable)) //可排序
              col.sortable = true
            if (inf && Base.isDef(inf.sortable)) col.sortable = inf.sortable
          }
        }
        catch (err)
        {
          _didIteratorError2 = true
          _iteratorError2 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion2 && _iterator2.return)
            
              _iterator2.return()
          }
          finally
          {
            if (_didIteratorError2)
            
              throw _iteratorError2
          }
        }
      }

      /**
       * 根据列名和列数据计算各列的宽，返回一个新的cols
       * @static
       * @method
       * @param   {Array.<Object>}     cols                    列对象数组(支持已构造好的表cols)
       * @param   {String}             cols.colname            列字段名
       * @param   {String}             cols.title              列文本名
       * @param   {Boolean}            [cols.sortable=false]   该列是否可排序
       * @param   {Array.<Object>}     tabDatas                表格待展示数据
       * @param   {Number}             [colMaxWidth=400]       列的最大宽度
       * @param   {Number}             [fontSize=13]           字体大小
       * @param   {Number}             [padding=21]            内容左右边距和
       * @returns {Array.<Object>}                             在传入的cols基础上更新列宽width，如[{colname: 'a', width: 12}]
       */

    }, {
      key: 'makeColsFitWidth',
      value: function makeColsFitWidth(cols, tabDatas)
      {
        var colMaxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400
        var fontSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 13
        var padding = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 21

        var margin = 0
        var headW = 0
        var contW = 0
        var contStr = ''

        //去标题和内容的最大长度
        var getMaxLen = function getMaxLen(col)
        {
          margin = col.sortable ? 46 : 10
          headW = Util.getStrWidth(col.title || col.colname, fontSize)
          contW = tabDatas.map(function(item)
          {
            contStr = Base.isObj(item[col.colname]) ? JSON.stringify(item[col.colname]) : item[col.colname]
            return Util.getStrWidth(contStr, fontSize)
          })
          return Math.max(headW + margin, Math.max.apply(Math, toConsumableArray(contW))) + padding
        }
        return cols.map(function(col)
        {
          return Base.extend({}, col, { width: Math.min(colMaxWidth, getMaxLen(col)) })
        })
      }
    }, {
      key: 'getEditVal',
      value: function getEditVal(cols, row)
      {
        var ret = {}
        var col = void 0,
          colname = void 0,
          opt = void 0

        var _iteratorNormalCompletion3 = true
        var _didIteratorError3 = false
        var _iteratorError3 = undefined

        try
        {
          for (var _iterator3 = cols[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)
          {
            col = _step3.value

            colname = col.colname
            if (colname.charAt(0) === '_') colname = colname.substring(1)

            if (col.isEdit || col.isDropdown || col.isDate || col.isDateTime) ret[colname] = row[col.colname]; else if (col.isSelect)
            {
              var _iteratorNormalCompletion4 = true
              var _didIteratorError4 = false
              var _iteratorError4 = undefined

              try
              {
                for (var _iterator4 = col.selOptions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true)
                {
                  opt = _step4.value

                  if (opt.label == row[col.colname])
                  {
                    ret[colname] = opt.value
                    break
                  }
                }
              }
              catch (err)
              {
                _didIteratorError4 = true
                _iteratorError4 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion4 && _iterator4.return)
                  
                    _iterator4.return()
                }
                finally
                {
                  if (_didIteratorError4)
                  
                    throw _iteratorError4
                }
              }
            }
          }
        }
        catch (err)
        {
          _didIteratorError3 = true
          _iteratorError3 = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion3 && _iterator3.return)
            
              _iterator3.return()
          }
          finally
          {
            if (_didIteratorError3)
            
              throw _iteratorError3
          }
        }

        return ret
      }
    }])
    return DataGrid
  }())

  var DlgModal = (function()
  {
    /**
     * @constructor
     */
    function DlgModal()
    {
      classCallCheck(this, DlgModal)

      this.modal = null //DOM
      this.list = new Stack() //堆栈
    }

    /**
     * 新开始一个模态
     * @param   {Number}      zIndex
     */


    createClass(DlgModal, [{
      key: 'start',
      value: function start(zIndex)
      {
        if (!this.modal)
        {
          var parent = Dom.byId('cx-scale')

          if (!parent) parent = Dom.body()

          this.modal = Dom.create('div', 'cx-dlgmodal', parent, null)
        }

        this.list.push({ zIndex: zIndex })
        Dom.setZIndex(this.modal, zIndex)
        this.show()
      }

      /**
       * 结束一个模态
       * @method
       */

    }, {
      key: 'end',
      value: function end()
      {
        //先弹掉一个
        this.list.pop()

        //再看堆栈里面还有没有，如果有则显示上一个，如果没有在隐藏
        if (this.list.size() > 0)
        {
          var top = this.list.getTop()
          Dom.setZIndex(this.modal, top.zIndex)
        }
        else this.hide()
      }

      /**
       * 显示模态
       * @method
       */

    }, {
      key: 'show',
      value: function show()
      {
        Dom.setVisible(this.modal, true)
      }

      /**
       * 隐藏模态
       * @method
       */

    }, {
      key: 'hide',
      value: function hide()
      {
        Dom.setVisible(this.modal, false)
      }
    }])
    return DlgModal
  }())

  /**
   * cx.DlgMove
   * 移动对话框
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-07-31
   */

  var DlgMove =
  /**
   * @constructor
   * @param   {dom}       container         父容器对象
   * @param   {Dialog}    dlg               对话框对象
   * @param   {dom}       dom               对话框的dom
   * @param   {Number}    zIndex            遮罩的z-index
   * @param   {Number}    x                 鼠标点击的x坐标
   * @param   {Number}    y                 鼠标点击的y坐标
   */
  function DlgMove(container, dlg, dom, zIndex, x, y)
  {
    var _this = this

    classCallCheck(this, DlgMove)

    var parent = Dom.byId('cx-scale')

    if (!parent) parent = Dom.body()

    this.container = container
    this.dlg = dlg
    this.dom = dom
    this.mx = x //鼠标按下的坐标
    this.my = y
    this.mark = Dom.create('div', 'cx-dlgmove', parent, null)
    Dom.setZIndex(this.mark, zIndex)

    //保留相对位置
    this.posContainer = Dom.getPosSizeBody(container)
    this.posDlg = Dom.getPosSizeBody(dom)
    this.dx = this.posDlg.x - this.posContainer.x
    this.dy = this.posDlg.y - this.posContainer.y

    //鼠标移动
    this.mark.onmousemove = function(evt)
    {
      evt.preventDefault()
      if (evt.clientX >= _this.posContainer.x && evt.clientX < _this.posContainer.x + _this.posContainer.w && evt.clientY >= _this.posContainer.y && evt.clientY < _this.posContainer.y + _this.posContainer.h)
      {
        _this.dom.style.left = _this.dx + evt.clientX - _this.mx + 'px'
        _this.dom.style.top = _this.dy + evt.clientY - _this.my + 'px'
      }
    }

    //鼠标弹起
    this.mark.onmouseup = function(evt)
    {
      evt.preventDefault()
      Dom.remove(_this.mark)
      _this.dlg.endMove()
      _this.dom = null
      _this.dlg = null
      _this.container = null
    }
  }

  /**
   * cx.DlgSize
   * 改变对话框大小
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-07-31
   */

  var DlgSize =
  /**
   * @constructor
   * @param   {Dialog}    dlg               对话框对象
   * @param   {dom}       dom               对话框的dom
   * @param   {Number}    zIndex            遮罩的z-index
   * @param   {Number}    x                 鼠标点击的x坐标
   * @param   {Number}    y                 鼠标点击的y坐标
   */
  function DlgSize(dlg, dom, zIndex, x, y)
  {
    var _this = this

    classCallCheck(this, DlgSize)

    var parent = Dom.byId('cx-scale')

    if (!parent) parent = Dom.body()

    this.dlg = dlg
    this.dom = dom
    this.mx = x //鼠标按下的坐标
    this.my = y
    this.mark = Dom.create('div', 'cx-dlgsize', parent, null)
    Dom.setZIndex(this.mark, zIndex)

    //保留相对位置
    this.size = Dom.getPosSizeBody(dom)

    //鼠标移动
    this.mark.onmousemove = function(evt)
    {
      evt.preventDefault()
      _this.dom.style.width = _this.size.w + evt.clientX - _this.mx + 'px'
      _this.dom.style.height = _this.size.h + evt.clientY - _this.my + 'px'
    }

    //鼠标弹起
    this.mark.onmouseup = function(evt)
    {
      evt.preventDefault()
      Dom.remove(_this.mark)
      _this.dlg.endSize()
      _this.dom = null
      _this.dlg = null
    }
  }

  /**
   * cx.upload
   * 类-上载文件的辅助对象
   *
   * @class
   * @memberof    cx
   * @author      Zhang Fayong
   * @since       2018-08-22
   */

  var Upload = (function()
  {
    function Upload()
    {
      classCallCheck(this, Upload)
    }

    createClass(Upload, null, [{
      key: 'getDefVal',

      /**
       * 取上载对象默认字段
       * @static
       * @method
       * @returns {Object}
       */
      value: function getDefVal()
      {
        return {
          major: 0, //实体主类型
          minor: 0, //实体子类型
          entityid: 0, //实体号
          username: Global.user.name, //上传人
          fid: 0, //fid
          sys: Global.user.sys, //实体子类型
          glid: 0, //关联id(自关联ID，父实体号)
          task: 0, //流程环节
          bustype: 0, //文档类型(0:普通文档,1:普通图片,2:二维码,3:档案卡片,4:音频,5:视频,6:建设规划许可证)
          tempFile: 0 //是否临时文件
        }
      }
    }])
    return Upload
  }())

  /* global cx */

  /**
   * cx.undo.Data
   * 类-回退步骤中的数据对象
   *
   * @class
   * @memberof    cx.undo
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Data = (function()
  {
    /**
     * @constructor
     * @param   {Object}        options                 参数对象
     * @param   {cx.Caller}     options.readyCall       数据备份完成后回调对象
     * @param   {Boolean}       [options.noAid = false] 是否不备份标注和附属设备,默认要备份
     */
    function Data(options)
    {
      classCallCheck(this, Data)

      options = options || {}
      /** * @property {Array}     atts              * 属性对象数组  */
      this.atts = []
      /** * @property {Array}     graPnt            * 点图形对象数组 */
      this.graPnt = []
      /** * @property {Array}     graLin            * 线图形对象数组 */
      this.graLin = []
      /** * @property {Array}     graPol            * 面图形对象数组 */
      this.graPol = []
      /** * @property {Array}     graAtt            * 属性对象数组 */
      this.graAtt = [] //（点）附属物图形
      /** * @property {Array}     label             * label对象数组 */
      this.label = []
      /** * @property {Number}    times             * 异步请求的总次数 */
      this.times = 0
      /** * @property {Number}    curTimes          * 异步完成的次数 */
      this.curTimes = 0
      /** * @property {Boolean}   noAid             * 是否不备份标注和附属设备 */
      this.noAid = options.noAid
      /** * @property {cx.Caller} readyCall         * 回退数据备份完成后回调 */
      this.readyCall = options.readyCall
    }

    /**
     * 启动备份
     * @method
     */


    createClass(Data, [{
      key: 'start',
      value: function start()
      {
        if (this.curTimes >= this.times && this.times >= 0)
        {
          //重新设置数据，避免多次启动
          this.curTimes = -1
          this.times = -1
          //调用回调函数
          Base.call(this.readyCall)
        }
      }

      /**
       * 从数据库备份属性数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbAtt',
      value: function fromDbAtt(major, minor, id)
      {
        var _this = this

        //异步次数+1
        this.times++

        //取数据
        Area.getAtt({ _major: major, _minor: minor, id: id }).then(function(ret)
        {
          _this.atts.push({ major: major, minor: minor, att: ret[0] })
          _this.curTimes++
          _this.start()
        })
      }

      /**
       * 从数据库备份图形数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       * @param   {Array}     list          备份的数据存储对象
       */

    }, {
      key: 'fromDbGra',
      value: function fromDbGra(major, minor, id, list)
      {
        var _this2 = this

        //异步次数+1
        this.times++

        //取数据
        Area.getGraph(major, 0, id).then(function(ret)
        {
          list.push(ret[0])
          _this2.curTimes++
          _this2.start()
        })
        //备份附属物
        if (!this.noAid)
        {
          this.fromDbLabel(major, minor, id)
          this.fromDbAttach(major, minor, id)
        }
      }

      /**
       * 从数据库备份图形数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {String}    ids           备份数据对象的id序列，用逗号分隔
       * @param   {Array}     list          备份的数据存储对象
       */

    }, {
      key: 'fromDbGras',
      value: function fromDbGras(major, minor, ids, list)
      {
        var _this3 = this

        //异步次数+1
        this.times++

        //取数据
        Area.getGraphs(major, 0, ids.toString).then(function(ret)
        {
          for (var i = 0; i < ret.length; i++)
          
            list.push(ret[i])
          _this3.curTimes++
          _this3.start()
        })
      }

      /**
       * 从数据库备份点图形数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbGraPnt',
      value: function fromDbGraPnt(major, minor, id)
      {
        this.fromDbGra(major, minor, id, this.graPnt)
      }

      /**
       * 从数据库备份线图形数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbGraLin',
      value: function fromDbGraLin(major, minor, id)
      {
        this.fromDbGra(major, minor, id, this.graLin)
      }

      /**
       * 从数据库备份面图形数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbGraPol',
      value: function fromDbGraPol(major, minor, id)
      {
        this.fromDbGra(major, minor, id, this.graPol)
      }

      /**
       * 从数据库备份点的拓扑线图形数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbGraPntTop',
      value: function fromDbGraPntTop(major, minor, id)
      {
        var _this4 = this

        //取点信息
        this.fromDbGra(major, minor, id, this.graPnt)
        //异步次数+1
        this.times++
        //取数据
        Area.getTopGraph(major, 0, id).then(function(ret)
        {
          for (var i = 0; i < ret.length; i++)
          
            _this4.graLin.push(ret[i])
          _this4.curTimes++
          _this4.start()
        })
      }

      /**
       * 从数据库备份附属物图形数据
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbGraAttach',
      value: function fromDbGraAttach(major, minor, id)
      {
        this.fromDbGra(major, minor, id, this.graAtt)
      }

      /**
       * 从数据库备份点
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbPnt',
      value: function fromDbPnt(major, minor, id)
      {
        this.fromDbAtt(major, minor, id)
        this.fromDbGraPnt(major, minor, id)
      }

      /**
       * 从数据库备份线
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbLin',
      value: function fromDbLin(major, minor, id)
      {
        this.fromDbAtt(major, minor, id)
        this.fromDbGraLin(major, minor, id)
      }

      /**
       * 从数据库备份面
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbPol',
      value: function fromDbPol(major, minor, id)
      {
        this.fromDbAtt(major, minor, id)
        this.fromDbGraPol(major, minor, id)
      }

      /**
       * 从数据库备份点和拓扑线
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbPntTop',
      value: function fromDbPntTop(major, minor, id)
      {
        var _this5 = this

        //取点信息
        this.fromDbGra(major, minor, id, this.graPnt)
        this.fromDbAtt(major, minor, id)

        //异步次数+1
        this.times++

        //取拓扑线图形数据
        Area.getTopGraph(major, 0, id).then(function(ret)
        {
          for (var i = 0; i < ret.length; i++)
          {
            //保存拓扑线数据
            _this5.graLin.push(ret[i])
            _this5.fromDbAtt(cx.major.LINE, ret[i].minor, ret[i].id)
            //备份拓扑线的附属
            if (!_this5.noAid)
            {
              _this5.fromDbLabel(cx.major.LINE, ret[i].minor, ret[i].id)
              _this5.fromDbAttach(cx.major.LINE, ret[i].minor, ret[i].id)
            }
          }
          _this5.curTimes++
          _this5.start()
        })
      }

      /**
       * 从数据库备份附属物
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbAttach',
      value: function fromDbAttach(major, minor, id)
      {
        var _this6 = this

        //1.先根据实体设备信息取出关联的附属物
        //2.再备份每个附属物
        var paras = {
          _major: major,
          _minor: minor,
          ids: id.toString()

          //异步次数+1
        }; this.times++

        Statistic.getAttach(paras).then(function(ret)
        {
          var aList = ret[0][cx.major.POINT] || []
          for (var i = aList.length - 1; i >= 0; i--)
          {
            //备份附属物的图形、属性数据（当作点实体处理）
            _this6.fromDbAtt(aList[i].major, aList[i].minor, aList[i].id)
            _this6.fromDbGraAttach(aList[i].major, aList[i].minor, aList[i].id)
          }
          _this6.curTimes++
          _this6.start()
        })
      }

      /**
       * 从数据库备份标注
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       */

    }, {
      key: 'fromDbLabel',
      value: function fromDbLabel(major, minor, id)
      {
        var _this7 = this

        var paras = {
          _major: cx.major.LABEL,
          _minor: 0,
          _exp: 'glmajor=? and glminor=? and gl=?',
          types: 'i,i,i',
          vals: [major, minor, id].toString()
        }
        Area.queryGra(paras).then(function(ret)
        {
          for (var i = 0, len1 = ret.length; i < len1; i++)
          
            _this7.label.push(ret[i])
        })
      }

      /**
       * 获取对象的标注
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Number}    id            备份数据对象的id
       * @returns {Object}                  标注对象
       */

    }, {
      key: 'getLabels',
      value: function getLabels(major, minor, id)
      {
        for (var i = 0, len = this.label.length; i < len; i++)
        
          if (this.label[i].minor === minor && this.label[i].gl === id) return this.label[i]
      }

      /**
       * 保存属性
       * @method
       * @param   {Number}    major         备份数据对象的主类型
       * @param   {Number}    minor         备份数据对象的子类型
       * @param   {Object}    att           属性数据对象
       */

    }, {
      key: 'saveAtt',
      value: function saveAtt(major, minor, att)
      {
        this.atts.push({ major: major, minor: minor, att: att })
      }

      /**
       * 保存点图形
       * @method
       * @param   {Object}    graph         数据对象
       */

    }, {
      key: 'saveGraPnt',
      value: function saveGraPnt(graph)
      {
        this.graPnt.push(graph)
      }

      /**
       * 保存线图形
       * @method
       * @param   {Object}    graph         数据对象
       */

    }, {
      key: 'saveGraLin',
      value: function saveGraLin(graph)
      {
        this.graLin.push(graph)
      }

      /**
       * 获取属性数据
       * @method
       * @param   {Number}    major         数据对象的主类型
       * @param   {Number}    minor         数据对象的子类型
       * @param   {Number}    id            数据对象的id
       * @returns {Object}
       */

    }, {
      key: 'getAtt',
      value: function getAtt(major, minor, id)
      {
        var _iteratorNormalCompletion = true
        var _didIteratorError = false
        var _iteratorError = undefined

        try
        {
          for (var _iterator = this.atts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
          {
            var item = _step.value

            if (item.major === major && item.minor === minor && item.att.id === id) return item.att
          }
        }
        catch (err)
        {
          _didIteratorError = true
          _iteratorError = err
        }
        finally
        {
          try
          {
            if (!_iteratorNormalCompletion && _iterator.return)
            
              _iterator.return()
          }
          finally
          {
            if (_didIteratorError)
            
              throw _iteratorError
          }
        }

        return null
      }

      /**
       * 获取全部点图形
       * @method
       * @returns {Array.<Object>}          数据对象序列
       */

    }, {
      key: 'getPnts',
      value: function getPnts()
      {
        return this.graPnt
      }

      /**
       * 获取全部线图形
       * @method
       * @returns {Array.<Object>}          数据对象序列
       */

    }, {
      key: 'getLins',
      value: function getLins()
      {
        return this.graLin
      }
    }])
    return Data
  }())

  /**
   * cx.undo.Step
   * 回退的步骤类
   *
   * @class
   * @memberof    cx.undo
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var Step = (function()
  {
    /**
     * @constructor
     * @param   {Object}        [options]               参数对象
     * @param   {cx.Caller}     [options.readyCall]     数据备份完成后回调对象
     * @param   {Boolean}       [options.noAid = false] 是否不备份标注和附属设备,默认要备份
     */
    function Step()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, Step)

      /** * @property {Number} stepId        * step对象的id */
      this.stepId = 0
      /** * @property {Data} dataOld            * 备份的数据对象 */
      this.dataOld = new Data({ readyCall: new Caller(this, 'readyData'), noAid: options.noAid })
      /** * @property {Data} dataNew            * 新增的数据对象 */
      this.dataNew = new Data()
      /** * @property {Number} major        * 回退操作数据的主类型 */
      this.major = 0
      /** * @property {Number} minor        * 回退操作数据的子类型 */
      this.minor = 0
      /** * @property {Number} id          * 回退操作数据的id */
      this.id = 0
      /** * @property {Date} time          * 回退创建的时间 */
      this.time = new Date() //时间
      /** * @property {cx.Caller} readyCall    * 回退数据备份完成后回调 */
      this.readyCall = options.readyCall
    }

    /**
     * 析构函数
     * @method
     */


    createClass(Step, [{
      key: 'destroy',
      value: function destroy()
      {
        this.readyCall = null
        this.dataNew = null
        this.dataOld = null
      }

      /**
       * 设置步骤的id
       * @method
       * @param {Number} newId id值
       */

    }, {
      key: 'setStepId',
      value: function setStepId(newId)
      {
        this.stepId = newId
      }

      /**
       * 设置步骤的id
       * @method
       * @returns {Number}     该步骤的id值
       */

    }, {
      key: 'getStepId',
      value: function getStepId()
      {
        return this.stepId
      }

      /**
       * 获取步骤对象创建的时间
       * @method
       * @returns {String}    时间字符串
       */

    }, {
      key: 'getTime',
      value: function getTime()
      {
        return Formatter.time(this.time)
      }

      /**
       * 获取步骤对象名称标题
       * @method
       * @returns {String}    名称
       */

    }, {
      key: 'getTitle',
      value: function getTitle()
      {
        return ''
      }

      /**
       * 获取步骤对象是否可跳过，执行后面的步骤
       * @method
       * @returns {Boolean}
       */

    }, {
      key: 'canSkip',
      value: function canSkip()
      {
        return false
      }

      /**
       * 步骤的对象的详细内容
       * @method
       */

    }, {
      key: 'detail',
      value: function detail()
      {}

      /**
       * 设置回退的信息
       * @method
       * @param {Number}      major         主类型
       * @param {Number}      minor         子类型
       * @param {Number}      id            id
       */

    }, {
      key: 'backup',
      value: function backup(major, minor, id)
      {
        this.major = major
        this.minor = minor
        this.id = id
      }

      /**
       * 开始备份数据
       * @method
       */

    }, {
      key: 'start',
      value: function start()
      {
        this.dataOld.start()
      }

      /**
       * 执行回退
       * @method
       */

    }, {
      key: 'undo',
      value: function undo()
      {}
      //回退时
      //重写该函数


      /**
       * 设置数据
       * @method
       * @param {Object} data 数据对象
       */

    }, {
      key: 'setData',
      value: function setData(data)
      {
        this.data = data
      }

      /**
       * 获取数据
       * @method
       * @returns {Object} data 数据对象
       */

    }, {
      key: 'getData',
      value: function getData()
      {
        return this.data
      }

      /**
       * 该步骤数据准备好后，执行
       * @method
       */

    }, {
      key: 'readyData',
      value: function readyData()
      {
        if (this.readyCall) this.readyCall.call()
      }
    }])
    return Step
  }())

  /**
   * cx.undo.AttDelete
   * 回退-属性删除
   *
   * @class
   * @memberof    cx.undo
   * @extends     undo.Step
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var AttDelete = (function(_Step)
  {
    inherits(AttDelete, _Step)

    /**
     * @constructor
     * @param   {Object}    [options = {}]
     */
    function AttDelete()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, AttDelete)
      return possibleConstructorReturn(this, (AttDelete.__proto__ || Object.getPrototypeOf(AttDelete)).call(this, options))
    }

    /**
     * 获取回退动作
     * @method
     * @returns {String}                回退动作
     */


    createClass(AttDelete, [{
      key: 'getTitle',
      value: function getTitle()
      {
        var ett = Global.entity.byMajMin(this.major, this.minor)
        if (ett) return Base.locale('删除 - ' + ett.namec, 'Delete - ' + ett.namee)
        return ''
      }

      /**
       * 数据备份
       * @method
       * @param   {Number}    major       操作对象的major
       * @param   {Number}    minor       操作对象的minor
       * @param   {Number}    att         操作对象的att
       */

    }, {
      key: 'backup',
      value: function backup(major, minor, att)
      {
        this.major = major
        this.minor = minor
        this.att = att
      }

      /**
       * 回退操作
       * @method
       */

    }, {
      key: 'undo',
      value: function undo()
      {
        cx.svr.attOper.insertWithId(this.major, this.minor, this.att, 0).then(function(attNew)
        {})
      }

      /**
       * 回退记录的详细信息
       * @method
       */

    }, {
      key: 'detail',
      value: function detail()
      {
        Run.runPlug('AttView', { major: this.major, minor: this.minor, att: this.att })
      }
    }])
    return AttDelete
  }(Step))

  /**
   * cx.undo.AttInsert
   * 回退-属性插入
   *
   * @class
   * @memberof    cx.undo
   * @extends     cx.undo.Step
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var AttInsert = (function(_Step)
  {
    inherits(AttInsert, _Step)

    /**
     * @constructor
     * @param   {Object}    [options = {}]
     */
    function AttInsert()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, AttInsert)
      return possibleConstructorReturn(this, (AttInsert.__proto__ || Object.getPrototypeOf(AttInsert)).call(this, options))
    }

    /**
     * 获取回退动作
     * @method
     * @returns {String}                回退动作
     */


    createClass(AttInsert, [{
      key: 'getTitle',
      value: function getTitle()
      {
        var ett = Global.entity.byMajMin(this.major, this.minor)
        if (ett) return Base.locale('增加 - ' + ett.namec, 'Insert - ' + ett.namee)
        return ''
      }

      /**
       * 数据备份
       * @method
       * @param   {Number}    major       操作对象的major
       * @param   {Number}    minor       操作对象的minor
       * @param   {Number}    att         操作对象的att
       */

    }, {
      key: 'backup',
      value: function backup(major, minor, att)
      {
        this.major = major
        this.minor = minor
        this.att = att
      }

      /**
       * 回退操作
       * @method
       */

    }, {
      key: 'undo',
      value: function undo()
      {
        cx.svr.attOper.del(this.major, this.minor, this.att)
      }

      /**
       * 回退记录的详细信息
       * @method
       */

    }, {
      key: 'detail',
      value: function detail()
      {
        Run.runPlug('AttView', { major: this.major, minor: this.minor, att: this.att })
      }
    }])
    return AttInsert
  }(Step))

  /**
   * cx.undo.AttInsertFile
   * 回退-属性插入
   *
   * @class
   * @memberof    cx.undo
   * @extends     cx.undo.Step
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var AttInsertFile = (function(_Step)
  {
    inherits(AttInsertFile, _Step)

    /**
     * @constructor
     * @param   {Object}    [options = {}]
     */
    function AttInsertFile()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, AttInsertFile)
      return possibleConstructorReturn(this, (AttInsertFile.__proto__ || Object.getPrototypeOf(AttInsertFile)).call(this, options))
    }

    /**
     * 获取回退动作
     * @method
     * @returns {String}    回退动作
     */


    createClass(AttInsertFile, [{
      key: 'getTitle',
      value: function getTitle()
      {
        var ett = Global.entity.byMajMin(this.major, this.minor)
        if (ett) return Base.locale('增加 - ' + ett.namec, 'Insert - ' + ett.namee)
        return ''
      }

      /**
       * 数据备份
       * @method
       * @param {Number} major 操作对象的major
       * @param {Number} minor 操作对象的minor
       * @param {Number} id 操作对象的id
       */

    }, {
      key: 'backup',
      value: function backup(major, minor, id)
      {
        get(AttInsertFile.prototype.__proto__ || Object.getPrototypeOf(AttInsertFile.prototype), 'backup', this).call(this, major, minor, id)
        this.start()
      }

      /**
       * 回退操作
       * @method
       */

    }, {
      key: 'undo',
      value: function undo()
      {
        var att = this.dataNew.getAtt(this.major, this.minor, this.id)
        cx.svr.attOper.del_File(this.major, this.minor, this.id, att, null)
      }

      /**
       * 回退记录的详细信息
       * @method
       */

    }, {
      key: 'detail',
      value: function detail()
      {
        var att = void 0
        att = this.dataNew.getAtt(this.major, this.minor, this.id)
        Run.runPlugin('AttDisp', { major: this.major, minor: this.minor, att: att })
      }
    }])
    return AttInsertFile
  }(Step))

  /**
   * cx.undo.AttUpdate
   * 回退-属性更新
   *
   * @class
   * @memberof    cx.undo
   * @extends     cx.undo.Step
   * @author      Zhang Fayong
   * @since       2018-04-29
   */

  var AttUpdate = (function(_Step)
  {
    inherits(AttUpdate, _Step)

    /**
     * @constructor
     * @param   {Object}    [options = {}]
     */
    function AttUpdate()
    {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      classCallCheck(this, AttUpdate)
      return possibleConstructorReturn(this, (AttUpdate.__proto__ || Object.getPrototypeOf(AttUpdate)).call(this, options))
    }

    /**
     * 获取回退动作
     * @method
     * @returns {String}    回退动作
     */


    createClass(AttUpdate, [{
      key: 'getTitle',
      value: function getTitle()
      {
        var ett = Global.entity.byMajMin(this.major, this.minor)
        if (ett) return Base.locale('修改 - ' + ett.namec, 'Update - ' + ett.namee)
        return ''
      }

      /**
       * 数据备份
       * @method
       * @param {Number}    major           操作对象的major
       * @param {Number}    minor           操作对象的minor
       * @param {Object}    attNew          新的属性
       * @param {Object}    attOld          原来的属性
       */

    }, {
      key: 'backup',
      value: function backup(major, minor, attNew, attOld)
      {
        this.major = major
        this.minor = minor
        this.attNew = attNew
        this.attOld = attOld
      }

      /**
       * 回退操作
       * @method
       */

    }, {
      key: 'undo',
      value: function undo()
      {
        cx.svr.attOper.update(this.major, this.minor, this.attOld, this.attNew)
      }

      /**
       * 回退记录的详细信息
       * @method
       */

    }, {
      key: 'detail',
      value: function detail()
      {
        var paras = {
          major: this.major,
          minor: this.minor,
          attOld: this.attOld,
          attNew: this.attNew
        }
        Run.runPlug('AttDiff', paras)
      }

      /**
       * 在回退记录列表中是否可跳过，回退后面的
       * @method
       */

    }, {
      key: 'canSkip',
      value: function canSkip()
      {
        return true
      }
    }])
    return AttUpdate
  }(Step))

  /**
   * @class       cx.vueEx
   *
   * 回退-属性删除
   *
   * @author      Zhang Fayong
   * @since       2018-05-14
   */

  var VueEx = (function()
  {
    function VueEx()
    {
      classCallCheck(this, VueEx)
    }

    createClass(VueEx, null, [{
      key: 'extend',

      /**
       * 扩展vue
       * @static
       * @method
       * @param {Object}    vue     vue对象
       */
      value: function extend(vue)
      {
        /**
         * 取字符串
         * @method
         * @param {String}    key           字符串key
         * @param {*}         argvs         变参
         */
        vue.prototype.$loc = function(key)
        {
          var ret = this.$t(key)

          for (var _len = arguments.length, argvs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)
          
            argvs[_key - 1] = arguments[_key]
          

          if (argvs.length > 0)
          {
            for (var i = 0; i < argvs.length; i++)
            
              ret = ret.replace('%' + (i + 1), '' + argvs[i])
          }
          return ret
        }

        /**
         * 正在处理提示控件，不显示具体进度
         */
        vue.prototype.$processing = {
          _loads: [],
          _getDom: function _getDom(target)
          {
            if (target) return Base.isStr(target) ? document.getElementById(target) || document.body : target; else return document.body
          },

          /**
           * 显示控件
           * @method
           * @param {Element|String|null}  [target]       正在加载显示的容器对象或id，默认是body
           */
          show: function show(target)
          {
            var dom = this._getDom(target)
            this.loading = vm.$loading({
              lock: true,
              text: vm.$loc('cx.processing'),
              spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.5)',
              customClass: 'cx-processing',
              target: dom
            })

            this._loads.push({ dom: dom, load: this.loading })
          },

          /**
           * 关闭控件
           * @method
           * @param {Element|String|null}  [target]       正在加载显示的容器对象或id，默认是body
           */
          close: function close(target)
          {
            var dom = this._getDom(target)
            var idx = this._loads.findIndex(function(item)
            {
              return item.dom === dom
            })
            var loadObj = this._loads[idx]

            if (!loadObj && this._loads.length === 1)
            {
              loadObj = this._loads[0]
              idx = 0
            }

            if (loadObj && loadObj.load)
            {
              loadObj.load.close()
              this._loads.splice(idx, 1)
            }
          }
        }

        /**
         * 显示返回结果
         * @method
         * @param {Object}    ret           服务返回值
         * @param {String}    [failMsg]     错误提示
         * @param {String}    [successMsg]  成功执行信息
         */
        vue.prototype.$showRet = function(ret, failMsg, successMsg)
        {
          if (ret.ret !== undefined)
          {
            if (ret.ret === 0)
            {
              if (successMsg) this.$message({ type: 'success', message: successMsg })
            }
            else if (ret.ret === 1)
            
              if (ret.errcode) this.$message.error(this.$t('cx.' + ret.errcode)); else if (ret.msg) this.$message.error(ret.msg); else this.$message.error(failMsg)
          }
          else if (ret.errcode) this.$message.error(this.$t('cx.' + ret.errcode)); else if (ret.msg) this.$message.error(ret.msg); else if (ret instanceof Error) this.$message.error(ret.message); else
          
          if (failMsg) this.$message.error(failMsg)
        }

        /**
         * 显示信息
         * @method
         * @param {String}    message       消息文本
         * @param {String}    [type]        类型(success/warning/info/error)
         * @param {Object}    [opts]        配置参数对象
         */
        vue.prototype.$showMsg = function(message, type, opts)
        {
          if (!type) this.$message(message); else
          
          if (type === 'error') this.$message.error(message); else this.$message(Base.extend({ type: type, message: message }, opts))
        }

        /**
         * 显示错误信息
         * @method
         * @param {String}    message       消息文本
         */
        vue.prototype.$showError = function(messages)
        {
          this.$message.error(messages)
        }

        /**
         * 显示错误代码
         * @method
         * @param {String}    errCode       错误代码
         */
        vue.prototype.$showErrCode = function(errCode)
        {
          var err = this.$loc(errCode)
          this.$message.error(err ? err : errCode)
        }

        /**
         * 确认信息
         * @method
         * @param   {String}    message       消息文本
         * @returns {Promise}
         */
        vue.prototype.$cfmMsg = function(message)
        {
          return this.$confirm(message, this.$loc('cx.prompt'), {
            confirmButtonText: this.$loc('cx.btnOk'),
            cancelButtonText: this.$loc('cx.btnCancel'),
            type: 'warning'
          })
        }

        /**
         * 取字段值
         * @method
         * @param   {String}      colname     字段名
         * @returns {*}
         */
        vue.prototype.$getFldVal = function(colname)
        {
          var _iteratorNormalCompletion = true
          var _didIteratorError = false
          var _iteratorError = undefined

          try
          {
            for (var _iterator = this.flds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
            {
              var fld = _step.value

              if (fld.colname === colname) return fld.value
            }
          }
          catch (err)
          {
            _didIteratorError = true
            _iteratorError = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion && _iterator.return)
              
                _iterator.return()
            }
            finally
            {
              if (_didIteratorError)
              
                throw _iteratorError
            }
          }

          return ''
        }

        /**
         * 设置字段值
         * @method
         * @param   {String}      colname     字段名
         * @param   {*}           value       字段值
         */
        vue.prototype.$setFldVal = function(colname, value)
        {
          var _iteratorNormalCompletion2 = true
          var _didIteratorError2 = false
          var _iteratorError2 = undefined

          try
          {
            for (var _iterator2 = this.flds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
            {
              var fld = _step2.value

              if (fld.colname === colname)
              {
                fld.value = value
                break
              }
            }
          }
          catch (err)
          {
            _didIteratorError2 = true
            _iteratorError2 = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion2 && _iterator2.return)
              
                _iterator2.return()
            }
            finally
            {
              if (_didIteratorError2)
              
                throw _iteratorError2
            }
          }
        }

        /**
         * 设置字段值
         * @method
         * @param   {Object}      refed       被引用的字段信息(#{prdid}:id => {prdid: id})
         * @param   {Object}      values      字段值
         */
        vue.prototype.$setRef = function(refed, values)
        {
          var key = void 0,
            fld = void 0
          for (key in refed)
          {
            this.$setFldVal(key, values[refed[key]])

            //如果别的字段引用了该字段的值，则需要通知到他们(如果字段显示出来了，fldChange会通知)
            var _iteratorNormalCompletion3 = true
            var _didIteratorError3 = false
            var _iteratorError3 = undefined

            try
            {
              for (var _iterator3 = this.flds[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)
              {
                fld = _step3.value

                if (!fld.show && fld.colname === key) this.$fldChange(fld)
              }
            }
            catch (err)
            {
              _didIteratorError3 = true
              _iteratorError3 = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion3 && _iterator3.return)
                
                  _iterator3.return()
              }
              finally
              {
                if (_didIteratorError3)
                
                  throw _iteratorError3
              }
            }
          }
        }

        /**
         * 字段值发生变化
         * @method
         * @param   {Object}      fld         字段信息
         */
        vue.prototype.$fldChange = function(fld)
        {
          var fld1 = void 0,
            ref = void 0

          //先处理自己这一行
          switch (fld.type)
          {
          case Consts.DISP_SELDEPPOS:
            this.$selDepPos(fld)
            break
          case Consts.DISP_SELDYNA:
            //设置引用字段的值
            var opt = Array$1.get1(fld.options, { value: fld.value })
            if (opt) this.$setRef(fld.refed, opt)
            break
          }

          //如果别的字段引用了该字段的值，则需要通知到他们
          var _iteratorNormalCompletion4 = true
          var _didIteratorError4 = false
          var _iteratorError4 = undefined

          try
          {
            for (var _iterator4 = this.flds[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true)
            {
              fld1 = _step4.value

              if (fld1 !== fld)
              {
                if (fld1.refs)
                {
                  var _iteratorNormalCompletion5 = true
                  var _didIteratorError5 = false
                  var _iteratorError5 = undefined

                  try
                  {
                    for (var _iterator5 = fld1.refs[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true)
                    {
                      ref = _step5.value

                      if (ref === fld.colname) fld1.refChange = fld1.refChange + 1 //强制变化
                    }
                  }
                  catch (err)
                  {
                    _didIteratorError5 = true
                    _iteratorError5 = err
                  }
                  finally
                  {
                    try
                    {
                      if (!_iteratorNormalCompletion5 && _iterator5.return)
                      
                        _iterator5.return()
                    }
                    finally
                    {
                      if (_didIteratorError5)
                      
                        throw _iteratorError5
                    }
                  }
                }
              }
            }

            //规则
          }
          catch (err)
          {
            _didIteratorError4 = true
            _iteratorError4 = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion4 && _iterator4.return)
              
                _iterator4.return()
            }
            finally
            {
              if (_didIteratorError4)
              
                throw _iteratorError4
            }
          }

          if ($g.tabrules)
          {
            var tabule = $g.tabrules.getTabRule(fld.tabname, this.flds)
            if (tabule) tabule.change(fld, this.flds, this)
          }

          this.$emit('fldChange', fld)
        }

        /**
         * 选择部门、职位发生变化后的调用函数
         * @method
         * @param   {Object}      fld         字段信息
         */
        vue.prototype.$selDepPos = function(fld)
        {
          if (fld.config)
          {
            var config = fld.config //'select:department,field:namec,#{cstdep}:namec'
            var opts = void 0,
              opt = void 0

            opts = []
            if (config.select === 'department') //选择部门
              opts = $g.init.organ; else if (config.select === 'position') //选择职位
              opts = $g.init.organ

            var _iteratorNormalCompletion6 = true
            var _didIteratorError6 = false
            var _iteratorError6 = undefined

            try
            {
              for (var _iterator6 = opts[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true)
              {
                opt = _step6.value

                if (opt[config.field] === fld.value) //找到当前选中的条目
                {
                  this.$setRef(fld.refed, opt) //设置其他需要修改的字段
                  break
                }
              }
            }
            catch (err)
            {
              _didIteratorError6 = true
              _iteratorError6 = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion6 && _iterator6.return)
                
                  _iterator6.return()
              }
              finally
              {
                if (_didIteratorError6)
                
                  throw _iteratorError6
              }
            }
          }
        }

        /**
         * 选择按钮后的调用函数
         * @method
         * @param   {Object}      fld         字段信息
         */
        vue.prototype.$valButton = function(fld)
        {
          var _this = this

          if (fld.config)
          {
            var config = fld.config //'plugin:SelCustomer,field:name,#{custid}:id,params:'
            var field = config.field

            //回调函数
            var onOk = function onOk(ret)
            {
              fld.value = ret[field] //赋值
              _this.$setRef(fld.refed, ret)
              _this.$fldChange(fld)
            }

            var params = void 0,
              param = void 0
            var arrParam = (config.params || '').split(',')
            var matches = void 0

            if (config.func) //运行函数
            {
              //构造插件调用参数
              params = []
              var _iteratorNormalCompletion7 = true
              var _didIteratorError7 = false
              var _iteratorError7 = undefined

              try
              {
                for (var _iterator7 = arrParam[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true)
                {
                  param = _step7.value

                  if (!param) continue
                  if (RegEx.refId.test(param))
                  {
                    matches = param.match(RegEx.refId)
                    params.push(this.$getFldVal(matches[1]))
                  }
                  else params.push(param)
                }

                //发起请求取数据
              }
              catch (err)
              {
                _didIteratorError7 = true
                _iteratorError7 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion7 && _iterator7.return)
                  
                    _iterator7.return()
                }
                finally
                {
                  if (_didIteratorError7)
                  
                    throw _iteratorError7
                }
              }

              Base.execute(config.func, params).then(onOk).catch(this.onError)
            }
            else if (config.plugin) //运行插件
            {
              var arrItem = void 0,
                paramKey = void 0,
                paramVal = void 0

                //构造插件调用参数
              params = {}
              var _iteratorNormalCompletion8 = true
              var _didIteratorError8 = false
              var _iteratorError8 = undefined

              try
              {
                for (var _iterator8 = arrParam[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true)
                {
                  param = _step8.value

                  if (!param) continue
                  arrItem = param.split('-')
                  paramKey = arrItem[0]
                  paramVal = arrItem[1]
                  if (!paramKey) continue
                  if (RegEx.refId.test(paramVal))
                  {
                    matches = paramVal.match(RegEx.refId)
                    params[paramKey] = this.$getFldVal(matches[1])
                  }
                  else params[paramKey] = paramVal
                }
              }
              catch (err)
              {
                _didIteratorError8 = true
                _iteratorError8 = err
              }
              finally
              {
                try
                {
                  if (!_iteratorNormalCompletion8 && _iterator8.return)
                  
                    _iterator8.return()
                }
                finally
                {
                  if (_didIteratorError8)
                  
                    throw _iteratorError8
                }
              }

              params.onOk = onOk

              //运行插件
              Run.runPlug(config.plugin, params)
            }
          }
        }

        /**
         * 动态选择数据发生变化之后的调用函数
         * @method
         * @param   {Object}      fld         字段信息
         */
        vue.prototype.$selDyna = function(fld)
        {
          var config = fld.config //'func:cx.oa.getCity(),params:#{province},field:name,fieldDisp:name'
          var refs = fld.refs
          var func = config.func
          var argvs = []
          var i = void 0

          //构造函数调用参数
          for (i = 0; i < refs.length; i++)
          
            argvs.push(this.$getFldVal(refs[i]))
          //压入参数

          //回调函数
          var onSuccess = function onSuccess(ret)
          {
            var valueFld = config.field
            var labelFld = config.fieldDisp

            if (!labelFld) //如果没有设置显示字段
              labelFld = valueFld

            //先清除数据
            Array$1.clear(fld.options)

            //把结果压入到下拉列表
            if (fld.expMode) fld.options.push({ value: '', label: '' }) //增加一个空行供不选择
            var _iteratorNormalCompletion9 = true
            var _didIteratorError9 = false
            var _iteratorError9 = undefined

            try
            {
              for (var _iterator9 = ret[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true)
              {
                var item = _step9.value

                item.label = item[labelFld]
                item.value = item[valueFld]
                fld.options.push(item)
              }
            }
            catch (err)
            {
              _didIteratorError9 = true
              _iteratorError9 = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion9 && _iterator9.return)
                
                  _iterator9.return()
              }
              finally
              {
                if (_didIteratorError9)
                
                  throw _iteratorError9
              }
            }
          }

          //发起请求取数据
          Base.execute(func, argvs).then(onSuccess)
        }

        /**
         * 字段验证
         * @method
         * @param   {Object}      fld         字段信息
         */
        vue.prototype.$valid = function(fld)
        {
          var _this2 = this

          var title = fld.title
          var val = fld.value === null || fld.value === undefined ? '' : '' + fld.value //保证是字符串
          var tmp = void 0
          var curVal = void 0

          var error = function error(msg)
          {
            _this2.$showMsg(msg, 'error')
          }

          if (!fld.disped) //如果没有显示，则不校验（有的字段是不显示的）
            return true

          if (!val) //''
          {
            if (fld.required) //必填
            {
              error(this.$loc('cx.fldRequired', title))
              return false
            }
            return true
          }

          if (fld.minlen && val.length < parseInt(fld.minlen)) //最小长度
          {
            error(this.$loc('cx.fldMinlen', title, fld.minlen))
            return false
          }

          if (fld.maxlen && val.length > parseInt(fld.maxlen)) //最大长度
          {
            error(this.$loc('cx.fldMaxlen', title, fld.maxlen))
            return false
          }

          if (fld.isnum)
          {
            if (!Number$1.is(val)) //数值型
            {
              error(this.$loc('cx.fldNumber', title))
              return false
            }

            curVal = parseFloat(val)
            if (fld.minval && curVal < parseInt(fld.minval)) //最小值
            {
              error(this.$loc('cx.fldMinVal', title, fld.minval))
              return false
            }

            if (fld.maxval && curVal > parseInt(fld.maxval)) //最大值
            {
              error(this.$loc('cx.fldMaxVal', title, fld.maxval))
              return false
            }
          }

          //数据格式
          switch (fld.type)
          {
          case Consts.DISP_DATE:
            if (!DateCx.parse(val))
            {
              error(this.$loc('cx.fldDate', title))
              return false
            }
            break
          case Consts.DISP_TIMESTAMP:
            if (!Datetime.parse(val))
            {
              error(this.$loc('cx.fldTimestamp', title))
              return false
            }
            break
          case Consts.DISP_TIME:
            if (!Time.parse(val))
            {
              error(this.$loc('cx.fldTime', title))
              return false
            }
            break
          }

          //匹配模式
          if (fld.pattern)
          {
            tmp = eval(fld.pattern)
            if (!tmp.test(val))
            {
              error(this.$loc('cx.fldPattern', title))
              return false
            }
          }

          return true
        }

        /**
         * 根据字段产生验证规则
         * @method
         * @param   {Array}     flds        字段信息列表
         * @returns {Object}
         */
        vue.prototype.$rules = function(flds)
        {
          var ret = {}
          var fld = void 0,
            rule = void 0,
            fldRules = void 0

          var _iteratorNormalCompletion10 = true
          var _didIteratorError10 = false
          var _iteratorError10 = undefined

          try
          {
            for (var _iterator10 = flds[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true)
            {
              fld = _step10.value

              if (!fld.editable) continue

              fldRules = []

              //必填项
              if (fld.required && fld.value === '')
              {
                rule = { required: true, message: this.$loc('cx.fldRequired', fld.title) }
                rule.type = 'string'
                fldRules.push(rule)
              }

              //长度限制
              if (!fld.isnum && (fld.minlen || fld.maxlen))
              {
                if (fld.minlen && !fld.maxlen) fldRules.push({ min: parseInt(fld.minlen), message: this.$loc('cx.fldMinlen', fld.title, fld.minlen) }); else if (!fld.minlen && fld.maxlen) fldRules.push({ max: parseInt(fld.maxlen), message: this.$loc('cx.fldMaxlen', fld.title, fld.maxlen) }); else
                {
                  rule = { min: parseInt(fld.minlen), max: parseInt(fld.maxlen) }
                  if (fld.minlen === fld.maxlen) rule.message = this.$loc('cx.fldLen', fld.title, fld.minlen); else rule.message = this.$loc('cx.fldLenRange', fld.title, fld.minlen, fld.maxlen)
                }
                if (rule)
                {
                  rule.type = 'string'
                  fldRules.push(rule)
                }
              }

              //值域限制(目前在elementUI上实现值域限制很困难，先屏蔽掉)
              // if (fld.isnum && (fld.minval || fld.maxval))
              // {
              //   if (fld.minval && !fld.maxval)
              //     rule = {min: parseInt(fld.minval), message: this.$loc('cx.fldMinVal', fld.title, fld.minval)}
              //   else if (!fld.minval && fld.maxval)
              //     rule = {max: parseInt(fld.maxval), message: this.$loc('cx.fldMaxVal', fld.title, fld.maxval)}
              //   else
              //   {
              //     rule = {min: parseInt(fld.minval), max: parseInt(fld.maxval)}
              //     if (fld.minval === fld.maxval)
              //       rule.message = this.$loc('cx.fldVal', fld.title, fld.minval)
              //     else
              //       rule.message = this.$loc('cx.fldValRange', fld.title, fld.minval, fld.maxval)
              //   }
              //   rule.type = 'number'
              //   fldRules.push(rule)
              // }

              //匹配模式
              if (fld.pattern) fldRules.push({ type: 'regexp', pattern: eval(fld.pattern), message: this.$loc('cx.fldPattern', fld.title) })

              if (fldRules.length > 0)
              {
                var _iteratorNormalCompletion11 = true
                var _didIteratorError11 = false
                var _iteratorError11 = undefined

                try
                {
                  for (var _iterator11 = fldRules[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true)
                  {
                    rule = _step11.value

                    rule.trigger = 'blur'
                  }
                }
                catch (err)
                {
                  _didIteratorError11 = true
                  _iteratorError11 = err
                }
                finally
                {
                  try
                  {
                    if (!_iteratorNormalCompletion11 && _iterator11.return)
                    
                      _iterator11.return()
                  }
                  finally
                  {
                    if (_didIteratorError11)
                    
                      throw _iteratorError11
                  }
                }

                ret[fld.colname] = fldRules
              }
            }
          }
          catch (err)
          {
            _didIteratorError10 = true
            _iteratorError10 = err
          }
          finally
          {
            try
            {
              if (!_iteratorNormalCompletion10 && _iterator10.return)
              
                _iterator10.return()
            }
            finally
            {
              if (_didIteratorError10)
              
                throw _iteratorError10
            }
          }

          return ret
        }

        /**
         * 根据字段产生验证规则
         * @method
         * @param   {Array}     flds        字段信息列表
         * @returns {Object}
         */
        vue.prototype.$mergeRules = function(rules, newRules)
        {
          var key1 = void 0
          var fld1 = void 0,
            fld2 = void 0
          var rule1 = void 0,
            rule2 = void 0
          var exist = void 0
          var i = void 0

          //规则里面有，新规则没有的，删除
          for (key1 in rules)
          {
            fld1 = rules[key1]
            fld2 = newRules[key1]

            if (!fld2)
            {
              delete rules[key1]
              continue
            }

            for (i = fld1.length - 1; i >= 0; i--)
            {
              rule1 = fld1[i]
              exist = 1
              if (rule1.required !== undefined)
              {
                rule2 = cx.array.get1(fld2, { required: rule1.required })
                if (!rule2) exist = 0
              }
              if (rule1.min !== undefined)
              {
                rule2 = cx.array.get1(fld2, { min: rule1.min })
                if (!rule2) exist = 0
              }
              if (rule1.max !== undefined)
              {
                rule2 = cx.array.get1(fld2, { min: rule1.max })
                if (!rule2) exist = 0
              }
              if (!exist) fld1.splice(i, 1)
            }
          }

          //新规则有，老规则没有的，添加
          for (key1 in newRules)
          {
            fld1 = newRules[key1]
            fld2 = rules[key1]

            if (!fld2)
            {
              rules[key1] = fld1
              continue
            }

            for (i = fld1.length - 1; i >= 0; i--)
            {
              rule1 = fld1[i]
              exist = 1
              if (rule1.required !== undefined)
              {
                rule2 = cx.array.get1(fld2, { required: rule1.required })
                if (!rule2) exist = 0
              }
              if (rule1.min !== undefined)
              {
                rule2 = cx.array.get1(fld2, { min: rule1.min })
                if (!rule2) exist = 0
              }
              if (rule1.max !== undefined)
              {
                rule2 = cx.array.get1(fld2, { min: rule1.max })
                if (!rule2) exist = 0
              }
              if (!exist) fld2.push(rule1)
            }
          }
        }
      }
    }])
    return VueEx
  }())

  var registers$1 = {}

  var Register = (function()
  {
    function Register()
    {
      classCallCheck(this, Register)
    }

    createClass(Register, null, [{
      key: 'get',

      /**
       * 根据Key取注册的模板组件
       * @static
       * @method
       * @param   {String}    name          名称
       * @param   {String}    [domain]      域
       * @returns {Object}                  结构如 {tag: String, com: Object}
       */
      value: function get(name, domain)
      {
        if (domain)
        {
          if (registers$1[domain]) return registers$1[domain][name]
        }
        else return registers$1[name]
      }

      /**
       * 注册模板属性组件
       * @static
       * @method
       * @param   {String}    name          名称
       * @param   {String}    template      HTML模板
       * @returns {Object}                  结构如 {tag: String, com: Object}
       */

    }, {
      key: 'tmplAtt',
      value: function tmplAtt(name, template)
      {
        var obj = void 0

        obj = registers$1[name]
        if (obj) return obj

        template = template.replace('<el-form', '<el-form ref="listForm"')

        var com = Vue__default['default'].extend({
          template: template,
          props: {
            flds: { type: Array, required: true }
          },

          data: function data()
          {
            return {
              values: {}, //数据
              rules: {} //验证规则
            }
          },
          mounted: function mounted()
          {
            this.rules = this.$rules(this.flds)

            var _iteratorNormalCompletion = true
            var _didIteratorError = false
            var _iteratorError = undefined

            try
            {
              for (var _iterator = this.flds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)
              {
                var fld = _step.value

                this.values[fld.colname] = fld.value
              }
            }
            catch (err)
            {
              _didIteratorError = true
              _iteratorError = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion && _iterator.return)
                
                  _iterator.return()
              }
              finally
              {
                if (_didIteratorError)
                
                  throw _iteratorError
              }
            }
          },


          methods: {
            getFld: function getFld(colname) //根据列名取列信息
            {
              return Array$1.get1(this.flds, { colname: colname })
            },
            onFldChange: function onFldChange(fld) //字段值发生变化
            {
              if (fld.value !== this.values[fld.colname]) this.values[fld.colname] = fld.value

              this.$refs['listForm'].clearValidate(fld.colname)
              this.$mergeRules(this.rules, this.$rules(this.flds))

              this.$fldChange(fld)
            },
            onValButton: function onValButton(fld) //消息响应函数-点击ValButton
            {
              this.$valButton(fld)
            },
            onSelDyna: function onSelDyna(fld) //当数据变化的时候，执行动态选择加载数据
            {
              this.$selDyna(fld)
            },
            onRuleChange: function onRuleChange(fld)
            {
              this.$refs['listForm'].clearValidate()
              this.$mergeRules(this.rules, this.$rules(this.flds))
            }
          }
        })

        obj = {
          tag: 'cx-tmplatt-' + Base.nextId(),
          com: com
        }
        Vue__default['default'].component(obj.tag, com)
        registers$1[name] = obj

        return obj
      }

      /**
       * 注册定制属性组件
       * @static
       * @method
       * @param   {String}    name            名称
       * @param   {String}    template        HTML模板
       * @param   {String}    domain          域
       * @returns {Object}                    结构如 {tag: String, com: Object}
       */

    }, {
      key: 'custAtt',
      value: function custAtt(name, template, domain)
      {
        var obj = void 0

        if (!registers$1[domain]) registers$1[domain] = {}
        obj = registers$1[domain][name]
        if (obj) return obj

        template = template.replace('<el-form', '<el-form ref="listForm" ')

        var com = Vue__default['default'].extend({
          template: template,
          data: function data()
          {
            return {
              flds: [],
              values: {}, //值
              rules: {} //验证规则
            }
          },
          mounted: function mounted()
          {
            this.rules = this.$rules(this.flds)

            var _iteratorNormalCompletion2 = true
            var _didIteratorError2 = false
            var _iteratorError2 = undefined

            try
            {
              for (var _iterator2 = this.flds[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)
              {
                var fld = _step2.value

                this.values[fld.colname] = fld.value
              }
            }
            catch (err)
            {
              _didIteratorError2 = true
              _iteratorError2 = err
            }
            finally
            {
              try
              {
                if (!_iteratorNormalCompletion2 && _iterator2.return)
                
                  _iterator2.return()
              }
              finally
              {
                if (_didIteratorError2)
                
                  throw _iteratorError2
              }
            }
          },


          methods: {
            getFlds: function getFlds() //取字段列表
            {
              return this.flds
            },
            getFld: function getFld(colname) //根据列名取列信息
            {
              return Array$1.get1(this.flds, { colname: colname })
            },
            onFldChange: function onFldChange(fld) //字段值发生变化
            {
              if (fld.value !== this.values[fld.colname]) this.values[fld.colname] = fld.value

              this.$refs['listForm'].clearValidate(fld.colname)
              this.$mergeRules(this.rules, this.$rules(this.flds))

              this.$fldChange(fld)
            },
            onValButton: function onValButton(fld) //消息响应函数-点击ValButton
            {
              this.$valButton(fld)
            },
            onSelDyna: function onSelDyna(fld) //当数据变化的时候，执行动态选择加载数据
            {
              this.$selDyna(fld)
            },
            onRuleChange: function onRuleChange(fld)
            {
              this.$refs['listForm'].clearValidate()
              this.$mergeRules(this.rules, this.$rules(this.flds))
            },
            getConfig: function getConfig() //取流程配置信息
            {
              var dom = this.$refs.config
              var config = null

              //取配置
              if (dom && dom.dataset) config = dom.dataset.options

              //解析
              if (config) config = cx.parser.parseOptions(config)

              return config
            }
          }
        })

        obj = {
          tag: 'cx-custatt-' + Base.nextId(),
          com: com
        }
        Vue__default['default'].component(obj.tag, com)
        registers$1[domain][name] = obj

        return obj
      }
    }])
    return Register
  }())

  var Router = (function()
  {
    function Router()
    {
      classCallCheck(this, Router)
    }

    createClass(Router, null, [{
      key: 'addTempRoute',

      // 这种写法打包报错
      // static asyncRoutes = []
      // static tempRoutes = []

      /**
       * 构造临时路由，并添加到vm.$router中
       * @method
       * @static
       * @param {String}          pRouteName               父路由的名称
       * @param {Array<Object>}   routeDatas               待添加的临时路由配置信息集合，每个对象包含以下信息
       * @param {String}          [routeDatas.routeName]   路由名，routeName比name优先级高，至少传一个
       * @param {String}          [routeDatas.name]        插件名，没有routeName是作为路由名。但重复使用的插件应由routeName指定唯一路由名
       * @param {String}          routeDatas.dir           组件的文件路径
       * @param {String}          routeDatas.classurl      组件的文件名
       */
      value: function addTempRoute(pRouteName, routeDatas)
      {
        var _this = this

        //1、首先过滤routeDatas，将已经创建过路由的过滤掉
        var routeList = routeDatas.filter(function(cfg)
        {
          return !_this.tempRoutes.some(function(item)
          {
            return item.pRouteName === pRouteName && item.routeDatas.some(function(li)
            {
              return li.name === cfg.name
            })
          })
        })
        if (routeList.length === 0) return

        //2、更新浏览器中缓存的临时路由信息
        this.updTempCache([{ pRouteName: pRouteName, routeDatas: routeDatas }])

        //3、构造临时路由。
        this.makeTempRoute(pRouteName, routeList)

        //4、将更新后的this.asyncRoutes重新添加到全局路由对象中
        vm.$router.addRoutes(this.asyncRoutes)
      }

      /**
       * 根据路由名称获取对应的路由配置信息对象
       * @method
       * @static
       * @param   {String}    name    路由名称
       * @returns {Object}            对应的路由配置信息对象
       */

    }, {
      key: 'findRoute',
      value: function findRoute(name)
      {
        var route = null
        var findChildren = function findChildren(list)
        {
          if (list.find(function(item)
          {
            return item.name === name
          }))
          {
            route = list.find(function(item)
            {
              return item.name === name
            })
          }
          else
          {
            list.filter(function(item)
            {
              return item.children && item.children.length !== 0
            }).forEach(function(item)
            {
              return findChildren(item.children)
            })
          }
        }
        findChildren(this.asyncRoutes)
        return route
      }

      /**
       * 从plugin表缓存数据中，获取类型为路由的数据集合 uitype为4
       * @method
       * @static
       * @returns   {Array<Object>}   路由配置信息集合
       */

    }, {
      key: 'getPlugsDef',
      value: function getPlugsDef()
      {
        return $g.init.plugin.filter(function(item)
        {
          return Number(item.uitype) === (cx.consts.UI_ROUTE || 4)
        })
      }

      /**
       * 从plugin表获取插件名是name的类型为路由深拷贝数据对象 uitype为4
       * @method
       * @static
       * @param   {String}        name   插件名
       * @returns {Object}               路由配置信息集合
       */

    }, {
      key: 'getPlugDefByName',
      value: function getPlugDefByName(name)
      {
        return JSON.parse(JSON.stringify($g.init.plugin.find(function(item)
        {
          return name === item.name && Number(item.uitype) === (cx.consts.UI_ROUTE || 4)
        })))
      }

      /**
       * 动态添加路由的方法，需要先重置matcher对象，再进行添加操作。
       * @method
       * @static
       * @param     {Array<Object>}   routes     待添加的路由配置对象集合
       */

    }, {
      key: 'addRoutes',
      value: function addRoutes(routes)
      {
        var createRouter = function createRouter()
        {
          return new VueRouter__default['default']({
            linkActiveClass: 'active',
            mode: 'hash',
            base: './',
            routes: vm.$router.options.routes
          })
        }
        //重置 matcher
        vm.$router.matcher = createRouter().matcher
        vm.$router.addRoutes(routes)
      }

      /**
       * 根据权限和plugin表中root根构建嵌套路由对象，并添加到vm.$router中。每个定义对象会存入路由的meta对象的plugDef属性中
       * @method
       * @static
       */

    }, {
      key: 'initAsyncRoutes',
      value: function initAsyncRoutes()
      {
        var _this2 = this

        //1、获取根路由
        this.asyncRoutes = this.getPlugsDef().filter(function(item)
        {
          return item.proute === 'root'
        }).map(function(item)
        {
          return _this2.makeRoute(item)
        })

        //2、遍历根路由，构造路由配置
        this.asyncRoutes.forEach(function(route)
        {
          return _this2.makeChildRoute(route)
        })

        //3、将构造好的路由配置添加到全局路由对象中
        this.addRoutes(this.asyncRoutes)
      }

      /**
       * 根据缓存数据构造临时路由，刷新时还原临时路由数据
       * @method
       * @static
       * @param   {Array<Object>}   routes    临时路由配置信息集合
       */

    }, {
      key: 'initTempRouteByCache',
      value: function initTempRouteByCache()
      {
        var _this3 = this

        var routeDatasStr = cx.localCache.get('tempRoutes')
        if (routeDatasStr)
        {
          var routeDatas = JSON.parse(routeDatasStr)
          if (routeDatas && cx.base.isArr(routeDatas))
          {
            this.tempRoutes = routeDatas
            routeDatas.forEach(function(route)
            {
              return _this3.makeTempRoute(route.pRouteName, route.routeDatas)
            })

            //将更新后的this.asyncRoutes重新添加到路由中
            vm.$router.addRoutes(this.asyncRoutes)
          }
        }
      }

      /**
       * 递归构造路由的下级嵌套路由
       * @method
       * @static
       * @param   {Object}   route   路由配置对象
       */

    }, {
      key: 'makeChildRoute',
      value: function makeChildRoute(route)
      {
        var _this4 = this

        //1、首先找到所有儿子路由
        var children = this.getPlugsDef().filter(function(item)
        {
          return item.proute === route.name
        })
        if (children.length !== 0)
        {
          //2、遍历构造儿子路由并放入当前路由的children属性中
          route.children = children.map(function(item)
          {
            return _this4.makeRoute(item)
          })

          //3、继续递归构造儿子路由的下级嵌套路由
          route.children.forEach(function(item)
          {
            return _this4.makeChildRoute(item)
          })
        }
      }

      /**
       * 根据组件路径信息异步加载组件模块，并注入获取文件路径的方法 getComPath
       * @method
       * @static
       * @param   {Object}   plug            路由配置信息(默认对应plugin表中的纪录)
       * @param   {String}   plug.dir        路由文件所在路径
       * @param   {String}   plug.classurl   路由文件名
       * @returns {Promise}
       */

    }, {
      key: 'makeComponent',
      value: function makeComponent(plug)
      {
        return new Promise(function(resolve)
        {
          // let mod = require(`@/${plug.dir}${plug.classurl}`).default
          var mod = cx.run.loadModuleByDef(plug)
          mod.methods = mod.methods || {}
          mod.methods.getComPath = function(_)
          {
            return '' + plug.dir + plug.classurl
          }
          resolve(mod)
        })
      }

      /**
       * 根据路由的配置信息，构造路由配置对象。plug定义对象会存入路由的meta对象的plugDef属性中，构造的路由对象path使用绝对路径提供地址更安全
       * @method
       * @static
       * @param   {Object}   plug               路由配置信息(默认对应plugin表中的纪录)
       * @param   {String}   [plug.routeName]   路由名，routeName比name优先级高，至少传一个
       * @param   {String}   [plug.name]        插件名，没有routeName是作为路由名。但重复使用的插件应由routeName指定唯一路由名
       * @param   {String}   plug.dir           路由文件所在路径
       * @param   {String}   plug.classurl      路由文件名
       * @returns {Object}                      路由配置对象
       */

    }, {
      key: 'makeRoute',
      value: function makeRoute(plug)
      {
        var _this5 = this

        var route = {
          path: '/' + plug.name,
          name: plug.routeName || plug.name,
          meta: { plugDef: plug },
          component: function component(_)
          {
            return _this5.makeComponent(plug)
          }

          //如果存在默认子路由，则添加重定向到该子路由的配置。
        }; if (plug.defchild) route.redirect = '/' + plug.defchild

        return route
      }

      /**
       * 构造临时路由。每个定义对象会存入路由的meta对象的plugDef属性中
       * @method
       * @static
       * @param {String}          pRouteName               父路由的名称
       * @param {Array<Object>}   routeDatas               待添加的临时路由配置信息集合，每个对象包含以下信息
       * @param {String}          [routeDatas.routeName]   路由名，routeName比name优先级高，至少传一个
       * @param {String}          [routeDatas.name]        插件名，没有routeName是作为路由名。但重复使用的插件应由routeName指定唯一路由名
       * @param {String}          routeDatas.dir           组件的文件路径
       * @param {String}          routeDatas.classurl      组件的文件名
       */

    }, {
      key: 'makeTempRoute',
      value: function makeTempRoute(pRouteName, routeDatas)
      {
        var _pRoute$children,
          _this6 = this

        //1、查找父路由对应的配置信息对象
        var pRoute = this.findRoute(pRouteName) || {}
        pRoute.children = pRoute.children || [];

        //2、开始构造路由
        (_pRoute$children = pRoute.children).push.apply(_pRoute$children, toConsumableArray(routeDatas.map(function(item)
        {
          return _this6.makeRoute(item)
        })))
      }

      /**
       * 备份临时路由的配置数据
       * @method
       * @static
       * @param   {Array<Object>}   data   临时路由的数据集合
       */

    }, {
      key: 'updTempCache',
      value: function updTempCache(data)
      {
        var _tempRoutes;

        (_tempRoutes = this.tempRoutes).push.apply(_tempRoutes, toConsumableArray(data))
        cx.localCache.set('tempRoutes', JSON.stringify(this.tempRoutes))
      }
    }])
    return Router
  }())

  Router.asyncRoutes = []
  Router.tempRoutes = []

  var CX = {
    array: Array$1,
    att: Att,
    AttBase: AttBase,
    AttFactory: AttFactory,
    base: Base,
    CacheLru: CacheLru,
    Caller: Caller,
    Color: Color,
    column: Column,
    consts: Consts,
    converter: Converter,
    date: DateCx,
    datetime: Datetime,
    dom: Dom,
    domClass: DomClass,
    Entities: Entities,
    error: Error$1,
    events: Events,
    ExpExcel: ExpExcel,
    FieldCfgs: FieldCfgs,
    Fields: Fields,
    file: File,
    FileLoader: FileLoader,
    formatter: Formatter,
    Funcs: Funcs,
    http: Http,
    IAccess: IAccess,
    IAttFactory: IAttFactory,
    ICache: ICache,
    ImageLoader: ImageLoader,
    IMessage: IMessage,
    iconCss: IconCss,
    InitRunenv: InitRunenv,
    localCache: LocalCache,
    MyIndexDb: MyIndexDb,
    number: Number$1,
    parser: Parser,
    Plugins: Plugins,
    ProcAssign: ProcAssign,
    ProcBase: ProcBase,
    regex: RegEx,
    run: Run,
    runnings: Runnings,
    service: Service,
    Services: Services,
    sqlexp: SqlExp,
    Stack: Stack,
    theme: Theme,
    time: Time,
    url: Url,
    util: Util,

    bpm: {
      IProcBase: IProcBase,
      bpm: Bpm$1,
      BpmHandle: ProcHandle
    },

    geo: {
      ILayer: ILayer,
      IMapara: Mapara,
      IViewport: IViewport
    },
    layer: {
      ITileLayer: ITileLayer,
      Wms: Wms,
      WmsArcgis: WmsArcgis
    },
    security: {
      encrypt: Encrypt
    },
    svr: {
      area: Area,
      area3: Area3,
      attOper: AttOper,
      bpm: Bpm,
      doc: Doc,
      feature: Feature,
      file: File$1,
      identity: Identity,
      login: Login,
      mail: Mail,
      network: Network,
      network3: Network3,
      stat: Statistic,
      dataCheck: DataCheck,
      threeanly: ThreeAnly,
      util: UtilSvr,
      gaspipe: Gaspipe,
      secret: Secret
    },
    tile: {
      GenImage: GenImage,
      TileImages: TileImages,
      Wmts: Wmts,
      WmtsWeb: WmtsWeb
    },
    containers: Containers,
    datagrid: DataGrid,
    dlgModal: new DlgModal(),
    DlgMove: DlgMove,
    DlgSize: DlgSize,
    resizes: Resizes,
    upload: Upload,
    undo: {
      AttDelete: AttDelete,
      AttInsert: AttInsert,
      AttInsertFile: AttInsertFile,
      AttUpdate: AttUpdate,
      Data: Data,
      Manager: Manager,
      Step: Step
    },
    vueEx: VueEx,
    vueRegister: Register,
    router: Router
  }

  return CX
}))



//////////////////
// WEBPACK FOOTER
// ./static/lib/cx.js
// module id = 7Aq0
// module chunks = 1